"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_31662 = void 0;
/* eslint-disable max-lines */
// Locally, we do not check this file as the local Typescript server in editors cannot handle the large JSON files.
// On CI, we will remove this full comment block and will still typecheck this file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// taken from https://github.com/wooorm/iso-3166/blob/main/2.js
// a list of all ISO-3166-2 country subdivisions
exports.ISO_31662 = {
    'AD-02': {
        code: 'AD-02',
        name: 'Canillo',
        parent: 'AD',
    },
    'AD-03': {
        code: 'AD-03',
        name: 'Encamp',
        parent: 'AD',
    },
    'AD-04': {
        code: 'AD-04',
        name: 'La Massana',
        parent: 'AD',
    },
    'AD-05': {
        code: 'AD-05',
        name: 'Ordino',
        parent: 'AD',
    },
    'AD-06': {
        code: 'AD-06',
        name: 'Sant Julià de Lòria',
        parent: 'AD',
    },
    'AD-07': {
        code: 'AD-07',
        name: 'Andorra la Vella',
        parent: 'AD',
    },
    'AD-08': {
        code: 'AD-08',
        name: 'Escaldes-Engordany',
        parent: 'AD',
    },
    'AE-AJ': {
        code: 'AE-AJ',
        name: '‘Ajmān',
        parent: 'AE',
    },
    'AE-AZ': {
        code: 'AE-AZ',
        name: 'Abū Z̧aby',
        parent: 'AE',
    },
    'AE-DU': {
        code: 'AE-DU',
        name: 'Dubayy',
        parent: 'AE',
    },
    'AE-FU': {
        code: 'AE-FU',
        name: 'Al Fujayrah',
        parent: 'AE',
    },
    'AE-RK': {
        code: 'AE-RK',
        name: 'Ra’s al Khaymah',
        parent: 'AE',
    },
    'AE-SH': {
        code: 'AE-SH',
        name: 'Ash Shāriqah',
        parent: 'AE',
    },
    'AE-UQ': {
        code: 'AE-UQ',
        name: 'Umm al Qaywayn',
        parent: 'AE',
    },
    'AF-BAL': {
        code: 'AF-BAL',
        name: 'Balkh',
        parent: 'AF',
    },
    'AF-BAM': {
        code: 'AF-BAM',
        name: 'Bāmyān',
        parent: 'AF',
    },
    'AF-BDG': {
        code: 'AF-BDG',
        name: 'Bādghīs',
        parent: 'AF',
    },
    'AF-BDS': {
        code: 'AF-BDS',
        name: 'Badakhshān',
        parent: 'AF',
    },
    'AF-BGL': {
        code: 'AF-BGL',
        name: 'Baghlān',
        parent: 'AF',
    },
    'AF-DAY': {
        code: 'AF-DAY',
        name: 'Dāykundī',
        parent: 'AF',
    },
    'AF-FRA': {
        code: 'AF-FRA',
        name: 'Farāh',
        parent: 'AF',
    },
    'AF-FYB': {
        code: 'AF-FYB',
        name: 'Fāryāb',
        parent: 'AF',
    },
    'AF-GHA': {
        code: 'AF-GHA',
        name: 'Ghaznī',
        parent: 'AF',
    },
    'AF-GHO': {
        code: 'AF-GHO',
        name: 'Ghōr',
        parent: 'AF',
    },
    'AF-HEL': {
        code: 'AF-HEL',
        name: 'Helmand',
        parent: 'AF',
    },
    'AF-HER': {
        code: 'AF-HER',
        name: 'Herāt',
        parent: 'AF',
    },
    'AF-JOW': {
        code: 'AF-JOW',
        name: 'Jowzjān',
        parent: 'AF',
    },
    'AF-KAB': {
        code: 'AF-KAB',
        name: 'Kābul',
        parent: 'AF',
    },
    'AF-KAN': {
        code: 'AF-KAN',
        name: 'Kandahār',
        parent: 'AF',
    },
    'AF-KAP': {
        code: 'AF-KAP',
        name: 'Kāpīsā',
        parent: 'AF',
    },
    'AF-KDZ': {
        code: 'AF-KDZ',
        name: 'Kunduz',
        parent: 'AF',
    },
    'AF-KHO': {
        code: 'AF-KHO',
        name: 'Khōst',
        parent: 'AF',
    },
    'AF-KNR': {
        code: 'AF-KNR',
        name: 'Kunaṟ',
        parent: 'AF',
    },
    'AF-LAG': {
        code: 'AF-LAG',
        name: 'Laghmān',
        parent: 'AF',
    },
    'AF-LOG': {
        code: 'AF-LOG',
        name: 'Lōgar',
        parent: 'AF',
    },
    'AF-NAN': {
        code: 'AF-NAN',
        name: 'Nangarhār',
        parent: 'AF',
    },
    'AF-NIM': {
        code: 'AF-NIM',
        name: 'Nīmrōz',
        parent: 'AF',
    },
    'AF-NUR': {
        code: 'AF-NUR',
        name: 'Nūristān',
        parent: 'AF',
    },
    'AF-PAN': {
        code: 'AF-PAN',
        name: 'Panjshayr',
        parent: 'AF',
    },
    'AF-PAR': {
        code: 'AF-PAR',
        name: 'Parwān',
        parent: 'AF',
    },
    'AF-PIA': {
        code: 'AF-PIA',
        name: 'Paktiyā',
        parent: 'AF',
    },
    'AF-PKA': {
        code: 'AF-PKA',
        name: 'Paktīkā',
        parent: 'AF',
    },
    'AF-SAM': {
        code: 'AF-SAM',
        name: 'Samangān',
        parent: 'AF',
    },
    'AF-SAR': {
        code: 'AF-SAR',
        name: 'Sar-e Pul',
        parent: 'AF',
    },
    'AF-TAK': {
        code: 'AF-TAK',
        name: 'Takhār',
        parent: 'AF',
    },
    'AF-URU': {
        code: 'AF-URU',
        name: 'Uruzgān',
        parent: 'AF',
    },
    'AF-WAR': {
        code: 'AF-WAR',
        name: 'Wardak',
        parent: 'AF',
    },
    'AF-ZAB': {
        code: 'AF-ZAB',
        name: 'Zābul',
        parent: 'AF',
    },
    'AG-03': {
        code: 'AG-03',
        name: 'Saint George',
        parent: 'AG',
    },
    'AG-04': {
        code: 'AG-04',
        name: 'Saint John',
        parent: 'AG',
    },
    'AG-05': {
        code: 'AG-05',
        name: 'Saint Mary',
        parent: 'AG',
    },
    'AG-06': {
        code: 'AG-06',
        name: 'Saint Paul',
        parent: 'AG',
    },
    'AG-07': {
        code: 'AG-07',
        name: 'Saint Peter',
        parent: 'AG',
    },
    'AG-08': {
        code: 'AG-08',
        name: 'Saint Philip',
        parent: 'AG',
    },
    'AG-10': {
        code: 'AG-10',
        name: 'Barbuda',
        parent: 'AG',
    },
    'AG-11': {
        code: 'AG-11',
        name: 'Redonda',
        parent: 'AG',
    },
    'AL-01': {
        code: 'AL-01',
        name: 'Berat',
        parent: 'AL',
    },
    'AL-02': {
        code: 'AL-02',
        name: 'Durrës',
        parent: 'AL',
    },
    'AL-03': {
        code: 'AL-03',
        name: 'Elbasan',
        parent: 'AL',
    },
    'AL-04': {
        code: 'AL-04',
        name: 'Fier',
        parent: 'AL',
    },
    'AL-05': {
        code: 'AL-05',
        name: 'Gjirokastër',
        parent: 'AL',
    },
    'AL-06': {
        code: 'AL-06',
        name: 'Korçë',
        parent: 'AL',
    },
    'AL-07': {
        code: 'AL-07',
        name: 'Kukës',
        parent: 'AL',
    },
    'AL-08': {
        code: 'AL-08',
        name: 'Lezhë',
        parent: 'AL',
    },
    'AL-09': {
        code: 'AL-09',
        name: 'Dibër',
        parent: 'AL',
    },
    'AL-10': {
        code: 'AL-10',
        name: 'Shkodër',
        parent: 'AL',
    },
    'AL-11': {
        code: 'AL-11',
        name: 'Tiranë',
        parent: 'AL',
    },
    'AL-12': {
        code: 'AL-12',
        name: 'Vlorë',
        parent: 'AL',
    },
    'AM-AG': {
        code: 'AM-AG',
        name: 'Aragac̣otn',
        parent: 'AM',
    },
    'AM-AR': {
        code: 'AM-AR',
        name: 'Ararat',
        parent: 'AM',
    },
    'AM-AV': {
        code: 'AM-AV',
        name: 'Armavir',
        parent: 'AM',
    },
    'AM-ER': {
        code: 'AM-ER',
        name: 'Erevan',
        parent: 'AM',
    },
    'AM-GR': {
        code: 'AM-GR',
        name: "Geġark'unik'",
        parent: 'AM',
    },
    'AM-KT': {
        code: 'AM-KT',
        name: "Kotayk'",
        parent: 'AM',
    },
    'AM-LO': {
        code: 'AM-LO',
        name: 'Loṙi',
        parent: 'AM',
    },
    'AM-SH': {
        code: 'AM-SH',
        name: 'Širak',
        parent: 'AM',
    },
    'AM-SU': {
        code: 'AM-SU',
        name: "Syunik'",
        parent: 'AM',
    },
    'AM-TV': {
        code: 'AM-TV',
        name: 'Tavuš',
        parent: 'AM',
    },
    'AM-VD': {
        code: 'AM-VD',
        name: 'Vayoć Jor',
        parent: 'AM',
    },
    'AO-BGO': {
        code: 'AO-BGO',
        name: 'Bengo',
        parent: 'AO',
    },
    'AO-BGU': {
        code: 'AO-BGU',
        name: 'Benguela',
        parent: 'AO',
    },
    'AO-BIE': {
        code: 'AO-BIE',
        name: 'Bié',
        parent: 'AO',
    },
    'AO-CAB': {
        code: 'AO-CAB',
        name: 'Cabinda',
        parent: 'AO',
    },
    'AO-CCU': {
        code: 'AO-CCU',
        name: 'Cuando Cubango',
        parent: 'AO',
    },
    'AO-CNN': {
        code: 'AO-CNN',
        name: 'Cunene',
        parent: 'AO',
    },
    'AO-CNO': {
        code: 'AO-CNO',
        name: 'Cuanza-Norte',
        parent: 'AO',
    },
    'AO-CUS': {
        code: 'AO-CUS',
        name: 'Cuanza-Sul',
        parent: 'AO',
    },
    'AO-HUA': {
        code: 'AO-HUA',
        name: 'Huambo',
        parent: 'AO',
    },
    'AO-HUI': {
        code: 'AO-HUI',
        name: 'Huíla',
        parent: 'AO',
    },
    'AO-LNO': {
        code: 'AO-LNO',
        name: 'Lunda-Norte',
        parent: 'AO',
    },
    'AO-LSU': {
        code: 'AO-LSU',
        name: 'Lunda-Sul',
        parent: 'AO',
    },
    'AO-LUA': {
        code: 'AO-LUA',
        name: 'Luanda',
        parent: 'AO',
    },
    'AO-MAL': {
        code: 'AO-MAL',
        name: 'Malange',
        parent: 'AO',
    },
    'AO-MOX': {
        code: 'AO-MOX',
        name: 'Moxico',
        parent: 'AO',
    },
    'AO-NAM': {
        code: 'AO-NAM',
        name: 'Namibe',
        parent: 'AO',
    },
    'AO-UIG': {
        code: 'AO-UIG',
        name: 'Uíge',
        parent: 'AO',
    },
    'AO-ZAI': {
        code: 'AO-ZAI',
        name: 'Zaire',
        parent: 'AO',
    },
    'AR-A': {
        code: 'AR-A',
        name: 'Salta',
        parent: 'AR',
    },
    'AR-B': {
        code: 'AR-B',
        name: 'Buenos Aires',
        parent: 'AR',
    },
    'AR-C': {
        code: 'AR-C',
        name: 'Ciudad Autónoma de Buenos Aires',
        parent: 'AR',
    },
    'AR-D': {
        code: 'AR-D',
        name: 'San Luis',
        parent: 'AR',
    },
    'AR-E': {
        code: 'AR-E',
        name: 'Entre Ríos',
        parent: 'AR',
    },
    'AR-F': {
        code: 'AR-F',
        name: 'La Rioja',
        parent: 'AR',
    },
    'AR-G': {
        code: 'AR-G',
        name: 'Santiago del Estero',
        parent: 'AR',
    },
    'AR-H': {
        code: 'AR-H',
        name: 'Chaco',
        parent: 'AR',
    },
    'AR-J': {
        code: 'AR-J',
        name: 'San Juan',
        parent: 'AR',
    },
    'AR-K': {
        code: 'AR-K',
        name: 'Catamarca',
        parent: 'AR',
    },
    'AR-L': {
        code: 'AR-L',
        name: 'La Pampa',
        parent: 'AR',
    },
    'AR-M': {
        code: 'AR-M',
        name: 'Mendoza',
        parent: 'AR',
    },
    'AR-N': {
        code: 'AR-N',
        name: 'Misiones',
        parent: 'AR',
    },
    'AR-P': {
        code: 'AR-P',
        name: 'Formosa',
        parent: 'AR',
    },
    'AR-Q': {
        code: 'AR-Q',
        name: 'Neuquén',
        parent: 'AR',
    },
    'AR-R': {
        code: 'AR-R',
        name: 'Río Negro',
        parent: 'AR',
    },
    'AR-S': {
        code: 'AR-S',
        name: 'Santa Fe',
        parent: 'AR',
    },
    'AR-T': {
        code: 'AR-T',
        name: 'Tucumán',
        parent: 'AR',
    },
    'AR-U': {
        code: 'AR-U',
        name: 'Chubut',
        parent: 'AR',
    },
    'AR-V': {
        code: 'AR-V',
        name: 'Tierra del Fuego',
        parent: 'AR',
    },
    'AR-W': {
        code: 'AR-W',
        name: 'Corrientes',
        parent: 'AR',
    },
    'AR-X': {
        code: 'AR-X',
        name: 'Córdoba',
        parent: 'AR',
    },
    'AR-Y': {
        code: 'AR-Y',
        name: 'Jujuy',
        parent: 'AR',
    },
    'AR-Z': {
        code: 'AR-Z',
        name: 'Santa Cruz',
        parent: 'AR',
    },
    'AT-1': {
        code: 'AT-1',
        name: 'Burgenland',
        parent: 'AT',
    },
    'AT-2': {
        code: 'AT-2',
        name: 'Kärnten',
        parent: 'AT',
    },
    'AT-3': {
        code: 'AT-3',
        name: 'Niederösterreich',
        parent: 'AT',
    },
    'AT-4': {
        code: 'AT-4',
        name: 'Oberösterreich',
        parent: 'AT',
    },
    'AT-5': {
        code: 'AT-5',
        name: 'Salzburg',
        parent: 'AT',
    },
    'AT-6': {
        code: 'AT-6',
        name: 'Steiermark',
        parent: 'AT',
    },
    'AT-7': {
        code: 'AT-7',
        name: 'Tirol',
        parent: 'AT',
    },
    'AT-8': {
        code: 'AT-8',
        name: 'Vorarlberg',
        parent: 'AT',
    },
    'AT-9': {
        code: 'AT-9',
        name: 'Wien',
        parent: 'AT',
    },
    'AU-ACT': {
        code: 'AU-ACT',
        name: 'Australian Capital Territory',
        parent: 'AU',
    },
    'AU-NSW': {
        code: 'AU-NSW',
        name: 'New South Wales',
        parent: 'AU',
    },
    'AU-NT': {
        code: 'AU-NT',
        name: 'Northern Territory',
        parent: 'AU',
    },
    'AU-QLD': {
        code: 'AU-QLD',
        name: 'Queensland',
        parent: 'AU',
    },
    'AU-SA': {
        code: 'AU-SA',
        name: 'South Australia',
        parent: 'AU',
    },
    'AU-TAS': {
        code: 'AU-TAS',
        name: 'Tasmania',
        parent: 'AU',
    },
    'AU-VIC': {
        code: 'AU-VIC',
        name: 'Victoria',
        parent: 'AU',
    },
    'AU-WA': {
        code: 'AU-WA',
        name: 'Western Australia',
        parent: 'AU',
    },
    'AZ-ABS': {
        code: 'AZ-ABS',
        name: 'Abşeron',
        parent: 'AZ',
    },
    'AZ-AGA': {
        code: 'AZ-AGA',
        name: 'Ağstafa',
        parent: 'AZ',
    },
    'AZ-AGC': {
        code: 'AZ-AGC',
        name: 'Ağcabədi',
        parent: 'AZ',
    },
    'AZ-AGM': {
        code: 'AZ-AGM',
        name: 'Ağdam',
        parent: 'AZ',
    },
    'AZ-AGS': {
        code: 'AZ-AGS',
        name: 'Ağdaş',
        parent: 'AZ',
    },
    'AZ-AGU': {
        code: 'AZ-AGU',
        name: 'Ağsu',
        parent: 'AZ',
    },
    'AZ-AST': {
        code: 'AZ-AST',
        name: 'Astara',
        parent: 'AZ',
    },
    'AZ-BA': {
        code: 'AZ-BA',
        name: 'Bakı',
        parent: 'AZ',
    },
    'AZ-BAB': {
        code: 'AZ-BAB',
        name: 'Babək',
        parent: 'AZ-NX',
    },
    'AZ-BAL': {
        code: 'AZ-BAL',
        name: 'Balakən',
        parent: 'AZ',
    },
    'AZ-BAR': {
        code: 'AZ-BAR',
        name: 'Bərdə',
        parent: 'AZ',
    },
    'AZ-BEY': {
        code: 'AZ-BEY',
        name: 'Beyləqan',
        parent: 'AZ',
    },
    'AZ-BIL': {
        code: 'AZ-BIL',
        name: 'Biləsuvar',
        parent: 'AZ',
    },
    'AZ-CAB': {
        code: 'AZ-CAB',
        name: 'Cəbrayıl',
        parent: 'AZ',
    },
    'AZ-CAL': {
        code: 'AZ-CAL',
        name: 'Cəlilabad',
        parent: 'AZ',
    },
    'AZ-CUL': {
        code: 'AZ-CUL',
        name: 'Culfa',
        parent: 'AZ-NX',
    },
    'AZ-DAS': {
        code: 'AZ-DAS',
        name: 'Daşkəsən',
        parent: 'AZ',
    },
    'AZ-FUZ': {
        code: 'AZ-FUZ',
        name: 'Füzuli',
        parent: 'AZ',
    },
    'AZ-GA': {
        code: 'AZ-GA',
        name: 'Gəncə',
        parent: 'AZ',
    },
    'AZ-GAD': {
        code: 'AZ-GAD',
        name: 'Gədəbəy',
        parent: 'AZ',
    },
    'AZ-GOR': {
        code: 'AZ-GOR',
        name: 'Goranboy',
        parent: 'AZ',
    },
    'AZ-GOY': {
        code: 'AZ-GOY',
        name: 'Göyçay',
        parent: 'AZ',
    },
    'AZ-GYG': {
        code: 'AZ-GYG',
        name: 'Göygöl',
        parent: 'AZ',
    },
    'AZ-HAC': {
        code: 'AZ-HAC',
        name: 'Hacıqabul',
        parent: 'AZ',
    },
    'AZ-IMI': {
        code: 'AZ-IMI',
        name: 'İmişli',
        parent: 'AZ',
    },
    'AZ-ISM': {
        code: 'AZ-ISM',
        name: 'İsmayıllı',
        parent: 'AZ',
    },
    'AZ-KAL': {
        code: 'AZ-KAL',
        name: 'Kəlbəcər',
        parent: 'AZ',
    },
    'AZ-KAN': {
        code: 'AZ-KAN',
        name: 'Kǝngǝrli',
        parent: 'AZ-NX',
    },
    'AZ-KUR': {
        code: 'AZ-KUR',
        name: 'Kürdəmir',
        parent: 'AZ',
    },
    'AZ-LA': {
        code: 'AZ-LA',
        name: 'Lənkəran',
        parent: 'AZ',
    },
    'AZ-LAC': {
        code: 'AZ-LAC',
        name: 'Laçın',
        parent: 'AZ',
    },
    'AZ-LAN': {
        code: 'AZ-LAN',
        name: 'Lənkəran',
        parent: 'AZ',
    },
    'AZ-LER': {
        code: 'AZ-LER',
        name: 'Lerik',
        parent: 'AZ',
    },
    'AZ-MAS': {
        code: 'AZ-MAS',
        name: 'Masallı',
        parent: 'AZ',
    },
    'AZ-MI': {
        code: 'AZ-MI',
        name: 'Mingəçevir',
        parent: 'AZ',
    },
    'AZ-NA': {
        code: 'AZ-NA',
        name: 'Naftalan',
        parent: 'AZ',
    },
    'AZ-NEF': {
        code: 'AZ-NEF',
        name: 'Neftçala',
        parent: 'AZ',
    },
    'AZ-NV': {
        code: 'AZ-NV',
        name: 'Naxçıvan',
        parent: 'AZ-NX',
    },
    'AZ-NX': {
        code: 'AZ-NX',
        name: 'Naxçıvan',
        parent: 'AZ',
    },
    'AZ-OGU': {
        code: 'AZ-OGU',
        name: 'Oğuz',
        parent: 'AZ',
    },
    'AZ-ORD': {
        code: 'AZ-ORD',
        name: 'Ordubad',
        parent: 'AZ-NX',
    },
    'AZ-QAB': {
        code: 'AZ-QAB',
        name: 'Qəbələ',
        parent: 'AZ',
    },
    'AZ-QAX': {
        code: 'AZ-QAX',
        name: 'Qax',
        parent: 'AZ',
    },
    'AZ-QAZ': {
        code: 'AZ-QAZ',
        name: 'Qazax',
        parent: 'AZ',
    },
    'AZ-QBA': {
        code: 'AZ-QBA',
        name: 'Quba',
        parent: 'AZ',
    },
    'AZ-QBI': {
        code: 'AZ-QBI',
        name: 'Qubadlı',
        parent: 'AZ',
    },
    'AZ-QOB': {
        code: 'AZ-QOB',
        name: 'Qobustan',
        parent: 'AZ',
    },
    'AZ-QUS': {
        code: 'AZ-QUS',
        name: 'Qusar',
        parent: 'AZ',
    },
    'AZ-SA': {
        code: 'AZ-SA',
        name: 'Şəki',
        parent: 'AZ',
    },
    'AZ-SAB': {
        code: 'AZ-SAB',
        name: 'Sabirabad',
        parent: 'AZ',
    },
    'AZ-SAD': {
        code: 'AZ-SAD',
        name: 'Sədərək',
        parent: 'AZ-NX',
    },
    'AZ-SAH': {
        code: 'AZ-SAH',
        name: 'Şahbuz',
        parent: 'AZ-NX',
    },
    'AZ-SAK': {
        code: 'AZ-SAK',
        name: 'Şəki',
        parent: 'AZ',
    },
    'AZ-SAL': {
        code: 'AZ-SAL',
        name: 'Salyan',
        parent: 'AZ',
    },
    'AZ-SAR': {
        code: 'AZ-SAR',
        name: 'Şərur',
        parent: 'AZ-NX',
    },
    'AZ-SAT': {
        code: 'AZ-SAT',
        name: 'Saatlı',
        parent: 'AZ',
    },
    'AZ-SBN': {
        code: 'AZ-SBN',
        name: 'Şabran',
        parent: 'AZ',
    },
    'AZ-SIY': {
        code: 'AZ-SIY',
        name: 'Siyəzən',
        parent: 'AZ',
    },
    'AZ-SKR': {
        code: 'AZ-SKR',
        name: 'Şəmkir',
        parent: 'AZ',
    },
    'AZ-SM': {
        code: 'AZ-SM',
        name: 'Sumqayıt',
        parent: 'AZ',
    },
    'AZ-SMI': {
        code: 'AZ-SMI',
        name: 'Şamaxı',
        parent: 'AZ',
    },
    'AZ-SMX': {
        code: 'AZ-SMX',
        name: 'Samux',
        parent: 'AZ',
    },
    'AZ-SR': {
        code: 'AZ-SR',
        name: 'Şirvan',
        parent: 'AZ',
    },
    'AZ-SUS': {
        code: 'AZ-SUS',
        name: 'Şuşa',
        parent: 'AZ',
    },
    'AZ-TAR': {
        code: 'AZ-TAR',
        name: 'Tərtər',
        parent: 'AZ',
    },
    'AZ-TOV': {
        code: 'AZ-TOV',
        name: 'Tovuz',
        parent: 'AZ',
    },
    'AZ-UCA': {
        code: 'AZ-UCA',
        name: 'Ucar',
        parent: 'AZ',
    },
    'AZ-XA': {
        code: 'AZ-XA',
        name: 'Xankəndi',
        parent: 'AZ',
    },
    'AZ-XAC': {
        code: 'AZ-XAC',
        name: 'Xaçmaz',
        parent: 'AZ',
    },
    'AZ-XCI': {
        code: 'AZ-XCI',
        name: 'Xocalı',
        parent: 'AZ',
    },
    'AZ-XIZ': {
        code: 'AZ-XIZ',
        name: 'Xızı',
        parent: 'AZ',
    },
    'AZ-XVD': {
        code: 'AZ-XVD',
        name: 'Xocavənd',
        parent: 'AZ',
    },
    'AZ-YAR': {
        code: 'AZ-YAR',
        name: 'Yardımlı',
        parent: 'AZ',
    },
    'AZ-YE': {
        code: 'AZ-YE',
        name: 'Yevlax',
        parent: 'AZ',
    },
    'AZ-YEV': {
        code: 'AZ-YEV',
        name: 'Yevlax',
        parent: 'AZ',
    },
    'AZ-ZAN': {
        code: 'AZ-ZAN',
        name: 'Zəngilan',
        parent: 'AZ',
    },
    'AZ-ZAQ': {
        code: 'AZ-ZAQ',
        name: 'Zaqatala',
        parent: 'AZ',
    },
    'AZ-ZAR': {
        code: 'AZ-ZAR',
        name: 'Zərdab',
        parent: 'AZ',
    },
    'BA-BIH': {
        code: 'BA-BIH',
        name: 'Federacija Bosne i Hercegovine',
        parent: 'BA',
    },
    'BA-BRC': {
        code: 'BA-BRC',
        name: 'Brčko distrikt',
        parent: 'BA',
    },
    'BA-SRP': {
        code: 'BA-SRP',
        name: 'Republika Srpska',
        parent: 'BA',
    },
    'BB-01': {
        code: 'BB-01',
        name: 'Christ Church',
        parent: 'BB',
    },
    'BB-02': {
        code: 'BB-02',
        name: 'Saint Andrew',
        parent: 'BB',
    },
    'BB-03': {
        code: 'BB-03',
        name: 'Saint George',
        parent: 'BB',
    },
    'BB-04': {
        code: 'BB-04',
        name: 'Saint James',
        parent: 'BB',
    },
    'BB-05': {
        code: 'BB-05',
        name: 'Saint John',
        parent: 'BB',
    },
    'BB-06': {
        code: 'BB-06',
        name: 'Saint Joseph',
        parent: 'BB',
    },
    'BB-07': {
        code: 'BB-07',
        name: 'Saint Lucy',
        parent: 'BB',
    },
    'BB-08': {
        code: 'BB-08',
        name: 'Saint Michael',
        parent: 'BB',
    },
    'BB-09': {
        code: 'BB-09',
        name: 'Saint Peter',
        parent: 'BB',
    },
    'BB-10': {
        code: 'BB-10',
        name: 'Saint Philip',
        parent: 'BB',
    },
    'BB-11': {
        code: 'BB-11',
        name: 'Saint Thomas',
        parent: 'BB',
    },
    'BD-01': {
        code: 'BD-01',
        name: 'Bandarban',
        parent: 'BD-B',
    },
    'BD-02': {
        code: 'BD-02',
        name: 'Barguna',
        parent: 'BD-A',
    },
    'BD-03': {
        code: 'BD-03',
        name: 'Bogura',
        parent: 'BD-E',
    },
    'BD-04': {
        code: 'BD-04',
        name: 'Brahmanbaria',
        parent: 'BD-B',
    },
    'BD-05': {
        code: 'BD-05',
        name: 'Bagerhat',
        parent: 'BD-D',
    },
    'BD-06': {
        code: 'BD-06',
        name: 'Barishal',
        parent: 'BD-A',
    },
    'BD-07': {
        code: 'BD-07',
        name: 'Bhola',
        parent: 'BD-A',
    },
    'BD-08': {
        code: 'BD-08',
        name: 'Cumilla',
        parent: 'BD-B',
    },
    'BD-09': {
        code: 'BD-09',
        name: 'Chandpur',
        parent: 'BD-B',
    },
    'BD-10': {
        code: 'BD-10',
        name: 'Chattogram',
        parent: 'BD-B',
    },
    'BD-11': {
        code: 'BD-11',
        name: "Cox's Bazar",
        parent: 'BD-B',
    },
    'BD-12': {
        code: 'BD-12',
        name: 'Chuadanga',
        parent: 'BD-D',
    },
    'BD-13': {
        code: 'BD-13',
        name: 'Dhaka',
        parent: 'BD-C',
    },
    'BD-14': {
        code: 'BD-14',
        name: 'Dinajpur',
        parent: 'BD-F',
    },
    'BD-15': {
        code: 'BD-15',
        name: 'Faridpur',
        parent: 'BD-C',
    },
    'BD-16': {
        code: 'BD-16',
        name: 'Feni',
        parent: 'BD-B',
    },
    'BD-17': {
        code: 'BD-17',
        name: 'Gopalganj',
        parent: 'BD-C',
    },
    'BD-18': {
        code: 'BD-18',
        name: 'Gazipur',
        parent: 'BD-C',
    },
    'BD-19': {
        code: 'BD-19',
        name: 'Gaibandha',
        parent: 'BD-F',
    },
    'BD-20': {
        code: 'BD-20',
        name: 'Habiganj',
        parent: 'BD-G',
    },
    'BD-21': {
        code: 'BD-21',
        name: 'Jamalpur',
        parent: 'BD-H',
    },
    'BD-22': {
        code: 'BD-22',
        name: 'Jashore',
        parent: 'BD-D',
    },
    'BD-23': {
        code: 'BD-23',
        name: 'Jhenaidah',
        parent: 'BD-D',
    },
    'BD-24': {
        code: 'BD-24',
        name: 'Joypurhat',
        parent: 'BD-E',
    },
    'BD-25': {
        code: 'BD-25',
        name: 'Jhalakathi',
        parent: 'BD-A',
    },
    'BD-26': {
        code: 'BD-26',
        name: 'Kishoreganj',
        parent: 'BD-C',
    },
    'BD-27': {
        code: 'BD-27',
        name: 'Khulna',
        parent: 'BD-D',
    },
    'BD-28': {
        code: 'BD-28',
        name: 'Kurigram',
        parent: 'BD-F',
    },
    'BD-29': {
        code: 'BD-29',
        name: 'Khagrachhari',
        parent: 'BD-B',
    },
    'BD-30': {
        code: 'BD-30',
        name: 'Kushtia',
        parent: 'BD-D',
    },
    'BD-31': {
        code: 'BD-31',
        name: 'Lakshmipur',
        parent: 'BD-B',
    },
    'BD-32': {
        code: 'BD-32',
        name: 'Lalmonirhat',
        parent: 'BD-F',
    },
    'BD-33': {
        code: 'BD-33',
        name: 'Manikganj',
        parent: 'BD-C',
    },
    'BD-34': {
        code: 'BD-34',
        name: 'Mymensingh',
        parent: 'BD-H',
    },
    'BD-35': {
        code: 'BD-35',
        name: 'Munshiganj',
        parent: 'BD-C',
    },
    'BD-36': {
        code: 'BD-36',
        name: 'Madaripur',
        parent: 'BD-C',
    },
    'BD-37': {
        code: 'BD-37',
        name: 'Magura',
        parent: 'BD-D',
    },
    'BD-38': {
        code: 'BD-38',
        name: 'Moulvibazar',
        parent: 'BD-G',
    },
    'BD-39': {
        code: 'BD-39',
        name: 'Meherpur',
        parent: 'BD-D',
    },
    'BD-40': {
        code: 'BD-40',
        name: 'Narayanganj',
        parent: 'BD-C',
    },
    'BD-41': {
        code: 'BD-41',
        name: 'Netrakona',
        parent: 'BD-H',
    },
    'BD-42': {
        code: 'BD-42',
        name: 'Narsingdi',
        parent: 'BD-C',
    },
    'BD-43': {
        code: 'BD-43',
        name: 'Narail',
        parent: 'BD-D',
    },
    'BD-44': {
        code: 'BD-44',
        name: 'Natore',
        parent: 'BD-E',
    },
    'BD-45': {
        code: 'BD-45',
        name: 'Chapai Nawabganj',
        parent: 'BD-E',
    },
    'BD-46': {
        code: 'BD-46',
        name: 'Nilphamari',
        parent: 'BD-F',
    },
    'BD-47': {
        code: 'BD-47',
        name: 'Noakhali',
        parent: 'BD-B',
    },
    'BD-48': {
        code: 'BD-48',
        name: 'Naogaon',
        parent: 'BD-E',
    },
    'BD-49': {
        code: 'BD-49',
        name: 'Pabna',
        parent: 'BD-E',
    },
    'BD-50': {
        code: 'BD-50',
        name: 'Pirojpur',
        parent: 'BD-A',
    },
    'BD-51': {
        code: 'BD-51',
        name: 'Patuakhali',
        parent: 'BD-A',
    },
    'BD-52': {
        code: 'BD-52',
        name: 'Panchagarh',
        parent: 'BD-F',
    },
    'BD-53': {
        code: 'BD-53',
        name: 'Rajbari',
        parent: 'BD-C',
    },
    'BD-54': {
        code: 'BD-54',
        name: 'Rajshahi',
        parent: 'BD-E',
    },
    'BD-55': {
        code: 'BD-55',
        name: 'Rangpur',
        parent: 'BD-F',
    },
    'BD-56': {
        code: 'BD-56',
        name: 'Rangamati',
        parent: 'BD-B',
    },
    'BD-57': {
        code: 'BD-57',
        name: 'Sherpur',
        parent: 'BD-H',
    },
    'BD-58': {
        code: 'BD-58',
        name: 'Satkhira',
        parent: 'BD-D',
    },
    'BD-59': {
        code: 'BD-59',
        name: 'Sirajganj',
        parent: 'BD-E',
    },
    'BD-60': {
        code: 'BD-60',
        name: 'Sylhet',
        parent: 'BD-G',
    },
    'BD-61': {
        code: 'BD-61',
        name: 'Sunamganj',
        parent: 'BD-G',
    },
    'BD-62': {
        code: 'BD-62',
        name: 'Shariatpur',
        parent: 'BD-C',
    },
    'BD-63': {
        code: 'BD-63',
        name: 'Tangail',
        parent: 'BD-C',
    },
    'BD-64': {
        code: 'BD-64',
        name: 'Thakurgaon',
        parent: 'BD-F',
    },
    'BD-A': {
        code: 'BD-A',
        name: 'Barishal',
        parent: 'BD',
    },
    'BD-B': {
        code: 'BD-B',
        name: 'Chattogram',
        parent: 'BD',
    },
    'BD-C': {
        code: 'BD-C',
        name: 'Dhaka',
        parent: 'BD',
    },
    'BD-D': {
        code: 'BD-D',
        name: 'Khulna',
        parent: 'BD',
    },
    'BD-E': {
        code: 'BD-E',
        name: 'Rajshahi',
        parent: 'BD',
    },
    'BD-F': {
        code: 'BD-F',
        name: 'Rangpur',
        parent: 'BD',
    },
    'BD-G': {
        code: 'BD-G',
        name: 'Sylhet',
        parent: 'BD',
    },
    'BD-H': {
        code: 'BD-H',
        name: 'Mymensingh',
        parent: 'BD',
    },
    'BE-BRU': {
        code: 'BE-BRU',
        name: 'Brussels Hoofdstedelijk Gewest',
        parent: 'BE',
    },
    'BE-VAN': {
        code: 'BE-VAN',
        name: 'Antwerpen',
        parent: 'BE-VLG',
    },
    'BE-VBR': {
        code: 'BE-VBR',
        name: 'Vlaams-Brabant',
        parent: 'BE-VLG',
    },
    'BE-VLG': {
        code: 'BE-VLG',
        name: 'Vlaams Gewest',
        parent: 'BE',
    },
    'BE-VLI': {
        code: 'BE-VLI',
        name: 'Limburg',
        parent: 'BE-VLG',
    },
    'BE-VOV': {
        code: 'BE-VOV',
        name: 'Oost-Vlaanderen',
        parent: 'BE-VLG',
    },
    'BE-VWV': {
        code: 'BE-VWV',
        name: 'West-Vlaanderen',
        parent: 'BE-VLG',
    },
    'BE-WAL': {
        code: 'BE-WAL',
        name: 'Waals Gewest',
        parent: 'BE',
    },
    'BE-WBR': {
        code: 'BE-WBR',
        name: 'Brabant wallon',
        parent: 'BE-WAL',
    },
    'BE-WHT': {
        code: 'BE-WHT',
        name: 'Hainaut',
        parent: 'BE-WAL',
    },
    'BE-WLG': {
        code: 'BE-WLG',
        name: 'Liège',
        parent: 'BE-WAL',
    },
    'BE-WLX': {
        code: 'BE-WLX',
        name: 'Luxembourg',
        parent: 'BE-WAL',
    },
    'BE-WNA': {
        code: 'BE-WNA',
        name: 'Namur',
        parent: 'BE-WAL',
    },
    'BF-01': {
        code: 'BF-01',
        name: 'Boucle du Mouhoun',
        parent: 'BF',
    },
    'BF-02': {
        code: 'BF-02',
        name: 'Cascades',
        parent: 'BF',
    },
    'BF-03': {
        code: 'BF-03',
        name: 'Centre',
        parent: 'BF',
    },
    'BF-04': {
        code: 'BF-04',
        name: 'Centre-Est',
        parent: 'BF',
    },
    'BF-05': {
        code: 'BF-05',
        name: 'Centre-Nord',
        parent: 'BF',
    },
    'BF-06': {
        code: 'BF-06',
        name: 'Centre-Ouest',
        parent: 'BF',
    },
    'BF-07': {
        code: 'BF-07',
        name: 'Centre-Sud',
        parent: 'BF',
    },
    'BF-08': {
        code: 'BF-08',
        name: 'Est',
        parent: 'BF',
    },
    'BF-09': {
        code: 'BF-09',
        name: 'Hauts-Bassins',
        parent: 'BF',
    },
    'BF-10': {
        code: 'BF-10',
        name: 'Nord',
        parent: 'BF',
    },
    'BF-11': {
        code: 'BF-11',
        name: 'Plateau-Central',
        parent: 'BF',
    },
    'BF-12': {
        code: 'BF-12',
        name: 'Sahel',
        parent: 'BF',
    },
    'BF-13': {
        code: 'BF-13',
        name: 'Sud-Ouest',
        parent: 'BF',
    },
    'BF-BAL': {
        code: 'BF-BAL',
        name: 'Balé',
        parent: 'BF-01',
    },
    'BF-BAM': {
        code: 'BF-BAM',
        name: 'Bam',
        parent: 'BF-05',
    },
    'BF-BAN': {
        code: 'BF-BAN',
        name: 'Banwa',
        parent: 'BF-01',
    },
    'BF-BAZ': {
        code: 'BF-BAZ',
        name: 'Bazèga',
        parent: 'BF-07',
    },
    'BF-BGR': {
        code: 'BF-BGR',
        name: 'Bougouriba',
        parent: 'BF-13',
    },
    'BF-BLG': {
        code: 'BF-BLG',
        name: 'Boulgou',
        parent: 'BF-04',
    },
    'BF-BLK': {
        code: 'BF-BLK',
        name: 'Boulkiemdé',
        parent: 'BF-06',
    },
    'BF-COM': {
        code: 'BF-COM',
        name: 'Comoé',
        parent: 'BF-02',
    },
    'BF-GAN': {
        code: 'BF-GAN',
        name: 'Ganzourgou',
        parent: 'BF-11',
    },
    'BF-GNA': {
        code: 'BF-GNA',
        name: 'Gnagna',
        parent: 'BF-08',
    },
    'BF-GOU': {
        code: 'BF-GOU',
        name: 'Gourma',
        parent: 'BF-08',
    },
    'BF-HOU': {
        code: 'BF-HOU',
        name: 'Houet',
        parent: 'BF-09',
    },
    'BF-IOB': {
        code: 'BF-IOB',
        name: 'Ioba',
        parent: 'BF-13',
    },
    'BF-KAD': {
        code: 'BF-KAD',
        name: 'Kadiogo',
        parent: 'BF-03',
    },
    'BF-KEN': {
        code: 'BF-KEN',
        name: 'Kénédougou',
        parent: 'BF-09',
    },
    'BF-KMD': {
        code: 'BF-KMD',
        name: 'Komondjari',
        parent: 'BF-08',
    },
    'BF-KMP': {
        code: 'BF-KMP',
        name: 'Kompienga',
        parent: 'BF-08',
    },
    'BF-KOP': {
        code: 'BF-KOP',
        name: 'Koulpélogo',
        parent: 'BF-04',
    },
    'BF-KOS': {
        code: 'BF-KOS',
        name: 'Kossi',
        parent: 'BF-01',
    },
    'BF-KOT': {
        code: 'BF-KOT',
        name: 'Kouritenga',
        parent: 'BF-04',
    },
    'BF-KOW': {
        code: 'BF-KOW',
        name: 'Kourwéogo',
        parent: 'BF-11',
    },
    'BF-LER': {
        code: 'BF-LER',
        name: 'Léraba',
        parent: 'BF-02',
    },
    'BF-LOR': {
        code: 'BF-LOR',
        name: 'Loroum',
        parent: 'BF-10',
    },
    'BF-MOU': {
        code: 'BF-MOU',
        name: 'Mouhoun',
        parent: 'BF-01',
    },
    'BF-NAM': {
        code: 'BF-NAM',
        name: 'Namentenga',
        parent: 'BF-05',
    },
    'BF-NAO': {
        code: 'BF-NAO',
        name: 'Nahouri',
        parent: 'BF-07',
    },
    'BF-NAY': {
        code: 'BF-NAY',
        name: 'Nayala',
        parent: 'BF-01',
    },
    'BF-NOU': {
        code: 'BF-NOU',
        name: 'Noumbiel',
        parent: 'BF-13',
    },
    'BF-OUB': {
        code: 'BF-OUB',
        name: 'Oubritenga',
        parent: 'BF-11',
    },
    'BF-OUD': {
        code: 'BF-OUD',
        name: 'Oudalan',
        parent: 'BF-12',
    },
    'BF-PAS': {
        code: 'BF-PAS',
        name: 'Passoré',
        parent: 'BF-10',
    },
    'BF-PON': {
        code: 'BF-PON',
        name: 'Poni',
        parent: 'BF-13',
    },
    'BF-SEN': {
        code: 'BF-SEN',
        name: 'Séno',
        parent: 'BF-12',
    },
    'BF-SIS': {
        code: 'BF-SIS',
        name: 'Sissili',
        parent: 'BF-06',
    },
    'BF-SMT': {
        code: 'BF-SMT',
        name: 'Sanmatenga',
        parent: 'BF-05',
    },
    'BF-SNG': {
        code: 'BF-SNG',
        name: 'Sanguié',
        parent: 'BF-06',
    },
    'BF-SOM': {
        code: 'BF-SOM',
        name: 'Soum',
        parent: 'BF-12',
    },
    'BF-SOR': {
        code: 'BF-SOR',
        name: 'Sourou',
        parent: 'BF-01',
    },
    'BF-TAP': {
        code: 'BF-TAP',
        name: 'Tapoa',
        parent: 'BF-08',
    },
    'BF-TUI': {
        code: 'BF-TUI',
        name: 'Tuy',
        parent: 'BF-09',
    },
    'BF-YAG': {
        code: 'BF-YAG',
        name: 'Yagha',
        parent: 'BF-12',
    },
    'BF-YAT': {
        code: 'BF-YAT',
        name: 'Yatenga',
        parent: 'BF-10',
    },
    'BF-ZIR': {
        code: 'BF-ZIR',
        name: 'Ziro',
        parent: 'BF-06',
    },
    'BF-ZON': {
        code: 'BF-ZON',
        name: 'Zondoma',
        parent: 'BF-10',
    },
    'BF-ZOU': {
        code: 'BF-ZOU',
        name: 'Zoundwéogo',
        parent: 'BF-07',
    },
    'BG-01': {
        code: 'BG-01',
        name: 'Blagoevgrad',
        parent: 'BG',
    },
    'BG-02': {
        code: 'BG-02',
        name: 'Burgas',
        parent: 'BG',
    },
    'BG-03': {
        code: 'BG-03',
        name: 'Varna',
        parent: 'BG',
    },
    'BG-04': {
        code: 'BG-04',
        name: 'Veliko Tarnovo',
        parent: 'BG',
    },
    'BG-05': {
        code: 'BG-05',
        name: 'Vidin',
        parent: 'BG',
    },
    'BG-06': {
        code: 'BG-06',
        name: 'Vratsa',
        parent: 'BG',
    },
    'BG-07': {
        code: 'BG-07',
        name: 'Gabrovo',
        parent: 'BG',
    },
    'BG-08': {
        code: 'BG-08',
        name: 'Dobrich',
        parent: 'BG',
    },
    'BG-09': {
        code: 'BG-09',
        name: 'Kardzhali',
        parent: 'BG',
    },
    'BG-10': {
        code: 'BG-10',
        name: 'Kyustendil',
        parent: 'BG',
    },
    'BG-11': {
        code: 'BG-11',
        name: 'Lovech',
        parent: 'BG',
    },
    'BG-12': {
        code: 'BG-12',
        name: 'Montana',
        parent: 'BG',
    },
    'BG-13': {
        code: 'BG-13',
        name: 'Pazardzhik',
        parent: 'BG',
    },
    'BG-14': {
        code: 'BG-14',
        name: 'Pernik',
        parent: 'BG',
    },
    'BG-15': {
        code: 'BG-15',
        name: 'Pleven',
        parent: 'BG',
    },
    'BG-16': {
        code: 'BG-16',
        name: 'Plovdiv',
        parent: 'BG',
    },
    'BG-17': {
        code: 'BG-17',
        name: 'Razgrad',
        parent: 'BG',
    },
    'BG-18': {
        code: 'BG-18',
        name: 'Ruse',
        parent: 'BG',
    },
    'BG-19': {
        code: 'BG-19',
        name: 'Silistra',
        parent: 'BG',
    },
    'BG-20': {
        code: 'BG-20',
        name: 'Sliven',
        parent: 'BG',
    },
    'BG-21': {
        code: 'BG-21',
        name: 'Smolyan',
        parent: 'BG',
    },
    'BG-22': {
        code: 'BG-22',
        name: 'Sofia (stolitsa)',
        parent: 'BG',
    },
    'BG-23': {
        code: 'BG-23',
        name: 'Sofia',
        parent: 'BG',
    },
    'BG-24': {
        code: 'BG-24',
        name: 'Stara Zagora',
        parent: 'BG',
    },
    'BG-25': {
        code: 'BG-25',
        name: 'Targovishte',
        parent: 'BG',
    },
    'BG-26': {
        code: 'BG-26',
        name: 'Haskovo',
        parent: 'BG',
    },
    'BG-27': {
        code: 'BG-27',
        name: 'Shumen',
        parent: 'BG',
    },
    'BG-28': {
        code: 'BG-28',
        name: 'Yambol',
        parent: 'BG',
    },
    'BH-13': {
        code: 'BH-13',
        name: 'Al ‘Āşimah',
        parent: 'BH',
    },
    'BH-14': {
        code: 'BH-14',
        name: 'Al Janūbīyah',
        parent: 'BH',
    },
    'BH-15': {
        code: 'BH-15',
        name: 'Al Muḩarraq',
        parent: 'BH',
    },
    'BH-17': {
        code: 'BH-17',
        name: 'Ash Shamālīyah',
        parent: 'BH',
    },
    'BI-BB': {
        code: 'BI-BB',
        name: 'Bubanza',
        parent: 'BI',
    },
    'BI-BL': {
        code: 'BI-BL',
        name: 'Bujumbura Rural',
        parent: 'BI',
    },
    'BI-BM': {
        code: 'BI-BM',
        name: 'Bujumbura Mairie',
        parent: 'BI',
    },
    'BI-BR': {
        code: 'BI-BR',
        name: 'Bururi',
        parent: 'BI',
    },
    'BI-CA': {
        code: 'BI-CA',
        name: 'Cankuzo',
        parent: 'BI',
    },
    'BI-CI': {
        code: 'BI-CI',
        name: 'Cibitoke',
        parent: 'BI',
    },
    'BI-GI': {
        code: 'BI-GI',
        name: 'Gitega',
        parent: 'BI',
    },
    'BI-KI': {
        code: 'BI-KI',
        name: 'Kirundo',
        parent: 'BI',
    },
    'BI-KR': {
        code: 'BI-KR',
        name: 'Karuzi',
        parent: 'BI',
    },
    'BI-KY': {
        code: 'BI-KY',
        name: 'Kayanza',
        parent: 'BI',
    },
    'BI-MA': {
        code: 'BI-MA',
        name: 'Makamba',
        parent: 'BI',
    },
    'BI-MU': {
        code: 'BI-MU',
        name: 'Muramvya',
        parent: 'BI',
    },
    'BI-MW': {
        code: 'BI-MW',
        name: 'Mwaro',
        parent: 'BI',
    },
    'BI-MY': {
        code: 'BI-MY',
        name: 'Muyinga',
        parent: 'BI',
    },
    'BI-NG': {
        code: 'BI-NG',
        name: 'Ngozi',
        parent: 'BI',
    },
    'BI-RM': {
        code: 'BI-RM',
        name: 'Rumonge',
        parent: 'BI',
    },
    'BI-RT': {
        code: 'BI-RT',
        name: 'Rutana',
        parent: 'BI',
    },
    'BI-RY': {
        code: 'BI-RY',
        name: 'Ruyigi',
        parent: 'BI',
    },
    'BJ-AK': {
        code: 'BJ-AK',
        name: 'Atacora',
        parent: 'BJ',
    },
    'BJ-AL': {
        code: 'BJ-AL',
        name: 'Alibori',
        parent: 'BJ',
    },
    'BJ-AQ': {
        code: 'BJ-AQ',
        name: 'Atlantique',
        parent: 'BJ',
    },
    'BJ-BO': {
        code: 'BJ-BO',
        name: 'Borgou',
        parent: 'BJ',
    },
    'BJ-CO': {
        code: 'BJ-CO',
        name: 'Collines',
        parent: 'BJ',
    },
    'BJ-DO': {
        code: 'BJ-DO',
        name: 'Donga',
        parent: 'BJ',
    },
    'BJ-KO': {
        code: 'BJ-KO',
        name: 'Couffo',
        parent: 'BJ',
    },
    'BJ-LI': {
        code: 'BJ-LI',
        name: 'Littoral',
        parent: 'BJ',
    },
    'BJ-MO': {
        code: 'BJ-MO',
        name: 'Mono',
        parent: 'BJ',
    },
    'BJ-OU': {
        code: 'BJ-OU',
        name: 'Ouémé',
        parent: 'BJ',
    },
    'BJ-PL': {
        code: 'BJ-PL',
        name: 'Plateau',
        parent: 'BJ',
    },
    'BJ-ZO': {
        code: 'BJ-ZO',
        name: 'Zou',
        parent: 'BJ',
    },
    'BN-BE': {
        code: 'BN-BE',
        name: 'Belait',
        parent: 'BN',
    },
    'BN-BM': {
        code: 'BN-BM',
        name: 'Brunei-Muara',
        parent: 'BN',
    },
    'BN-TE': {
        code: 'BN-TE',
        name: 'Temburong',
        parent: 'BN',
    },
    'BN-TU': {
        code: 'BN-TU',
        name: 'Tutong',
        parent: 'BN',
    },
    'BO-B': {
        code: 'BO-B',
        name: 'El Beni',
        parent: 'BO',
    },
    'BO-C': {
        code: 'BO-C',
        name: 'Cochabamba',
        parent: 'BO',
    },
    'BO-H': {
        code: 'BO-H',
        name: 'Chuquisaca',
        parent: 'BO',
    },
    'BO-L': {
        code: 'BO-L',
        name: 'La Paz',
        parent: 'BO',
    },
    'BO-N': {
        code: 'BO-N',
        name: 'Pando',
        parent: 'BO',
    },
    'BO-O': {
        code: 'BO-O',
        name: 'Oruro',
        parent: 'BO',
    },
    'BO-P': {
        code: 'BO-P',
        name: 'Potosí',
        parent: 'BO',
    },
    'BO-S': {
        code: 'BO-S',
        name: 'Santa Cruz',
        parent: 'BO',
    },
    'BO-T': {
        code: 'BO-T',
        name: 'Tarija',
        parent: 'BO',
    },
    'BQ-BO': {
        code: 'BQ-BO',
        name: 'Bonaire',
        parent: 'BQ',
    },
    'BQ-SA': {
        code: 'BQ-SA',
        name: 'Saba',
        parent: 'BQ',
    },
    'BQ-SE': {
        code: 'BQ-SE',
        name: 'Sint Eustatius',
        parent: 'BQ',
    },
    'BR-AC': {
        code: 'BR-AC',
        name: 'Acre',
        parent: 'BR',
    },
    'BR-AL': {
        code: 'BR-AL',
        name: 'Alagoas',
        parent: 'BR',
    },
    'BR-AM': {
        code: 'BR-AM',
        name: 'Amazonas',
        parent: 'BR',
    },
    'BR-AP': {
        code: 'BR-AP',
        name: 'Amapá',
        parent: 'BR',
    },
    'BR-BA': {
        code: 'BR-BA',
        name: 'Bahia',
        parent: 'BR',
    },
    'BR-CE': {
        code: 'BR-CE',
        name: 'Ceará',
        parent: 'BR',
    },
    'BR-DF': {
        code: 'BR-DF',
        name: 'Distrito Federal',
        parent: 'BR',
    },
    'BR-ES': {
        code: 'BR-ES',
        name: 'Espírito Santo',
        parent: 'BR',
    },
    'BR-GO': {
        code: 'BR-GO',
        name: 'Goiás',
        parent: 'BR',
    },
    'BR-MA': {
        code: 'BR-MA',
        name: 'Maranhão',
        parent: 'BR',
    },
    'BR-MG': {
        code: 'BR-MG',
        name: 'Minas Gerais',
        parent: 'BR',
    },
    'BR-MS': {
        code: 'BR-MS',
        name: 'Mato Grosso do Sul',
        parent: 'BR',
    },
    'BR-MT': {
        code: 'BR-MT',
        name: 'Mato Grosso',
        parent: 'BR',
    },
    'BR-PA': {
        code: 'BR-PA',
        name: 'Pará',
        parent: 'BR',
    },
    'BR-PB': {
        code: 'BR-PB',
        name: 'Paraíba',
        parent: 'BR',
    },
    'BR-PE': {
        code: 'BR-PE',
        name: 'Pernambuco',
        parent: 'BR',
    },
    'BR-PI': {
        code: 'BR-PI',
        name: 'Piauí',
        parent: 'BR',
    },
    'BR-PR': {
        code: 'BR-PR',
        name: 'Paraná',
        parent: 'BR',
    },
    'BR-RJ': {
        code: 'BR-RJ',
        name: 'Rio de Janeiro',
        parent: 'BR',
    },
    'BR-RN': {
        code: 'BR-RN',
        name: 'Rio Grande do Norte',
        parent: 'BR',
    },
    'BR-RO': {
        code: 'BR-RO',
        name: 'Rondônia',
        parent: 'BR',
    },
    'BR-RR': {
        code: 'BR-RR',
        name: 'Roraima',
        parent: 'BR',
    },
    'BR-RS': {
        code: 'BR-RS',
        name: 'Rio Grande do Sul',
        parent: 'BR',
    },
    'BR-SC': {
        code: 'BR-SC',
        name: 'Santa Catarina',
        parent: 'BR',
    },
    'BR-SE': {
        code: 'BR-SE',
        name: 'Sergipe',
        parent: 'BR',
    },
    'BR-SP': {
        code: 'BR-SP',
        name: 'São Paulo',
        parent: 'BR',
    },
    'BR-TO': {
        code: 'BR-TO',
        name: 'Tocantins',
        parent: 'BR',
    },
    'BS-AK': {
        code: 'BS-AK',
        name: 'Acklins',
        parent: 'BS',
    },
    'BS-BI': {
        code: 'BS-BI',
        name: 'Bimini',
        parent: 'BS',
    },
    'BS-BP': {
        code: 'BS-BP',
        name: 'Black Point',
        parent: 'BS',
    },
    'BS-BY': {
        code: 'BS-BY',
        name: 'Berry Islands',
        parent: 'BS',
    },
    'BS-CE': {
        code: 'BS-CE',
        name: 'Central Eleuthera',
        parent: 'BS',
    },
    'BS-CI': {
        code: 'BS-CI',
        name: 'Cat Island',
        parent: 'BS',
    },
    'BS-CK': {
        code: 'BS-CK',
        name: 'Crooked Island and Long Cay',
        parent: 'BS',
    },
    'BS-CO': {
        code: 'BS-CO',
        name: 'Central Abaco',
        parent: 'BS',
    },
    'BS-CS': {
        code: 'BS-CS',
        name: 'Central Andros',
        parent: 'BS',
    },
    'BS-EG': {
        code: 'BS-EG',
        name: 'East Grand Bahama',
        parent: 'BS',
    },
    'BS-EX': {
        code: 'BS-EX',
        name: 'Exuma',
        parent: 'BS',
    },
    'BS-FP': {
        code: 'BS-FP',
        name: 'City of Freeport',
        parent: 'BS',
    },
    'BS-GC': {
        code: 'BS-GC',
        name: 'Grand Cay',
        parent: 'BS',
    },
    'BS-HI': {
        code: 'BS-HI',
        name: 'Harbour Island',
        parent: 'BS',
    },
    'BS-HT': {
        code: 'BS-HT',
        name: 'Hope Town',
        parent: 'BS',
    },
    'BS-IN': {
        code: 'BS-IN',
        name: 'Inagua',
        parent: 'BS',
    },
    'BS-LI': {
        code: 'BS-LI',
        name: 'Long Island',
        parent: 'BS',
    },
    'BS-MC': {
        code: 'BS-MC',
        name: 'Mangrove Cay',
        parent: 'BS',
    },
    'BS-MG': {
        code: 'BS-MG',
        name: 'Mayaguana',
        parent: 'BS',
    },
    'BS-MI': {
        code: 'BS-MI',
        name: "Moore's Island",
        parent: 'BS',
    },
    'BS-NE': {
        code: 'BS-NE',
        name: 'North Eleuthera',
        parent: 'BS',
    },
    'BS-NO': {
        code: 'BS-NO',
        name: 'North Abaco',
        parent: 'BS',
    },
    'BS-NP': {
        code: 'BS-NP',
        name: 'New Providence',
        parent: 'BS',
    },
    'BS-NS': {
        code: 'BS-NS',
        name: 'North Andros',
        parent: 'BS',
    },
    'BS-RC': {
        code: 'BS-RC',
        name: 'Rum Cay',
        parent: 'BS',
    },
    'BS-RI': {
        code: 'BS-RI',
        name: 'Ragged Island',
        parent: 'BS',
    },
    'BS-SA': {
        code: 'BS-SA',
        name: 'South Andros',
        parent: 'BS',
    },
    'BS-SE': {
        code: 'BS-SE',
        name: 'South Eleuthera',
        parent: 'BS',
    },
    'BS-SO': {
        code: 'BS-SO',
        name: 'South Abaco',
        parent: 'BS',
    },
    'BS-SS': {
        code: 'BS-SS',
        name: 'San Salvador',
        parent: 'BS',
    },
    'BS-SW': {
        code: 'BS-SW',
        name: 'Spanish Wells',
        parent: 'BS',
    },
    'BS-WG': {
        code: 'BS-WG',
        name: 'West Grand Bahama',
        parent: 'BS',
    },
    'BT-11': {
        code: 'BT-11',
        name: 'Paro',
        parent: 'BT',
    },
    'BT-12': {
        code: 'BT-12',
        name: 'Chhukha',
        parent: 'BT',
    },
    'BT-13': {
        code: 'BT-13',
        name: 'Haa',
        parent: 'BT',
    },
    'BT-14': {
        code: 'BT-14',
        name: 'Samtse',
        parent: 'BT',
    },
    'BT-15': {
        code: 'BT-15',
        name: 'Thimphu',
        parent: 'BT',
    },
    'BT-21': {
        code: 'BT-21',
        name: 'Tsirang',
        parent: 'BT',
    },
    'BT-22': {
        code: 'BT-22',
        name: 'Dagana',
        parent: 'BT',
    },
    'BT-23': {
        code: 'BT-23',
        name: 'Punakha',
        parent: 'BT',
    },
    'BT-24': {
        code: 'BT-24',
        name: 'Wangdue Phodrang',
        parent: 'BT',
    },
    'BT-31': {
        code: 'BT-31',
        name: 'Sarpang',
        parent: 'BT',
    },
    'BT-32': {
        code: 'BT-32',
        name: 'Trongsa',
        parent: 'BT',
    },
    'BT-33': {
        code: 'BT-33',
        name: 'Bumthang',
        parent: 'BT',
    },
    'BT-34': {
        code: 'BT-34',
        name: 'Zhemgang',
        parent: 'BT',
    },
    'BT-41': {
        code: 'BT-41',
        name: 'Trashigang',
        parent: 'BT',
    },
    'BT-42': {
        code: 'BT-42',
        name: 'Monggar',
        parent: 'BT',
    },
    'BT-43': {
        code: 'BT-43',
        name: 'Pema Gatshel',
        parent: 'BT',
    },
    'BT-44': {
        code: 'BT-44',
        name: 'Lhuentse',
        parent: 'BT',
    },
    'BT-45': {
        code: 'BT-45',
        name: 'Samdrup Jongkhar',
        parent: 'BT',
    },
    'BT-GA': {
        code: 'BT-GA',
        name: 'Gasa',
        parent: 'BT',
    },
    'BT-TY': {
        code: 'BT-TY',
        name: 'Trashi Yangtse',
        parent: 'BT',
    },
    'BW-CE': {
        code: 'BW-CE',
        name: 'Central',
        parent: 'BW',
    },
    'BW-CH': {
        code: 'BW-CH',
        name: 'Chobe',
        parent: 'BW',
    },
    'BW-FR': {
        code: 'BW-FR',
        name: 'Francistown',
        parent: 'BW',
    },
    'BW-GA': {
        code: 'BW-GA',
        name: 'Gaborone',
        parent: 'BW',
    },
    'BW-GH': {
        code: 'BW-GH',
        name: 'Ghanzi',
        parent: 'BW',
    },
    'BW-JW': {
        code: 'BW-JW',
        name: 'Jwaneng',
        parent: 'BW',
    },
    'BW-KG': {
        code: 'BW-KG',
        name: 'Kgalagadi',
        parent: 'BW',
    },
    'BW-KL': {
        code: 'BW-KL',
        name: 'Kgatleng',
        parent: 'BW',
    },
    'BW-KW': {
        code: 'BW-KW',
        name: 'Kweneng',
        parent: 'BW',
    },
    'BW-LO': {
        code: 'BW-LO',
        name: 'Lobatse',
        parent: 'BW',
    },
    'BW-NE': {
        code: 'BW-NE',
        name: 'North East',
        parent: 'BW',
    },
    'BW-NW': {
        code: 'BW-NW',
        name: 'North West',
        parent: 'BW',
    },
    'BW-SE': {
        code: 'BW-SE',
        name: 'South East',
        parent: 'BW',
    },
    'BW-SO': {
        code: 'BW-SO',
        name: 'Southern',
        parent: 'BW',
    },
    'BW-SP': {
        code: 'BW-SP',
        name: 'Selibe Phikwe',
        parent: 'BW',
    },
    'BW-ST': {
        code: 'BW-ST',
        name: 'Sowa Town',
        parent: 'BW',
    },
    'BY-BR': {
        code: 'BY-BR',
        name: "Brestskaya voblasts'",
        parent: 'BY',
    },
    'BY-HM': {
        code: 'BY-HM',
        name: 'Horad Minsk',
        parent: 'BY',
    },
    'BY-HO': {
        code: 'BY-HO',
        name: "Homyel'skaya voblasts'",
        parent: 'BY',
    },
    'BY-HR': {
        code: 'BY-HR',
        name: "Hrodzyenskaya voblasts'",
        parent: 'BY',
    },
    'BY-MA': {
        code: 'BY-MA',
        name: "Mahilyowskaya voblasts'",
        parent: 'BY',
    },
    'BY-MI': {
        code: 'BY-MI',
        name: "Minskaya voblasts'",
        parent: 'BY',
    },
    'BY-VI': {
        code: 'BY-VI',
        name: "Vitsyebskaya voblasts'",
        parent: 'BY',
    },
    'BZ-BZ': {
        code: 'BZ-BZ',
        name: 'Belize',
        parent: 'BZ',
    },
    'BZ-CY': {
        code: 'BZ-CY',
        name: 'Cayo',
        parent: 'BZ',
    },
    'BZ-CZL': {
        code: 'BZ-CZL',
        name: 'Corozal',
        parent: 'BZ',
    },
    'BZ-OW': {
        code: 'BZ-OW',
        name: 'Orange Walk',
        parent: 'BZ',
    },
    'BZ-SC': {
        code: 'BZ-SC',
        name: 'Stann Creek',
        parent: 'BZ',
    },
    'BZ-TOL': {
        code: 'BZ-TOL',
        name: 'Toledo',
        parent: 'BZ',
    },
    'CA-AB': {
        code: 'CA-AB',
        name: 'Alberta',
        parent: 'CA',
    },
    'CA-BC': {
        code: 'CA-BC',
        name: 'British Columbia',
        parent: 'CA',
    },
    'CA-MB': {
        code: 'CA-MB',
        name: 'Manitoba',
        parent: 'CA',
    },
    'CA-NB': {
        code: 'CA-NB',
        name: 'New Brunswick',
        parent: 'CA',
    },
    'CA-NL': {
        code: 'CA-NL',
        name: 'Newfoundland and Labrador',
        parent: 'CA',
    },
    'CA-NS': {
        code: 'CA-NS',
        name: 'Nova Scotia',
        parent: 'CA',
    },
    'CA-NT': {
        code: 'CA-NT',
        name: 'Northwest Territories',
        parent: 'CA',
    },
    'CA-NU': {
        code: 'CA-NU',
        name: 'Nunavut',
        parent: 'CA',
    },
    'CA-ON': {
        code: 'CA-ON',
        name: 'Ontario',
        parent: 'CA',
    },
    'CA-PE': {
        code: 'CA-PE',
        name: 'Prince Edward Island',
        parent: 'CA',
    },
    'CA-QC': {
        code: 'CA-QC',
        name: 'Quebec',
        parent: 'CA',
    },
    'CA-SK': {
        code: 'CA-SK',
        name: 'Saskatchewan',
        parent: 'CA',
    },
    'CA-YT': {
        code: 'CA-YT',
        name: 'Yukon',
        parent: 'CA',
    },
    'CD-BC': {
        code: 'CD-BC',
        name: 'Kongo Central',
        parent: 'CD',
    },
    'CD-BU': {
        code: 'CD-BU',
        name: 'Bas-Uélé',
        parent: 'CD',
    },
    'CD-EQ': {
        code: 'CD-EQ',
        name: 'Équateur',
        parent: 'CD',
    },
    'CD-HK': {
        code: 'CD-HK',
        name: 'Haut-Katanga',
        parent: 'CD',
    },
    'CD-HL': {
        code: 'CD-HL',
        name: 'Haut-Lomami',
        parent: 'CD',
    },
    'CD-HU': {
        code: 'CD-HU',
        name: 'Haut-Uélé',
        parent: 'CD',
    },
    'CD-IT': {
        code: 'CD-IT',
        name: 'Ituri',
        parent: 'CD',
    },
    'CD-KC': {
        code: 'CD-KC',
        name: 'Kasaï Central',
        parent: 'CD',
    },
    'CD-KE': {
        code: 'CD-KE',
        name: 'Kasaï Oriental',
        parent: 'CD',
    },
    'CD-KG': {
        code: 'CD-KG',
        name: 'Kwango',
        parent: 'CD',
    },
    'CD-KL': {
        code: 'CD-KL',
        name: 'Kwilu',
        parent: 'CD',
    },
    'CD-KN': {
        code: 'CD-KN',
        name: 'Kinshasa',
        parent: 'CD',
    },
    'CD-KS': {
        code: 'CD-KS',
        name: 'Kasaï',
        parent: 'CD',
    },
    'CD-LO': {
        code: 'CD-LO',
        name: 'Lomami',
        parent: 'CD',
    },
    'CD-LU': {
        code: 'CD-LU',
        name: 'Lualaba',
        parent: 'CD',
    },
    'CD-MA': {
        code: 'CD-MA',
        name: 'Maniema',
        parent: 'CD',
    },
    'CD-MN': {
        code: 'CD-MN',
        name: 'Mai-Ndombe',
        parent: 'CD',
    },
    'CD-MO': {
        code: 'CD-MO',
        name: 'Mongala',
        parent: 'CD',
    },
    'CD-NK': {
        code: 'CD-NK',
        name: 'Nord-Kivu',
        parent: 'CD',
    },
    'CD-NU': {
        code: 'CD-NU',
        name: 'Nord-Ubangi',
        parent: 'CD',
    },
    'CD-SA': {
        code: 'CD-SA',
        name: 'Sankuru',
        parent: 'CD',
    },
    'CD-SK': {
        code: 'CD-SK',
        name: 'Sud-Kivu',
        parent: 'CD',
    },
    'CD-SU': {
        code: 'CD-SU',
        name: 'Sud-Ubangi',
        parent: 'CD',
    },
    'CD-TA': {
        code: 'CD-TA',
        name: 'Tanganyika',
        parent: 'CD',
    },
    'CD-TO': {
        code: 'CD-TO',
        name: 'Tshopo',
        parent: 'CD',
    },
    'CD-TU': {
        code: 'CD-TU',
        name: 'Tshuapa',
        parent: 'CD',
    },
    'CF-AC': {
        code: 'CF-AC',
        name: 'Ouham',
        parent: 'CF',
    },
    'CF-BB': {
        code: 'CF-BB',
        name: 'Bamingui-Bangoran',
        parent: 'CF',
    },
    'CF-BGF': {
        code: 'CF-BGF',
        name: 'Bangui',
        parent: 'CF',
    },
    'CF-BK': {
        code: 'CF-BK',
        name: 'Basse-Kotto',
        parent: 'CF',
    },
    'CF-HK': {
        code: 'CF-HK',
        name: 'Haute-Kotto',
        parent: 'CF',
    },
    'CF-HM': {
        code: 'CF-HM',
        name: 'Haut-Mbomou',
        parent: 'CF',
    },
    'CF-HS': {
        code: 'CF-HS',
        name: 'Haute-Sangha/Mambéré-Kadéï',
        parent: 'CF',
    },
    'CF-KB': {
        code: 'CF-KB',
        name: 'Gribingui',
        parent: 'CF',
    },
    'CF-KG': {
        code: 'CF-KG',
        name: 'Kémo-Gribingui',
        parent: 'CF',
    },
    'CF-LB': {
        code: 'CF-LB',
        name: 'Lobaye',
        parent: 'CF',
    },
    'CF-MB': {
        code: 'CF-MB',
        name: 'Mbomou',
        parent: 'CF',
    },
    'CF-MP': {
        code: 'CF-MP',
        name: 'Ombella-Mpoko',
        parent: 'CF',
    },
    'CF-NM': {
        code: 'CF-NM',
        name: 'Nana-Mambéré',
        parent: 'CF',
    },
    'CF-OP': {
        code: 'CF-OP',
        name: 'Ouham-Pendé',
        parent: 'CF',
    },
    'CF-SE': {
        code: 'CF-SE',
        name: 'Sangha',
        parent: 'CF',
    },
    'CF-UK': {
        code: 'CF-UK',
        name: 'Ouaka',
        parent: 'CF',
    },
    'CF-VK': {
        code: 'CF-VK',
        name: 'Vakaga',
        parent: 'CF',
    },
    'CG-11': {
        code: 'CG-11',
        name: 'Bouenza',
        parent: 'CG',
    },
    'CG-12': {
        code: 'CG-12',
        name: 'Pool',
        parent: 'CG',
    },
    'CG-13': {
        code: 'CG-13',
        name: 'Sangha',
        parent: 'CG',
    },
    'CG-14': {
        code: 'CG-14',
        name: 'Plateaux',
        parent: 'CG',
    },
    'CG-15': {
        code: 'CG-15',
        name: 'Cuvette-Ouest',
        parent: 'CG',
    },
    'CG-16': {
        code: 'CG-16',
        name: 'Pointe-Noire',
        parent: 'CG',
    },
    'CG-2': {
        code: 'CG-2',
        name: 'Lékoumou',
        parent: 'CG',
    },
    'CG-5': {
        code: 'CG-5',
        name: 'Kouilou',
        parent: 'CG',
    },
    'CG-7': {
        code: 'CG-7',
        name: 'Likouala',
        parent: 'CG',
    },
    'CG-8': {
        code: 'CG-8',
        name: 'Cuvette',
        parent: 'CG',
    },
    'CG-9': {
        code: 'CG-9',
        name: 'Niari',
        parent: 'CG',
    },
    'CG-BZV': {
        code: 'CG-BZV',
        name: 'Brazzaville',
        parent: 'CG',
    },
    'CH-AG': {
        code: 'CH-AG',
        name: 'Aargau',
        parent: 'CH',
    },
    'CH-AI': {
        code: 'CH-AI',
        name: 'Appenzell Innerrhoden',
        parent: 'CH',
    },
    'CH-AR': {
        code: 'CH-AR',
        name: 'Appenzell Ausserrhoden',
        parent: 'CH',
    },
    'CH-BE': {
        code: 'CH-BE',
        name: 'Bern',
        parent: 'CH',
    },
    'CH-BL': {
        code: 'CH-BL',
        name: 'Basel-Landschaft',
        parent: 'CH',
    },
    'CH-BS': {
        code: 'CH-BS',
        name: 'Basel-Stadt',
        parent: 'CH',
    },
    'CH-FR': {
        code: 'CH-FR',
        name: 'Fribourg',
        parent: 'CH',
    },
    'CH-GE': {
        code: 'CH-GE',
        name: 'Genève',
        parent: 'CH',
    },
    'CH-GL': {
        code: 'CH-GL',
        name: 'Glarus',
        parent: 'CH',
    },
    'CH-GR': {
        code: 'CH-GR',
        name: 'Graubünden',
        parent: 'CH',
    },
    'CH-JU': {
        code: 'CH-JU',
        name: 'Jura',
        parent: 'CH',
    },
    'CH-LU': {
        code: 'CH-LU',
        name: 'Luzern',
        parent: 'CH',
    },
    'CH-NE': {
        code: 'CH-NE',
        name: 'Neuchâtel',
        parent: 'CH',
    },
    'CH-NW': {
        code: 'CH-NW',
        name: 'Nidwalden',
        parent: 'CH',
    },
    'CH-OW': {
        code: 'CH-OW',
        name: 'Obwalden',
        parent: 'CH',
    },
    'CH-SG': {
        code: 'CH-SG',
        name: 'Sankt Gallen',
        parent: 'CH',
    },
    'CH-SH': {
        code: 'CH-SH',
        name: 'Schaffhausen',
        parent: 'CH',
    },
    'CH-SO': {
        code: 'CH-SO',
        name: 'Solothurn',
        parent: 'CH',
    },
    'CH-SZ': {
        code: 'CH-SZ',
        name: 'Schwyz',
        parent: 'CH',
    },
    'CH-TG': {
        code: 'CH-TG',
        name: 'Thurgau',
        parent: 'CH',
    },
    'CH-TI': {
        code: 'CH-TI',
        name: 'Ticino',
        parent: 'CH',
    },
    'CH-UR': {
        code: 'CH-UR',
        name: 'Uri',
        parent: 'CH',
    },
    'CH-VD': {
        code: 'CH-VD',
        name: 'Vaud',
        parent: 'CH',
    },
    'CH-VS': {
        code: 'CH-VS',
        name: 'Valais',
        parent: 'CH',
    },
    'CH-ZG': {
        code: 'CH-ZG',
        name: 'Zug',
        parent: 'CH',
    },
    'CH-ZH': {
        code: 'CH-ZH',
        name: 'Zürich',
        parent: 'CH',
    },
    'CI-AB': {
        code: 'CI-AB',
        name: 'Abidjan',
        parent: 'CI',
    },
    'CI-BS': {
        code: 'CI-BS',
        name: 'Bas-Sassandra',
        parent: 'CI',
    },
    'CI-CM': {
        code: 'CI-CM',
        name: 'Comoé',
        parent: 'CI',
    },
    'CI-DN': {
        code: 'CI-DN',
        name: 'Denguélé',
        parent: 'CI',
    },
    'CI-GD': {
        code: 'CI-GD',
        name: 'Gôh-Djiboua',
        parent: 'CI',
    },
    'CI-LC': {
        code: 'CI-LC',
        name: 'Lacs',
        parent: 'CI',
    },
    'CI-LG': {
        code: 'CI-LG',
        name: 'Lagunes',
        parent: 'CI',
    },
    'CI-MG': {
        code: 'CI-MG',
        name: 'Montagnes',
        parent: 'CI',
    },
    'CI-SM': {
        code: 'CI-SM',
        name: 'Sassandra-Marahoué',
        parent: 'CI',
    },
    'CI-SV': {
        code: 'CI-SV',
        name: 'Savanes',
        parent: 'CI',
    },
    'CI-VB': {
        code: 'CI-VB',
        name: 'Vallée du Bandama',
        parent: 'CI',
    },
    'CI-WR': {
        code: 'CI-WR',
        name: 'Woroba',
        parent: 'CI',
    },
    'CI-YM': {
        code: 'CI-YM',
        name: 'Yamoussoukro',
        parent: 'CI',
    },
    'CI-ZZ': {
        code: 'CI-ZZ',
        name: 'Zanzan',
        parent: 'CI',
    },
    'CL-AI': {
        code: 'CL-AI',
        name: 'Aisén del General Carlos Ibañez del Campo',
        parent: 'CL',
    },
    'CL-AN': {
        code: 'CL-AN',
        name: 'Antofagasta',
        parent: 'CL',
    },
    'CL-AP': {
        code: 'CL-AP',
        name: 'Arica y Parinacota',
        parent: 'CL',
    },
    'CL-AR': {
        code: 'CL-AR',
        name: 'La Araucanía',
        parent: 'CL',
    },
    'CL-AT': {
        code: 'CL-AT',
        name: 'Atacama',
        parent: 'CL',
    },
    'CL-BI': {
        code: 'CL-BI',
        name: 'Biobío',
        parent: 'CL',
    },
    'CL-CO': {
        code: 'CL-CO',
        name: 'Coquimbo',
        parent: 'CL',
    },
    'CL-LI': {
        code: 'CL-LI',
        name: "Libertador General Bernardo O'Higgins",
        parent: 'CL',
    },
    'CL-LL': {
        code: 'CL-LL',
        name: 'Los Lagos',
        parent: 'CL',
    },
    'CL-LR': {
        code: 'CL-LR',
        name: 'Los Ríos',
        parent: 'CL',
    },
    'CL-MA': {
        code: 'CL-MA',
        name: 'Magallanes',
        parent: 'CL',
    },
    'CL-ML': {
        code: 'CL-ML',
        name: 'Maule',
        parent: 'CL',
    },
    'CL-NB': {
        code: 'CL-NB',
        name: 'Ñuble',
        parent: 'CL',
    },
    'CL-RM': {
        code: 'CL-RM',
        name: 'Región Metropolitana de Santiago',
        parent: 'CL',
    },
    'CL-TA': {
        code: 'CL-TA',
        name: 'Tarapacá',
        parent: 'CL',
    },
    'CL-VS': {
        code: 'CL-VS',
        name: 'Valparaíso',
        parent: 'CL',
    },
    'CM-AD': {
        code: 'CM-AD',
        name: 'Adamaoua',
        parent: 'CM',
    },
    'CM-CE': {
        code: 'CM-CE',
        name: 'Centre',
        parent: 'CM',
    },
    'CM-EN': {
        code: 'CM-EN',
        name: 'Far North',
        parent: 'CM',
    },
    'CM-ES': {
        code: 'CM-ES',
        name: 'East',
        parent: 'CM',
    },
    'CM-LT': {
        code: 'CM-LT',
        name: 'Littoral',
        parent: 'CM',
    },
    'CM-NO': {
        code: 'CM-NO',
        name: 'North',
        parent: 'CM',
    },
    'CM-NW': {
        code: 'CM-NW',
        name: 'North-West',
        parent: 'CM',
    },
    'CM-OU': {
        code: 'CM-OU',
        name: 'West',
        parent: 'CM',
    },
    'CM-SU': {
        code: 'CM-SU',
        name: 'South',
        parent: 'CM',
    },
    'CM-SW': {
        code: 'CM-SW',
        name: 'South-West',
        parent: 'CM',
    },
    'CN-AH': {
        code: 'CN-AH',
        name: 'Anhui Sheng',
        parent: 'CN',
    },
    'CN-BJ': {
        code: 'CN-BJ',
        name: 'Beijing Shi',
        parent: 'CN',
    },
    'CN-CQ': {
        code: 'CN-CQ',
        name: 'Chongqing Shi',
        parent: 'CN',
    },
    'CN-FJ': {
        code: 'CN-FJ',
        name: 'Fujian Sheng',
        parent: 'CN',
    },
    'CN-GD': {
        code: 'CN-GD',
        name: 'Guangdong Sheng',
        parent: 'CN',
    },
    'CN-GS': {
        code: 'CN-GS',
        name: 'Gansu Sheng',
        parent: 'CN',
    },
    'CN-GX': {
        code: 'CN-GX',
        name: 'Guangxi Zhuangzu Zizhiqu',
        parent: 'CN',
    },
    'CN-GZ': {
        code: 'CN-GZ',
        name: 'Guizhou Sheng',
        parent: 'CN',
    },
    'CN-HA': {
        code: 'CN-HA',
        name: 'Henan Sheng',
        parent: 'CN',
    },
    'CN-HB': {
        code: 'CN-HB',
        name: 'Hubei Sheng',
        parent: 'CN',
    },
    'CN-HE': {
        code: 'CN-HE',
        name: 'Hebei Sheng',
        parent: 'CN',
    },
    'CN-HI': {
        code: 'CN-HI',
        name: 'Hainan Sheng',
        parent: 'CN',
    },
    'CN-HK': {
        code: 'CN-HK',
        name: 'Hong Kong SAR',
        parent: 'CN',
    },
    'CN-HL': {
        code: 'CN-HL',
        name: 'Heilongjiang Sheng',
        parent: 'CN',
    },
    'CN-HN': {
        code: 'CN-HN',
        name: 'Hunan Sheng',
        parent: 'CN',
    },
    'CN-JL': {
        code: 'CN-JL',
        name: 'Jilin Sheng',
        parent: 'CN',
    },
    'CN-JS': {
        code: 'CN-JS',
        name: 'Jiangsu Sheng',
        parent: 'CN',
    },
    'CN-JX': {
        code: 'CN-JX',
        name: 'Jiangxi Sheng',
        parent: 'CN',
    },
    'CN-LN': {
        code: 'CN-LN',
        name: 'Liaoning Sheng',
        parent: 'CN',
    },
    'CN-MO': {
        code: 'CN-MO',
        name: 'Macao SAR',
        parent: 'CN',
    },
    'CN-NM': {
        code: 'CN-NM',
        name: 'Nei Mongol Zizhiqu',
        parent: 'CN',
    },
    'CN-NX': {
        code: 'CN-NX',
        name: 'Ningxia Huizi Zizhiqu',
        parent: 'CN',
    },
    'CN-QH': {
        code: 'CN-QH',
        name: 'Qinghai Sheng',
        parent: 'CN',
    },
    'CN-SC': {
        code: 'CN-SC',
        name: 'Sichuan Sheng',
        parent: 'CN',
    },
    'CN-SD': {
        code: 'CN-SD',
        name: 'Shandong Sheng',
        parent: 'CN',
    },
    'CN-SH': {
        code: 'CN-SH',
        name: 'Shanghai Shi',
        parent: 'CN',
    },
    'CN-SN': {
        code: 'CN-SN',
        name: 'Shaanxi Sheng',
        parent: 'CN',
    },
    'CN-SX': {
        code: 'CN-SX',
        name: 'Shanxi Sheng',
        parent: 'CN',
    },
    'CN-TJ': {
        code: 'CN-TJ',
        name: 'Tianjin Shi',
        parent: 'CN',
    },
    'CN-TW': {
        code: 'CN-TW',
        name: 'Taiwan Sheng',
        parent: 'CN',
    },
    'CN-XJ': {
        code: 'CN-XJ',
        name: 'Xinjiang Uygur Zizhiqu',
        parent: 'CN',
    },
    'CN-XZ': {
        code: 'CN-XZ',
        name: 'Xizang Zizhiqu',
        parent: 'CN',
    },
    'CN-YN': {
        code: 'CN-YN',
        name: 'Yunnan Sheng',
        parent: 'CN',
    },
    'CN-ZJ': {
        code: 'CN-ZJ',
        name: 'Zhejiang Sheng',
        parent: 'CN',
    },
    'CO-AMA': {
        code: 'CO-AMA',
        name: 'Amazonas',
        parent: 'CO',
    },
    'CO-ANT': {
        code: 'CO-ANT',
        name: 'Antioquia',
        parent: 'CO',
    },
    'CO-ARA': {
        code: 'CO-ARA',
        name: 'Arauca',
        parent: 'CO',
    },
    'CO-ATL': {
        code: 'CO-ATL',
        name: 'Atlántico',
        parent: 'CO',
    },
    'CO-BOL': {
        code: 'CO-BOL',
        name: 'Bolívar',
        parent: 'CO',
    },
    'CO-BOY': {
        code: 'CO-BOY',
        name: 'Boyacá',
        parent: 'CO',
    },
    'CO-CAL': {
        code: 'CO-CAL',
        name: 'Caldas',
        parent: 'CO',
    },
    'CO-CAQ': {
        code: 'CO-CAQ',
        name: 'Caquetá',
        parent: 'CO',
    },
    'CO-CAS': {
        code: 'CO-CAS',
        name: 'Casanare',
        parent: 'CO',
    },
    'CO-CAU': {
        code: 'CO-CAU',
        name: 'Cauca',
        parent: 'CO',
    },
    'CO-CES': {
        code: 'CO-CES',
        name: 'Cesar',
        parent: 'CO',
    },
    'CO-CHO': {
        code: 'CO-CHO',
        name: 'Chocó',
        parent: 'CO',
    },
    'CO-COR': {
        code: 'CO-COR',
        name: 'Córdoba',
        parent: 'CO',
    },
    'CO-CUN': {
        code: 'CO-CUN',
        name: 'Cundinamarca',
        parent: 'CO',
    },
    'CO-DC': {
        code: 'CO-DC',
        name: 'Distrito Capital de Bogotá',
        parent: 'CO',
    },
    'CO-GUA': {
        code: 'CO-GUA',
        name: 'Guainía',
        parent: 'CO',
    },
    'CO-GUV': {
        code: 'CO-GUV',
        name: 'Guaviare',
        parent: 'CO',
    },
    'CO-HUI': {
        code: 'CO-HUI',
        name: 'Huila',
        parent: 'CO',
    },
    'CO-LAG': {
        code: 'CO-LAG',
        name: 'La Guajira',
        parent: 'CO',
    },
    'CO-MAG': {
        code: 'CO-MAG',
        name: 'Magdalena',
        parent: 'CO',
    },
    'CO-MET': {
        code: 'CO-MET',
        name: 'Meta',
        parent: 'CO',
    },
    'CO-NAR': {
        code: 'CO-NAR',
        name: 'Nariño',
        parent: 'CO',
    },
    'CO-NSA': {
        code: 'CO-NSA',
        name: 'Norte de Santander',
        parent: 'CO',
    },
    'CO-PUT': {
        code: 'CO-PUT',
        name: 'Putumayo',
        parent: 'CO',
    },
    'CO-QUI': {
        code: 'CO-QUI',
        name: 'Quindío',
        parent: 'CO',
    },
    'CO-RIS': {
        code: 'CO-RIS',
        name: 'Risaralda',
        parent: 'CO',
    },
    'CO-SAN': {
        code: 'CO-SAN',
        name: 'Santander',
        parent: 'CO',
    },
    'CO-SAP': {
        code: 'CO-SAP',
        name: 'San Andrés, Providencia y Santa Catalina',
        parent: 'CO',
    },
    'CO-SUC': {
        code: 'CO-SUC',
        name: 'Sucre',
        parent: 'CO',
    },
    'CO-TOL': {
        code: 'CO-TOL',
        name: 'Tolima',
        parent: 'CO',
    },
    'CO-VAC': {
        code: 'CO-VAC',
        name: 'Valle del Cauca',
        parent: 'CO',
    },
    'CO-VAU': {
        code: 'CO-VAU',
        name: 'Vaupés',
        parent: 'CO',
    },
    'CO-VID': {
        code: 'CO-VID',
        name: 'Vichada',
        parent: 'CO',
    },
    'CR-A': {
        code: 'CR-A',
        name: 'Alajuela',
        parent: 'CR',
    },
    'CR-C': {
        code: 'CR-C',
        name: 'Cartago',
        parent: 'CR',
    },
    'CR-G': {
        code: 'CR-G',
        name: 'Guanacaste',
        parent: 'CR',
    },
    'CR-H': {
        code: 'CR-H',
        name: 'Heredia',
        parent: 'CR',
    },
    'CR-L': {
        code: 'CR-L',
        name: 'Limón',
        parent: 'CR',
    },
    'CR-P': {
        code: 'CR-P',
        name: 'Puntarenas',
        parent: 'CR',
    },
    'CR-SJ': {
        code: 'CR-SJ',
        name: 'San José',
        parent: 'CR',
    },
    'CU-01': {
        code: 'CU-01',
        name: 'Pinar del Río',
        parent: 'CU',
    },
    'CU-03': {
        code: 'CU-03',
        name: 'La Habana',
        parent: 'CU',
    },
    'CU-04': {
        code: 'CU-04',
        name: 'Matanzas',
        parent: 'CU',
    },
    'CU-05': {
        code: 'CU-05',
        name: 'Villa Clara',
        parent: 'CU',
    },
    'CU-06': {
        code: 'CU-06',
        name: 'Cienfuegos',
        parent: 'CU',
    },
    'CU-07': {
        code: 'CU-07',
        name: 'Sancti Spíritus',
        parent: 'CU',
    },
    'CU-08': {
        code: 'CU-08',
        name: 'Ciego de Ávila',
        parent: 'CU',
    },
    'CU-09': {
        code: 'CU-09',
        name: 'Camagüey',
        parent: 'CU',
    },
    'CU-10': {
        code: 'CU-10',
        name: 'Las Tunas',
        parent: 'CU',
    },
    'CU-11': {
        code: 'CU-11',
        name: 'Holguín',
        parent: 'CU',
    },
    'CU-12': {
        code: 'CU-12',
        name: 'Granma',
        parent: 'CU',
    },
    'CU-13': {
        code: 'CU-13',
        name: 'Santiago de Cuba',
        parent: 'CU',
    },
    'CU-14': {
        code: 'CU-14',
        name: 'Guantánamo',
        parent: 'CU',
    },
    'CU-15': {
        code: 'CU-15',
        name: 'Artemisa',
        parent: 'CU',
    },
    'CU-16': {
        code: 'CU-16',
        name: 'Mayabeque',
        parent: 'CU',
    },
    'CU-99': {
        code: 'CU-99',
        name: 'Isla de la Juventud',
        parent: 'CU',
    },
    'CV-B': {
        code: 'CV-B',
        name: 'Ilhas de Barlavento',
        parent: 'CV',
    },
    'CV-BR': {
        code: 'CV-BR',
        name: 'Brava',
        parent: 'CV-S',
    },
    'CV-BV': {
        code: 'CV-BV',
        name: 'Boa Vista',
        parent: 'CV-B',
    },
    'CV-CA': {
        code: 'CV-CA',
        name: 'Santa Catarina',
        parent: 'CV-S',
    },
    'CV-CF': {
        code: 'CV-CF',
        name: 'Santa Catarina do Fogo',
        parent: 'CV-S',
    },
    'CV-CR': {
        code: 'CV-CR',
        name: 'Santa Cruz',
        parent: 'CV-S',
    },
    'CV-MA': {
        code: 'CV-MA',
        name: 'Maio',
        parent: 'CV-S',
    },
    'CV-MO': {
        code: 'CV-MO',
        name: 'Mosteiros',
        parent: 'CV-S',
    },
    'CV-PA': {
        code: 'CV-PA',
        name: 'Paul',
        parent: 'CV-B',
    },
    'CV-PN': {
        code: 'CV-PN',
        name: 'Porto Novo',
        parent: 'CV-B',
    },
    'CV-PR': {
        code: 'CV-PR',
        name: 'Praia',
        parent: 'CV-S',
    },
    'CV-RB': {
        code: 'CV-RB',
        name: 'Ribeira Brava',
        parent: 'CV-B',
    },
    'CV-RG': {
        code: 'CV-RG',
        name: 'Ribeira Grande',
        parent: 'CV-B',
    },
    'CV-RS': {
        code: 'CV-RS',
        name: 'Ribeira Grande de Santiago',
        parent: 'CV-S',
    },
    'CV-S': {
        code: 'CV-S',
        name: 'Ilhas de Sotavento',
        parent: 'CV',
    },
    'CV-SD': {
        code: 'CV-SD',
        name: 'São Domingos',
        parent: 'CV-S',
    },
    'CV-SF': {
        code: 'CV-SF',
        name: 'São Filipe',
        parent: 'CV-S',
    },
    'CV-SL': {
        code: 'CV-SL',
        name: 'Sal',
        parent: 'CV-B',
    },
    'CV-SM': {
        code: 'CV-SM',
        name: 'São Miguel',
        parent: 'CV-S',
    },
    'CV-SO': {
        code: 'CV-SO',
        name: 'São Lourenço dos Órgãos',
        parent: 'CV-S',
    },
    'CV-SS': {
        code: 'CV-SS',
        name: 'São Salvador do Mundo',
        parent: 'CV-S',
    },
    'CV-SV': {
        code: 'CV-SV',
        name: 'São Vicente',
        parent: 'CV-B',
    },
    'CV-TA': {
        code: 'CV-TA',
        name: 'Tarrafal',
        parent: 'CV-S',
    },
    'CV-TS': {
        code: 'CV-TS',
        name: 'Tarrafal de São Nicolau',
        parent: 'CV-B',
    },
    'CY-01': {
        code: 'CY-01',
        name: 'Lefkosia',
        parent: 'CY',
    },
    'CY-02': {
        code: 'CY-02',
        name: 'Lemesos',
        parent: 'CY',
    },
    'CY-03': {
        code: 'CY-03',
        name: 'Larnaka',
        parent: 'CY',
    },
    'CY-04': {
        code: 'CY-04',
        name: 'Ammochostos',
        parent: 'CY',
    },
    'CY-05': {
        code: 'CY-05',
        name: 'Pafos',
        parent: 'CY',
    },
    'CY-06': {
        code: 'CY-06',
        name: 'Keryneia',
        parent: 'CY',
    },
    'CZ-10': {
        code: 'CZ-10',
        name: 'Praha, Hlavní město',
        parent: 'CZ',
    },
    'CZ-20': {
        code: 'CZ-20',
        name: 'Středočeský kraj',
        parent: 'CZ',
    },
    'CZ-201': {
        code: 'CZ-201',
        name: 'Benešov',
        parent: 'CZ-20',
    },
    'CZ-202': {
        code: 'CZ-202',
        name: 'Beroun',
        parent: 'CZ-20',
    },
    'CZ-203': {
        code: 'CZ-203',
        name: 'Kladno',
        parent: 'CZ-20',
    },
    'CZ-204': {
        code: 'CZ-204',
        name: 'Kolín',
        parent: 'CZ-20',
    },
    'CZ-205': {
        code: 'CZ-205',
        name: 'Kutná Hora',
        parent: 'CZ-20',
    },
    'CZ-206': {
        code: 'CZ-206',
        name: 'Mělník',
        parent: 'CZ-20',
    },
    'CZ-207': {
        code: 'CZ-207',
        name: 'Mladá Boleslav',
        parent: 'CZ-20',
    },
    'CZ-208': {
        code: 'CZ-208',
        name: 'Nymburk',
        parent: 'CZ-20',
    },
    'CZ-209': {
        code: 'CZ-209',
        name: 'Praha-východ',
        parent: 'CZ-20',
    },
    'CZ-20A': {
        code: 'CZ-20A',
        name: 'Praha-západ',
        parent: 'CZ-20',
    },
    'CZ-20B': {
        code: 'CZ-20B',
        name: 'Příbram',
        parent: 'CZ-20',
    },
    'CZ-20C': {
        code: 'CZ-20C',
        name: 'Rakovník',
        parent: 'CZ-20',
    },
    'CZ-31': {
        code: 'CZ-31',
        name: 'Jihočeský kraj',
        parent: 'CZ',
    },
    'CZ-311': {
        code: 'CZ-311',
        name: 'České Budějovice',
        parent: 'CZ-31',
    },
    'CZ-312': {
        code: 'CZ-312',
        name: 'Český Krumlov',
        parent: 'CZ-31',
    },
    'CZ-313': {
        code: 'CZ-313',
        name: 'Jindřichův Hradec',
        parent: 'CZ-31',
    },
    'CZ-314': {
        code: 'CZ-314',
        name: 'Písek',
        parent: 'CZ-31',
    },
    'CZ-315': {
        code: 'CZ-315',
        name: 'Prachatice',
        parent: 'CZ-31',
    },
    'CZ-316': {
        code: 'CZ-316',
        name: 'Strakonice',
        parent: 'CZ-31',
    },
    'CZ-317': {
        code: 'CZ-317',
        name: 'Tábor',
        parent: 'CZ-31',
    },
    'CZ-32': {
        code: 'CZ-32',
        name: 'Plzeňský kraj',
        parent: 'CZ',
    },
    'CZ-321': {
        code: 'CZ-321',
        name: 'Domažlice',
        parent: 'CZ-32',
    },
    'CZ-322': {
        code: 'CZ-322',
        name: 'Klatovy',
        parent: 'CZ-32',
    },
    'CZ-323': {
        code: 'CZ-323',
        name: 'Plzeň-město',
        parent: 'CZ-32',
    },
    'CZ-324': {
        code: 'CZ-324',
        name: 'Plzeň-jih',
        parent: 'CZ-32',
    },
    'CZ-325': {
        code: 'CZ-325',
        name: 'Plzeň-sever',
        parent: 'CZ-32',
    },
    'CZ-326': {
        code: 'CZ-326',
        name: 'Rokycany',
        parent: 'CZ-32',
    },
    'CZ-327': {
        code: 'CZ-327',
        name: 'Tachov',
        parent: 'CZ-32',
    },
    'CZ-41': {
        code: 'CZ-41',
        name: 'Karlovarský kraj',
        parent: 'CZ',
    },
    'CZ-411': {
        code: 'CZ-411',
        name: 'Cheb',
        parent: 'CZ-41',
    },
    'CZ-412': {
        code: 'CZ-412',
        name: 'Karlovy Vary',
        parent: 'CZ-41',
    },
    'CZ-413': {
        code: 'CZ-413',
        name: 'Sokolov',
        parent: 'CZ-41',
    },
    'CZ-42': {
        code: 'CZ-42',
        name: 'Ústecký kraj',
        parent: 'CZ',
    },
    'CZ-421': {
        code: 'CZ-421',
        name: 'Děčín',
        parent: 'CZ-42',
    },
    'CZ-422': {
        code: 'CZ-422',
        name: 'Chomutov',
        parent: 'CZ-42',
    },
    'CZ-423': {
        code: 'CZ-423',
        name: 'Litoměřice',
        parent: 'CZ-42',
    },
    'CZ-424': {
        code: 'CZ-424',
        name: 'Louny',
        parent: 'CZ-42',
    },
    'CZ-425': {
        code: 'CZ-425',
        name: 'Most',
        parent: 'CZ-42',
    },
    'CZ-426': {
        code: 'CZ-426',
        name: 'Teplice',
        parent: 'CZ-42',
    },
    'CZ-427': {
        code: 'CZ-427',
        name: 'Ústí nad Labem',
        parent: 'CZ-42',
    },
    'CZ-51': {
        code: 'CZ-51',
        name: 'Liberecký kraj',
        parent: 'CZ',
    },
    'CZ-511': {
        code: 'CZ-511',
        name: 'Česká Lípa',
        parent: 'CZ-51',
    },
    'CZ-512': {
        code: 'CZ-512',
        name: 'Jablonec nad Nisou',
        parent: 'CZ-51',
    },
    'CZ-513': {
        code: 'CZ-513',
        name: 'Liberec',
        parent: 'CZ-51',
    },
    'CZ-514': {
        code: 'CZ-514',
        name: 'Semily',
        parent: 'CZ-51',
    },
    'CZ-52': {
        code: 'CZ-52',
        name: 'Královéhradecký kraj',
        parent: 'CZ',
    },
    'CZ-521': {
        code: 'CZ-521',
        name: 'Hradec Králové',
        parent: 'CZ-52',
    },
    'CZ-522': {
        code: 'CZ-522',
        name: 'Jičín',
        parent: 'CZ-52',
    },
    'CZ-523': {
        code: 'CZ-523',
        name: 'Náchod',
        parent: 'CZ-52',
    },
    'CZ-524': {
        code: 'CZ-524',
        name: 'Rychnov nad Kněžnou',
        parent: 'CZ-52',
    },
    'CZ-525': {
        code: 'CZ-525',
        name: 'Trutnov',
        parent: 'CZ-52',
    },
    'CZ-53': {
        code: 'CZ-53',
        name: 'Pardubický kraj',
        parent: 'CZ',
    },
    'CZ-531': {
        code: 'CZ-531',
        name: 'Chrudim',
        parent: 'CZ-53',
    },
    'CZ-532': {
        code: 'CZ-532',
        name: 'Pardubice',
        parent: 'CZ-53',
    },
    'CZ-533': {
        code: 'CZ-533',
        name: 'Svitavy',
        parent: 'CZ-53',
    },
    'CZ-534': {
        code: 'CZ-534',
        name: 'Ústí nad Orlicí',
        parent: 'CZ-53',
    },
    'CZ-63': {
        code: 'CZ-63',
        name: 'Kraj Vysočina',
        parent: 'CZ',
    },
    'CZ-631': {
        code: 'CZ-631',
        name: 'Havlíčkův Brod',
        parent: 'CZ-63',
    },
    'CZ-632': {
        code: 'CZ-632',
        name: 'Jihlava',
        parent: 'CZ-63',
    },
    'CZ-633': {
        code: 'CZ-633',
        name: 'Pelhřimov',
        parent: 'CZ-63',
    },
    'CZ-634': {
        code: 'CZ-634',
        name: 'Třebíč',
        parent: 'CZ-63',
    },
    'CZ-635': {
        code: 'CZ-635',
        name: 'Žďár nad Sázavou',
        parent: 'CZ-63',
    },
    'CZ-64': {
        code: 'CZ-64',
        name: 'Jihomoravský kraj',
        parent: 'CZ',
    },
    'CZ-641': {
        code: 'CZ-641',
        name: 'Blansko',
        parent: 'CZ-64',
    },
    'CZ-642': {
        code: 'CZ-642',
        name: 'Brno-město',
        parent: 'CZ-64',
    },
    'CZ-643': {
        code: 'CZ-643',
        name: 'Brno-venkov',
        parent: 'CZ-64',
    },
    'CZ-644': {
        code: 'CZ-644',
        name: 'Břeclav',
        parent: 'CZ-64',
    },
    'CZ-645': {
        code: 'CZ-645',
        name: 'Hodonín',
        parent: 'CZ-64',
    },
    'CZ-646': {
        code: 'CZ-646',
        name: 'Vyškov',
        parent: 'CZ-64',
    },
    'CZ-647': {
        code: 'CZ-647',
        name: 'Znojmo',
        parent: 'CZ-64',
    },
    'CZ-71': {
        code: 'CZ-71',
        name: 'Olomoucký kraj',
        parent: 'CZ',
    },
    'CZ-711': {
        code: 'CZ-711',
        name: 'Jeseník',
        parent: 'CZ-71',
    },
    'CZ-712': {
        code: 'CZ-712',
        name: 'Olomouc',
        parent: 'CZ-71',
    },
    'CZ-713': {
        code: 'CZ-713',
        name: 'Prostějov',
        parent: 'CZ-71',
    },
    'CZ-714': {
        code: 'CZ-714',
        name: 'Přerov',
        parent: 'CZ-71',
    },
    'CZ-715': {
        code: 'CZ-715',
        name: 'Šumperk',
        parent: 'CZ-71',
    },
    'CZ-72': {
        code: 'CZ-72',
        name: 'Zlínský kraj',
        parent: 'CZ',
    },
    'CZ-721': {
        code: 'CZ-721',
        name: 'Kroměříž',
        parent: 'CZ-72',
    },
    'CZ-722': {
        code: 'CZ-722',
        name: 'Uherské Hradiště',
        parent: 'CZ-72',
    },
    'CZ-723': {
        code: 'CZ-723',
        name: 'Vsetín',
        parent: 'CZ-72',
    },
    'CZ-724': {
        code: 'CZ-724',
        name: 'Zlín',
        parent: 'CZ-72',
    },
    'CZ-80': {
        code: 'CZ-80',
        name: 'Moravskoslezský kraj',
        parent: 'CZ',
    },
    'CZ-801': {
        code: 'CZ-801',
        name: 'Bruntál',
        parent: 'CZ-80',
    },
    'CZ-802': {
        code: 'CZ-802',
        name: 'Frýdek-Místek',
        parent: 'CZ-80',
    },
    'CZ-803': {
        code: 'CZ-803',
        name: 'Karviná',
        parent: 'CZ-80',
    },
    'CZ-804': {
        code: 'CZ-804',
        name: 'Nový Jičín',
        parent: 'CZ-80',
    },
    'CZ-805': {
        code: 'CZ-805',
        name: 'Opava',
        parent: 'CZ-80',
    },
    'CZ-806': {
        code: 'CZ-806',
        name: 'Ostrava-město',
        parent: 'CZ-80',
    },
    'DE-BB': {
        code: 'DE-BB',
        name: 'Brandenburg',
        parent: 'DE',
    },
    'DE-BE': {
        code: 'DE-BE',
        name: 'Berlin',
        parent: 'DE',
    },
    'DE-BW': {
        code: 'DE-BW',
        name: 'Baden-Württemberg',
        parent: 'DE',
    },
    'DE-BY': {
        code: 'DE-BY',
        name: 'Bayern',
        parent: 'DE',
    },
    'DE-HB': {
        code: 'DE-HB',
        name: 'Bremen',
        parent: 'DE',
    },
    'DE-HE': {
        code: 'DE-HE',
        name: 'Hessen',
        parent: 'DE',
    },
    'DE-HH': {
        code: 'DE-HH',
        name: 'Hamburg',
        parent: 'DE',
    },
    'DE-MV': {
        code: 'DE-MV',
        name: 'Mecklenburg-Vorpommern',
        parent: 'DE',
    },
    'DE-NI': {
        code: 'DE-NI',
        name: 'Niedersachsen',
        parent: 'DE',
    },
    'DE-NW': {
        code: 'DE-NW',
        name: 'Nordrhein-Westfalen',
        parent: 'DE',
    },
    'DE-RP': {
        code: 'DE-RP',
        name: 'Rheinland-Pfalz',
        parent: 'DE',
    },
    'DE-SH': {
        code: 'DE-SH',
        name: 'Schleswig-Holstein',
        parent: 'DE',
    },
    'DE-SL': {
        code: 'DE-SL',
        name: 'Saarland',
        parent: 'DE',
    },
    'DE-SN': {
        code: 'DE-SN',
        name: 'Sachsen',
        parent: 'DE',
    },
    'DE-ST': {
        code: 'DE-ST',
        name: 'Sachsen-Anhalt',
        parent: 'DE',
    },
    'DE-TH': {
        code: 'DE-TH',
        name: 'Thüringen',
        parent: 'DE',
    },
    'DJ-AR': {
        code: 'DJ-AR',
        name: 'Arta',
        parent: 'DJ',
    },
    'DJ-AS': {
        code: 'DJ-AS',
        name: 'Ali Sabieh',
        parent: 'DJ',
    },
    'DJ-DI': {
        code: 'DJ-DI',
        name: 'Dikhil',
        parent: 'DJ',
    },
    'DJ-DJ': {
        code: 'DJ-DJ',
        name: 'Djibouti',
        parent: 'DJ',
    },
    'DJ-OB': {
        code: 'DJ-OB',
        name: 'Obock',
        parent: 'DJ',
    },
    'DJ-TA': {
        code: 'DJ-TA',
        name: 'Tadjourah',
        parent: 'DJ',
    },
    'DK-81': {
        code: 'DK-81',
        name: 'Nordjylland',
        parent: 'DK',
    },
    'DK-82': {
        code: 'DK-82',
        name: 'Midtjylland',
        parent: 'DK',
    },
    'DK-83': {
        code: 'DK-83',
        name: 'Syddanmark',
        parent: 'DK',
    },
    'DK-84': {
        code: 'DK-84',
        name: 'Hovedstaden',
        parent: 'DK',
    },
    'DK-85': {
        code: 'DK-85',
        name: 'Sjælland',
        parent: 'DK',
    },
    'DM-02': {
        code: 'DM-02',
        name: 'Saint Andrew',
        parent: 'DM',
    },
    'DM-03': {
        code: 'DM-03',
        name: 'Saint David',
        parent: 'DM',
    },
    'DM-04': {
        code: 'DM-04',
        name: 'Saint George',
        parent: 'DM',
    },
    'DM-05': {
        code: 'DM-05',
        name: 'Saint John',
        parent: 'DM',
    },
    'DM-06': {
        code: 'DM-06',
        name: 'Saint Joseph',
        parent: 'DM',
    },
    'DM-07': {
        code: 'DM-07',
        name: 'Saint Luke',
        parent: 'DM',
    },
    'DM-08': {
        code: 'DM-08',
        name: 'Saint Mark',
        parent: 'DM',
    },
    'DM-09': {
        code: 'DM-09',
        name: 'Saint Patrick',
        parent: 'DM',
    },
    'DM-10': {
        code: 'DM-10',
        name: 'Saint Paul',
        parent: 'DM',
    },
    'DM-11': {
        code: 'DM-11',
        name: 'Saint Peter',
        parent: 'DM',
    },
    'DO-01': {
        code: 'DO-01',
        name: 'Distrito Nacional (Santo Domingo)',
        parent: 'DO-40',
    },
    'DO-02': {
        code: 'DO-02',
        name: 'Azua',
        parent: 'DO-41',
    },
    'DO-03': {
        code: 'DO-03',
        name: 'Baoruco',
        parent: 'DO-38',
    },
    'DO-04': {
        code: 'DO-04',
        name: 'Barahona',
        parent: 'DO-38',
    },
    'DO-05': {
        code: 'DO-05',
        name: 'Dajabón',
        parent: 'DO-34',
    },
    'DO-06': {
        code: 'DO-06',
        name: 'Duarte',
        parent: 'DO-33',
    },
    'DO-07': {
        code: 'DO-07',
        name: 'Elías Piña',
        parent: 'DO-37',
    },
    'DO-08': {
        code: 'DO-08',
        name: 'El Seibo',
        parent: 'DO-42',
    },
    'DO-09': {
        code: 'DO-09',
        name: 'Espaillat',
        parent: 'DO-35',
    },
    'DO-10': {
        code: 'DO-10',
        name: 'Independencia',
        parent: 'DO-38',
    },
    'DO-11': {
        code: 'DO-11',
        name: 'La Altagracia',
        parent: 'DO-42',
    },
    'DO-12': {
        code: 'DO-12',
        name: 'La Romana',
        parent: 'DO-42',
    },
    'DO-13': {
        code: 'DO-13',
        name: 'La Vega',
        parent: 'DO-36',
    },
    'DO-14': {
        code: 'DO-14',
        name: 'María Trinidad Sánchez',
        parent: 'DO-33',
    },
    'DO-15': {
        code: 'DO-15',
        name: 'Monte Cristi',
        parent: 'DO-34',
    },
    'DO-16': {
        code: 'DO-16',
        name: 'Pedernales',
        parent: 'DO-38',
    },
    'DO-17': {
        code: 'DO-17',
        name: 'Peravia',
        parent: 'DO-41',
    },
    'DO-18': {
        code: 'DO-18',
        name: 'Puerto Plata',
        parent: 'DO-35',
    },
    'DO-19': {
        code: 'DO-19',
        name: 'Hermanas Mirabal',
        parent: 'DO-33',
    },
    'DO-20': {
        code: 'DO-20',
        name: 'Samaná',
        parent: 'DO-33',
    },
    'DO-21': {
        code: 'DO-21',
        name: 'San Cristóbal',
        parent: 'DO-41',
    },
    'DO-22': {
        code: 'DO-22',
        name: 'San Juan',
        parent: 'DO-37',
    },
    'DO-23': {
        code: 'DO-23',
        name: 'San Pedro de Macorís',
        parent: 'DO-39',
    },
    'DO-24': {
        code: 'DO-24',
        name: 'Sánchez Ramírez',
        parent: 'DO-36',
    },
    'DO-25': {
        code: 'DO-25',
        name: 'Santiago',
        parent: 'DO-35',
    },
    'DO-26': {
        code: 'DO-26',
        name: 'Santiago Rodríguez',
        parent: 'DO-34',
    },
    'DO-27': {
        code: 'DO-27',
        name: 'Valverde',
        parent: 'DO-34',
    },
    'DO-28': {
        code: 'DO-28',
        name: 'Monseñor Nouel',
        parent: 'DO-36',
    },
    'DO-29': {
        code: 'DO-29',
        name: 'Monte Plata',
        parent: 'DO-39',
    },
    'DO-30': {
        code: 'DO-30',
        name: 'Hato Mayor',
        parent: 'DO-39',
    },
    'DO-31': {
        code: 'DO-31',
        name: 'San José de Ocoa',
        parent: 'DO-41',
    },
    'DO-32': {
        code: 'DO-32',
        name: 'Santo Domingo',
        parent: 'DO-40',
    },
    'DO-33': {
        code: 'DO-33',
        name: 'Cibao Nordeste',
        parent: 'DO',
    },
    'DO-34': {
        code: 'DO-34',
        name: 'Cibao Noroeste',
        parent: 'DO',
    },
    'DO-35': {
        code: 'DO-35',
        name: 'Cibao Norte',
        parent: 'DO',
    },
    'DO-36': {
        code: 'DO-36',
        name: 'Cibao Sur',
        parent: 'DO',
    },
    'DO-37': {
        code: 'DO-37',
        name: 'El Valle',
        parent: 'DO',
    },
    'DO-38': {
        code: 'DO-38',
        name: 'Enriquillo',
        parent: 'DO',
    },
    'DO-39': {
        code: 'DO-39',
        name: 'Higuamo',
        parent: 'DO',
    },
    'DO-40': {
        code: 'DO-40',
        name: 'Ozama',
        parent: 'DO',
    },
    'DO-41': {
        code: 'DO-41',
        name: 'Valdesia',
        parent: 'DO',
    },
    'DO-42': {
        code: 'DO-42',
        name: 'Yuma',
        parent: 'DO',
    },
    'DZ-01': {
        code: 'DZ-01',
        name: 'Adrar',
        parent: 'DZ',
    },
    'DZ-02': {
        code: 'DZ-02',
        name: 'Chlef',
        parent: 'DZ',
    },
    'DZ-03': {
        code: 'DZ-03',
        name: 'Laghouat',
        parent: 'DZ',
    },
    'DZ-04': {
        code: 'DZ-04',
        name: 'Oum el Bouaghi',
        parent: 'DZ',
    },
    'DZ-05': {
        code: 'DZ-05',
        name: 'Batna',
        parent: 'DZ',
    },
    'DZ-06': {
        code: 'DZ-06',
        name: 'Béjaïa',
        parent: 'DZ',
    },
    'DZ-07': {
        code: 'DZ-07',
        name: 'Biskra',
        parent: 'DZ',
    },
    'DZ-08': {
        code: 'DZ-08',
        name: 'Béchar',
        parent: 'DZ',
    },
    'DZ-09': {
        code: 'DZ-09',
        name: 'Blida',
        parent: 'DZ',
    },
    'DZ-10': {
        code: 'DZ-10',
        name: 'Bouira',
        parent: 'DZ',
    },
    'DZ-11': {
        code: 'DZ-11',
        name: 'Tamanrasset',
        parent: 'DZ',
    },
    'DZ-12': {
        code: 'DZ-12',
        name: 'Tébessa',
        parent: 'DZ',
    },
    'DZ-13': {
        code: 'DZ-13',
        name: 'Tlemcen',
        parent: 'DZ',
    },
    'DZ-14': {
        code: 'DZ-14',
        name: 'Tiaret',
        parent: 'DZ',
    },
    'DZ-15': {
        code: 'DZ-15',
        name: 'Tizi Ouzou',
        parent: 'DZ',
    },
    'DZ-16': {
        code: 'DZ-16',
        name: 'Alger',
        parent: 'DZ',
    },
    'DZ-17': {
        code: 'DZ-17',
        name: 'Djelfa',
        parent: 'DZ',
    },
    'DZ-18': {
        code: 'DZ-18',
        name: 'Jijel',
        parent: 'DZ',
    },
    'DZ-19': {
        code: 'DZ-19',
        name: 'Sétif',
        parent: 'DZ',
    },
    'DZ-20': {
        code: 'DZ-20',
        name: 'Saïda',
        parent: 'DZ',
    },
    'DZ-21': {
        code: 'DZ-21',
        name: 'Skikda',
        parent: 'DZ',
    },
    'DZ-22': {
        code: 'DZ-22',
        name: 'Sidi Bel Abbès',
        parent: 'DZ',
    },
    'DZ-23': {
        code: 'DZ-23',
        name: 'Annaba',
        parent: 'DZ',
    },
    'DZ-24': {
        code: 'DZ-24',
        name: 'Guelma',
        parent: 'DZ',
    },
    'DZ-25': {
        code: 'DZ-25',
        name: 'Constantine',
        parent: 'DZ',
    },
    'DZ-26': {
        code: 'DZ-26',
        name: 'Médéa',
        parent: 'DZ',
    },
    'DZ-27': {
        code: 'DZ-27',
        name: 'Mostaganem',
        parent: 'DZ',
    },
    'DZ-28': {
        code: 'DZ-28',
        name: "M'sila",
        parent: 'DZ',
    },
    'DZ-29': {
        code: 'DZ-29',
        name: 'Mascara',
        parent: 'DZ',
    },
    'DZ-30': {
        code: 'DZ-30',
        name: 'Ouargla',
        parent: 'DZ',
    },
    'DZ-31': {
        code: 'DZ-31',
        name: 'Oran',
        parent: 'DZ',
    },
    'DZ-32': {
        code: 'DZ-32',
        name: 'El Bayadh',
        parent: 'DZ',
    },
    'DZ-33': {
        code: 'DZ-33',
        name: 'Illizi',
        parent: 'DZ',
    },
    'DZ-34': {
        code: 'DZ-34',
        name: 'Bordj Bou Arréridj',
        parent: 'DZ',
    },
    'DZ-35': {
        code: 'DZ-35',
        name: 'Boumerdès',
        parent: 'DZ',
    },
    'DZ-36': {
        code: 'DZ-36',
        name: 'El Tarf',
        parent: 'DZ',
    },
    'DZ-37': {
        code: 'DZ-37',
        name: 'Tindouf',
        parent: 'DZ',
    },
    'DZ-38': {
        code: 'DZ-38',
        name: 'Tissemsilt',
        parent: 'DZ',
    },
    'DZ-39': {
        code: 'DZ-39',
        name: 'El Oued',
        parent: 'DZ',
    },
    'DZ-40': {
        code: 'DZ-40',
        name: 'Khenchela',
        parent: 'DZ',
    },
    'DZ-41': {
        code: 'DZ-41',
        name: 'Souk Ahras',
        parent: 'DZ',
    },
    'DZ-42': {
        code: 'DZ-42',
        name: 'Tipaza',
        parent: 'DZ',
    },
    'DZ-43': {
        code: 'DZ-43',
        name: 'Mila',
        parent: 'DZ',
    },
    'DZ-44': {
        code: 'DZ-44',
        name: 'Aïn Defla',
        parent: 'DZ',
    },
    'DZ-45': {
        code: 'DZ-45',
        name: 'Naama',
        parent: 'DZ',
    },
    'DZ-46': {
        code: 'DZ-46',
        name: 'Aïn Témouchent',
        parent: 'DZ',
    },
    'DZ-47': {
        code: 'DZ-47',
        name: 'Ghardaïa',
        parent: 'DZ',
    },
    'DZ-48': {
        code: 'DZ-48',
        name: 'Relizane',
        parent: 'DZ',
    },
    'EC-A': {
        code: 'EC-A',
        name: 'Azuay',
        parent: 'EC',
    },
    'EC-B': {
        code: 'EC-B',
        name: 'Bolívar',
        parent: 'EC',
    },
    'EC-C': {
        code: 'EC-C',
        name: 'Carchi',
        parent: 'EC',
    },
    'EC-D': {
        code: 'EC-D',
        name: 'Orellana',
        parent: 'EC',
    },
    'EC-E': {
        code: 'EC-E',
        name: 'Esmeraldas',
        parent: 'EC',
    },
    'EC-F': {
        code: 'EC-F',
        name: 'Cañar',
        parent: 'EC',
    },
    'EC-G': {
        code: 'EC-G',
        name: 'Guayas',
        parent: 'EC',
    },
    'EC-H': {
        code: 'EC-H',
        name: 'Chimborazo',
        parent: 'EC',
    },
    'EC-I': {
        code: 'EC-I',
        name: 'Imbabura',
        parent: 'EC',
    },
    'EC-L': {
        code: 'EC-L',
        name: 'Loja',
        parent: 'EC',
    },
    'EC-M': {
        code: 'EC-M',
        name: 'Manabí',
        parent: 'EC',
    },
    'EC-N': {
        code: 'EC-N',
        name: 'Napo',
        parent: 'EC',
    },
    'EC-O': {
        code: 'EC-O',
        name: 'El Oro',
        parent: 'EC',
    },
    'EC-P': {
        code: 'EC-P',
        name: 'Pichincha',
        parent: 'EC',
    },
    'EC-R': {
        code: 'EC-R',
        name: 'Los Ríos',
        parent: 'EC',
    },
    'EC-S': {
        code: 'EC-S',
        name: 'Morona Santiago',
        parent: 'EC',
    },
    'EC-SD': {
        code: 'EC-SD',
        name: 'Santo Domingo de los Tsáchilas',
        parent: 'EC',
    },
    'EC-SE': {
        code: 'EC-SE',
        name: 'Santa Elena',
        parent: 'EC',
    },
    'EC-T': {
        code: 'EC-T',
        name: 'Tungurahua',
        parent: 'EC',
    },
    'EC-U': {
        code: 'EC-U',
        name: 'Sucumbíos',
        parent: 'EC',
    },
    'EC-W': {
        code: 'EC-W',
        name: 'Galápagos',
        parent: 'EC',
    },
    'EC-X': {
        code: 'EC-X',
        name: 'Cotopaxi',
        parent: 'EC',
    },
    'EC-Y': {
        code: 'EC-Y',
        name: 'Pastaza',
        parent: 'EC',
    },
    'EC-Z': {
        code: 'EC-Z',
        name: 'Zamora Chinchipe',
        parent: 'EC',
    },
    'EE-130': {
        code: 'EE-130',
        name: 'Alutaguse',
        parent: 'EE',
    },
    'EE-141': {
        code: 'EE-141',
        name: 'Anija',
        parent: 'EE',
    },
    'EE-142': {
        code: 'EE-142',
        name: 'Antsla',
        parent: 'EE',
    },
    'EE-171': {
        code: 'EE-171',
        name: 'Elva',
        parent: 'EE',
    },
    'EE-184': {
        code: 'EE-184',
        name: 'Haapsalu',
        parent: 'EE',
    },
    'EE-191': {
        code: 'EE-191',
        name: 'Haljala',
        parent: 'EE',
    },
    'EE-198': {
        code: 'EE-198',
        name: 'Harku',
        parent: 'EE',
    },
    'EE-205': {
        code: 'EE-205',
        name: 'Hiiumaa',
        parent: 'EE',
    },
    'EE-214': {
        code: 'EE-214',
        name: 'Häädemeeste',
        parent: 'EE',
    },
    'EE-245': {
        code: 'EE-245',
        name: 'Jõelähtme',
        parent: 'EE',
    },
    'EE-247': {
        code: 'EE-247',
        name: 'Jõgeva',
        parent: 'EE',
    },
    'EE-251': {
        code: 'EE-251',
        name: 'Jõhvi',
        parent: 'EE',
    },
    'EE-255': {
        code: 'EE-255',
        name: 'Järva',
        parent: 'EE',
    },
    'EE-272': {
        code: 'EE-272',
        name: 'Kadrina',
        parent: 'EE',
    },
    'EE-283': {
        code: 'EE-283',
        name: 'Kambja',
        parent: 'EE',
    },
    'EE-284': {
        code: 'EE-284',
        name: 'Kanepi',
        parent: 'EE',
    },
    'EE-291': {
        code: 'EE-291',
        name: 'Kastre',
        parent: 'EE',
    },
    'EE-293': {
        code: 'EE-293',
        name: 'Kehtna',
        parent: 'EE',
    },
    'EE-296': {
        code: 'EE-296',
        name: 'Keila',
        parent: 'EE',
    },
    'EE-303': {
        code: 'EE-303',
        name: 'Kihnu',
        parent: 'EE',
    },
    'EE-305': {
        code: 'EE-305',
        name: 'Kiili',
        parent: 'EE',
    },
    'EE-317': {
        code: 'EE-317',
        name: 'Kohila',
        parent: 'EE',
    },
    'EE-321': {
        code: 'EE-321',
        name: 'Kohtla-Järve',
        parent: 'EE',
    },
    'EE-338': {
        code: 'EE-338',
        name: 'Kose',
        parent: 'EE',
    },
    'EE-353': {
        code: 'EE-353',
        name: 'Kuusalu',
        parent: 'EE',
    },
    'EE-37': {
        code: 'EE-37',
        name: 'Harjumaa',
        parent: 'EE',
    },
    'EE-39': {
        code: 'EE-39',
        name: 'Hiiumaa',
        parent: 'EE',
    },
    'EE-424': {
        code: 'EE-424',
        name: 'Loksa',
        parent: 'EE',
    },
    'EE-430': {
        code: 'EE-430',
        name: 'Lääneranna',
        parent: 'EE',
    },
    'EE-431': {
        code: 'EE-431',
        name: 'Lääne-Harju',
        parent: 'EE',
    },
    'EE-432': {
        code: 'EE-432',
        name: 'Luunja',
        parent: 'EE',
    },
    'EE-441': {
        code: 'EE-441',
        name: 'Lääne-Nigula',
        parent: 'EE',
    },
    'EE-442': {
        code: 'EE-442',
        name: 'Lüganuse',
        parent: 'EE',
    },
    'EE-446': {
        code: 'EE-446',
        name: 'Maardu',
        parent: 'EE',
    },
    'EE-45': {
        code: 'EE-45',
        name: 'Ida-Virumaa',
        parent: 'EE',
    },
    'EE-478': {
        code: 'EE-478',
        name: 'Muhu',
        parent: 'EE',
    },
    'EE-480': {
        code: 'EE-480',
        name: 'Mulgi',
        parent: 'EE',
    },
    'EE-486': {
        code: 'EE-486',
        name: 'Mustvee',
        parent: 'EE',
    },
    'EE-50': {
        code: 'EE-50',
        name: 'Jõgevamaa',
        parent: 'EE',
    },
    'EE-503': {
        code: 'EE-503',
        name: 'Märjamaa',
        parent: 'EE',
    },
    'EE-511': {
        code: 'EE-511',
        name: 'Narva',
        parent: 'EE',
    },
    'EE-514': {
        code: 'EE-514',
        name: 'Narva-Jõesuu',
        parent: 'EE',
    },
    'EE-52': {
        code: 'EE-52',
        name: 'Järvamaa',
        parent: 'EE',
    },
    'EE-528': {
        code: 'EE-528',
        name: 'Nõo',
        parent: 'EE',
    },
    'EE-557': {
        code: 'EE-557',
        name: 'Otepää',
        parent: 'EE',
    },
    'EE-56': {
        code: 'EE-56',
        name: 'Läänemaa',
        parent: 'EE',
    },
    'EE-567': {
        code: 'EE-567',
        name: 'Paide',
        parent: 'EE',
    },
    'EE-586': {
        code: 'EE-586',
        name: 'Peipsiääre',
        parent: 'EE',
    },
    'EE-60': {
        code: 'EE-60',
        name: 'Lääne-Virumaa',
        parent: 'EE',
    },
    'EE-615': {
        code: 'EE-615',
        name: 'Põhja-Sakala',
        parent: 'EE',
    },
    'EE-618': {
        code: 'EE-618',
        name: 'Põltsamaa',
        parent: 'EE',
    },
    'EE-622': {
        code: 'EE-622',
        name: 'Põlva',
        parent: 'EE',
    },
    'EE-624': {
        code: 'EE-624',
        name: 'Pärnu',
        parent: 'EE',
    },
    'EE-638': {
        code: 'EE-638',
        name: 'Põhja-Pärnumaa',
        parent: 'EE',
    },
    'EE-64': {
        code: 'EE-64',
        name: 'Põlvamaa',
        parent: 'EE',
    },
    'EE-651': {
        code: 'EE-651',
        name: 'Raasiku',
        parent: 'EE',
    },
    'EE-653': {
        code: 'EE-653',
        name: 'Rae',
        parent: 'EE',
    },
    'EE-661': {
        code: 'EE-661',
        name: 'Rakvere',
        parent: 'EE',
    },
    'EE-663': {
        code: 'EE-663',
        name: 'Rakvere',
        parent: 'EE',
    },
    'EE-668': {
        code: 'EE-668',
        name: 'Rapla',
        parent: 'EE',
    },
    'EE-68': {
        code: 'EE-68',
        name: 'Pärnumaa',
        parent: 'EE',
    },
    'EE-689': {
        code: 'EE-689',
        name: 'Ruhnu',
        parent: 'EE',
    },
    'EE-698': {
        code: 'EE-698',
        name: 'Rõuge',
        parent: 'EE',
    },
    'EE-708': {
        code: 'EE-708',
        name: 'Räpina',
        parent: 'EE',
    },
    'EE-71': {
        code: 'EE-71',
        name: 'Raplamaa',
        parent: 'EE',
    },
    'EE-712': {
        code: 'EE-712',
        name: 'Saarde',
        parent: 'EE',
    },
    'EE-714': {
        code: 'EE-714',
        name: 'Saaremaa',
        parent: 'EE',
    },
    'EE-719': {
        code: 'EE-719',
        name: 'Saku',
        parent: 'EE',
    },
    'EE-726': {
        code: 'EE-726',
        name: 'Saue',
        parent: 'EE',
    },
    'EE-732': {
        code: 'EE-732',
        name: 'Setomaa',
        parent: 'EE',
    },
    'EE-735': {
        code: 'EE-735',
        name: 'Sillamäe',
        parent: 'EE',
    },
    'EE-74': {
        code: 'EE-74',
        name: 'Saaremaa',
        parent: 'EE',
    },
    'EE-784': {
        code: 'EE-784',
        name: 'Tallinn',
        parent: 'EE',
    },
    'EE-79': {
        code: 'EE-79',
        name: 'Tartumaa',
        parent: 'EE',
    },
    'EE-792': {
        code: 'EE-792',
        name: 'Tapa',
        parent: 'EE',
    },
    'EE-793': {
        code: 'EE-793',
        name: 'Tartu',
        parent: 'EE',
    },
    'EE-796': {
        code: 'EE-796',
        name: 'Tartu',
        parent: 'EE',
    },
    'EE-803': {
        code: 'EE-803',
        name: 'Toila',
        parent: 'EE',
    },
    'EE-809': {
        code: 'EE-809',
        name: 'Tori',
        parent: 'EE',
    },
    'EE-81': {
        code: 'EE-81',
        name: 'Valgamaa',
        parent: 'EE',
    },
    'EE-824': {
        code: 'EE-824',
        name: 'Tõrva',
        parent: 'EE',
    },
    'EE-834': {
        code: 'EE-834',
        name: 'Türi',
        parent: 'EE',
    },
    'EE-84': {
        code: 'EE-84',
        name: 'Viljandimaa',
        parent: 'EE',
    },
    'EE-855': {
        code: 'EE-855',
        name: 'Valga',
        parent: 'EE',
    },
    'EE-87': {
        code: 'EE-87',
        name: 'Võrumaa',
        parent: 'EE',
    },
    'EE-890': {
        code: 'EE-890',
        name: 'Viimsi',
        parent: 'EE',
    },
    'EE-897': {
        code: 'EE-897',
        name: 'Viljandi',
        parent: 'EE',
    },
    'EE-899': {
        code: 'EE-899',
        name: 'Viljandi',
        parent: 'EE',
    },
    'EE-901': {
        code: 'EE-901',
        name: 'Vinni',
        parent: 'EE',
    },
    'EE-903': {
        code: 'EE-903',
        name: 'Viru-Nigula',
        parent: 'EE',
    },
    'EE-907': {
        code: 'EE-907',
        name: 'Vormsi',
        parent: 'EE',
    },
    'EE-917': {
        code: 'EE-917',
        name: 'Võru',
        parent: 'EE',
    },
    'EE-919': {
        code: 'EE-919',
        name: 'Võru',
        parent: 'EE',
    },
    'EE-928': {
        code: 'EE-928',
        name: 'Väike-Maarja',
        parent: 'EE',
    },
    'EG-ALX': {
        code: 'EG-ALX',
        name: 'Al Iskandarīyah',
        parent: 'EG',
    },
    'EG-ASN': {
        code: 'EG-ASN',
        name: 'Aswān',
        parent: 'EG',
    },
    'EG-AST': {
        code: 'EG-AST',
        name: 'Asyūţ',
        parent: 'EG',
    },
    'EG-BA': {
        code: 'EG-BA',
        name: 'Al Baḩr al Aḩmar',
        parent: 'EG',
    },
    'EG-BH': {
        code: 'EG-BH',
        name: 'Al Buḩayrah',
        parent: 'EG',
    },
    'EG-BNS': {
        code: 'EG-BNS',
        name: 'Banī Suwayf',
        parent: 'EG',
    },
    'EG-C': {
        code: 'EG-C',
        name: 'Al Qāhirah',
        parent: 'EG',
    },
    'EG-DK': {
        code: 'EG-DK',
        name: 'Ad Daqahlīyah',
        parent: 'EG',
    },
    'EG-DT': {
        code: 'EG-DT',
        name: 'Dumyāţ',
        parent: 'EG',
    },
    'EG-FYM': {
        code: 'EG-FYM',
        name: 'Al Fayyūm',
        parent: 'EG',
    },
    'EG-GH': {
        code: 'EG-GH',
        name: 'Al Gharbīyah',
        parent: 'EG',
    },
    'EG-GZ': {
        code: 'EG-GZ',
        name: 'Al Jīzah',
        parent: 'EG',
    },
    'EG-IS': {
        code: 'EG-IS',
        name: "Al Ismā'īlīyah",
        parent: 'EG',
    },
    'EG-JS': {
        code: 'EG-JS',
        name: "Janūb Sīnā'",
        parent: 'EG',
    },
    'EG-KB': {
        code: 'EG-KB',
        name: 'Al Qalyūbīyah',
        parent: 'EG',
    },
    'EG-KFS': {
        code: 'EG-KFS',
        name: 'Kafr ash Shaykh',
        parent: 'EG',
    },
    'EG-KN': {
        code: 'EG-KN',
        name: 'Qinā',
        parent: 'EG',
    },
    'EG-LX': {
        code: 'EG-LX',
        name: 'Al Uqşur',
        parent: 'EG',
    },
    'EG-MN': {
        code: 'EG-MN',
        name: 'Al Minyā',
        parent: 'EG',
    },
    'EG-MNF': {
        code: 'EG-MNF',
        name: 'Al Minūfīyah',
        parent: 'EG',
    },
    'EG-MT': {
        code: 'EG-MT',
        name: 'Maţrūḩ',
        parent: 'EG',
    },
    'EG-PTS': {
        code: 'EG-PTS',
        name: 'Būr Sa‘īd',
        parent: 'EG',
    },
    'EG-SHG': {
        code: 'EG-SHG',
        name: 'Sūhāj',
        parent: 'EG',
    },
    'EG-SHR': {
        code: 'EG-SHR',
        name: 'Ash Sharqīyah',
        parent: 'EG',
    },
    'EG-SIN': {
        code: 'EG-SIN',
        name: "Shamāl Sīnā'",
        parent: 'EG',
    },
    'EG-SUZ': {
        code: 'EG-SUZ',
        name: 'As Suways',
        parent: 'EG',
    },
    'EG-WAD': {
        code: 'EG-WAD',
        name: 'Al Wādī al Jadīd',
        parent: 'EG',
    },
    'ER-AN': {
        code: 'ER-AN',
        name: 'Ansabā',
        parent: 'ER',
    },
    'ER-DK': {
        code: 'ER-DK',
        name: 'Janūbī al Baḩrī al Aḩmar',
        parent: 'ER',
    },
    'ER-DU': {
        code: 'ER-DU',
        name: 'Al Janūbī',
        parent: 'ER',
    },
    'ER-GB': {
        code: 'ER-GB',
        name: 'Qāsh-Barkah',
        parent: 'ER',
    },
    'ER-MA': {
        code: 'ER-MA',
        name: 'Al Awsaţ',
        parent: 'ER',
    },
    'ER-SK': {
        code: 'ER-SK',
        name: 'Shimālī al Baḩrī al Aḩmar',
        parent: 'ER',
    },
    'ES-A': {
        code: 'ES-A',
        name: 'AlicanteAlacant',
        parent: 'ES-VC',
    },
    'ES-AB': {
        code: 'ES-AB',
        name: 'Albacete',
        parent: 'ES-CM',
    },
    'ES-AL': {
        code: 'ES-AL',
        name: 'Almería',
        parent: 'ES-AN',
    },
    'ES-AN': {
        code: 'ES-AN',
        name: 'Andalucía',
        parent: 'ES',
    },
    'ES-AR': {
        code: 'ES-AR',
        name: 'Aragón',
        parent: 'ES',
    },
    'ES-AS': {
        code: 'ES-AS',
        name: 'Asturias, Principado de',
        parent: 'ES',
    },
    'ES-AV': {
        code: 'ES-AV',
        name: 'Ávila',
        parent: 'ES-CL',
    },
    'ES-B': {
        code: 'ES-B',
        name: 'Barcelona',
        parent: 'ES-CT',
    },
    'ES-BA': {
        code: 'ES-BA',
        name: 'Badajoz',
        parent: 'ES-EX',
    },
    'ES-BI': {
        code: 'ES-BI',
        name: 'Bizkaia',
        parent: 'ES-PV',
    },
    'ES-BU': {
        code: 'ES-BU',
        name: 'Burgos',
        parent: 'ES-CL',
    },
    'ES-C': {
        code: 'ES-C',
        name: 'A Coruña',
        parent: 'ES-GA',
    },
    'ES-CA': {
        code: 'ES-CA',
        name: 'Cádiz',
        parent: 'ES-AN',
    },
    'ES-CB': {
        code: 'ES-CB',
        name: 'Cantabria',
        parent: 'ES',
    },
    'ES-CC': {
        code: 'ES-CC',
        name: 'Cáceres',
        parent: 'ES-EX',
    },
    'ES-CE': {
        code: 'ES-CE',
        name: 'Ceuta',
        parent: 'ES',
    },
    'ES-CL': {
        code: 'ES-CL',
        name: 'Castilla y León',
        parent: 'ES',
    },
    'ES-CM': {
        code: 'ES-CM',
        name: 'Castilla-La Mancha',
        parent: 'ES',
    },
    'ES-CN': {
        code: 'ES-CN',
        name: 'Canarias',
        parent: 'ES',
    },
    'ES-CO': {
        code: 'ES-CO',
        name: 'Córdoba',
        parent: 'ES-AN',
    },
    'ES-CR': {
        code: 'ES-CR',
        name: 'Ciudad Real',
        parent: 'ES-CM',
    },
    'ES-CS': {
        code: 'ES-CS',
        name: 'CastellónCastelló',
        parent: 'ES-VC',
    },
    'ES-CT': {
        code: 'ES-CT',
        name: 'Catalunya',
        parent: 'ES',
    },
    'ES-CU': {
        code: 'ES-CU',
        name: 'Cuenca',
        parent: 'ES-CM',
    },
    'ES-EX': {
        code: 'ES-EX',
        name: 'Extremadura',
        parent: 'ES',
    },
    'ES-GA': {
        code: 'ES-GA',
        name: 'Galicia',
        parent: 'ES',
    },
    'ES-GC': {
        code: 'ES-GC',
        name: 'Las Palmas',
        parent: 'ES-CN',
    },
    'ES-GI': {
        code: 'ES-GI',
        name: 'Girona',
        parent: 'ES-CT',
    },
    'ES-GR': {
        code: 'ES-GR',
        name: 'Granada',
        parent: 'ES-AN',
    },
    'ES-GU': {
        code: 'ES-GU',
        name: 'Guadalajara',
        parent: 'ES-CM',
    },
    'ES-H': {
        code: 'ES-H',
        name: 'Huelva',
        parent: 'ES-AN',
    },
    'ES-HU': {
        code: 'ES-HU',
        name: 'Huesca',
        parent: 'ES-AR',
    },
    'ES-IB': {
        code: 'ES-IB',
        name: 'Illes Balears',
        parent: 'ES',
    },
    'ES-J': {
        code: 'ES-J',
        name: 'Jaén',
        parent: 'ES-AN',
    },
    'ES-L': {
        code: 'ES-L',
        name: 'Lleida',
        parent: 'ES-CT',
    },
    'ES-LE': {
        code: 'ES-LE',
        name: 'León',
        parent: 'ES-CL',
    },
    'ES-LO': {
        code: 'ES-LO',
        name: 'La Rioja',
        parent: 'ES-RI',
    },
    'ES-LU': {
        code: 'ES-LU',
        name: 'Lugo',
        parent: 'ES-GA',
    },
    'ES-M': {
        code: 'ES-M',
        name: 'Madrid',
        parent: 'ES-MD',
    },
    'ES-MA': {
        code: 'ES-MA',
        name: 'Málaga',
        parent: 'ES-AN',
    },
    'ES-MC': {
        code: 'ES-MC',
        name: 'Murcia, Región de',
        parent: 'ES',
    },
    'ES-MD': {
        code: 'ES-MD',
        name: 'Madrid, Comunidad de',
        parent: 'ES',
    },
    'ES-ML': {
        code: 'ES-ML',
        name: 'Melilla',
        parent: 'ES',
    },
    'ES-MU': {
        code: 'ES-MU',
        name: 'Murcia',
        parent: 'ES-MC',
    },
    'ES-NA': {
        code: 'ES-NA',
        name: 'NavarraNafarroa',
        parent: 'ES-NC',
    },
    'ES-NC': {
        code: 'ES-NC',
        name: 'Navarra, Comunidad Foral deNafarroako Foru Komunitatea',
        parent: 'ES',
    },
    'ES-O': {
        code: 'ES-O',
        name: 'Asturias',
        parent: 'ES-AS',
    },
    'ES-OR': {
        code: 'ES-OR',
        name: 'Ourense',
        parent: 'ES-GA',
    },
    'ES-P': {
        code: 'ES-P',
        name: 'Palencia',
        parent: 'ES-CL',
    },
    'ES-PM': {
        code: 'ES-PM',
        name: 'Illes Balears',
        parent: 'ES-IB',
    },
    'ES-PO': {
        code: 'ES-PO',
        name: 'Pontevedra',
        parent: 'ES-GA',
    },
    'ES-PV': {
        code: 'ES-PV',
        name: 'País VascoEuskal Herria',
        parent: 'ES',
    },
    'ES-RI': {
        code: 'ES-RI',
        name: 'La Rioja',
        parent: 'ES',
    },
    'ES-S': {
        code: 'ES-S',
        name: 'Cantabria',
        parent: 'ES-CB',
    },
    'ES-SA': {
        code: 'ES-SA',
        name: 'Salamanca',
        parent: 'ES-CL',
    },
    'ES-SE': {
        code: 'ES-SE',
        name: 'Sevilla',
        parent: 'ES-AN',
    },
    'ES-SG': {
        code: 'ES-SG',
        name: 'Segovia',
        parent: 'ES-CL',
    },
    'ES-SO': {
        code: 'ES-SO',
        name: 'Soria',
        parent: 'ES-CL',
    },
    'ES-SS': {
        code: 'ES-SS',
        name: 'Gipuzkoa',
        parent: 'ES-PV',
    },
    'ES-T': {
        code: 'ES-T',
        name: 'Tarragona',
        parent: 'ES-CT',
    },
    'ES-TE': {
        code: 'ES-TE',
        name: 'Teruel',
        parent: 'ES-AR',
    },
    'ES-TF': {
        code: 'ES-TF',
        name: 'Santa Cruz de Tenerife',
        parent: 'ES-CN',
    },
    'ES-TO': {
        code: 'ES-TO',
        name: 'Toledo',
        parent: 'ES-CM',
    },
    'ES-V': {
        code: 'ES-V',
        name: 'València',
        parent: 'ES-VC',
    },
    'ES-VA': {
        code: 'ES-VA',
        name: 'Valladolid',
        parent: 'ES-CL',
    },
    'ES-VC': {
        code: 'ES-VC',
        name: 'Valenciana, Comunitat',
        parent: 'ES',
    },
    'ES-VI': {
        code: 'ES-VI',
        name: 'ÁlavaAraba',
        parent: 'ES-PV',
    },
    'ES-Z': {
        code: 'ES-Z',
        name: 'Zaragoza',
        parent: 'ES-AR',
    },
    'ES-ZA': {
        code: 'ES-ZA',
        name: 'Zamora',
        parent: 'ES-CL',
    },
    'ET-AA': {
        code: 'ET-AA',
        name: 'Ādīs Ābeba',
        parent: 'ET',
    },
    'ET-AF': {
        code: 'ET-AF',
        name: 'Āfar',
        parent: 'ET',
    },
    'ET-AM': {
        code: 'ET-AM',
        name: 'Āmara',
        parent: 'ET',
    },
    'ET-BE': {
        code: 'ET-BE',
        name: 'Bīnshangul Gumuz',
        parent: 'ET',
    },
    'ET-DD': {
        code: 'ET-DD',
        name: 'Dirē Dawa',
        parent: 'ET',
    },
    'ET-GA': {
        code: 'ET-GA',
        name: 'Gambēla Hizboch',
        parent: 'ET',
    },
    'ET-HA': {
        code: 'ET-HA',
        name: 'Hārerī Hizb',
        parent: 'ET',
    },
    'ET-OR': {
        code: 'ET-OR',
        name: 'Oromīya',
        parent: 'ET',
    },
    'ET-SN': {
        code: 'ET-SN',
        name: 'YeDebub Bihēroch Bihēreseboch na Hizboch',
        parent: 'ET',
    },
    'ET-SO': {
        code: 'ET-SO',
        name: 'Sumalē',
        parent: 'ET',
    },
    'ET-TI': {
        code: 'ET-TI',
        name: 'Tigray',
        parent: 'ET',
    },
    'FI-01': {
        code: 'FI-01',
        name: 'Ahvenanmaan maakunta',
        parent: 'FI',
    },
    'FI-02': {
        code: 'FI-02',
        name: 'Etelä-Karjala',
        parent: 'FI',
    },
    'FI-03': {
        code: 'FI-03',
        name: 'Etelä-Pohjanmaa',
        parent: 'FI',
    },
    'FI-04': {
        code: 'FI-04',
        name: 'Etelä-Savo',
        parent: 'FI',
    },
    'FI-05': {
        code: 'FI-05',
        name: 'Kainuu',
        parent: 'FI',
    },
    'FI-06': {
        code: 'FI-06',
        name: 'Kanta-Häme',
        parent: 'FI',
    },
    'FI-07': {
        code: 'FI-07',
        name: 'Keski-Pohjanmaa',
        parent: 'FI',
    },
    'FI-08': {
        code: 'FI-08',
        name: 'Keski-Suomi',
        parent: 'FI',
    },
    'FI-09': {
        code: 'FI-09',
        name: 'Kymenlaakso',
        parent: 'FI',
    },
    'FI-10': {
        code: 'FI-10',
        name: 'Lappi',
        parent: 'FI',
    },
    'FI-11': {
        code: 'FI-11',
        name: 'Pirkanmaa',
        parent: 'FI',
    },
    'FI-12': {
        code: 'FI-12',
        name: 'Pohjanmaa',
        parent: 'FI',
    },
    'FI-13': {
        code: 'FI-13',
        name: 'Pohjois-Karjala',
        parent: 'FI',
    },
    'FI-14': {
        code: 'FI-14',
        name: 'Pohjois-Pohjanmaa',
        parent: 'FI',
    },
    'FI-15': {
        code: 'FI-15',
        name: 'Pohjois-Savo',
        parent: 'FI',
    },
    'FI-16': {
        code: 'FI-16',
        name: 'Päijät-Häme',
        parent: 'FI',
    },
    'FI-17': {
        code: 'FI-17',
        name: 'Satakunta',
        parent: 'FI',
    },
    'FI-18': {
        code: 'FI-18',
        name: 'Uusimaa',
        parent: 'FI',
    },
    'FI-19': {
        code: 'FI-19',
        name: 'Varsinais-Suomi',
        parent: 'FI',
    },
    'FJ-01': {
        code: 'FJ-01',
        name: 'Ba',
        parent: 'FJ-W',
    },
    'FJ-02': {
        code: 'FJ-02',
        name: 'Bua',
        parent: 'FJ-N',
    },
    'FJ-03': {
        code: 'FJ-03',
        name: 'Cakaudrove',
        parent: 'FJ-N',
    },
    'FJ-04': {
        code: 'FJ-04',
        name: 'Kadavu',
        parent: 'FJ-E',
    },
    'FJ-05': {
        code: 'FJ-05',
        name: 'Lau',
        parent: 'FJ-E',
    },
    'FJ-06': {
        code: 'FJ-06',
        name: 'Lomaiviti',
        parent: 'FJ-E',
    },
    'FJ-07': {
        code: 'FJ-07',
        name: 'Macuata',
        parent: 'FJ-N',
    },
    'FJ-08': {
        code: 'FJ-08',
        name: 'Nadroga and Navosa',
        parent: 'FJ-W',
    },
    'FJ-09': {
        code: 'FJ-09',
        name: 'Naitasiri',
        parent: 'FJ-C',
    },
    'FJ-10': {
        code: 'FJ-10',
        name: 'Namosi',
        parent: 'FJ-C',
    },
    'FJ-11': {
        code: 'FJ-11',
        name: 'Ra',
        parent: 'FJ-W',
    },
    'FJ-12': {
        code: 'FJ-12',
        name: 'Rewa',
        parent: 'FJ-C',
    },
    'FJ-13': {
        code: 'FJ-13',
        name: 'Serua',
        parent: 'FJ-C',
    },
    'FJ-14': {
        code: 'FJ-14',
        name: 'Tailevu',
        parent: 'FJ-C',
    },
    'FJ-C': {
        code: 'FJ-C',
        name: 'Central',
        parent: 'FJ',
    },
    'FJ-E': {
        code: 'FJ-E',
        name: 'Eastern',
        parent: 'FJ',
    },
    'FJ-N': {
        code: 'FJ-N',
        name: 'Northern',
        parent: 'FJ',
    },
    'FJ-R': {
        code: 'FJ-R',
        name: 'Rotuma',
        parent: 'FJ',
    },
    'FJ-W': {
        code: 'FJ-W',
        name: 'Western',
        parent: 'FJ',
    },
    'FM-KSA': {
        code: 'FM-KSA',
        name: 'Kosrae',
        parent: 'FM',
    },
    'FM-PNI': {
        code: 'FM-PNI',
        name: 'Pohnpei',
        parent: 'FM',
    },
    'FM-TRK': {
        code: 'FM-TRK',
        name: 'Chuuk',
        parent: 'FM',
    },
    'FM-YAP': {
        code: 'FM-YAP',
        name: 'Yap',
        parent: 'FM',
    },
    'FR-01': {
        code: 'FR-01',
        name: 'Ain',
        parent: 'FR-ARA',
    },
    'FR-02': {
        code: 'FR-02',
        name: 'Aisne',
        parent: 'FR-HDF',
    },
    'FR-03': {
        code: 'FR-03',
        name: 'Allier',
        parent: 'FR-ARA',
    },
    'FR-04': {
        code: 'FR-04',
        name: 'Alpes-de-Haute-Provence',
        parent: 'FR-PAC',
    },
    'FR-05': {
        code: 'FR-05',
        name: 'Hautes-Alpes',
        parent: 'FR-PAC',
    },
    'FR-06': {
        code: 'FR-06',
        name: 'Alpes-Maritimes',
        parent: 'FR-PAC',
    },
    'FR-07': {
        code: 'FR-07',
        name: 'Ardèche',
        parent: 'FR-ARA',
    },
    'FR-08': {
        code: 'FR-08',
        name: 'Ardennes',
        parent: 'FR-GES',
    },
    'FR-09': {
        code: 'FR-09',
        name: 'Ariège',
        parent: 'FR-OCC',
    },
    'FR-10': {
        code: 'FR-10',
        name: 'Aube',
        parent: 'FR-GES',
    },
    'FR-11': {
        code: 'FR-11',
        name: 'Aude',
        parent: 'FR-OCC',
    },
    'FR-12': {
        code: 'FR-12',
        name: 'Aveyron',
        parent: 'FR-OCC',
    },
    'FR-13': {
        code: 'FR-13',
        name: 'Bouches-du-Rhône',
        parent: 'FR-PAC',
    },
    'FR-14': {
        code: 'FR-14',
        name: 'Calvados',
        parent: 'FR-NOR',
    },
    'FR-15': {
        code: 'FR-15',
        name: 'Cantal',
        parent: 'FR-ARA',
    },
    'FR-16': {
        code: 'FR-16',
        name: 'Charente',
        parent: 'FR-NAQ',
    },
    'FR-17': {
        code: 'FR-17',
        name: 'Charente-Maritime',
        parent: 'FR-NAQ',
    },
    'FR-18': {
        code: 'FR-18',
        name: 'Cher',
        parent: 'FR-CVL',
    },
    'FR-19': {
        code: 'FR-19',
        name: 'Corrèze',
        parent: 'FR-NAQ',
    },
    'FR-20R': {
        code: 'FR-20R',
        name: 'Corse',
        parent: 'FR',
    },
    'FR-21': {
        code: 'FR-21',
        name: "Côte-d'Or",
        parent: 'FR-BFC',
    },
    'FR-22': {
        code: 'FR-22',
        name: "Côtes-d'Armor",
        parent: 'FR-BRE',
    },
    'FR-23': {
        code: 'FR-23',
        name: 'Creuse',
        parent: 'FR-NAQ',
    },
    'FR-24': {
        code: 'FR-24',
        name: 'Dordogne',
        parent: 'FR-NAQ',
    },
    'FR-25': {
        code: 'FR-25',
        name: 'Doubs',
        parent: 'FR-BFC',
    },
    'FR-26': {
        code: 'FR-26',
        name: 'Drôme',
        parent: 'FR-ARA',
    },
    'FR-27': {
        code: 'FR-27',
        name: 'Eure',
        parent: 'FR-NOR',
    },
    'FR-28': {
        code: 'FR-28',
        name: 'Eure-et-Loir',
        parent: 'FR-CVL',
    },
    'FR-29': {
        code: 'FR-29',
        name: 'Finistère',
        parent: 'FR-BRE',
    },
    'FR-2A': {
        code: 'FR-2A',
        name: 'Corse-du-Sud',
        parent: 'FR-20R',
    },
    'FR-2B': {
        code: 'FR-2B',
        name: 'Haute-Corse',
        parent: 'FR-20R',
    },
    'FR-30': {
        code: 'FR-30',
        name: 'Gard',
        parent: 'FR-OCC',
    },
    'FR-31': {
        code: 'FR-31',
        name: 'Haute-Garonne',
        parent: 'FR-OCC',
    },
    'FR-32': {
        code: 'FR-32',
        name: 'Gers',
        parent: 'FR-OCC',
    },
    'FR-33': {
        code: 'FR-33',
        name: 'Gironde',
        parent: 'FR-NAQ',
    },
    'FR-34': {
        code: 'FR-34',
        name: 'Hérault',
        parent: 'FR-OCC',
    },
    'FR-35': {
        code: 'FR-35',
        name: 'Ille-et-Vilaine',
        parent: 'FR-BRE',
    },
    'FR-36': {
        code: 'FR-36',
        name: 'Indre',
        parent: 'FR-CVL',
    },
    'FR-37': {
        code: 'FR-37',
        name: 'Indre-et-Loire',
        parent: 'FR-CVL',
    },
    'FR-38': {
        code: 'FR-38',
        name: 'Isère',
        parent: 'FR-ARA',
    },
    'FR-39': {
        code: 'FR-39',
        name: 'Jura',
        parent: 'FR-BFC',
    },
    'FR-40': {
        code: 'FR-40',
        name: 'Landes',
        parent: 'FR-NAQ',
    },
    'FR-41': {
        code: 'FR-41',
        name: 'Loir-et-Cher',
        parent: 'FR-CVL',
    },
    'FR-42': {
        code: 'FR-42',
        name: 'Loire',
        parent: 'FR-ARA',
    },
    'FR-43': {
        code: 'FR-43',
        name: 'Haute-Loire',
        parent: 'FR-ARA',
    },
    'FR-44': {
        code: 'FR-44',
        name: 'Loire-Atlantique',
        parent: 'FR-PDL',
    },
    'FR-45': {
        code: 'FR-45',
        name: 'Loiret',
        parent: 'FR-CVL',
    },
    'FR-46': {
        code: 'FR-46',
        name: 'Lot',
        parent: 'FR-OCC',
    },
    'FR-47': {
        code: 'FR-47',
        name: 'Lot-et-Garonne',
        parent: 'FR-NAQ',
    },
    'FR-48': {
        code: 'FR-48',
        name: 'Lozère',
        parent: 'FR-OCC',
    },
    'FR-49': {
        code: 'FR-49',
        name: 'Maine-et-Loire',
        parent: 'FR-PDL',
    },
    'FR-50': {
        code: 'FR-50',
        name: 'Manche',
        parent: 'FR-NOR',
    },
    'FR-51': {
        code: 'FR-51',
        name: 'Marne',
        parent: 'FR-GES',
    },
    'FR-52': {
        code: 'FR-52',
        name: 'Haute-Marne',
        parent: 'FR-GES',
    },
    'FR-53': {
        code: 'FR-53',
        name: 'Mayenne',
        parent: 'FR-PDL',
    },
    'FR-54': {
        code: 'FR-54',
        name: 'Meurthe-et-Moselle',
        parent: 'FR-GES',
    },
    'FR-55': {
        code: 'FR-55',
        name: 'Meuse',
        parent: 'FR-GES',
    },
    'FR-56': {
        code: 'FR-56',
        name: 'Morbihan',
        parent: 'FR-BRE',
    },
    'FR-57': {
        code: 'FR-57',
        name: 'Moselle',
        parent: 'FR-GES',
    },
    'FR-58': {
        code: 'FR-58',
        name: 'Nièvre',
        parent: 'FR-BFC',
    },
    'FR-59': {
        code: 'FR-59',
        name: 'Nord',
        parent: 'FR-HDF',
    },
    'FR-60': {
        code: 'FR-60',
        name: 'Oise',
        parent: 'FR-HDF',
    },
    'FR-61': {
        code: 'FR-61',
        name: 'Orne',
        parent: 'FR-NOR',
    },
    'FR-62': {
        code: 'FR-62',
        name: 'Pas-de-Calais',
        parent: 'FR-HDF',
    },
    'FR-63': {
        code: 'FR-63',
        name: 'Puy-de-Dôme',
        parent: 'FR-ARA',
    },
    'FR-64': {
        code: 'FR-64',
        name: 'Pyrénées-Atlantiques',
        parent: 'FR-NAQ',
    },
    'FR-65': {
        code: 'FR-65',
        name: 'Hautes-Pyrénées',
        parent: 'FR-OCC',
    },
    'FR-66': {
        code: 'FR-66',
        name: 'Pyrénées-Orientales',
        parent: 'FR-OCC',
    },
    'FR-67': {
        code: 'FR-67',
        name: 'Bas-Rhin',
        parent: 'FR-GES',
    },
    'FR-68': {
        code: 'FR-68',
        name: 'Haut-Rhin',
        parent: 'FR-GES',
    },
    'FR-69': {
        code: 'FR-69',
        name: 'Rhône',
        parent: 'FR-ARA',
    },
    'FR-70': {
        code: 'FR-70',
        name: 'Haute-Saône',
        parent: 'FR-BFC',
    },
    'FR-71': {
        code: 'FR-71',
        name: 'Saône-et-Loire',
        parent: 'FR-BFC',
    },
    'FR-72': {
        code: 'FR-72',
        name: 'Sarthe',
        parent: 'FR-PDL',
    },
    'FR-73': {
        code: 'FR-73',
        name: 'Savoie',
        parent: 'FR-ARA',
    },
    'FR-74': {
        code: 'FR-74',
        name: 'Haute-Savoie',
        parent: 'FR-ARA',
    },
    'FR-75': {
        code: 'FR-75',
        name: 'Paris',
        parent: 'FR-IDF',
    },
    'FR-76': {
        code: 'FR-76',
        name: 'Seine-Maritime',
        parent: 'FR-NOR',
    },
    'FR-77': {
        code: 'FR-77',
        name: 'Seine-et-Marne',
        parent: 'FR-IDF',
    },
    'FR-78': {
        code: 'FR-78',
        name: 'Yvelines',
        parent: 'FR-IDF',
    },
    'FR-79': {
        code: 'FR-79',
        name: 'Deux-Sèvres',
        parent: 'FR-NAQ',
    },
    'FR-80': {
        code: 'FR-80',
        name: 'Somme',
        parent: 'FR-HDF',
    },
    'FR-81': {
        code: 'FR-81',
        name: 'Tarn',
        parent: 'FR-OCC',
    },
    'FR-82': {
        code: 'FR-82',
        name: 'Tarn-et-Garonne',
        parent: 'FR-OCC',
    },
    'FR-83': {
        code: 'FR-83',
        name: 'Var',
        parent: 'FR-PAC',
    },
    'FR-84': {
        code: 'FR-84',
        name: 'Vaucluse',
        parent: 'FR-PAC',
    },
    'FR-85': {
        code: 'FR-85',
        name: 'Vendée',
        parent: 'FR-PDL',
    },
    'FR-86': {
        code: 'FR-86',
        name: 'Vienne',
        parent: 'FR-NAQ',
    },
    'FR-87': {
        code: 'FR-87',
        name: 'Haute-Vienne',
        parent: 'FR-NAQ',
    },
    'FR-88': {
        code: 'FR-88',
        name: 'Vosges',
        parent: 'FR-GES',
    },
    'FR-89': {
        code: 'FR-89',
        name: 'Yonne',
        parent: 'FR-BFC',
    },
    'FR-90': {
        code: 'FR-90',
        name: 'Territoire de Belfort',
        parent: 'FR-BFC',
    },
    'FR-91': {
        code: 'FR-91',
        name: 'Essonne',
        parent: 'FR-IDF',
    },
    'FR-92': {
        code: 'FR-92',
        name: 'Hauts-de-Seine',
        parent: 'FR-IDF',
    },
    'FR-93': {
        code: 'FR-93',
        name: 'Seine-Saint-Denis',
        parent: 'FR-IDF',
    },
    'FR-94': {
        code: 'FR-94',
        name: 'Val-de-Marne',
        parent: 'FR-IDF',
    },
    'FR-95': {
        code: 'FR-95',
        name: "Val-d'Oise",
        parent: 'FR-IDF',
    },
    'FR-971': {
        code: 'FR-971',
        name: 'Guadeloupe',
        parent: 'FR-GP',
    },
    'FR-972': {
        code: 'FR-972',
        name: 'Martinique',
        parent: 'FR-MQ',
    },
    'FR-973': {
        code: 'FR-973',
        name: 'Guyane (française)',
        parent: 'FR-GF',
    },
    'FR-974': {
        code: 'FR-974',
        name: 'La Réunion',
        parent: 'FR-RE',
    },
    'FR-976': {
        code: 'FR-976',
        name: 'Mayotte',
        parent: 'FR-YT',
    },
    'FR-ARA': {
        code: 'FR-ARA',
        name: 'Auvergne-Rhône-Alpes',
        parent: 'FR',
    },
    'FR-BFC': {
        code: 'FR-BFC',
        name: 'Bourgogne-Franche-Comté',
        parent: 'FR',
    },
    'FR-BL': {
        code: 'FR-BL',
        name: 'Saint-Barthélemy',
        parent: 'FR',
    },
    'FR-BRE': {
        code: 'FR-BRE',
        name: 'Bretagne',
        parent: 'FR',
    },
    'FR-CP': {
        code: 'FR-CP',
        name: 'Clipperton',
        parent: 'FR',
    },
    'FR-CVL': {
        code: 'FR-CVL',
        name: 'Centre-Val de Loire',
        parent: 'FR',
    },
    'FR-GES': {
        code: 'FR-GES',
        name: 'Grand-Est',
        parent: 'FR',
    },
    'FR-GF': {
        code: 'FR-GF',
        name: 'Guyane (française)',
        parent: 'FR',
    },
    'FR-GP': {
        code: 'FR-GP',
        name: 'Guadeloupe',
        parent: 'FR',
    },
    'FR-HDF': {
        code: 'FR-HDF',
        name: 'Hauts-de-France',
        parent: 'FR',
    },
    'FR-IDF': {
        code: 'FR-IDF',
        name: 'Île-de-France',
        parent: 'FR',
    },
    'FR-MF': {
        code: 'FR-MF',
        name: 'Saint-Martin',
        parent: 'FR',
    },
    'FR-MQ': {
        code: 'FR-MQ',
        name: 'Martinique',
        parent: 'FR',
    },
    'FR-NAQ': {
        code: 'FR-NAQ',
        name: 'Nouvelle-Aquitaine',
        parent: 'FR',
    },
    'FR-NC': {
        code: 'FR-NC',
        name: 'Nouvelle-Calédonie',
        parent: 'FR',
    },
    'FR-NOR': {
        code: 'FR-NOR',
        name: 'Normandie',
        parent: 'FR',
    },
    'FR-OCC': {
        code: 'FR-OCC',
        name: 'Occitanie',
        parent: 'FR',
    },
    'FR-PAC': {
        code: 'FR-PAC',
        name: 'Provence-Alpes-Côte-d’Azur',
        parent: 'FR',
    },
    'FR-PDL': {
        code: 'FR-PDL',
        name: 'Pays-de-la-Loire',
        parent: 'FR',
    },
    'FR-PF': {
        code: 'FR-PF',
        name: 'Polynésie française',
        parent: 'FR',
    },
    'FR-PM': {
        code: 'FR-PM',
        name: 'Saint-Pierre-et-Miquelon',
        parent: 'FR',
    },
    'FR-RE': {
        code: 'FR-RE',
        name: 'La Réunion',
        parent: 'FR',
    },
    'FR-TF': {
        code: 'FR-TF',
        name: 'Terres australes françaises',
        parent: 'FR',
    },
    'FR-WF': {
        code: 'FR-WF',
        name: 'Wallis-et-Futuna',
        parent: 'FR',
    },
    'FR-YT': {
        code: 'FR-YT',
        name: 'Mayotte',
        parent: 'FR',
    },
    'GA-1': {
        code: 'GA-1',
        name: 'Estuaire',
        parent: 'GA',
    },
    'GA-2': {
        code: 'GA-2',
        name: 'Haut-Ogooué',
        parent: 'GA',
    },
    'GA-3': {
        code: 'GA-3',
        name: 'Moyen-Ogooué',
        parent: 'GA',
    },
    'GA-4': {
        code: 'GA-4',
        name: 'Ngounié',
        parent: 'GA',
    },
    'GA-5': {
        code: 'GA-5',
        name: 'Nyanga',
        parent: 'GA',
    },
    'GA-6': {
        code: 'GA-6',
        name: 'Ogooué-Ivindo',
        parent: 'GA',
    },
    'GA-7': {
        code: 'GA-7',
        name: 'Ogooué-Lolo',
        parent: 'GA',
    },
    'GA-8': {
        code: 'GA-8',
        name: 'Ogooué-Maritime',
        parent: 'GA',
    },
    'GA-9': {
        code: 'GA-9',
        name: 'Woleu-Ntem',
        parent: 'GA',
    },
    'GB-ABC': {
        code: 'GB-ABC',
        name: 'Armagh City, Banbridge and Craigavon',
        parent: 'GB-NIR',
    },
    'GB-ABD': {
        code: 'GB-ABD',
        name: 'Aberdeenshire',
        parent: 'GB-SCT',
    },
    'GB-ABE': {
        code: 'GB-ABE',
        name: 'Aberdeen City',
        parent: 'GB-SCT',
    },
    'GB-AGB': {
        code: 'GB-AGB',
        name: 'Argyll and Bute',
        parent: 'GB-SCT',
    },
    'GB-AGY': {
        code: 'GB-AGY',
        name: 'Isle of Anglesey',
        parent: 'GB-WLS',
    },
    'GB-AND': {
        code: 'GB-AND',
        name: 'Ards and North Down',
        parent: 'GB-NIR',
    },
    'GB-ANN': {
        code: 'GB-ANN',
        name: 'Antrim and Newtownabbey',
        parent: 'GB-NIR',
    },
    'GB-ANS': {
        code: 'GB-ANS',
        name: 'Angus',
        parent: 'GB-SCT',
    },
    'GB-BAS': {
        code: 'GB-BAS',
        name: 'Bath and North East Somerset',
        parent: 'GB-ENG',
    },
    'GB-BBD': {
        code: 'GB-BBD',
        name: 'Blackburn with Darwen',
        parent: 'GB-ENG',
    },
    'GB-BCP': {
        code: 'GB-BCP',
        name: 'Bournemouth, Christchurch and Poole',
        parent: 'GB-ENG',
    },
    'GB-BDF': {
        code: 'GB-BDF',
        name: 'Bedford',
        parent: 'GB-ENG',
    },
    'GB-BDG': {
        code: 'GB-BDG',
        name: 'Barking and Dagenham',
        parent: 'GB-ENG',
    },
    'GB-BEN': {
        code: 'GB-BEN',
        name: 'Brent',
        parent: 'GB-ENG',
    },
    'GB-BEX': {
        code: 'GB-BEX',
        name: 'Bexley',
        parent: 'GB-ENG',
    },
    'GB-BFS': {
        code: 'GB-BFS',
        name: 'Belfast City',
        parent: 'GB-NIR',
    },
    'GB-BGE': {
        code: 'GB-BGE',
        name: 'Bridgend',
        parent: 'GB-WLS',
    },
    'GB-BGW': {
        code: 'GB-BGW',
        name: 'Blaenau Gwent',
        parent: 'GB-WLS',
    },
    'GB-BIR': {
        code: 'GB-BIR',
        name: 'Birmingham',
        parent: 'GB-ENG',
    },
    'GB-BKM': {
        code: 'GB-BKM',
        name: 'Buckinghamshire',
        parent: 'GB-ENG',
    },
    'GB-BNE': {
        code: 'GB-BNE',
        name: 'Barnet',
        parent: 'GB-ENG',
    },
    'GB-BNH': {
        code: 'GB-BNH',
        name: 'Brighton and Hove',
        parent: 'GB-ENG',
    },
    'GB-BNS': {
        code: 'GB-BNS',
        name: 'Barnsley',
        parent: 'GB-ENG',
    },
    'GB-BOL': {
        code: 'GB-BOL',
        name: 'Bolton',
        parent: 'GB-ENG',
    },
    'GB-BPL': {
        code: 'GB-BPL',
        name: 'Blackpool',
        parent: 'GB-ENG',
    },
    'GB-BRC': {
        code: 'GB-BRC',
        name: 'Bracknell Forest',
        parent: 'GB-ENG',
    },
    'GB-BRD': {
        code: 'GB-BRD',
        name: 'Bradford',
        parent: 'GB-ENG',
    },
    'GB-BRY': {
        code: 'GB-BRY',
        name: 'Bromley',
        parent: 'GB-ENG',
    },
    'GB-BST': {
        code: 'GB-BST',
        name: 'Bristol, City of',
        parent: 'GB-ENG',
    },
    'GB-BUR': {
        code: 'GB-BUR',
        name: 'Bury',
        parent: 'GB-ENG',
    },
    'GB-CAM': {
        code: 'GB-CAM',
        name: 'Cambridgeshire',
        parent: 'GB-ENG',
    },
    'GB-CAY': {
        code: 'GB-CAY',
        name: 'Caerphilly',
        parent: 'GB-WLS',
    },
    'GB-CBF': {
        code: 'GB-CBF',
        name: 'Central Bedfordshire',
        parent: 'GB-ENG',
    },
    'GB-CCG': {
        code: 'GB-CCG',
        name: 'Causeway Coast and Glens',
        parent: 'GB-NIR',
    },
    'GB-CGN': {
        code: 'GB-CGN',
        name: 'Ceredigion',
        parent: 'GB-WLS',
    },
    'GB-CHE': {
        code: 'GB-CHE',
        name: 'Cheshire East',
        parent: 'GB-ENG',
    },
    'GB-CHW': {
        code: 'GB-CHW',
        name: 'Cheshire West and Chester',
        parent: 'GB-ENG',
    },
    'GB-CLD': {
        code: 'GB-CLD',
        name: 'Calderdale',
        parent: 'GB-ENG',
    },
    'GB-CLK': {
        code: 'GB-CLK',
        name: 'Clackmannanshire',
        parent: 'GB-SCT',
    },
    'GB-CMA': {
        code: 'GB-CMA',
        name: 'Cumbria',
        parent: 'GB-ENG',
    },
    'GB-CMD': {
        code: 'GB-CMD',
        name: 'Camden',
        parent: 'GB-ENG',
    },
    'GB-CMN': {
        code: 'GB-CMN',
        name: 'Carmarthenshire',
        parent: 'GB-WLS',
    },
    'GB-CON': {
        code: 'GB-CON',
        name: 'Cornwall',
        parent: 'GB-ENG',
    },
    'GB-COV': {
        code: 'GB-COV',
        name: 'Coventry',
        parent: 'GB-ENG',
    },
    'GB-CRF': {
        code: 'GB-CRF',
        name: 'Cardiff',
        parent: 'GB-WLS',
    },
    'GB-CRY': {
        code: 'GB-CRY',
        name: 'Croydon',
        parent: 'GB-ENG',
    },
    'GB-CWY': {
        code: 'GB-CWY',
        name: 'Conwy',
        parent: 'GB-WLS',
    },
    'GB-DAL': {
        code: 'GB-DAL',
        name: 'Darlington',
        parent: 'GB-ENG',
    },
    'GB-DBY': {
        code: 'GB-DBY',
        name: 'Derbyshire',
        parent: 'GB-ENG',
    },
    'GB-DEN': {
        code: 'GB-DEN',
        name: 'Denbighshire',
        parent: 'GB-WLS',
    },
    'GB-DER': {
        code: 'GB-DER',
        name: 'Derby',
        parent: 'GB-ENG',
    },
    'GB-DEV': {
        code: 'GB-DEV',
        name: 'Devon',
        parent: 'GB-ENG',
    },
    'GB-DGY': {
        code: 'GB-DGY',
        name: 'Dumfries and Galloway',
        parent: 'GB-SCT',
    },
    'GB-DNC': {
        code: 'GB-DNC',
        name: 'Doncaster',
        parent: 'GB-ENG',
    },
    'GB-DND': {
        code: 'GB-DND',
        name: 'Dundee City',
        parent: 'GB-SCT',
    },
    'GB-DOR': {
        code: 'GB-DOR',
        name: 'Dorset',
        parent: 'GB-ENG',
    },
    'GB-DRS': {
        code: 'GB-DRS',
        name: 'Derry and Strabane',
        parent: 'GB-NIR',
    },
    'GB-DUD': {
        code: 'GB-DUD',
        name: 'Dudley',
        parent: 'GB-ENG',
    },
    'GB-DUR': {
        code: 'GB-DUR',
        name: 'Durham, County',
        parent: 'GB-ENG',
    },
    'GB-EAL': {
        code: 'GB-EAL',
        name: 'Ealing',
        parent: 'GB-ENG',
    },
    'GB-EAW': {
        code: 'GB-EAW',
        name: 'England and Wales',
        parent: 'GB',
    },
    'GB-EAY': {
        code: 'GB-EAY',
        name: 'East Ayrshire',
        parent: 'GB-SCT',
    },
    'GB-EDH': {
        code: 'GB-EDH',
        name: 'Edinburgh, City of',
        parent: 'GB-SCT',
    },
    'GB-EDU': {
        code: 'GB-EDU',
        name: 'East Dunbartonshire',
        parent: 'GB-SCT',
    },
    'GB-ELN': {
        code: 'GB-ELN',
        name: 'East Lothian',
        parent: 'GB-SCT',
    },
    'GB-ELS': {
        code: 'GB-ELS',
        name: 'Eilean Siar',
        parent: 'GB-SCT',
    },
    'GB-ENF': {
        code: 'GB-ENF',
        name: 'Enfield',
        parent: 'GB-ENG',
    },
    'GB-ENG': {
        code: 'GB-ENG',
        name: 'England',
        parent: 'GB',
    },
    'GB-ERW': {
        code: 'GB-ERW',
        name: 'East Renfrewshire',
        parent: 'GB-SCT',
    },
    'GB-ERY': {
        code: 'GB-ERY',
        name: 'East Riding of Yorkshire',
        parent: 'GB-ENG',
    },
    'GB-ESS': {
        code: 'GB-ESS',
        name: 'Essex',
        parent: 'GB-ENG',
    },
    'GB-ESX': {
        code: 'GB-ESX',
        name: 'East Sussex',
        parent: 'GB-ENG',
    },
    'GB-FAL': {
        code: 'GB-FAL',
        name: 'Falkirk',
        parent: 'GB-SCT',
    },
    'GB-FIF': {
        code: 'GB-FIF',
        name: 'Fife',
        parent: 'GB-SCT',
    },
    'GB-FLN': {
        code: 'GB-FLN',
        name: 'Flintshire',
        parent: 'GB-WLS',
    },
    'GB-FMO': {
        code: 'GB-FMO',
        name: 'Fermanagh and Omagh',
        parent: 'GB-NIR',
    },
    'GB-GAT': {
        code: 'GB-GAT',
        name: 'Gateshead',
        parent: 'GB-ENG',
    },
    'GB-GBN': {
        code: 'GB-GBN',
        name: 'Great Britain',
        parent: 'GB',
    },
    'GB-GLG': {
        code: 'GB-GLG',
        name: 'Glasgow City',
        parent: 'GB-SCT',
    },
    'GB-GLS': {
        code: 'GB-GLS',
        name: 'Gloucestershire',
        parent: 'GB-ENG',
    },
    'GB-GRE': {
        code: 'GB-GRE',
        name: 'Greenwich',
        parent: 'GB-ENG',
    },
    'GB-GWN': {
        code: 'GB-GWN',
        name: 'Gwynedd',
        parent: 'GB-WLS',
    },
    'GB-HAL': {
        code: 'GB-HAL',
        name: 'Halton',
        parent: 'GB-ENG',
    },
    'GB-HAM': {
        code: 'GB-HAM',
        name: 'Hampshire',
        parent: 'GB-ENG',
    },
    'GB-HAV': {
        code: 'GB-HAV',
        name: 'Havering',
        parent: 'GB-ENG',
    },
    'GB-HCK': {
        code: 'GB-HCK',
        name: 'Hackney',
        parent: 'GB-ENG',
    },
    'GB-HEF': {
        code: 'GB-HEF',
        name: 'Herefordshire',
        parent: 'GB-ENG',
    },
    'GB-HIL': {
        code: 'GB-HIL',
        name: 'Hillingdon',
        parent: 'GB-ENG',
    },
    'GB-HLD': {
        code: 'GB-HLD',
        name: 'Highland',
        parent: 'GB-SCT',
    },
    'GB-HMF': {
        code: 'GB-HMF',
        name: 'Hammersmith and Fulham',
        parent: 'GB-ENG',
    },
    'GB-HNS': {
        code: 'GB-HNS',
        name: 'Hounslow',
        parent: 'GB-ENG',
    },
    'GB-HPL': {
        code: 'GB-HPL',
        name: 'Hartlepool',
        parent: 'GB-ENG',
    },
    'GB-HRT': {
        code: 'GB-HRT',
        name: 'Hertfordshire',
        parent: 'GB-ENG',
    },
    'GB-HRW': {
        code: 'GB-HRW',
        name: 'Harrow',
        parent: 'GB-ENG',
    },
    'GB-HRY': {
        code: 'GB-HRY',
        name: 'Haringey',
        parent: 'GB-ENG',
    },
    'GB-IOS': {
        code: 'GB-IOS',
        name: 'Isles of Scilly',
        parent: 'GB-ENG',
    },
    'GB-IOW': {
        code: 'GB-IOW',
        name: 'Isle of Wight',
        parent: 'GB-ENG',
    },
    'GB-ISL': {
        code: 'GB-ISL',
        name: 'Islington',
        parent: 'GB-ENG',
    },
    'GB-IVC': {
        code: 'GB-IVC',
        name: 'Inverclyde',
        parent: 'GB-SCT',
    },
    'GB-KEC': {
        code: 'GB-KEC',
        name: 'Kensington and Chelsea',
        parent: 'GB-ENG',
    },
    'GB-KEN': {
        code: 'GB-KEN',
        name: 'Kent',
        parent: 'GB-ENG',
    },
    'GB-KHL': {
        code: 'GB-KHL',
        name: 'Kingston upon Hull',
        parent: 'GB-ENG',
    },
    'GB-KIR': {
        code: 'GB-KIR',
        name: 'Kirklees',
        parent: 'GB-ENG',
    },
    'GB-KTT': {
        code: 'GB-KTT',
        name: 'Kingston upon Thames',
        parent: 'GB-ENG',
    },
    'GB-KWL': {
        code: 'GB-KWL',
        name: 'Knowsley',
        parent: 'GB-ENG',
    },
    'GB-LAN': {
        code: 'GB-LAN',
        name: 'Lancashire',
        parent: 'GB-ENG',
    },
    'GB-LBC': {
        code: 'GB-LBC',
        name: 'Lisburn and Castlereagh',
        parent: 'GB-NIR',
    },
    'GB-LBH': {
        code: 'GB-LBH',
        name: 'Lambeth',
        parent: 'GB-ENG',
    },
    'GB-LCE': {
        code: 'GB-LCE',
        name: 'Leicester',
        parent: 'GB-ENG',
    },
    'GB-LDS': {
        code: 'GB-LDS',
        name: 'Leeds',
        parent: 'GB-ENG',
    },
    'GB-LEC': {
        code: 'GB-LEC',
        name: 'Leicestershire',
        parent: 'GB-ENG',
    },
    'GB-LEW': {
        code: 'GB-LEW',
        name: 'Lewisham',
        parent: 'GB-ENG',
    },
    'GB-LIN': {
        code: 'GB-LIN',
        name: 'Lincolnshire',
        parent: 'GB-ENG',
    },
    'GB-LIV': {
        code: 'GB-LIV',
        name: 'Liverpool',
        parent: 'GB-ENG',
    },
    'GB-LND': {
        code: 'GB-LND',
        name: 'London, City of',
        parent: 'GB-ENG',
    },
    'GB-LUT': {
        code: 'GB-LUT',
        name: 'Luton',
        parent: 'GB-ENG',
    },
    'GB-MAN': {
        code: 'GB-MAN',
        name: 'Manchester',
        parent: 'GB-ENG',
    },
    'GB-MDB': {
        code: 'GB-MDB',
        name: 'Middlesbrough',
        parent: 'GB-ENG',
    },
    'GB-MDW': {
        code: 'GB-MDW',
        name: 'Medway',
        parent: 'GB-ENG',
    },
    'GB-MEA': {
        code: 'GB-MEA',
        name: 'Mid and East Antrim',
        parent: 'GB-NIR',
    },
    'GB-MIK': {
        code: 'GB-MIK',
        name: 'Milton Keynes',
        parent: 'GB-ENG',
    },
    'GB-MLN': {
        code: 'GB-MLN',
        name: 'Midlothian',
        parent: 'GB-SCT',
    },
    'GB-MON': {
        code: 'GB-MON',
        name: 'Monmouthshire',
        parent: 'GB-WLS',
    },
    'GB-MRT': {
        code: 'GB-MRT',
        name: 'Merton',
        parent: 'GB-ENG',
    },
    'GB-MRY': {
        code: 'GB-MRY',
        name: 'Moray',
        parent: 'GB-SCT',
    },
    'GB-MTY': {
        code: 'GB-MTY',
        name: 'Merthyr Tydfil',
        parent: 'GB-WLS',
    },
    'GB-MUL': {
        code: 'GB-MUL',
        name: 'Mid-Ulster',
        parent: 'GB-NIR',
    },
    'GB-NAY': {
        code: 'GB-NAY',
        name: 'North Ayrshire',
        parent: 'GB-SCT',
    },
    'GB-NBL': {
        code: 'GB-NBL',
        name: 'Northumberland',
        parent: 'GB-ENG',
    },
    'GB-NEL': {
        code: 'GB-NEL',
        name: 'North East Lincolnshire',
        parent: 'GB-ENG',
    },
    'GB-NET': {
        code: 'GB-NET',
        name: 'Newcastle upon Tyne',
        parent: 'GB-ENG',
    },
    'GB-NFK': {
        code: 'GB-NFK',
        name: 'Norfolk',
        parent: 'GB-ENG',
    },
    'GB-NGM': {
        code: 'GB-NGM',
        name: 'Nottingham',
        parent: 'GB-ENG',
    },
    'GB-NIR': {
        code: 'GB-NIR',
        name: 'Northern Ireland',
        parent: 'GB',
    },
    'GB-NLK': {
        code: 'GB-NLK',
        name: 'North Lanarkshire',
        parent: 'GB-SCT',
    },
    'GB-NLN': {
        code: 'GB-NLN',
        name: 'North Lincolnshire',
        parent: 'GB-ENG',
    },
    'GB-NMD': {
        code: 'GB-NMD',
        name: 'Newry, Mourne and Down',
        parent: 'GB-NIR',
    },
    'GB-NSM': {
        code: 'GB-NSM',
        name: 'North Somerset',
        parent: 'GB-ENG',
    },
    'GB-NTH': {
        code: 'GB-NTH',
        name: 'Northamptonshire',
        parent: 'GB-ENG',
    },
    'GB-NTL': {
        code: 'GB-NTL',
        name: 'Neath Port Talbot',
        parent: 'GB-WLS',
    },
    'GB-NTT': {
        code: 'GB-NTT',
        name: 'Nottinghamshire',
        parent: 'GB-ENG',
    },
    'GB-NTY': {
        code: 'GB-NTY',
        name: 'North Tyneside',
        parent: 'GB-ENG',
    },
    'GB-NWM': {
        code: 'GB-NWM',
        name: 'Newham',
        parent: 'GB-ENG',
    },
    'GB-NWP': {
        code: 'GB-NWP',
        name: 'Newport',
        parent: 'GB-WLS',
    },
    'GB-NYK': {
        code: 'GB-NYK',
        name: 'North Yorkshire',
        parent: 'GB-ENG',
    },
    'GB-OLD': {
        code: 'GB-OLD',
        name: 'Oldham',
        parent: 'GB-ENG',
    },
    'GB-ORK': {
        code: 'GB-ORK',
        name: 'Orkney Islands',
        parent: 'GB-SCT',
    },
    'GB-OXF': {
        code: 'GB-OXF',
        name: 'Oxfordshire',
        parent: 'GB-ENG',
    },
    'GB-PEM': {
        code: 'GB-PEM',
        name: 'Pembrokeshire',
        parent: 'GB-WLS',
    },
    'GB-PKN': {
        code: 'GB-PKN',
        name: 'Perth and Kinross',
        parent: 'GB-SCT',
    },
    'GB-PLY': {
        code: 'GB-PLY',
        name: 'Plymouth',
        parent: 'GB-ENG',
    },
    'GB-POR': {
        code: 'GB-POR',
        name: 'Portsmouth',
        parent: 'GB-ENG',
    },
    'GB-POW': {
        code: 'GB-POW',
        name: 'Powys',
        parent: 'GB-WLS',
    },
    'GB-PTE': {
        code: 'GB-PTE',
        name: 'Peterborough',
        parent: 'GB-ENG',
    },
    'GB-RCC': {
        code: 'GB-RCC',
        name: 'Redcar and Cleveland',
        parent: 'GB-ENG',
    },
    'GB-RCH': {
        code: 'GB-RCH',
        name: 'Rochdale',
        parent: 'GB-ENG',
    },
    'GB-RCT': {
        code: 'GB-RCT',
        name: 'Rhondda Cynon Taff',
        parent: 'GB-WLS',
    },
    'GB-RDB': {
        code: 'GB-RDB',
        name: 'Redbridge',
        parent: 'GB-ENG',
    },
    'GB-RDG': {
        code: 'GB-RDG',
        name: 'Reading',
        parent: 'GB-ENG',
    },
    'GB-RFW': {
        code: 'GB-RFW',
        name: 'Renfrewshire',
        parent: 'GB-SCT',
    },
    'GB-RIC': {
        code: 'GB-RIC',
        name: 'Richmond upon Thames',
        parent: 'GB-ENG',
    },
    'GB-ROT': {
        code: 'GB-ROT',
        name: 'Rotherham',
        parent: 'GB-ENG',
    },
    'GB-RUT': {
        code: 'GB-RUT',
        name: 'Rutland',
        parent: 'GB-ENG',
    },
    'GB-SAW': {
        code: 'GB-SAW',
        name: 'Sandwell',
        parent: 'GB-ENG',
    },
    'GB-SAY': {
        code: 'GB-SAY',
        name: 'South Ayrshire',
        parent: 'GB-SCT',
    },
    'GB-SCB': {
        code: 'GB-SCB',
        name: 'Scottish Borders',
        parent: 'GB-SCT',
    },
    'GB-SCT': {
        code: 'GB-SCT',
        name: 'Scotland',
        parent: 'GB',
    },
    'GB-SFK': {
        code: 'GB-SFK',
        name: 'Suffolk',
        parent: 'GB-ENG',
    },
    'GB-SFT': {
        code: 'GB-SFT',
        name: 'Sefton',
        parent: 'GB-ENG',
    },
    'GB-SGC': {
        code: 'GB-SGC',
        name: 'South Gloucestershire',
        parent: 'GB-ENG',
    },
    'GB-SHF': {
        code: 'GB-SHF',
        name: 'Sheffield',
        parent: 'GB-ENG',
    },
    'GB-SHN': {
        code: 'GB-SHN',
        name: 'St. Helens',
        parent: 'GB-ENG',
    },
    'GB-SHR': {
        code: 'GB-SHR',
        name: 'Shropshire',
        parent: 'GB-ENG',
    },
    'GB-SKP': {
        code: 'GB-SKP',
        name: 'Stockport',
        parent: 'GB-ENG',
    },
    'GB-SLF': {
        code: 'GB-SLF',
        name: 'Salford',
        parent: 'GB-ENG',
    },
    'GB-SLG': {
        code: 'GB-SLG',
        name: 'Slough',
        parent: 'GB-ENG',
    },
    'GB-SLK': {
        code: 'GB-SLK',
        name: 'South Lanarkshire',
        parent: 'GB-SCT',
    },
    'GB-SND': {
        code: 'GB-SND',
        name: 'Sunderland',
        parent: 'GB-ENG',
    },
    'GB-SOL': {
        code: 'GB-SOL',
        name: 'Solihull',
        parent: 'GB-ENG',
    },
    'GB-SOM': {
        code: 'GB-SOM',
        name: 'Somerset',
        parent: 'GB-ENG',
    },
    'GB-SOS': {
        code: 'GB-SOS',
        name: 'Southend-on-Sea',
        parent: 'GB-ENG',
    },
    'GB-SRY': {
        code: 'GB-SRY',
        name: 'Surrey',
        parent: 'GB-ENG',
    },
    'GB-STE': {
        code: 'GB-STE',
        name: 'Stoke-on-Trent',
        parent: 'GB-ENG',
    },
    'GB-STG': {
        code: 'GB-STG',
        name: 'Stirling',
        parent: 'GB-SCT',
    },
    'GB-STH': {
        code: 'GB-STH',
        name: 'Southampton',
        parent: 'GB-ENG',
    },
    'GB-STN': {
        code: 'GB-STN',
        name: 'Sutton',
        parent: 'GB-ENG',
    },
    'GB-STS': {
        code: 'GB-STS',
        name: 'Staffordshire',
        parent: 'GB-ENG',
    },
    'GB-STT': {
        code: 'GB-STT',
        name: 'Stockton-on-Tees',
        parent: 'GB-ENG',
    },
    'GB-STY': {
        code: 'GB-STY',
        name: 'South Tyneside',
        parent: 'GB-ENG',
    },
    'GB-SWA': {
        code: 'GB-SWA',
        name: 'Swansea',
        parent: 'GB-WLS',
    },
    'GB-SWD': {
        code: 'GB-SWD',
        name: 'Swindon',
        parent: 'GB-ENG',
    },
    'GB-SWK': {
        code: 'GB-SWK',
        name: 'Southwark',
        parent: 'GB-ENG',
    },
    'GB-TAM': {
        code: 'GB-TAM',
        name: 'Tameside',
        parent: 'GB-ENG',
    },
    'GB-TFW': {
        code: 'GB-TFW',
        name: 'Telford and Wrekin',
        parent: 'GB-ENG',
    },
    'GB-THR': {
        code: 'GB-THR',
        name: 'Thurrock',
        parent: 'GB-ENG',
    },
    'GB-TOB': {
        code: 'GB-TOB',
        name: 'Torbay',
        parent: 'GB-ENG',
    },
    'GB-TOF': {
        code: 'GB-TOF',
        name: 'Torfaen',
        parent: 'GB-WLS',
    },
    'GB-TRF': {
        code: 'GB-TRF',
        name: 'Trafford',
        parent: 'GB-ENG',
    },
    'GB-TWH': {
        code: 'GB-TWH',
        name: 'Tower Hamlets',
        parent: 'GB-ENG',
    },
    'GB-UKM': {
        code: 'GB-UKM',
        name: 'United Kingdom',
        parent: 'GB',
    },
    'GB-VGL': {
        code: 'GB-VGL',
        name: 'Vale of Glamorgan, The',
        parent: 'GB-WLS',
    },
    'GB-WAR': {
        code: 'GB-WAR',
        name: 'Warwickshire',
        parent: 'GB-ENG',
    },
    'GB-WBK': {
        code: 'GB-WBK',
        name: 'West Berkshire',
        parent: 'GB-ENG',
    },
    'GB-WDU': {
        code: 'GB-WDU',
        name: 'West Dunbartonshire',
        parent: 'GB-SCT',
    },
    'GB-WFT': {
        code: 'GB-WFT',
        name: 'Waltham Forest',
        parent: 'GB-ENG',
    },
    'GB-WGN': {
        code: 'GB-WGN',
        name: 'Wigan',
        parent: 'GB-ENG',
    },
    'GB-WIL': {
        code: 'GB-WIL',
        name: 'Wiltshire',
        parent: 'GB-ENG',
    },
    'GB-WKF': {
        code: 'GB-WKF',
        name: 'Wakefield',
        parent: 'GB-ENG',
    },
    'GB-WLL': {
        code: 'GB-WLL',
        name: 'Walsall',
        parent: 'GB-ENG',
    },
    'GB-WLN': {
        code: 'GB-WLN',
        name: 'West Lothian',
        parent: 'GB-SCT',
    },
    'GB-WLS': {
        code: 'GB-WLS',
        name: 'Wales',
        parent: 'GB',
    },
    'GB-WLV': {
        code: 'GB-WLV',
        name: 'Wolverhampton',
        parent: 'GB-ENG',
    },
    'GB-WND': {
        code: 'GB-WND',
        name: 'Wandsworth',
        parent: 'GB-ENG',
    },
    'GB-WNM': {
        code: 'GB-WNM',
        name: 'Windsor and Maidenhead',
        parent: 'GB-ENG',
    },
    'GB-WOK': {
        code: 'GB-WOK',
        name: 'Wokingham',
        parent: 'GB-ENG',
    },
    'GB-WOR': {
        code: 'GB-WOR',
        name: 'Worcestershire',
        parent: 'GB-ENG',
    },
    'GB-WRL': {
        code: 'GB-WRL',
        name: 'Wirral',
        parent: 'GB-ENG',
    },
    'GB-WRT': {
        code: 'GB-WRT',
        name: 'Warrington',
        parent: 'GB-ENG',
    },
    'GB-WRX': {
        code: 'GB-WRX',
        name: 'Wrexham',
        parent: 'GB-WLS',
    },
    'GB-WSM': {
        code: 'GB-WSM',
        name: 'Westminster',
        parent: 'GB-ENG',
    },
    'GB-WSX': {
        code: 'GB-WSX',
        name: 'West Sussex',
        parent: 'GB-ENG',
    },
    'GB-YOR': {
        code: 'GB-YOR',
        name: 'York',
        parent: 'GB-ENG',
    },
    'GB-ZET': {
        code: 'GB-ZET',
        name: 'Shetland Islands',
        parent: 'GB-SCT',
    },
    'GD-01': {
        code: 'GD-01',
        name: 'Saint Andrew',
        parent: 'GD',
    },
    'GD-02': {
        code: 'GD-02',
        name: 'Saint David',
        parent: 'GD',
    },
    'GD-03': {
        code: 'GD-03',
        name: 'Saint George',
        parent: 'GD',
    },
    'GD-04': {
        code: 'GD-04',
        name: 'Saint John',
        parent: 'GD',
    },
    'GD-05': {
        code: 'GD-05',
        name: 'Saint Mark',
        parent: 'GD',
    },
    'GD-06': {
        code: 'GD-06',
        name: 'Saint Patrick',
        parent: 'GD',
    },
    'GD-10': {
        code: 'GD-10',
        name: 'Southern Grenadine Islands',
        parent: 'GD',
    },
    'GE-AB': {
        code: 'GE-AB',
        name: 'Abkhazia',
        parent: 'GE',
    },
    'GE-AJ': {
        code: 'GE-AJ',
        name: 'Ajaria',
        parent: 'GE',
    },
    'GE-GU': {
        code: 'GE-GU',
        name: 'Guria',
        parent: 'GE',
    },
    'GE-IM': {
        code: 'GE-IM',
        name: 'Imereti',
        parent: 'GE',
    },
    'GE-KA': {
        code: 'GE-KA',
        name: "K'akheti",
        parent: 'GE',
    },
    'GE-KK': {
        code: 'GE-KK',
        name: 'Kvemo Kartli',
        parent: 'GE',
    },
    'GE-MM': {
        code: 'GE-MM',
        name: 'Mtskheta-Mtianeti',
        parent: 'GE',
    },
    'GE-RL': {
        code: 'GE-RL',
        name: "Rach'a-Lechkhumi-Kvemo Svaneti",
        parent: 'GE',
    },
    'GE-SJ': {
        code: 'GE-SJ',
        name: 'Samtskhe-Javakheti',
        parent: 'GE',
    },
    'GE-SK': {
        code: 'GE-SK',
        name: 'Shida Kartli',
        parent: 'GE',
    },
    'GE-SZ': {
        code: 'GE-SZ',
        name: 'Samegrelo-Zemo Svaneti',
        parent: 'GE',
    },
    'GE-TB': {
        code: 'GE-TB',
        name: 'Tbilisi',
        parent: 'GE',
    },
    'GH-AA': {
        code: 'GH-AA',
        name: 'Greater Accra',
        parent: 'GH',
    },
    'GH-AF': {
        code: 'GH-AF',
        name: 'Ahafo',
        parent: 'GH',
    },
    'GH-AH': {
        code: 'GH-AH',
        name: 'Ashanti',
        parent: 'GH',
    },
    'GH-BA': {
        code: 'GH-BA',
        name: 'Brong-Ahafo',
        parent: 'GH',
    },
    'GH-BE': {
        code: 'GH-BE',
        name: 'Bono East',
        parent: 'GH',
    },
    'GH-BO': {
        code: 'GH-BO',
        name: 'Bono',
        parent: 'GH',
    },
    'GH-CP': {
        code: 'GH-CP',
        name: 'Central',
        parent: 'GH',
    },
    'GH-EP': {
        code: 'GH-EP',
        name: 'Eastern',
        parent: 'GH',
    },
    'GH-NE': {
        code: 'GH-NE',
        name: 'North East',
        parent: 'GH',
    },
    'GH-NP': {
        code: 'GH-NP',
        name: 'Northern',
        parent: 'GH',
    },
    'GH-OT': {
        code: 'GH-OT',
        name: 'Oti',
        parent: 'GH',
    },
    'GH-SV': {
        code: 'GH-SV',
        name: 'Savannah',
        parent: 'GH',
    },
    'GH-TV': {
        code: 'GH-TV',
        name: 'Volta',
        parent: 'GH',
    },
    'GH-UE': {
        code: 'GH-UE',
        name: 'Upper East',
        parent: 'GH',
    },
    'GH-UW': {
        code: 'GH-UW',
        name: 'Upper West',
        parent: 'GH',
    },
    'GH-WN': {
        code: 'GH-WN',
        name: 'Western North',
        parent: 'GH',
    },
    'GH-WP': {
        code: 'GH-WP',
        name: 'Western',
        parent: 'GH',
    },
    'GL-AV': {
        code: 'GL-AV',
        name: 'Avannaata Kommunia',
        parent: 'GL',
    },
    'GL-KU': {
        code: 'GL-KU',
        name: 'Kommune Kujalleq',
        parent: 'GL',
    },
    'GL-QE': {
        code: 'GL-QE',
        name: 'Qeqqata Kommunia',
        parent: 'GL',
    },
    'GL-QT': {
        code: 'GL-QT',
        name: 'Kommune Qeqertalik',
        parent: 'GL',
    },
    'GL-SM': {
        code: 'GL-SM',
        name: 'Kommuneqarfik Sermersooq',
        parent: 'GL',
    },
    'GM-B': {
        code: 'GM-B',
        name: 'Banjul',
        parent: 'GM',
    },
    'GM-L': {
        code: 'GM-L',
        name: 'Lower River',
        parent: 'GM',
    },
    'GM-M': {
        code: 'GM-M',
        name: 'Central River',
        parent: 'GM',
    },
    'GM-N': {
        code: 'GM-N',
        name: 'North Bank',
        parent: 'GM',
    },
    'GM-U': {
        code: 'GM-U',
        name: 'Upper River',
        parent: 'GM',
    },
    'GM-W': {
        code: 'GM-W',
        name: 'Western',
        parent: 'GM',
    },
    'GN-B': {
        code: 'GN-B',
        name: 'Boké',
        parent: 'GN',
    },
    'GN-BE': {
        code: 'GN-BE',
        name: 'Beyla',
        parent: 'GN-N',
    },
    'GN-BF': {
        code: 'GN-BF',
        name: 'Boffa',
        parent: 'GN-B',
    },
    'GN-BK': {
        code: 'GN-BK',
        name: 'Boké',
        parent: 'GN-B',
    },
    'GN-C': {
        code: 'GN-C',
        name: 'Conakry',
        parent: 'GN',
    },
    'GN-CO': {
        code: 'GN-CO',
        name: 'Coyah',
        parent: 'GN-D',
    },
    'GN-D': {
        code: 'GN-D',
        name: 'Kindia',
        parent: 'GN',
    },
    'GN-DB': {
        code: 'GN-DB',
        name: 'Dabola',
        parent: 'GN-F',
    },
    'GN-DI': {
        code: 'GN-DI',
        name: 'Dinguiraye',
        parent: 'GN-F',
    },
    'GN-DL': {
        code: 'GN-DL',
        name: 'Dalaba',
        parent: 'GN-M',
    },
    'GN-DU': {
        code: 'GN-DU',
        name: 'Dubréka',
        parent: 'GN-D',
    },
    'GN-F': {
        code: 'GN-F',
        name: 'Faranah',
        parent: 'GN',
    },
    'GN-FA': {
        code: 'GN-FA',
        name: 'Faranah',
        parent: 'GN-F',
    },
    'GN-FO': {
        code: 'GN-FO',
        name: 'Forécariah',
        parent: 'GN-D',
    },
    'GN-FR': {
        code: 'GN-FR',
        name: 'Fria',
        parent: 'GN-B',
    },
    'GN-GA': {
        code: 'GN-GA',
        name: 'Gaoual',
        parent: 'GN-B',
    },
    'GN-GU': {
        code: 'GN-GU',
        name: 'Guékédou',
        parent: 'GN-N',
    },
    'GN-K': {
        code: 'GN-K',
        name: 'Kankan',
        parent: 'GN',
    },
    'GN-KA': {
        code: 'GN-KA',
        name: 'Kankan',
        parent: 'GN-K',
    },
    'GN-KB': {
        code: 'GN-KB',
        name: 'Koubia',
        parent: 'GN-L',
    },
    'GN-KD': {
        code: 'GN-KD',
        name: 'Kindia',
        parent: 'GN-D',
    },
    'GN-KE': {
        code: 'GN-KE',
        name: 'Kérouané',
        parent: 'GN-K',
    },
    'GN-KN': {
        code: 'GN-KN',
        name: 'Koundara',
        parent: 'GN-B',
    },
    'GN-KO': {
        code: 'GN-KO',
        name: 'Kouroussa',
        parent: 'GN-K',
    },
    'GN-KS': {
        code: 'GN-KS',
        name: 'Kissidougou',
        parent: 'GN-F',
    },
    'GN-L': {
        code: 'GN-L',
        name: 'Labé',
        parent: 'GN',
    },
    'GN-LA': {
        code: 'GN-LA',
        name: 'Labé',
        parent: 'GN-L',
    },
    'GN-LE': {
        code: 'GN-LE',
        name: 'Lélouma',
        parent: 'GN-L',
    },
    'GN-LO': {
        code: 'GN-LO',
        name: 'Lola',
        parent: 'GN-N',
    },
    'GN-M': {
        code: 'GN-M',
        name: 'Mamou',
        parent: 'GN',
    },
    'GN-MC': {
        code: 'GN-MC',
        name: 'Macenta',
        parent: 'GN-N',
    },
    'GN-MD': {
        code: 'GN-MD',
        name: 'Mandiana',
        parent: 'GN-K',
    },
    'GN-ML': {
        code: 'GN-ML',
        name: 'Mali',
        parent: 'GN-L',
    },
    'GN-MM': {
        code: 'GN-MM',
        name: 'Mamou',
        parent: 'GN-M',
    },
    'GN-N': {
        code: 'GN-N',
        name: 'Nzérékoré',
        parent: 'GN',
    },
    'GN-NZ': {
        code: 'GN-NZ',
        name: 'Nzérékoré',
        parent: 'GN-N',
    },
    'GN-PI': {
        code: 'GN-PI',
        name: 'Pita',
        parent: 'GN-M',
    },
    'GN-SI': {
        code: 'GN-SI',
        name: 'Siguiri',
        parent: 'GN-K',
    },
    'GN-TE': {
        code: 'GN-TE',
        name: 'Télimélé',
        parent: 'GN-D',
    },
    'GN-TO': {
        code: 'GN-TO',
        name: 'Tougué',
        parent: 'GN-L',
    },
    'GN-YO': {
        code: 'GN-YO',
        name: 'Yomou',
        parent: 'GN-N',
    },
    'GQ-AN': {
        code: 'GQ-AN',
        name: 'Annobón',
        parent: 'GQ-I',
    },
    'GQ-BN': {
        code: 'GQ-BN',
        name: 'Bioko Norte',
        parent: 'GQ-I',
    },
    'GQ-BS': {
        code: 'GQ-BS',
        name: 'Bioko Sur',
        parent: 'GQ-I',
    },
    'GQ-C': {
        code: 'GQ-C',
        name: 'Región Continental',
        parent: 'GQ',
    },
    'GQ-CS': {
        code: 'GQ-CS',
        name: 'Centro Sur',
        parent: 'GQ-C',
    },
    'GQ-DJ': {
        code: 'GQ-DJ',
        name: 'Djibloho',
        parent: 'GQ-C',
    },
    'GQ-I': {
        code: 'GQ-I',
        name: 'Región Insular',
        parent: 'GQ',
    },
    'GQ-KN': {
        code: 'GQ-KN',
        name: 'Kié-Ntem',
        parent: 'GQ-C',
    },
    'GQ-LI': {
        code: 'GQ-LI',
        name: 'Litoral',
        parent: 'GQ-C',
    },
    'GQ-WN': {
        code: 'GQ-WN',
        name: 'Wele-Nzas',
        parent: 'GQ-C',
    },
    'GR-69': {
        code: 'GR-69',
        name: 'Ágion Óros',
        parent: 'GR',
    },
    'GR-A': {
        code: 'GR-A',
        name: 'Anatolikí Makedonía kai Thráki',
        parent: 'GR',
    },
    'GR-B': {
        code: 'GR-B',
        name: 'Kentrikí Makedonía',
        parent: 'GR',
    },
    'GR-C': {
        code: 'GR-C',
        name: 'Dytikí Makedonía',
        parent: 'GR',
    },
    'GR-D': {
        code: 'GR-D',
        name: 'Ípeiros',
        parent: 'GR',
    },
    'GR-E': {
        code: 'GR-E',
        name: 'Thessalía',
        parent: 'GR',
    },
    'GR-F': {
        code: 'GR-F',
        name: 'Ionía Nísia',
        parent: 'GR',
    },
    'GR-G': {
        code: 'GR-G',
        name: 'Dytikí Elláda',
        parent: 'GR',
    },
    'GR-H': {
        code: 'GR-H',
        name: 'Stereá Elláda',
        parent: 'GR',
    },
    'GR-I': {
        code: 'GR-I',
        name: 'Attikí',
        parent: 'GR',
    },
    'GR-J': {
        code: 'GR-J',
        name: 'Pelopónnisos',
        parent: 'GR',
    },
    'GR-K': {
        code: 'GR-K',
        name: 'Vóreio Aigaío',
        parent: 'GR',
    },
    'GR-L': {
        code: 'GR-L',
        name: 'Nótio Aigaío',
        parent: 'GR',
    },
    'GR-M': {
        code: 'GR-M',
        name: 'Kríti',
        parent: 'GR',
    },
    'GT-AV': {
        code: 'GT-AV',
        name: 'Alta Verapaz',
        parent: 'GT',
    },
    'GT-BV': {
        code: 'GT-BV',
        name: 'Baja Verapaz',
        parent: 'GT',
    },
    'GT-CM': {
        code: 'GT-CM',
        name: 'Chimaltenango',
        parent: 'GT',
    },
    'GT-CQ': {
        code: 'GT-CQ',
        name: 'Chiquimula',
        parent: 'GT',
    },
    'GT-ES': {
        code: 'GT-ES',
        name: 'Escuintla',
        parent: 'GT',
    },
    'GT-GU': {
        code: 'GT-GU',
        name: 'Guatemala',
        parent: 'GT',
    },
    'GT-HU': {
        code: 'GT-HU',
        name: 'Huehuetenango',
        parent: 'GT',
    },
    'GT-IZ': {
        code: 'GT-IZ',
        name: 'Izabal',
        parent: 'GT',
    },
    'GT-JA': {
        code: 'GT-JA',
        name: 'Jalapa',
        parent: 'GT',
    },
    'GT-JU': {
        code: 'GT-JU',
        name: 'Jutiapa',
        parent: 'GT',
    },
    'GT-PE': {
        code: 'GT-PE',
        name: 'Petén',
        parent: 'GT',
    },
    'GT-PR': {
        code: 'GT-PR',
        name: 'El Progreso',
        parent: 'GT',
    },
    'GT-QC': {
        code: 'GT-QC',
        name: 'Quiché',
        parent: 'GT',
    },
    'GT-QZ': {
        code: 'GT-QZ',
        name: 'Quetzaltenango',
        parent: 'GT',
    },
    'GT-RE': {
        code: 'GT-RE',
        name: 'Retalhuleu',
        parent: 'GT',
    },
    'GT-SA': {
        code: 'GT-SA',
        name: 'Sacatepéquez',
        parent: 'GT',
    },
    'GT-SM': {
        code: 'GT-SM',
        name: 'San Marcos',
        parent: 'GT',
    },
    'GT-SO': {
        code: 'GT-SO',
        name: 'Sololá',
        parent: 'GT',
    },
    'GT-SR': {
        code: 'GT-SR',
        name: 'Santa Rosa',
        parent: 'GT',
    },
    'GT-SU': {
        code: 'GT-SU',
        name: 'Suchitepéquez',
        parent: 'GT',
    },
    'GT-TO': {
        code: 'GT-TO',
        name: 'Totonicapán',
        parent: 'GT',
    },
    'GT-ZA': {
        code: 'GT-ZA',
        name: 'Zacapa',
        parent: 'GT',
    },
    'GW-BA': {
        code: 'GW-BA',
        name: 'Bafatá',
        parent: 'GW-L',
    },
    'GW-BL': {
        code: 'GW-BL',
        name: 'Bolama / Bijagós',
        parent: 'GW-S',
    },
    'GW-BM': {
        code: 'GW-BM',
        name: 'Biombo',
        parent: 'GW-N',
    },
    'GW-BS': {
        code: 'GW-BS',
        name: 'Bissau',
        parent: 'GW',
    },
    'GW-CA': {
        code: 'GW-CA',
        name: 'Cacheu',
        parent: 'GW-N',
    },
    'GW-GA': {
        code: 'GW-GA',
        name: 'Gabú',
        parent: 'GW-L',
    },
    'GW-L': {
        code: 'GW-L',
        name: 'Leste',
        parent: 'GW',
    },
    'GW-N': {
        code: 'GW-N',
        name: 'Norte',
        parent: 'GW',
    },
    'GW-OI': {
        code: 'GW-OI',
        name: 'Oio',
        parent: 'GW-N',
    },
    'GW-QU': {
        code: 'GW-QU',
        name: 'Quinara',
        parent: 'GW-S',
    },
    'GW-S': {
        code: 'GW-S',
        name: 'Sul',
        parent: 'GW',
    },
    'GW-TO': {
        code: 'GW-TO',
        name: 'Tombali',
        parent: 'GW-S',
    },
    'GY-BA': {
        code: 'GY-BA',
        name: 'Barima-Waini',
        parent: 'GY',
    },
    'GY-CU': {
        code: 'GY-CU',
        name: 'Cuyuni-Mazaruni',
        parent: 'GY',
    },
    'GY-DE': {
        code: 'GY-DE',
        name: 'Demerara-Mahaica',
        parent: 'GY',
    },
    'GY-EB': {
        code: 'GY-EB',
        name: 'East Berbice-Corentyne',
        parent: 'GY',
    },
    'GY-ES': {
        code: 'GY-ES',
        name: 'Essequibo Islands-West Demerara',
        parent: 'GY',
    },
    'GY-MA': {
        code: 'GY-MA',
        name: 'Mahaica-Berbice',
        parent: 'GY',
    },
    'GY-PM': {
        code: 'GY-PM',
        name: 'Pomeroon-Supenaam',
        parent: 'GY',
    },
    'GY-PT': {
        code: 'GY-PT',
        name: 'Potaro-Siparuni',
        parent: 'GY',
    },
    'GY-UD': {
        code: 'GY-UD',
        name: 'Upper Demerara-Berbice',
        parent: 'GY',
    },
    'GY-UT': {
        code: 'GY-UT',
        name: 'Upper Takutu-Upper Essequibo',
        parent: 'GY',
    },
    'HN-AT': {
        code: 'HN-AT',
        name: 'Atlántida',
        parent: 'HN',
    },
    'HN-CH': {
        code: 'HN-CH',
        name: 'Choluteca',
        parent: 'HN',
    },
    'HN-CL': {
        code: 'HN-CL',
        name: 'Colón',
        parent: 'HN',
    },
    'HN-CM': {
        code: 'HN-CM',
        name: 'Comayagua',
        parent: 'HN',
    },
    'HN-CP': {
        code: 'HN-CP',
        name: 'Copán',
        parent: 'HN',
    },
    'HN-CR': {
        code: 'HN-CR',
        name: 'Cortés',
        parent: 'HN',
    },
    'HN-EP': {
        code: 'HN-EP',
        name: 'El Paraíso',
        parent: 'HN',
    },
    'HN-FM': {
        code: 'HN-FM',
        name: 'Francisco Morazán',
        parent: 'HN',
    },
    'HN-GD': {
        code: 'HN-GD',
        name: 'Gracias a Dios',
        parent: 'HN',
    },
    'HN-IB': {
        code: 'HN-IB',
        name: 'Islas de la Bahía',
        parent: 'HN',
    },
    'HN-IN': {
        code: 'HN-IN',
        name: 'Intibucá',
        parent: 'HN',
    },
    'HN-LE': {
        code: 'HN-LE',
        name: 'Lempira',
        parent: 'HN',
    },
    'HN-LP': {
        code: 'HN-LP',
        name: 'La Paz',
        parent: 'HN',
    },
    'HN-OC': {
        code: 'HN-OC',
        name: 'Ocotepeque',
        parent: 'HN',
    },
    'HN-OL': {
        code: 'HN-OL',
        name: 'Olancho',
        parent: 'HN',
    },
    'HN-SB': {
        code: 'HN-SB',
        name: 'Santa Bárbara',
        parent: 'HN',
    },
    'HN-VA': {
        code: 'HN-VA',
        name: 'Valle',
        parent: 'HN',
    },
    'HN-YO': {
        code: 'HN-YO',
        name: 'Yoro',
        parent: 'HN',
    },
    'HR-01': {
        code: 'HR-01',
        name: 'Zagrebačka županija',
        parent: 'HR',
    },
    'HR-02': {
        code: 'HR-02',
        name: 'Krapinsko-zagorska županija',
        parent: 'HR',
    },
    'HR-03': {
        code: 'HR-03',
        name: 'Sisačko-moslavačka županija',
        parent: 'HR',
    },
    'HR-04': {
        code: 'HR-04',
        name: 'Karlovačka županija',
        parent: 'HR',
    },
    'HR-05': {
        code: 'HR-05',
        name: 'Varaždinska županija',
        parent: 'HR',
    },
    'HR-06': {
        code: 'HR-06',
        name: 'Koprivničko-križevačka županija',
        parent: 'HR',
    },
    'HR-07': {
        code: 'HR-07',
        name: 'Bjelovarsko-bilogorska županija',
        parent: 'HR',
    },
    'HR-08': {
        code: 'HR-08',
        name: 'Primorsko-goranska županija',
        parent: 'HR',
    },
    'HR-09': {
        code: 'HR-09',
        name: 'Ličko-senjska županija',
        parent: 'HR',
    },
    'HR-10': {
        code: 'HR-10',
        name: 'Virovitičko-podravska županija',
        parent: 'HR',
    },
    'HR-11': {
        code: 'HR-11',
        name: 'Požeško-slavonska županija',
        parent: 'HR',
    },
    'HR-12': {
        code: 'HR-12',
        name: 'Brodsko-posavska županija',
        parent: 'HR',
    },
    'HR-13': {
        code: 'HR-13',
        name: 'Zadarska županija',
        parent: 'HR',
    },
    'HR-14': {
        code: 'HR-14',
        name: 'Osječko-baranjska županija',
        parent: 'HR',
    },
    'HR-15': {
        code: 'HR-15',
        name: 'Šibensko-kninska županija',
        parent: 'HR',
    },
    'HR-16': {
        code: 'HR-16',
        name: 'Vukovarsko-srijemska županija',
        parent: 'HR',
    },
    'HR-17': {
        code: 'HR-17',
        name: 'Splitsko-dalmatinska županija',
        parent: 'HR',
    },
    'HR-18': {
        code: 'HR-18',
        name: 'Istarska županija',
        parent: 'HR',
    },
    'HR-19': {
        code: 'HR-19',
        name: 'Dubrovačko-neretvanska županija',
        parent: 'HR',
    },
    'HR-20': {
        code: 'HR-20',
        name: 'Međimurska županija',
        parent: 'HR',
    },
    'HR-21': {
        code: 'HR-21',
        name: 'Grad Zagreb',
        parent: 'HR',
    },
    'HT-AR': {
        code: 'HT-AR',
        name: 'Artibonite',
        parent: 'HT',
    },
    'HT-CE': {
        code: 'HT-CE',
        name: 'Centre',
        parent: 'HT',
    },
    'HT-GA': {
        code: 'HT-GA',
        name: 'Grande’Anse',
        parent: 'HT',
    },
    'HT-ND': {
        code: 'HT-ND',
        name: 'Nord',
        parent: 'HT',
    },
    'HT-NE': {
        code: 'HT-NE',
        name: 'Nord-Est',
        parent: 'HT',
    },
    'HT-NI': {
        code: 'HT-NI',
        name: 'Nippes',
        parent: 'HT',
    },
    'HT-NO': {
        code: 'HT-NO',
        name: 'Nord-Ouest',
        parent: 'HT',
    },
    'HT-OU': {
        code: 'HT-OU',
        name: 'Ouest',
        parent: 'HT',
    },
    'HT-SD': {
        code: 'HT-SD',
        name: 'Sud',
        parent: 'HT',
    },
    'HT-SE': {
        code: 'HT-SE',
        name: 'Sud-Est',
        parent: 'HT',
    },
    'HU-BA': {
        code: 'HU-BA',
        name: 'Baranya',
        parent: 'HU',
    },
    'HU-BC': {
        code: 'HU-BC',
        name: 'Békéscsaba',
        parent: 'HU',
    },
    'HU-BE': {
        code: 'HU-BE',
        name: 'Békés',
        parent: 'HU',
    },
    'HU-BK': {
        code: 'HU-BK',
        name: 'Bács-Kiskun',
        parent: 'HU',
    },
    'HU-BU': {
        code: 'HU-BU',
        name: 'Budapest',
        parent: 'HU',
    },
    'HU-BZ': {
        code: 'HU-BZ',
        name: 'Borsod-Abaúj-Zemplén',
        parent: 'HU',
    },
    'HU-CS': {
        code: 'HU-CS',
        name: 'Csongrád',
        parent: 'HU',
    },
    'HU-DE': {
        code: 'HU-DE',
        name: 'Debrecen',
        parent: 'HU',
    },
    'HU-DU': {
        code: 'HU-DU',
        name: 'Dunaújváros',
        parent: 'HU',
    },
    'HU-EG': {
        code: 'HU-EG',
        name: 'Eger',
        parent: 'HU',
    },
    'HU-ER': {
        code: 'HU-ER',
        name: 'Érd',
        parent: 'HU',
    },
    'HU-FE': {
        code: 'HU-FE',
        name: 'Fejér',
        parent: 'HU',
    },
    'HU-GS': {
        code: 'HU-GS',
        name: 'Győr-Moson-Sopron',
        parent: 'HU',
    },
    'HU-GY': {
        code: 'HU-GY',
        name: 'Győr',
        parent: 'HU',
    },
    'HU-HB': {
        code: 'HU-HB',
        name: 'Hajdú-Bihar',
        parent: 'HU',
    },
    'HU-HE': {
        code: 'HU-HE',
        name: 'Heves',
        parent: 'HU',
    },
    'HU-HV': {
        code: 'HU-HV',
        name: 'Hódmezővásárhely',
        parent: 'HU',
    },
    'HU-JN': {
        code: 'HU-JN',
        name: 'Jász-Nagykun-Szolnok',
        parent: 'HU',
    },
    'HU-KE': {
        code: 'HU-KE',
        name: 'Komárom-Esztergom',
        parent: 'HU',
    },
    'HU-KM': {
        code: 'HU-KM',
        name: 'Kecskemét',
        parent: 'HU',
    },
    'HU-KV': {
        code: 'HU-KV',
        name: 'Kaposvár',
        parent: 'HU',
    },
    'HU-MI': {
        code: 'HU-MI',
        name: 'Miskolc',
        parent: 'HU',
    },
    'HU-NK': {
        code: 'HU-NK',
        name: 'Nagykanizsa',
        parent: 'HU',
    },
    'HU-NO': {
        code: 'HU-NO',
        name: 'Nógrád',
        parent: 'HU',
    },
    'HU-NY': {
        code: 'HU-NY',
        name: 'Nyíregyháza',
        parent: 'HU',
    },
    'HU-PE': {
        code: 'HU-PE',
        name: 'Pest',
        parent: 'HU',
    },
    'HU-PS': {
        code: 'HU-PS',
        name: 'Pécs',
        parent: 'HU',
    },
    'HU-SD': {
        code: 'HU-SD',
        name: 'Szeged',
        parent: 'HU',
    },
    'HU-SF': {
        code: 'HU-SF',
        name: 'Székesfehérvár',
        parent: 'HU',
    },
    'HU-SH': {
        code: 'HU-SH',
        name: 'Szombathely',
        parent: 'HU',
    },
    'HU-SK': {
        code: 'HU-SK',
        name: 'Szolnok',
        parent: 'HU',
    },
    'HU-SN': {
        code: 'HU-SN',
        name: 'Sopron',
        parent: 'HU',
    },
    'HU-SO': {
        code: 'HU-SO',
        name: 'Somogy',
        parent: 'HU',
    },
    'HU-SS': {
        code: 'HU-SS',
        name: 'Szekszárd',
        parent: 'HU',
    },
    'HU-ST': {
        code: 'HU-ST',
        name: 'Salgótarján',
        parent: 'HU',
    },
    'HU-SZ': {
        code: 'HU-SZ',
        name: 'Szabolcs-Szatmár-Bereg',
        parent: 'HU',
    },
    'HU-TB': {
        code: 'HU-TB',
        name: 'Tatabánya',
        parent: 'HU',
    },
    'HU-TO': {
        code: 'HU-TO',
        name: 'Tolna',
        parent: 'HU',
    },
    'HU-VA': {
        code: 'HU-VA',
        name: 'Vas',
        parent: 'HU',
    },
    'HU-VE': {
        code: 'HU-VE',
        name: 'Veszprém',
        parent: 'HU',
    },
    'HU-VM': {
        code: 'HU-VM',
        name: 'Veszprém',
        parent: 'HU',
    },
    'HU-ZA': {
        code: 'HU-ZA',
        name: 'Zala',
        parent: 'HU',
    },
    'HU-ZE': {
        code: 'HU-ZE',
        name: 'Zalaegerszeg',
        parent: 'HU',
    },
    'ID-AC': {
        code: 'ID-AC',
        name: 'Aceh',
        parent: 'ID-SM',
    },
    'ID-BA': {
        code: 'ID-BA',
        name: 'Bali',
        parent: 'ID-NU',
    },
    'ID-BB': {
        code: 'ID-BB',
        name: 'Kepulauan Bangka Belitung',
        parent: 'ID-SM',
    },
    'ID-BE': {
        code: 'ID-BE',
        name: 'Bengkulu',
        parent: 'ID-SM',
    },
    'ID-BT': {
        code: 'ID-BT',
        name: 'Banten',
        parent: 'ID-JW',
    },
    'ID-GO': {
        code: 'ID-GO',
        name: 'Gorontalo',
        parent: 'ID-SL',
    },
    'ID-JA': {
        code: 'ID-JA',
        name: 'Jambi',
        parent: 'ID-SM',
    },
    'ID-JB': {
        code: 'ID-JB',
        name: 'Jawa Barat',
        parent: 'ID-JW',
    },
    'ID-JI': {
        code: 'ID-JI',
        name: 'Jawa Timur',
        parent: 'ID-JW',
    },
    'ID-JK': {
        code: 'ID-JK',
        name: 'Jakarta Raya',
        parent: 'ID-JW',
    },
    'ID-JT': {
        code: 'ID-JT',
        name: 'Jawa Tengah',
        parent: 'ID-JW',
    },
    'ID-JW': {
        code: 'ID-JW',
        name: 'Jawa',
        parent: 'ID',
    },
    'ID-KA': {
        code: 'ID-KA',
        name: 'Kalimantan',
        parent: 'ID',
    },
    'ID-KB': {
        code: 'ID-KB',
        name: 'Kalimantan Barat',
        parent: 'ID-KA',
    },
    'ID-KI': {
        code: 'ID-KI',
        name: 'Kalimantan Timur',
        parent: 'ID-KA',
    },
    'ID-KR': {
        code: 'ID-KR',
        name: 'Kepulauan Riau',
        parent: 'ID-SM',
    },
    'ID-KS': {
        code: 'ID-KS',
        name: 'Kalimantan Selatan',
        parent: 'ID-KA',
    },
    'ID-KT': {
        code: 'ID-KT',
        name: 'Kalimantan Tengah',
        parent: 'ID-KA',
    },
    'ID-KU': {
        code: 'ID-KU',
        name: 'Kalimantan Utara',
        parent: 'ID-KA',
    },
    'ID-LA': {
        code: 'ID-LA',
        name: 'Lampung',
        parent: 'ID-SM',
    },
    'ID-MA': {
        code: 'ID-MA',
        name: 'Maluku',
        parent: 'ID-ML',
    },
    'ID-ML': {
        code: 'ID-ML',
        name: 'Maluku',
        parent: 'ID',
    },
    'ID-MU': {
        code: 'ID-MU',
        name: 'Maluku Utara',
        parent: 'ID-ML',
    },
    'ID-NB': {
        code: 'ID-NB',
        name: 'Nusa Tenggara Barat',
        parent: 'ID-NU',
    },
    'ID-NT': {
        code: 'ID-NT',
        name: 'Nusa Tenggara Timur',
        parent: 'ID-NU',
    },
    'ID-NU': {
        code: 'ID-NU',
        name: 'Nusa Tenggara',
        parent: 'ID',
    },
    'ID-PA': {
        code: 'ID-PA',
        name: 'Papua',
        parent: 'ID-PP',
    },
    'ID-PB': {
        code: 'ID-PB',
        name: 'Papua Barat',
        parent: 'ID-PP',
    },
    'ID-PP': {
        code: 'ID-PP',
        name: 'Papua',
        parent: 'ID',
    },
    'ID-RI': {
        code: 'ID-RI',
        name: 'Riau',
        parent: 'ID-SM',
    },
    'ID-SA': {
        code: 'ID-SA',
        name: 'Sulawesi Utara',
        parent: 'ID-SL',
    },
    'ID-SB': {
        code: 'ID-SB',
        name: 'Sumatera Barat',
        parent: 'ID-SM',
    },
    'ID-SG': {
        code: 'ID-SG',
        name: 'Sulawesi Tenggara',
        parent: 'ID-SL',
    },
    'ID-SL': {
        code: 'ID-SL',
        name: 'Sulawesi',
        parent: 'ID',
    },
    'ID-SM': {
        code: 'ID-SM',
        name: 'Sumatera',
        parent: 'ID',
    },
    'ID-SN': {
        code: 'ID-SN',
        name: 'Sulawesi Selatan',
        parent: 'ID-SL',
    },
    'ID-SR': {
        code: 'ID-SR',
        name: 'Sulawesi Barat',
        parent: 'ID-SL',
    },
    'ID-SS': {
        code: 'ID-SS',
        name: 'Sumatera Selatan',
        parent: 'ID-SM',
    },
    'ID-ST': {
        code: 'ID-ST',
        name: 'Sulawesi Tengah',
        parent: 'ID-SL',
    },
    'ID-SU': {
        code: 'ID-SU',
        name: 'Sumatera Utara',
        parent: 'ID-SM',
    },
    'ID-YO': {
        code: 'ID-YO',
        name: 'Yogyakarta',
        parent: 'ID-JW',
    },
    'IE-C': {
        code: 'IE-C',
        name: 'Connaught',
        parent: 'IE',
    },
    'IE-CE': {
        code: 'IE-CE',
        name: 'Clare',
        parent: 'IE-M',
    },
    'IE-CN': {
        code: 'IE-CN',
        name: 'Cavan',
        parent: 'IE-U',
    },
    'IE-CO': {
        code: 'IE-CO',
        name: 'Cork',
        parent: 'IE-M',
    },
    'IE-CW': {
        code: 'IE-CW',
        name: 'Carlow',
        parent: 'IE-L',
    },
    'IE-D': {
        code: 'IE-D',
        name: 'Dublin',
        parent: 'IE-L',
    },
    'IE-DL': {
        code: 'IE-DL',
        name: 'Donegal',
        parent: 'IE-U',
    },
    'IE-G': {
        code: 'IE-G',
        name: 'Galway',
        parent: 'IE-C',
    },
    'IE-KE': {
        code: 'IE-KE',
        name: 'Kildare',
        parent: 'IE-L',
    },
    'IE-KK': {
        code: 'IE-KK',
        name: 'Kilkenny',
        parent: 'IE-L',
    },
    'IE-KY': {
        code: 'IE-KY',
        name: 'Kerry',
        parent: 'IE-M',
    },
    'IE-L': {
        code: 'IE-L',
        name: 'Leinster',
        parent: 'IE',
    },
    'IE-LD': {
        code: 'IE-LD',
        name: 'Longford',
        parent: 'IE-L',
    },
    'IE-LH': {
        code: 'IE-LH',
        name: 'Louth',
        parent: 'IE-L',
    },
    'IE-LK': {
        code: 'IE-LK',
        name: 'Limerick',
        parent: 'IE-M',
    },
    'IE-LM': {
        code: 'IE-LM',
        name: 'Leitrim',
        parent: 'IE-C',
    },
    'IE-LS': {
        code: 'IE-LS',
        name: 'Laois',
        parent: 'IE-L',
    },
    'IE-M': {
        code: 'IE-M',
        name: 'Munster',
        parent: 'IE',
    },
    'IE-MH': {
        code: 'IE-MH',
        name: 'Meath',
        parent: 'IE-L',
    },
    'IE-MN': {
        code: 'IE-MN',
        name: 'Monaghan',
        parent: 'IE-U',
    },
    'IE-MO': {
        code: 'IE-MO',
        name: 'Mayo',
        parent: 'IE-C',
    },
    'IE-OY': {
        code: 'IE-OY',
        name: 'Offaly',
        parent: 'IE-L',
    },
    'IE-RN': {
        code: 'IE-RN',
        name: 'Roscommon',
        parent: 'IE-C',
    },
    'IE-SO': {
        code: 'IE-SO',
        name: 'Sligo',
        parent: 'IE-C',
    },
    'IE-TA': {
        code: 'IE-TA',
        name: 'Tipperary',
        parent: 'IE-M',
    },
    'IE-U': {
        code: 'IE-U',
        name: 'Ulster',
        parent: 'IE',
    },
    'IE-WD': {
        code: 'IE-WD',
        name: 'Waterford',
        parent: 'IE-M',
    },
    'IE-WH': {
        code: 'IE-WH',
        name: 'Westmeath',
        parent: 'IE-L',
    },
    'IE-WW': {
        code: 'IE-WW',
        name: 'Wicklow',
        parent: 'IE-L',
    },
    'IE-WX': {
        code: 'IE-WX',
        name: 'Wexford',
        parent: 'IE-L',
    },
    'IL-D': {
        code: 'IL-D',
        name: 'HaDarom',
        parent: 'IL',
    },
    'IL-HA': {
        code: 'IL-HA',
        name: 'H̱efa',
        parent: 'IL',
    },
    'IL-JM': {
        code: 'IL-JM',
        name: 'Yerushalayim',
        parent: 'IL',
    },
    'IL-M': {
        code: 'IL-M',
        name: 'HaMerkaz',
        parent: 'IL',
    },
    'IL-TA': {
        code: 'IL-TA',
        name: 'Tel Aviv',
        parent: 'IL',
    },
    'IL-Z': {
        code: 'IL-Z',
        name: 'HaTsafon',
        parent: 'IL',
    },
    'IN-AN': {
        code: 'IN-AN',
        name: 'Andaman and Nicobar Islands',
        parent: 'IN',
    },
    'IN-AP': {
        code: 'IN-AP',
        name: 'Andhra Pradesh',
        parent: 'IN',
    },
    'IN-AR': {
        code: 'IN-AR',
        name: 'Arunāchal Pradesh',
        parent: 'IN',
    },
    'IN-AS': {
        code: 'IN-AS',
        name: 'Assam',
        parent: 'IN',
    },
    'IN-BR': {
        code: 'IN-BR',
        name: 'Bihār',
        parent: 'IN',
    },
    'IN-CH': {
        code: 'IN-CH',
        name: 'Chandigarh',
        parent: 'IN',
    },
    'IN-CT': {
        code: 'IN-CT',
        name: 'Chhattīsgarh',
        parent: 'IN',
    },
    'IN-DH': {
        code: 'IN-DH',
        name: 'Dādra and Nagar Haveli and Damān and Diu',
        parent: 'IN',
    },
    'IN-DL': {
        code: 'IN-DL',
        name: 'Delhi',
        parent: 'IN',
    },
    'IN-GA': {
        code: 'IN-GA',
        name: 'Goa',
        parent: 'IN',
    },
    'IN-GJ': {
        code: 'IN-GJ',
        name: 'Gujarāt',
        parent: 'IN',
    },
    'IN-HP': {
        code: 'IN-HP',
        name: 'Himāchal Pradesh',
        parent: 'IN',
    },
    'IN-HR': {
        code: 'IN-HR',
        name: 'Haryāna',
        parent: 'IN',
    },
    'IN-JH': {
        code: 'IN-JH',
        name: 'Jhārkhand',
        parent: 'IN',
    },
    'IN-JK': {
        code: 'IN-JK',
        name: 'Jammu and Kashmīr',
        parent: 'IN',
    },
    'IN-KA': {
        code: 'IN-KA',
        name: 'Karnātaka',
        parent: 'IN',
    },
    'IN-KL': {
        code: 'IN-KL',
        name: 'Kerala',
        parent: 'IN',
    },
    'IN-LA': {
        code: 'IN-LA',
        name: 'Ladākh',
        parent: 'IN',
    },
    'IN-LD': {
        code: 'IN-LD',
        name: 'Lakshadweep',
        parent: 'IN',
    },
    'IN-MH': {
        code: 'IN-MH',
        name: 'Mahārāshtra',
        parent: 'IN',
    },
    'IN-ML': {
        code: 'IN-ML',
        name: 'Meghālaya',
        parent: 'IN',
    },
    'IN-MN': {
        code: 'IN-MN',
        name: 'Manipur',
        parent: 'IN',
    },
    'IN-MP': {
        code: 'IN-MP',
        name: 'Madhya Pradesh',
        parent: 'IN',
    },
    'IN-MZ': {
        code: 'IN-MZ',
        name: 'Mizoram',
        parent: 'IN',
    },
    'IN-NL': {
        code: 'IN-NL',
        name: 'Nāgāland',
        parent: 'IN',
    },
    'IN-OR': {
        code: 'IN-OR',
        name: 'Odisha',
        parent: 'IN',
    },
    'IN-PB': {
        code: 'IN-PB',
        name: 'Punjab',
        parent: 'IN',
    },
    'IN-PY': {
        code: 'IN-PY',
        name: 'Puducherry',
        parent: 'IN',
    },
    'IN-RJ': {
        code: 'IN-RJ',
        name: 'Rājasthān',
        parent: 'IN',
    },
    'IN-SK': {
        code: 'IN-SK',
        name: 'Sikkim',
        parent: 'IN',
    },
    'IN-TG': {
        code: 'IN-TG',
        name: 'Telangāna',
        parent: 'IN',
    },
    'IN-TN': {
        code: 'IN-TN',
        name: 'Tamil Nādu',
        parent: 'IN',
    },
    'IN-TR': {
        code: 'IN-TR',
        name: 'Tripura',
        parent: 'IN',
    },
    'IN-UP': {
        code: 'IN-UP',
        name: 'Uttar Pradesh',
        parent: 'IN',
    },
    'IN-UT': {
        code: 'IN-UT',
        name: 'Uttarākhand',
        parent: 'IN',
    },
    'IN-WB': {
        code: 'IN-WB',
        name: 'West Bengal',
        parent: 'IN',
    },
    'IQ-AN': {
        code: 'IQ-AN',
        name: 'Al Anbār',
        parent: 'IQ',
    },
    'IQ-AR': {
        code: 'IQ-AR',
        name: 'Arbīl',
        parent: 'IQ',
    },
    'IQ-BA': {
        code: 'IQ-BA',
        name: 'Al Başrah',
        parent: 'IQ',
    },
    'IQ-BB': {
        code: 'IQ-BB',
        name: 'Bābil',
        parent: 'IQ',
    },
    'IQ-BG': {
        code: 'IQ-BG',
        name: 'Baghdād',
        parent: 'IQ',
    },
    'IQ-DA': {
        code: 'IQ-DA',
        name: 'Dahūk',
        parent: 'IQ',
    },
    'IQ-DI': {
        code: 'IQ-DI',
        name: 'Diyālá',
        parent: 'IQ',
    },
    'IQ-DQ': {
        code: 'IQ-DQ',
        name: 'Dhī Qār',
        parent: 'IQ',
    },
    'IQ-HA': {
        code: 'IQ-HA',
        name: 'Halabja',
        parent: 'IQ',
    },
    'IQ-KA': {
        code: 'IQ-KA',
        name: 'Karbalā’',
        parent: 'IQ',
    },
    'IQ-KI': {
        code: 'IQ-KI',
        name: 'Kirkūk',
        parent: 'IQ',
    },
    'IQ-MA': {
        code: 'IQ-MA',
        name: 'Maysān',
        parent: 'IQ',
    },
    'IQ-MU': {
        code: 'IQ-MU',
        name: 'Al Muthanná',
        parent: 'IQ',
    },
    'IQ-NA': {
        code: 'IQ-NA',
        name: 'An Najaf',
        parent: 'IQ',
    },
    'IQ-NI': {
        code: 'IQ-NI',
        name: 'Nīnawá',
        parent: 'IQ',
    },
    'IQ-QA': {
        code: 'IQ-QA',
        name: 'Al Qādisīyah',
        parent: 'IQ',
    },
    'IQ-SD': {
        code: 'IQ-SD',
        name: 'Şalāḩ ad Dīn',
        parent: 'IQ',
    },
    'IQ-SU': {
        code: 'IQ-SU',
        name: 'As Sulaymānīyah',
        parent: 'IQ',
    },
    'IQ-WA': {
        code: 'IQ-WA',
        name: 'Wāsiţ',
        parent: 'IQ',
    },
    'IR-00': {
        code: 'IR-00',
        name: 'Markazī',
        parent: 'IR',
    },
    'IR-01': {
        code: 'IR-01',
        name: 'Gīlān',
        parent: 'IR',
    },
    'IR-02': {
        code: 'IR-02',
        name: 'Māzandarān',
        parent: 'IR',
    },
    'IR-03': {
        code: 'IR-03',
        name: 'Āz̄ārbāyjān-e Shārqī',
        parent: 'IR',
    },
    'IR-04': {
        code: 'IR-04',
        name: 'Āz̄ārbāyjān-e Ghārbī',
        parent: 'IR',
    },
    'IR-05': {
        code: 'IR-05',
        name: 'Kermānshāh',
        parent: 'IR',
    },
    'IR-06': {
        code: 'IR-06',
        name: 'Khūzestān',
        parent: 'IR',
    },
    'IR-07': {
        code: 'IR-07',
        name: 'Fārs',
        parent: 'IR',
    },
    'IR-08': {
        code: 'IR-08',
        name: 'Kermān',
        parent: 'IR',
    },
    'IR-09': {
        code: 'IR-09',
        name: 'Khorāsān-e Raẕavī',
        parent: 'IR',
    },
    'IR-10': {
        code: 'IR-10',
        name: 'Eşfahān',
        parent: 'IR',
    },
    'IR-11': {
        code: 'IR-11',
        name: 'Sīstān va Balūchestān',
        parent: 'IR',
    },
    'IR-12': {
        code: 'IR-12',
        name: 'Kordestān',
        parent: 'IR',
    },
    'IR-13': {
        code: 'IR-13',
        name: 'Hamadān',
        parent: 'IR',
    },
    'IR-14': {
        code: 'IR-14',
        name: 'Chahār Maḩāl va Bakhtīārī',
        parent: 'IR',
    },
    'IR-15': {
        code: 'IR-15',
        name: 'Lorestān',
        parent: 'IR',
    },
    'IR-16': {
        code: 'IR-16',
        name: 'Īlām',
        parent: 'IR',
    },
    'IR-17': {
        code: 'IR-17',
        name: 'Kohgīlūyeh va Bowyer Aḩmad',
        parent: 'IR',
    },
    'IR-18': {
        code: 'IR-18',
        name: 'Būshehr',
        parent: 'IR',
    },
    'IR-19': {
        code: 'IR-19',
        name: 'Zanjān',
        parent: 'IR',
    },
    'IR-20': {
        code: 'IR-20',
        name: 'Semnān',
        parent: 'IR',
    },
    'IR-21': {
        code: 'IR-21',
        name: 'Yazd',
        parent: 'IR',
    },
    'IR-22': {
        code: 'IR-22',
        name: 'Hormozgān',
        parent: 'IR',
    },
    'IR-23': {
        code: 'IR-23',
        name: 'Tehrān',
        parent: 'IR',
    },
    'IR-24': {
        code: 'IR-24',
        name: 'Ardabīl',
        parent: 'IR',
    },
    'IR-25': {
        code: 'IR-25',
        name: 'Qom',
        parent: 'IR',
    },
    'IR-26': {
        code: 'IR-26',
        name: 'Qazvīn',
        parent: 'IR',
    },
    'IR-27': {
        code: 'IR-27',
        name: 'Golestān',
        parent: 'IR',
    },
    'IR-28': {
        code: 'IR-28',
        name: 'Khorāsān-e Shomālī',
        parent: 'IR',
    },
    'IR-29': {
        code: 'IR-29',
        name: 'Khorāsān-e Jonūbī',
        parent: 'IR',
    },
    'IR-30': {
        code: 'IR-30',
        name: 'Alborz',
        parent: 'IR',
    },
    'IS-1': {
        code: 'IS-1',
        name: 'Höfuðborgarsvæði',
        parent: 'IS',
    },
    'IS-2': {
        code: 'IS-2',
        name: 'Suðurnes',
        parent: 'IS',
    },
    'IS-3': {
        code: 'IS-3',
        name: 'Vesturland',
        parent: 'IS',
    },
    'IS-4': {
        code: 'IS-4',
        name: 'Vestfirðir',
        parent: 'IS',
    },
    'IS-5': {
        code: 'IS-5',
        name: 'Norðurland vestra',
        parent: 'IS',
    },
    'IS-6': {
        code: 'IS-6',
        name: 'Norðurland eystra',
        parent: 'IS',
    },
    'IS-7': {
        code: 'IS-7',
        name: 'Austurland',
        parent: 'IS',
    },
    'IS-8': {
        code: 'IS-8',
        name: 'Suðurland',
        parent: 'IS',
    },
    'IS-AKH': {
        code: 'IS-AKH',
        name: 'Akrahreppur',
        parent: 'IS',
    },
    'IS-AKN': {
        code: 'IS-AKN',
        name: 'Akraneskaupstaður',
        parent: 'IS',
    },
    'IS-AKU': {
        code: 'IS-AKU',
        name: 'Akureyrarbær',
        parent: 'IS',
    },
    'IS-ARN': {
        code: 'IS-ARN',
        name: 'Árneshreppur',
        parent: 'IS',
    },
    'IS-ASA': {
        code: 'IS-ASA',
        name: 'Ásahreppur',
        parent: 'IS',
    },
    'IS-BFJ': {
        code: 'IS-BFJ',
        name: 'Borgarfjarðarhreppur',
        parent: 'IS',
    },
    'IS-BLA': {
        code: 'IS-BLA',
        name: 'Bláskógabyggð',
        parent: 'IS',
    },
    'IS-BLO': {
        code: 'IS-BLO',
        name: 'Blönduósbær',
        parent: 'IS',
    },
    'IS-BOG': {
        code: 'IS-BOG',
        name: 'Borgarbyggð',
        parent: 'IS',
    },
    'IS-BOL': {
        code: 'IS-BOL',
        name: 'Bolungarvíkurkaupstaður',
        parent: 'IS',
    },
    'IS-DAB': {
        code: 'IS-DAB',
        name: 'Dalabyggð',
        parent: 'IS',
    },
    'IS-DAV': {
        code: 'IS-DAV',
        name: 'Dalvíkurbyggð',
        parent: 'IS',
    },
    'IS-DJU': {
        code: 'IS-DJU',
        name: 'Djúpavogshreppur',
        parent: 'IS',
    },
    'IS-EOM': {
        code: 'IS-EOM',
        name: 'Eyja- og Miklaholtshreppur',
        parent: 'IS',
    },
    'IS-EYF': {
        code: 'IS-EYF',
        name: 'Eyjafjarðarsveit',
        parent: 'IS',
    },
    'IS-FJD': {
        code: 'IS-FJD',
        name: 'Fjarðabyggð',
        parent: 'IS',
    },
    'IS-FJL': {
        code: 'IS-FJL',
        name: 'Fjallabyggð',
        parent: 'IS',
    },
    'IS-FLA': {
        code: 'IS-FLA',
        name: 'Flóahreppur',
        parent: 'IS',
    },
    'IS-FLD': {
        code: 'IS-FLD',
        name: 'Fljótsdalshérað',
        parent: 'IS',
    },
    'IS-FLR': {
        code: 'IS-FLR',
        name: 'Fljótsdalshreppur',
        parent: 'IS',
    },
    'IS-GAR': {
        code: 'IS-GAR',
        name: 'Garðabær',
        parent: 'IS',
    },
    'IS-GOG': {
        code: 'IS-GOG',
        name: 'Grímsnes- og Grafningshreppur',
        parent: 'IS',
    },
    'IS-GRN': {
        code: 'IS-GRN',
        name: 'Grindavíkurbær',
        parent: 'IS',
    },
    'IS-GRU': {
        code: 'IS-GRU',
        name: 'Grundarfjarðarbær',
        parent: 'IS',
    },
    'IS-GRY': {
        code: 'IS-GRY',
        name: 'Grýtubakkahreppur',
        parent: 'IS',
    },
    'IS-HAF': {
        code: 'IS-HAF',
        name: 'Hafnarfjarðarkaupstaður',
        parent: 'IS',
    },
    'IS-HEL': {
        code: 'IS-HEL',
        name: 'Helgafellssveit',
        parent: 'IS',
    },
    'IS-HRG': {
        code: 'IS-HRG',
        name: 'Hörgársveit',
        parent: 'IS',
    },
    'IS-HRU': {
        code: 'IS-HRU',
        name: 'Hrunamannahreppur',
        parent: 'IS',
    },
    'IS-HUT': {
        code: 'IS-HUT',
        name: 'Húnavatnshreppur',
        parent: 'IS',
    },
    'IS-HUV': {
        code: 'IS-HUV',
        name: 'Húnaþing vestra',
        parent: 'IS',
    },
    'IS-HVA': {
        code: 'IS-HVA',
        name: 'Hvalfjarðarsveit',
        parent: 'IS',
    },
    'IS-HVE': {
        code: 'IS-HVE',
        name: 'Hveragerðisbær',
        parent: 'IS',
    },
    'IS-ISA': {
        code: 'IS-ISA',
        name: 'Ísafjarðarbær',
        parent: 'IS',
    },
    'IS-KAL': {
        code: 'IS-KAL',
        name: 'Kaldrananeshreppur',
        parent: 'IS',
    },
    'IS-KJO': {
        code: 'IS-KJO',
        name: 'Kjósarhreppur',
        parent: 'IS',
    },
    'IS-KOP': {
        code: 'IS-KOP',
        name: 'Kópavogsbær',
        parent: 'IS',
    },
    'IS-LAN': {
        code: 'IS-LAN',
        name: 'Langanesbyggð',
        parent: 'IS',
    },
    'IS-MOS': {
        code: 'IS-MOS',
        name: 'Mosfellsbær',
        parent: 'IS',
    },
    'IS-MYR': {
        code: 'IS-MYR',
        name: 'Mýrdalshreppur',
        parent: 'IS',
    },
    'IS-NOR': {
        code: 'IS-NOR',
        name: 'Norðurþing',
        parent: 'IS',
    },
    'IS-RGE': {
        code: 'IS-RGE',
        name: 'Rangárþing eystra',
        parent: 'IS',
    },
    'IS-RGY': {
        code: 'IS-RGY',
        name: 'Rangárþing ytra',
        parent: 'IS',
    },
    'IS-RHH': {
        code: 'IS-RHH',
        name: 'Reykhólahreppur',
        parent: 'IS',
    },
    'IS-RKN': {
        code: 'IS-RKN',
        name: 'Reykjanesbær',
        parent: 'IS',
    },
    'IS-RKV': {
        code: 'IS-RKV',
        name: 'Reykjavíkurborg',
        parent: 'IS',
    },
    'IS-SBH': {
        code: 'IS-SBH',
        name: 'Svalbarðshreppur',
        parent: 'IS',
    },
    'IS-SBT': {
        code: 'IS-SBT',
        name: 'Svalbarðsstrandarhreppur',
        parent: 'IS',
    },
    'IS-SDN': {
        code: 'IS-SDN',
        name: 'Suðurnesjabær',
        parent: 'IS',
    },
    'IS-SDV': {
        code: 'IS-SDV',
        name: 'Súðavíkurhreppur',
        parent: 'IS',
    },
    'IS-SEL': {
        code: 'IS-SEL',
        name: 'Seltjarnarnesbær',
        parent: 'IS',
    },
    'IS-SEY': {
        code: 'IS-SEY',
        name: 'Seyðisfjarðarkaupstaður',
        parent: 'IS',
    },
    'IS-SFA': {
        code: 'IS-SFA',
        name: 'Sveitarfélagið Árborg',
        parent: 'IS',
    },
    'IS-SHF': {
        code: 'IS-SHF',
        name: 'Sveitarfélagið Hornafjörður',
        parent: 'IS',
    },
    'IS-SKF': {
        code: 'IS-SKF',
        name: 'Skaftárhreppur',
        parent: 'IS',
    },
    'IS-SKG': {
        code: 'IS-SKG',
        name: 'Skagabyggð',
        parent: 'IS',
    },
    'IS-SKO': {
        code: 'IS-SKO',
        name: 'Skorradalshreppur',
        parent: 'IS',
    },
    'IS-SKU': {
        code: 'IS-SKU',
        name: 'Skútustaðahreppur',
        parent: 'IS',
    },
    'IS-SNF': {
        code: 'IS-SNF',
        name: 'Snæfellsbær',
        parent: 'IS',
    },
    'IS-SOG': {
        code: 'IS-SOG',
        name: 'Skeiða- og Gnúpverjahreppur',
        parent: 'IS',
    },
    'IS-SOL': {
        code: 'IS-SOL',
        name: 'Sveitarfélagið Ölfus',
        parent: 'IS',
    },
    'IS-SSF': {
        code: 'IS-SSF',
        name: 'Sveitarfélagið Skagafjörður',
        parent: 'IS',
    },
    'IS-SSS': {
        code: 'IS-SSS',
        name: 'Sveitarfélagið Skagaströnd',
        parent: 'IS',
    },
    'IS-STR': {
        code: 'IS-STR',
        name: 'Strandabyggð',
        parent: 'IS',
    },
    'IS-STY': {
        code: 'IS-STY',
        name: 'Stykkishólmsbær',
        parent: 'IS',
    },
    'IS-SVG': {
        code: 'IS-SVG',
        name: 'Sveitarfélagið Vogar',
        parent: 'IS',
    },
    'IS-TAL': {
        code: 'IS-TAL',
        name: 'Tálknafjarðarhreppur',
        parent: 'IS',
    },
    'IS-THG': {
        code: 'IS-THG',
        name: 'Þingeyjarsveit',
        parent: 'IS',
    },
    'IS-TJO': {
        code: 'IS-TJO',
        name: 'Tjörneshreppur',
        parent: 'IS',
    },
    'IS-VEM': {
        code: 'IS-VEM',
        name: 'Vestmannaeyjabær',
        parent: 'IS',
    },
    'IS-VER': {
        code: 'IS-VER',
        name: 'Vesturbyggð',
        parent: 'IS',
    },
    'IS-VOP': {
        code: 'IS-VOP',
        name: 'Vopnafjarðarhreppur',
        parent: 'IS',
    },
    'IT-21': {
        code: 'IT-21',
        name: 'Piemonte',
        parent: 'IT',
    },
    'IT-23': {
        code: 'IT-23',
        name: "Valle d'Aosta, Val d'Aoste",
        parent: 'IT',
    },
    'IT-25': {
        code: 'IT-25',
        name: 'Lombardia',
        parent: 'IT',
    },
    'IT-32': {
        code: 'IT-32',
        name: 'Trentino-Alto Adige, Trentino-Südtirol',
        parent: 'IT',
    },
    'IT-34': {
        code: 'IT-34',
        name: 'Veneto',
        parent: 'IT',
    },
    'IT-36': {
        code: 'IT-36',
        name: 'Friuli Venezia Giulia',
        parent: 'IT',
    },
    'IT-42': {
        code: 'IT-42',
        name: 'Liguria',
        parent: 'IT',
    },
    'IT-45': {
        code: 'IT-45',
        name: 'Emilia-Romagna',
        parent: 'IT',
    },
    'IT-52': {
        code: 'IT-52',
        name: 'Toscana',
        parent: 'IT',
    },
    'IT-55': {
        code: 'IT-55',
        name: 'Umbria',
        parent: 'IT',
    },
    'IT-57': {
        code: 'IT-57',
        name: 'Marche',
        parent: 'IT',
    },
    'IT-62': {
        code: 'IT-62',
        name: 'Lazio',
        parent: 'IT',
    },
    'IT-65': {
        code: 'IT-65',
        name: 'Abruzzo',
        parent: 'IT',
    },
    'IT-67': {
        code: 'IT-67',
        name: 'Molise',
        parent: 'IT',
    },
    'IT-72': {
        code: 'IT-72',
        name: 'Campania',
        parent: 'IT',
    },
    'IT-75': {
        code: 'IT-75',
        name: 'Puglia',
        parent: 'IT',
    },
    'IT-77': {
        code: 'IT-77',
        name: 'Basilicata',
        parent: 'IT',
    },
    'IT-78': {
        code: 'IT-78',
        name: 'Calabria',
        parent: 'IT',
    },
    'IT-82': {
        code: 'IT-82',
        name: 'Sicilia',
        parent: 'IT',
    },
    'IT-88': {
        code: 'IT-88',
        name: 'Sardegna',
        parent: 'IT',
    },
    'IT-AG': {
        code: 'IT-AG',
        name: 'Agrigento',
        parent: 'IT-82',
    },
    'IT-AL': {
        code: 'IT-AL',
        name: 'Alessandria',
        parent: 'IT-21',
    },
    'IT-AN': {
        code: 'IT-AN',
        name: 'Ancona',
        parent: 'IT-57',
    },
    'IT-AP': {
        code: 'IT-AP',
        name: 'Ascoli Piceno',
        parent: 'IT-57',
    },
    'IT-AQ': {
        code: 'IT-AQ',
        name: "L'Aquila",
        parent: 'IT-65',
    },
    'IT-AR': {
        code: 'IT-AR',
        name: 'Arezzo',
        parent: 'IT-52',
    },
    'IT-AT': {
        code: 'IT-AT',
        name: 'Asti',
        parent: 'IT-21',
    },
    'IT-AV': {
        code: 'IT-AV',
        name: 'Avellino',
        parent: 'IT-72',
    },
    'IT-BA': {
        code: 'IT-BA',
        name: 'Bari',
        parent: 'IT-75',
    },
    'IT-BG': {
        code: 'IT-BG',
        name: 'Bergamo',
        parent: 'IT-25',
    },
    'IT-BI': {
        code: 'IT-BI',
        name: 'Biella',
        parent: 'IT-21',
    },
    'IT-BL': {
        code: 'IT-BL',
        name: 'Belluno',
        parent: 'IT-34',
    },
    'IT-BN': {
        code: 'IT-BN',
        name: 'Benevento',
        parent: 'IT-72',
    },
    'IT-BO': {
        code: 'IT-BO',
        name: 'Bologna',
        parent: 'IT-45',
    },
    'IT-BR': {
        code: 'IT-BR',
        name: 'Brindisi',
        parent: 'IT-75',
    },
    'IT-BS': {
        code: 'IT-BS',
        name: 'Brescia',
        parent: 'IT-25',
    },
    'IT-BT': {
        code: 'IT-BT',
        name: 'Barletta-Andria-Trani',
        parent: 'IT-75',
    },
    'IT-BZ': {
        code: 'IT-BZ',
        name: 'Bolzano, Bozen',
        parent: 'IT-32',
    },
    'IT-CA': {
        code: 'IT-CA',
        name: 'Cagliari',
        parent: 'IT-88',
    },
    'IT-CB': {
        code: 'IT-CB',
        name: 'Campobasso',
        parent: 'IT-67',
    },
    'IT-CE': {
        code: 'IT-CE',
        name: 'Caserta',
        parent: 'IT-72',
    },
    'IT-CH': {
        code: 'IT-CH',
        name: 'Chieti',
        parent: 'IT-65',
    },
    'IT-CL': {
        code: 'IT-CL',
        name: 'Caltanissetta',
        parent: 'IT-82',
    },
    'IT-CN': {
        code: 'IT-CN',
        name: 'Cuneo',
        parent: 'IT-21',
    },
    'IT-CO': {
        code: 'IT-CO',
        name: 'Como',
        parent: 'IT-25',
    },
    'IT-CR': {
        code: 'IT-CR',
        name: 'Cremona',
        parent: 'IT-25',
    },
    'IT-CS': {
        code: 'IT-CS',
        name: 'Cosenza',
        parent: 'IT-78',
    },
    'IT-CT': {
        code: 'IT-CT',
        name: 'Catania',
        parent: 'IT-82',
    },
    'IT-CZ': {
        code: 'IT-CZ',
        name: 'Catanzaro',
        parent: 'IT-78',
    },
    'IT-EN': {
        code: 'IT-EN',
        name: 'Enna',
        parent: 'IT-82',
    },
    'IT-FC': {
        code: 'IT-FC',
        name: 'Forlì-Cesena',
        parent: 'IT-45',
    },
    'IT-FE': {
        code: 'IT-FE',
        name: 'Ferrara',
        parent: 'IT-45',
    },
    'IT-FG': {
        code: 'IT-FG',
        name: 'Foggia',
        parent: 'IT-75',
    },
    'IT-FI': {
        code: 'IT-FI',
        name: 'Firenze',
        parent: 'IT-52',
    },
    'IT-FM': {
        code: 'IT-FM',
        name: 'Fermo',
        parent: 'IT-57',
    },
    'IT-FR': {
        code: 'IT-FR',
        name: 'Frosinone',
        parent: 'IT-62',
    },
    'IT-GE': {
        code: 'IT-GE',
        name: 'Genova',
        parent: 'IT-42',
    },
    'IT-GO': {
        code: 'IT-GO',
        name: 'Gorizia',
        parent: 'IT-36',
    },
    'IT-GR': {
        code: 'IT-GR',
        name: 'Grosseto',
        parent: 'IT-52',
    },
    'IT-IM': {
        code: 'IT-IM',
        name: 'Imperia',
        parent: 'IT-42',
    },
    'IT-IS': {
        code: 'IT-IS',
        name: 'Isernia',
        parent: 'IT-67',
    },
    'IT-KR': {
        code: 'IT-KR',
        name: 'Crotone',
        parent: 'IT-78',
    },
    'IT-LC': {
        code: 'IT-LC',
        name: 'Lecco',
        parent: 'IT-25',
    },
    'IT-LE': {
        code: 'IT-LE',
        name: 'Lecce',
        parent: 'IT-75',
    },
    'IT-LI': {
        code: 'IT-LI',
        name: 'Livorno',
        parent: 'IT-52',
    },
    'IT-LO': {
        code: 'IT-LO',
        name: 'Lodi',
        parent: 'IT-25',
    },
    'IT-LT': {
        code: 'IT-LT',
        name: 'Latina',
        parent: 'IT-62',
    },
    'IT-LU': {
        code: 'IT-LU',
        name: 'Lucca',
        parent: 'IT-52',
    },
    'IT-MB': {
        code: 'IT-MB',
        name: 'Monza e Brianza',
        parent: 'IT-25',
    },
    'IT-MC': {
        code: 'IT-MC',
        name: 'Macerata',
        parent: 'IT-57',
    },
    'IT-ME': {
        code: 'IT-ME',
        name: 'Messina',
        parent: 'IT-82',
    },
    'IT-MI': {
        code: 'IT-MI',
        name: 'Milano',
        parent: 'IT-25',
    },
    'IT-MN': {
        code: 'IT-MN',
        name: 'Mantova',
        parent: 'IT-25',
    },
    'IT-MO': {
        code: 'IT-MO',
        name: 'Modena',
        parent: 'IT-45',
    },
    'IT-MS': {
        code: 'IT-MS',
        name: 'Massa-Carrara',
        parent: 'IT-52',
    },
    'IT-MT': {
        code: 'IT-MT',
        name: 'Matera',
        parent: 'IT-77',
    },
    'IT-NA': {
        code: 'IT-NA',
        name: 'Napoli',
        parent: 'IT-72',
    },
    'IT-NO': {
        code: 'IT-NO',
        name: 'Novara',
        parent: 'IT-21',
    },
    'IT-NU': {
        code: 'IT-NU',
        name: 'Nuoro',
        parent: 'IT-88',
    },
    'IT-OR': {
        code: 'IT-OR',
        name: 'Oristano',
        parent: 'IT-88',
    },
    'IT-PA': {
        code: 'IT-PA',
        name: 'Palermo',
        parent: 'IT-82',
    },
    'IT-PC': {
        code: 'IT-PC',
        name: 'Piacenza',
        parent: 'IT-45',
    },
    'IT-PD': {
        code: 'IT-PD',
        name: 'Padova',
        parent: 'IT-34',
    },
    'IT-PE': {
        code: 'IT-PE',
        name: 'Pescara',
        parent: 'IT-65',
    },
    'IT-PG': {
        code: 'IT-PG',
        name: 'Perugia',
        parent: 'IT-55',
    },
    'IT-PI': {
        code: 'IT-PI',
        name: 'Pisa',
        parent: 'IT-52',
    },
    'IT-PN': {
        code: 'IT-PN',
        name: 'Pordenone',
        parent: 'IT-36',
    },
    'IT-PO': {
        code: 'IT-PO',
        name: 'Prato',
        parent: 'IT-52',
    },
    'IT-PR': {
        code: 'IT-PR',
        name: 'Parma',
        parent: 'IT-45',
    },
    'IT-PT': {
        code: 'IT-PT',
        name: 'Pistoia',
        parent: 'IT-52',
    },
    'IT-PU': {
        code: 'IT-PU',
        name: 'Pesaro e Urbino',
        parent: 'IT-57',
    },
    'IT-PV': {
        code: 'IT-PV',
        name: 'Pavia',
        parent: 'IT-25',
    },
    'IT-PZ': {
        code: 'IT-PZ',
        name: 'Potenza',
        parent: 'IT-77',
    },
    'IT-RA': {
        code: 'IT-RA',
        name: 'Ravenna',
        parent: 'IT-45',
    },
    'IT-RC': {
        code: 'IT-RC',
        name: 'Reggio Calabria',
        parent: 'IT-78',
    },
    'IT-RE': {
        code: 'IT-RE',
        name: 'Reggio Emilia',
        parent: 'IT-45',
    },
    'IT-RG': {
        code: 'IT-RG',
        name: 'Ragusa',
        parent: 'IT-82',
    },
    'IT-RI': {
        code: 'IT-RI',
        name: 'Rieti',
        parent: 'IT-62',
    },
    'IT-RM': {
        code: 'IT-RM',
        name: 'Roma',
        parent: 'IT-62',
    },
    'IT-RN': {
        code: 'IT-RN',
        name: 'Rimini',
        parent: 'IT-45',
    },
    'IT-RO': {
        code: 'IT-RO',
        name: 'Rovigo',
        parent: 'IT-34',
    },
    'IT-SA': {
        code: 'IT-SA',
        name: 'Salerno',
        parent: 'IT-72',
    },
    'IT-SI': {
        code: 'IT-SI',
        name: 'Siena',
        parent: 'IT-52',
    },
    'IT-SO': {
        code: 'IT-SO',
        name: 'Sondrio',
        parent: 'IT-25',
    },
    'IT-SP': {
        code: 'IT-SP',
        name: 'La Spezia',
        parent: 'IT-42',
    },
    'IT-SR': {
        code: 'IT-SR',
        name: 'Siracusa',
        parent: 'IT-82',
    },
    'IT-SS': {
        code: 'IT-SS',
        name: 'Sassari',
        parent: 'IT-88',
    },
    'IT-SU': {
        code: 'IT-SU',
        name: 'Sud Sardegna',
        parent: 'IT-88',
    },
    'IT-SV': {
        code: 'IT-SV',
        name: 'Savona',
        parent: 'IT-42',
    },
    'IT-TA': {
        code: 'IT-TA',
        name: 'Taranto',
        parent: 'IT-75',
    },
    'IT-TE': {
        code: 'IT-TE',
        name: 'Teramo',
        parent: 'IT-65',
    },
    'IT-TN': {
        code: 'IT-TN',
        name: 'Trento',
        parent: 'IT-32',
    },
    'IT-TO': {
        code: 'IT-TO',
        name: 'Torino',
        parent: 'IT-21',
    },
    'IT-TP': {
        code: 'IT-TP',
        name: 'Trapani',
        parent: 'IT-82',
    },
    'IT-TR': {
        code: 'IT-TR',
        name: 'Terni',
        parent: 'IT-55',
    },
    'IT-TS': {
        code: 'IT-TS',
        name: 'Trieste',
        parent: 'IT-36',
    },
    'IT-TV': {
        code: 'IT-TV',
        name: 'Treviso',
        parent: 'IT-34',
    },
    'IT-UD': {
        code: 'IT-UD',
        name: 'Udine',
        parent: 'IT-36',
    },
    'IT-VA': {
        code: 'IT-VA',
        name: 'Varese',
        parent: 'IT-25',
    },
    'IT-VB': {
        code: 'IT-VB',
        name: 'Verbano-Cusio-Ossola',
        parent: 'IT-21',
    },
    'IT-VC': {
        code: 'IT-VC',
        name: 'Vercelli',
        parent: 'IT-21',
    },
    'IT-VE': {
        code: 'IT-VE',
        name: 'Venezia',
        parent: 'IT-34',
    },
    'IT-VI': {
        code: 'IT-VI',
        name: 'Vicenza',
        parent: 'IT-34',
    },
    'IT-VR': {
        code: 'IT-VR',
        name: 'Verona',
        parent: 'IT-34',
    },
    'IT-VT': {
        code: 'IT-VT',
        name: 'Viterbo',
        parent: 'IT-62',
    },
    'IT-VV': {
        code: 'IT-VV',
        name: 'Vibo Valentia',
        parent: 'IT-78',
    },
    'JM-01': {
        code: 'JM-01',
        name: 'Kingston',
        parent: 'JM',
    },
    'JM-02': {
        code: 'JM-02',
        name: 'Saint Andrew',
        parent: 'JM',
    },
    'JM-03': {
        code: 'JM-03',
        name: 'Saint Thomas',
        parent: 'JM',
    },
    'JM-04': {
        code: 'JM-04',
        name: 'Portland',
        parent: 'JM',
    },
    'JM-05': {
        code: 'JM-05',
        name: 'Saint Mary',
        parent: 'JM',
    },
    'JM-06': {
        code: 'JM-06',
        name: 'Saint Ann',
        parent: 'JM',
    },
    'JM-07': {
        code: 'JM-07',
        name: 'Trelawny',
        parent: 'JM',
    },
    'JM-08': {
        code: 'JM-08',
        name: 'Saint James',
        parent: 'JM',
    },
    'JM-09': {
        code: 'JM-09',
        name: 'Hanover',
        parent: 'JM',
    },
    'JM-10': {
        code: 'JM-10',
        name: 'Westmoreland',
        parent: 'JM',
    },
    'JM-11': {
        code: 'JM-11',
        name: 'Saint Elizabeth',
        parent: 'JM',
    },
    'JM-12': {
        code: 'JM-12',
        name: 'Manchester',
        parent: 'JM',
    },
    'JM-13': {
        code: 'JM-13',
        name: 'Clarendon',
        parent: 'JM',
    },
    'JM-14': {
        code: 'JM-14',
        name: 'Saint Catherine',
        parent: 'JM',
    },
    'JO-AJ': {
        code: 'JO-AJ',
        name: '‘Ajlūn',
        parent: 'JO',
    },
    'JO-AM': {
        code: 'JO-AM',
        name: 'Al ‘A̅şimah',
        parent: 'JO',
    },
    'JO-AQ': {
        code: 'JO-AQ',
        name: 'Al ‘Aqabah',
        parent: 'JO',
    },
    'JO-AT': {
        code: 'JO-AT',
        name: 'Aţ Ţafīlah',
        parent: 'JO',
    },
    'JO-AZ': {
        code: 'JO-AZ',
        name: 'Az Zarqā’',
        parent: 'JO',
    },
    'JO-BA': {
        code: 'JO-BA',
        name: 'Al Balqā’',
        parent: 'JO',
    },
    'JO-IR': {
        code: 'JO-IR',
        name: 'Irbid',
        parent: 'JO',
    },
    'JO-JA': {
        code: 'JO-JA',
        name: 'Jarash',
        parent: 'JO',
    },
    'JO-KA': {
        code: 'JO-KA',
        name: 'Al Karak',
        parent: 'JO',
    },
    'JO-MA': {
        code: 'JO-MA',
        name: 'Al Mafraq',
        parent: 'JO',
    },
    'JO-MD': {
        code: 'JO-MD',
        name: 'Mādabā',
        parent: 'JO',
    },
    'JO-MN': {
        code: 'JO-MN',
        name: 'Ma‘ān',
        parent: 'JO',
    },
    'JP-01': {
        code: 'JP-01',
        name: 'Hokkaidô',
        parent: 'JP',
    },
    'JP-02': {
        code: 'JP-02',
        name: 'Aomori',
        parent: 'JP',
    },
    'JP-03': {
        code: 'JP-03',
        name: 'Iwate',
        parent: 'JP',
    },
    'JP-04': {
        code: 'JP-04',
        name: 'Miyagi',
        parent: 'JP',
    },
    'JP-05': {
        code: 'JP-05',
        name: 'Akita',
        parent: 'JP',
    },
    'JP-06': {
        code: 'JP-06',
        name: 'Yamagata',
        parent: 'JP',
    },
    'JP-07': {
        code: 'JP-07',
        name: 'Hukusima',
        parent: 'JP',
    },
    'JP-08': {
        code: 'JP-08',
        name: 'Ibaraki',
        parent: 'JP',
    },
    'JP-09': {
        code: 'JP-09',
        name: 'Totigi',
        parent: 'JP',
    },
    'JP-10': {
        code: 'JP-10',
        name: 'Gunma',
        parent: 'JP',
    },
    'JP-11': {
        code: 'JP-11',
        name: 'Saitama',
        parent: 'JP',
    },
    'JP-12': {
        code: 'JP-12',
        name: 'Tiba',
        parent: 'JP',
    },
    'JP-13': {
        code: 'JP-13',
        name: 'Tôkyô',
        parent: 'JP',
    },
    'JP-14': {
        code: 'JP-14',
        name: 'Kanagawa',
        parent: 'JP',
    },
    'JP-15': {
        code: 'JP-15',
        name: 'Niigata',
        parent: 'JP',
    },
    'JP-16': {
        code: 'JP-16',
        name: 'Toyama',
        parent: 'JP',
    },
    'JP-17': {
        code: 'JP-17',
        name: 'Isikawa',
        parent: 'JP',
    },
    'JP-18': {
        code: 'JP-18',
        name: 'Hukui',
        parent: 'JP',
    },
    'JP-19': {
        code: 'JP-19',
        name: 'Yamanasi',
        parent: 'JP',
    },
    'JP-20': {
        code: 'JP-20',
        name: 'Nagano',
        parent: 'JP',
    },
    'JP-21': {
        code: 'JP-21',
        name: 'Gihu',
        parent: 'JP',
    },
    'JP-22': {
        code: 'JP-22',
        name: 'Sizuoka',
        parent: 'JP',
    },
    'JP-23': {
        code: 'JP-23',
        name: 'Aiti',
        parent: 'JP',
    },
    'JP-24': {
        code: 'JP-24',
        name: 'Mie',
        parent: 'JP',
    },
    'JP-25': {
        code: 'JP-25',
        name: 'Siga',
        parent: 'JP',
    },
    'JP-26': {
        code: 'JP-26',
        name: 'Kyôto',
        parent: 'JP',
    },
    'JP-27': {
        code: 'JP-27',
        name: 'Ôsaka',
        parent: 'JP',
    },
    'JP-28': {
        code: 'JP-28',
        name: 'Hyôgo',
        parent: 'JP',
    },
    'JP-29': {
        code: 'JP-29',
        name: 'Nara',
        parent: 'JP',
    },
    'JP-30': {
        code: 'JP-30',
        name: 'Wakayama',
        parent: 'JP',
    },
    'JP-31': {
        code: 'JP-31',
        name: 'Tottori',
        parent: 'JP',
    },
    'JP-32': {
        code: 'JP-32',
        name: 'Simane',
        parent: 'JP',
    },
    'JP-33': {
        code: 'JP-33',
        name: 'Okayama',
        parent: 'JP',
    },
    'JP-34': {
        code: 'JP-34',
        name: 'Hirosima',
        parent: 'JP',
    },
    'JP-35': {
        code: 'JP-35',
        name: 'Yamaguti',
        parent: 'JP',
    },
    'JP-36': {
        code: 'JP-36',
        name: 'Tokusima',
        parent: 'JP',
    },
    'JP-37': {
        code: 'JP-37',
        name: 'Kagawa',
        parent: 'JP',
    },
    'JP-38': {
        code: 'JP-38',
        name: 'Ehime',
        parent: 'JP',
    },
    'JP-39': {
        code: 'JP-39',
        name: 'Kôti',
        parent: 'JP',
    },
    'JP-40': {
        code: 'JP-40',
        name: 'Hukuoka',
        parent: 'JP',
    },
    'JP-41': {
        code: 'JP-41',
        name: 'Saga',
        parent: 'JP',
    },
    'JP-42': {
        code: 'JP-42',
        name: 'Nagasaki',
        parent: 'JP',
    },
    'JP-43': {
        code: 'JP-43',
        name: 'Kumamoto',
        parent: 'JP',
    },
    'JP-44': {
        code: 'JP-44',
        name: 'Ôita',
        parent: 'JP',
    },
    'JP-45': {
        code: 'JP-45',
        name: 'Miyazaki',
        parent: 'JP',
    },
    'JP-46': {
        code: 'JP-46',
        name: 'Kagosima',
        parent: 'JP',
    },
    'JP-47': {
        code: 'JP-47',
        name: 'Okinawa',
        parent: 'JP',
    },
    'KE-01': {
        code: 'KE-01',
        name: 'Baringo',
        parent: 'KE',
    },
    'KE-02': {
        code: 'KE-02',
        name: 'Bomet',
        parent: 'KE',
    },
    'KE-03': {
        code: 'KE-03',
        name: 'Bungoma',
        parent: 'KE',
    },
    'KE-04': {
        code: 'KE-04',
        name: 'Busia',
        parent: 'KE',
    },
    'KE-05': {
        code: 'KE-05',
        name: 'Elgeyo/Marakwet',
        parent: 'KE',
    },
    'KE-06': {
        code: 'KE-06',
        name: 'Embu',
        parent: 'KE',
    },
    'KE-07': {
        code: 'KE-07',
        name: 'Garissa',
        parent: 'KE',
    },
    'KE-08': {
        code: 'KE-08',
        name: 'Homa Bay',
        parent: 'KE',
    },
    'KE-09': {
        code: 'KE-09',
        name: 'Isiolo',
        parent: 'KE',
    },
    'KE-10': {
        code: 'KE-10',
        name: 'Kajiado',
        parent: 'KE',
    },
    'KE-11': {
        code: 'KE-11',
        name: 'Kakamega',
        parent: 'KE',
    },
    'KE-12': {
        code: 'KE-12',
        name: 'Kericho',
        parent: 'KE',
    },
    'KE-13': {
        code: 'KE-13',
        name: 'Kiambu',
        parent: 'KE',
    },
    'KE-14': {
        code: 'KE-14',
        name: 'Kilifi',
        parent: 'KE',
    },
    'KE-15': {
        code: 'KE-15',
        name: 'Kirinyaga',
        parent: 'KE',
    },
    'KE-16': {
        code: 'KE-16',
        name: 'Kisii',
        parent: 'KE',
    },
    'KE-17': {
        code: 'KE-17',
        name: 'Kisumu',
        parent: 'KE',
    },
    'KE-18': {
        code: 'KE-18',
        name: 'Kitui',
        parent: 'KE',
    },
    'KE-19': {
        code: 'KE-19',
        name: 'Kwale',
        parent: 'KE',
    },
    'KE-20': {
        code: 'KE-20',
        name: 'Laikipia',
        parent: 'KE',
    },
    'KE-21': {
        code: 'KE-21',
        name: 'Lamu',
        parent: 'KE',
    },
    'KE-22': {
        code: 'KE-22',
        name: 'Machakos',
        parent: 'KE',
    },
    'KE-23': {
        code: 'KE-23',
        name: 'Makueni',
        parent: 'KE',
    },
    'KE-24': {
        code: 'KE-24',
        name: 'Mandera',
        parent: 'KE',
    },
    'KE-25': {
        code: 'KE-25',
        name: 'Marsabit',
        parent: 'KE',
    },
    'KE-26': {
        code: 'KE-26',
        name: 'Meru',
        parent: 'KE',
    },
    'KE-27': {
        code: 'KE-27',
        name: 'Migori',
        parent: 'KE',
    },
    'KE-28': {
        code: 'KE-28',
        name: 'Mombasa',
        parent: 'KE',
    },
    'KE-29': {
        code: 'KE-29',
        name: "Murang'a",
        parent: 'KE',
    },
    'KE-30': {
        code: 'KE-30',
        name: 'Nairobi City',
        parent: 'KE',
    },
    'KE-31': {
        code: 'KE-31',
        name: 'Nakuru',
        parent: 'KE',
    },
    'KE-32': {
        code: 'KE-32',
        name: 'Nandi',
        parent: 'KE',
    },
    'KE-33': {
        code: 'KE-33',
        name: 'Narok',
        parent: 'KE',
    },
    'KE-34': {
        code: 'KE-34',
        name: 'Nyamira',
        parent: 'KE',
    },
    'KE-35': {
        code: 'KE-35',
        name: 'Nyandarua',
        parent: 'KE',
    },
    'KE-36': {
        code: 'KE-36',
        name: 'Nyeri',
        parent: 'KE',
    },
    'KE-37': {
        code: 'KE-37',
        name: 'Samburu',
        parent: 'KE',
    },
    'KE-38': {
        code: 'KE-38',
        name: 'Siaya',
        parent: 'KE',
    },
    'KE-39': {
        code: 'KE-39',
        name: 'Taita/Taveta',
        parent: 'KE',
    },
    'KE-40': {
        code: 'KE-40',
        name: 'Tana River',
        parent: 'KE',
    },
    'KE-41': {
        code: 'KE-41',
        name: 'Tharaka-Nithi',
        parent: 'KE',
    },
    'KE-42': {
        code: 'KE-42',
        name: 'Trans Nzoia',
        parent: 'KE',
    },
    'KE-43': {
        code: 'KE-43',
        name: 'Turkana',
        parent: 'KE',
    },
    'KE-44': {
        code: 'KE-44',
        name: 'Uasin Gishu',
        parent: 'KE',
    },
    'KE-45': {
        code: 'KE-45',
        name: 'Vihiga',
        parent: 'KE',
    },
    'KE-46': {
        code: 'KE-46',
        name: 'Wajir',
        parent: 'KE',
    },
    'KE-47': {
        code: 'KE-47',
        name: 'West Pokot',
        parent: 'KE',
    },
    'KG-B': {
        code: 'KG-B',
        name: 'Batken',
        parent: 'KG',
    },
    'KG-C': {
        code: 'KG-C',
        name: 'Chüy',
        parent: 'KG',
    },
    'KG-GB': {
        code: 'KG-GB',
        name: 'Bishkek Shaary',
        parent: 'KG',
    },
    'KG-GO': {
        code: 'KG-GO',
        name: 'Osh Shaary',
        parent: 'KG',
    },
    'KG-J': {
        code: 'KG-J',
        name: 'Jalal-Abad',
        parent: 'KG',
    },
    'KG-N': {
        code: 'KG-N',
        name: 'Naryn',
        parent: 'KG',
    },
    'KG-O': {
        code: 'KG-O',
        name: 'Osh',
        parent: 'KG',
    },
    'KG-T': {
        code: 'KG-T',
        name: 'Talas',
        parent: 'KG',
    },
    'KG-Y': {
        code: 'KG-Y',
        name: 'Ysyk-Köl',
        parent: 'KG',
    },
    'KH-1': {
        code: 'KH-1',
        name: 'Banteay Mean Choăy',
        parent: 'KH',
    },
    'KH-10': {
        code: 'KH-10',
        name: 'Kracheh',
        parent: 'KH',
    },
    'KH-11': {
        code: 'KH-11',
        name: 'Mondol Kiri',
        parent: 'KH',
    },
    'KH-12': {
        code: 'KH-12',
        name: 'Phnom Penh',
        parent: 'KH',
    },
    'KH-13': {
        code: 'KH-13',
        name: 'Preah Vihear',
        parent: 'KH',
    },
    'KH-14': {
        code: 'KH-14',
        name: 'Prey Veaeng',
        parent: 'KH',
    },
    'KH-15': {
        code: 'KH-15',
        name: 'Pousaat',
        parent: 'KH',
    },
    'KH-16': {
        code: 'KH-16',
        name: 'Rotanak Kiri',
        parent: 'KH',
    },
    'KH-17': {
        code: 'KH-17',
        name: 'Siem Reab',
        parent: 'KH',
    },
    'KH-18': {
        code: 'KH-18',
        name: 'Preah Sihanouk',
        parent: 'KH',
    },
    'KH-19': {
        code: 'KH-19',
        name: 'Stueng Traeng',
        parent: 'KH',
    },
    'KH-2': {
        code: 'KH-2',
        name: 'Baat Dambang',
        parent: 'KH',
    },
    'KH-20': {
        code: 'KH-20',
        name: 'Svaay Rieng',
        parent: 'KH',
    },
    'KH-21': {
        code: 'KH-21',
        name: 'Taakaev',
        parent: 'KH',
    },
    'KH-22': {
        code: 'KH-22',
        name: 'Otdar Mean Chey',
        parent: 'KH',
    },
    'KH-23': {
        code: 'KH-23',
        name: 'Kaeb',
        parent: 'KH',
    },
    'KH-24': {
        code: 'KH-24',
        name: 'Pailin',
        parent: 'KH',
    },
    'KH-25': {
        code: 'KH-25',
        name: 'Tbong Khmum',
        parent: 'KH',
    },
    'KH-3': {
        code: 'KH-3',
        name: 'Kampong Chaam',
        parent: 'KH',
    },
    'KH-4': {
        code: 'KH-4',
        name: 'Kampong Chhnang',
        parent: 'KH',
    },
    'KH-5': {
        code: 'KH-5',
        name: 'Kampong Spueu',
        parent: 'KH',
    },
    'KH-6': {
        code: 'KH-6',
        name: 'Kampong Thum',
        parent: 'KH',
    },
    'KH-7': {
        code: 'KH-7',
        name: 'Kampot',
        parent: 'KH',
    },
    'KH-8': {
        code: 'KH-8',
        name: 'Kandaal',
        parent: 'KH',
    },
    'KH-9': {
        code: 'KH-9',
        name: 'Kaoh Kong',
        parent: 'KH',
    },
    'KI-G': {
        code: 'KI-G',
        name: 'Gilbert Islands',
        parent: 'KI',
    },
    'KI-L': {
        code: 'KI-L',
        name: 'Line Islands',
        parent: 'KI',
    },
    'KI-P': {
        code: 'KI-P',
        name: 'Phoenix Islands',
        parent: 'KI',
    },
    'KM-A': {
        code: 'KM-A',
        name: 'Anjouan',
        parent: 'KM',
    },
    'KM-G': {
        code: 'KM-G',
        name: 'Grande Comore',
        parent: 'KM',
    },
    'KM-M': {
        code: 'KM-M',
        name: 'Mohéli',
        parent: 'KM',
    },
    'KN-01': {
        code: 'KN-01',
        name: 'Christ Church Nichola Town',
        parent: 'KN-K',
    },
    'KN-02': {
        code: 'KN-02',
        name: 'Saint Anne Sandy Point',
        parent: 'KN-K',
    },
    'KN-03': {
        code: 'KN-03',
        name: 'Saint George Basseterre',
        parent: 'KN-K',
    },
    'KN-04': {
        code: 'KN-04',
        name: 'Saint George Gingerland',
        parent: 'KN-N',
    },
    'KN-05': {
        code: 'KN-05',
        name: 'Saint James Windward',
        parent: 'KN-N',
    },
    'KN-06': {
        code: 'KN-06',
        name: 'Saint John Capisterre',
        parent: 'KN-K',
    },
    'KN-07': {
        code: 'KN-07',
        name: 'Saint John Figtree',
        parent: 'KN-N',
    },
    'KN-08': {
        code: 'KN-08',
        name: 'Saint Mary Cayon',
        parent: 'KN-K',
    },
    'KN-09': {
        code: 'KN-09',
        name: 'Saint Paul Capisterre',
        parent: 'KN-K',
    },
    'KN-10': {
        code: 'KN-10',
        name: 'Saint Paul Charlestown',
        parent: 'KN-N',
    },
    'KN-11': {
        code: 'KN-11',
        name: 'Saint Peter Basseterre',
        parent: 'KN-K',
    },
    'KN-12': {
        code: 'KN-12',
        name: 'Saint Thomas Lowland',
        parent: 'KN-N',
    },
    'KN-13': {
        code: 'KN-13',
        name: 'Saint Thomas Middle Island',
        parent: 'KN-K',
    },
    'KN-15': {
        code: 'KN-15',
        name: 'Trinity Palmetto Point',
        parent: 'KN-K',
    },
    'KN-K': {
        code: 'KN-K',
        name: 'Saint Kitts',
        parent: 'KN',
    },
    'KN-N': {
        code: 'KN-N',
        name: 'Nevis',
        parent: 'KN',
    },
    'KP-01': {
        code: 'KP-01',
        name: 'Pyongyang',
        parent: 'KP',
    },
    'KP-02': {
        code: 'KP-02',
        name: 'South Pyongan',
        parent: 'KP',
    },
    'KP-03': {
        code: 'KP-03',
        name: 'North Pyongan',
        parent: 'KP',
    },
    'KP-04': {
        code: 'KP-04',
        name: 'Chagang',
        parent: 'KP',
    },
    'KP-05': {
        code: 'KP-05',
        name: 'South Hwanghae',
        parent: 'KP',
    },
    'KP-06': {
        code: 'KP-06',
        name: 'North Hwanghae',
        parent: 'KP',
    },
    'KP-07': {
        code: 'KP-07',
        name: 'Kangwon',
        parent: 'KP',
    },
    'KP-08': {
        code: 'KP-08',
        name: 'South Hamgyong',
        parent: 'KP',
    },
    'KP-09': {
        code: 'KP-09',
        name: 'North Hamgyong',
        parent: 'KP',
    },
    'KP-10': {
        code: 'KP-10',
        name: 'Ryanggang',
        parent: 'KP',
    },
    'KP-13': {
        code: 'KP-13',
        name: 'Rason',
        parent: 'KP',
    },
    'KP-14': {
        code: 'KP-14',
        name: 'Nampo',
        parent: 'KP',
    },
    'KR-11': {
        code: 'KR-11',
        name: 'Seoul',
        parent: 'KR',
    },
    'KR-26': {
        code: 'KR-26',
        name: 'Busan',
        parent: 'KR',
    },
    'KR-27': {
        code: 'KR-27',
        name: 'Daegu',
        parent: 'KR',
    },
    'KR-28': {
        code: 'KR-28',
        name: 'Incheon',
        parent: 'KR',
    },
    'KR-29': {
        code: 'KR-29',
        name: 'Gwangju',
        parent: 'KR',
    },
    'KR-30': {
        code: 'KR-30',
        name: 'Daejeon',
        parent: 'KR',
    },
    'KR-31': {
        code: 'KR-31',
        name: 'Ulsan',
        parent: 'KR',
    },
    'KR-41': {
        code: 'KR-41',
        name: 'Gyeonggi',
        parent: 'KR',
    },
    'KR-42': {
        code: 'KR-42',
        name: 'Gangwon',
        parent: 'KR',
    },
    'KR-43': {
        code: 'KR-43',
        name: 'North Chungcheong',
        parent: 'KR',
    },
    'KR-44': {
        code: 'KR-44',
        name: 'South Chungcheong',
        parent: 'KR',
    },
    'KR-45': {
        code: 'KR-45',
        name: 'North Jeolla',
        parent: 'KR',
    },
    'KR-46': {
        code: 'KR-46',
        name: 'South Jeolla',
        parent: 'KR',
    },
    'KR-47': {
        code: 'KR-47',
        name: 'North Gyeongsang',
        parent: 'KR',
    },
    'KR-48': {
        code: 'KR-48',
        name: 'South Gyeongsang',
        parent: 'KR',
    },
    'KR-49': {
        code: 'KR-49',
        name: 'Jeju',
        parent: 'KR',
    },
    'KR-50': {
        code: 'KR-50',
        name: 'Sejong',
        parent: 'KR',
    },
    'KW-AH': {
        code: 'KW-AH',
        name: 'Al Aḩmadī',
        parent: 'KW',
    },
    'KW-FA': {
        code: 'KW-FA',
        name: 'Al Farwānīyah',
        parent: 'KW',
    },
    'KW-HA': {
        code: 'KW-HA',
        name: 'Ḩawallī',
        parent: 'KW',
    },
    'KW-JA': {
        code: 'KW-JA',
        name: 'Al Jahrā’',
        parent: 'KW',
    },
    'KW-KU': {
        code: 'KW-KU',
        name: 'Al ‘Āşimah',
        parent: 'KW',
    },
    'KW-MU': {
        code: 'KW-MU',
        name: 'Mubārak al Kabīr',
        parent: 'KW',
    },
    'KZ-AKM': {
        code: 'KZ-AKM',
        name: 'Aqmola oblysy',
        parent: 'KZ',
    },
    'KZ-AKT': {
        code: 'KZ-AKT',
        name: 'Aqtöbe oblysy',
        parent: 'KZ',
    },
    'KZ-ALA': {
        code: 'KZ-ALA',
        name: 'Almaty',
        parent: 'KZ',
    },
    'KZ-ALM': {
        code: 'KZ-ALM',
        name: 'Almaty oblysy',
        parent: 'KZ',
    },
    'KZ-AST': {
        code: 'KZ-AST',
        name: 'Nur-Sultan',
        parent: 'KZ',
    },
    'KZ-ATY': {
        code: 'KZ-ATY',
        name: 'Atyraū oblysy',
        parent: 'KZ',
    },
    'KZ-KAR': {
        code: 'KZ-KAR',
        name: 'Qaraghandy oblysy',
        parent: 'KZ',
    },
    'KZ-KUS': {
        code: 'KZ-KUS',
        name: 'Qostanay oblysy',
        parent: 'KZ',
    },
    'KZ-KZY': {
        code: 'KZ-KZY',
        name: 'Qyzylorda oblysy',
        parent: 'KZ',
    },
    'KZ-MAN': {
        code: 'KZ-MAN',
        name: 'Mangghystaū oblysy',
        parent: 'KZ',
    },
    'KZ-PAV': {
        code: 'KZ-PAV',
        name: 'Pavlodar oblysy',
        parent: 'KZ',
    },
    'KZ-SEV': {
        code: 'KZ-SEV',
        name: 'Soltüstik Qazaqstan oblysy',
        parent: 'KZ',
    },
    'KZ-SHY': {
        code: 'KZ-SHY',
        name: 'Shymkent',
        parent: 'KZ',
    },
    'KZ-VOS': {
        code: 'KZ-VOS',
        name: 'Shyghys Qazaqstan oblysy',
        parent: 'KZ',
    },
    'KZ-YUZ': {
        code: 'KZ-YUZ',
        name: 'Türkistan oblysy',
        parent: 'KZ',
    },
    'KZ-ZAP': {
        code: 'KZ-ZAP',
        name: 'Batys Qazaqstan oblysy',
        parent: 'KZ',
    },
    'KZ-ZHA': {
        code: 'KZ-ZHA',
        name: 'Zhambyl oblysy',
        parent: 'KZ',
    },
    'LA-AT': {
        code: 'LA-AT',
        name: 'Attapu',
        parent: 'LA',
    },
    'LA-BK': {
        code: 'LA-BK',
        name: 'Bokèo',
        parent: 'LA',
    },
    'LA-BL': {
        code: 'LA-BL',
        name: 'Bolikhamxai',
        parent: 'LA',
    },
    'LA-CH': {
        code: 'LA-CH',
        name: 'Champasak',
        parent: 'LA',
    },
    'LA-HO': {
        code: 'LA-HO',
        name: 'Houaphan',
        parent: 'LA',
    },
    'LA-KH': {
        code: 'LA-KH',
        name: 'Khammouan',
        parent: 'LA',
    },
    'LA-LM': {
        code: 'LA-LM',
        name: 'Louang Namtha',
        parent: 'LA',
    },
    'LA-LP': {
        code: 'LA-LP',
        name: 'Louangphabang',
        parent: 'LA',
    },
    'LA-OU': {
        code: 'LA-OU',
        name: 'Oudômxai',
        parent: 'LA',
    },
    'LA-PH': {
        code: 'LA-PH',
        name: 'Phôngsali',
        parent: 'LA',
    },
    'LA-SL': {
        code: 'LA-SL',
        name: 'Salavan',
        parent: 'LA',
    },
    'LA-SV': {
        code: 'LA-SV',
        name: 'Savannakhét',
        parent: 'LA',
    },
    'LA-VI': {
        code: 'LA-VI',
        name: 'Viangchan',
        parent: 'LA',
    },
    'LA-VT': {
        code: 'LA-VT',
        name: 'Viangchan',
        parent: 'LA',
    },
    'LA-XA': {
        code: 'LA-XA',
        name: 'Xaignabouli',
        parent: 'LA',
    },
    'LA-XE': {
        code: 'LA-XE',
        name: 'Xékong',
        parent: 'LA',
    },
    'LA-XI': {
        code: 'LA-XI',
        name: 'Xiangkhouang',
        parent: 'LA',
    },
    'LA-XS': {
        code: 'LA-XS',
        name: 'Xaisômboun',
        parent: 'LA',
    },
    'LB-AK': {
        code: 'LB-AK',
        name: 'Aakkâr',
        parent: 'LB',
    },
    'LB-AS': {
        code: 'LB-AS',
        name: 'Liban-Nord',
        parent: 'LB',
    },
    'LB-BA': {
        code: 'LB-BA',
        name: 'Beyrouth',
        parent: 'LB',
    },
    'LB-BH': {
        code: 'LB-BH',
        name: 'Baalbek-Hermel',
        parent: 'LB',
    },
    'LB-BI': {
        code: 'LB-BI',
        name: 'Béqaa',
        parent: 'LB',
    },
    'LB-JA': {
        code: 'LB-JA',
        name: 'Liban-Sud',
        parent: 'LB',
    },
    'LB-JL': {
        code: 'LB-JL',
        name: 'Mont-Liban',
        parent: 'LB',
    },
    'LB-NA': {
        code: 'LB-NA',
        name: 'Nabatîyé',
        parent: 'LB',
    },
    'LC-01': {
        code: 'LC-01',
        name: 'Anse la Raye',
        parent: 'LC',
    },
    'LC-02': {
        code: 'LC-02',
        name: 'Castries',
        parent: 'LC',
    },
    'LC-03': {
        code: 'LC-03',
        name: 'Choiseul',
        parent: 'LC',
    },
    'LC-05': {
        code: 'LC-05',
        name: 'Dennery',
        parent: 'LC',
    },
    'LC-06': {
        code: 'LC-06',
        name: 'Gros Islet',
        parent: 'LC',
    },
    'LC-07': {
        code: 'LC-07',
        name: 'Laborie',
        parent: 'LC',
    },
    'LC-08': {
        code: 'LC-08',
        name: 'Micoud',
        parent: 'LC',
    },
    'LC-10': {
        code: 'LC-10',
        name: 'Soufrière',
        parent: 'LC',
    },
    'LC-11': {
        code: 'LC-11',
        name: 'Vieux Fort',
        parent: 'LC',
    },
    'LC-12': {
        code: 'LC-12',
        name: 'Canaries',
        parent: 'LC',
    },
    'LI-01': {
        code: 'LI-01',
        name: 'Balzers',
        parent: 'LI',
    },
    'LI-02': {
        code: 'LI-02',
        name: 'Eschen',
        parent: 'LI',
    },
    'LI-03': {
        code: 'LI-03',
        name: 'Gamprin',
        parent: 'LI',
    },
    'LI-04': {
        code: 'LI-04',
        name: 'Mauren',
        parent: 'LI',
    },
    'LI-05': {
        code: 'LI-05',
        name: 'Planken',
        parent: 'LI',
    },
    'LI-06': {
        code: 'LI-06',
        name: 'Ruggell',
        parent: 'LI',
    },
    'LI-07': {
        code: 'LI-07',
        name: 'Schaan',
        parent: 'LI',
    },
    'LI-08': {
        code: 'LI-08',
        name: 'Schellenberg',
        parent: 'LI',
    },
    'LI-09': {
        code: 'LI-09',
        name: 'Triesen',
        parent: 'LI',
    },
    'LI-10': {
        code: 'LI-10',
        name: 'Triesenberg',
        parent: 'LI',
    },
    'LI-11': {
        code: 'LI-11',
        name: 'Vaduz',
        parent: 'LI',
    },
    'LK-1': {
        code: 'LK-1',
        name: 'Western Province',
        parent: 'LK',
    },
    'LK-11': {
        code: 'LK-11',
        name: 'Colombo',
        parent: 'LK-1',
    },
    'LK-12': {
        code: 'LK-12',
        name: 'Gampaha',
        parent: 'LK-1',
    },
    'LK-13': {
        code: 'LK-13',
        name: 'Kalutara',
        parent: 'LK-1',
    },
    'LK-2': {
        code: 'LK-2',
        name: 'Central Province',
        parent: 'LK',
    },
    'LK-21': {
        code: 'LK-21',
        name: 'Kandy',
        parent: 'LK-2',
    },
    'LK-22': {
        code: 'LK-22',
        name: 'Matale',
        parent: 'LK-2',
    },
    'LK-23': {
        code: 'LK-23',
        name: 'Nuwara Eliya',
        parent: 'LK-2',
    },
    'LK-3': {
        code: 'LK-3',
        name: 'Southern Province',
        parent: 'LK',
    },
    'LK-31': {
        code: 'LK-31',
        name: 'Galle',
        parent: 'LK-3',
    },
    'LK-32': {
        code: 'LK-32',
        name: 'Matara',
        parent: 'LK-3',
    },
    'LK-33': {
        code: 'LK-33',
        name: 'Hambantota',
        parent: 'LK-3',
    },
    'LK-4': {
        code: 'LK-4',
        name: 'Northern Province',
        parent: 'LK',
    },
    'LK-41': {
        code: 'LK-41',
        name: 'Jaffna',
        parent: 'LK-4',
    },
    'LK-42': {
        code: 'LK-42',
        name: 'Kilinochchi',
        parent: 'LK-4',
    },
    'LK-43': {
        code: 'LK-43',
        name: 'Mannar',
        parent: 'LK-4',
    },
    'LK-44': {
        code: 'LK-44',
        name: 'Vavuniya',
        parent: 'LK-4',
    },
    'LK-45': {
        code: 'LK-45',
        name: 'Mullaittivu',
        parent: 'LK-4',
    },
    'LK-5': {
        code: 'LK-5',
        name: 'Eastern Province',
        parent: 'LK',
    },
    'LK-51': {
        code: 'LK-51',
        name: 'Batticaloa',
        parent: 'LK-5',
    },
    'LK-52': {
        code: 'LK-52',
        name: 'Ampara',
        parent: 'LK-5',
    },
    'LK-53': {
        code: 'LK-53',
        name: 'Trincomalee',
        parent: 'LK-5',
    },
    'LK-6': {
        code: 'LK-6',
        name: 'North Western Province',
        parent: 'LK',
    },
    'LK-61': {
        code: 'LK-61',
        name: 'Kurunegala',
        parent: 'LK-6',
    },
    'LK-62': {
        code: 'LK-62',
        name: 'Puttalam',
        parent: 'LK-6',
    },
    'LK-7': {
        code: 'LK-7',
        name: 'North Central Province',
        parent: 'LK',
    },
    'LK-71': {
        code: 'LK-71',
        name: 'Anuradhapura',
        parent: 'LK-7',
    },
    'LK-72': {
        code: 'LK-72',
        name: 'Polonnaruwa',
        parent: 'LK-7',
    },
    'LK-8': {
        code: 'LK-8',
        name: 'Uva Province',
        parent: 'LK',
    },
    'LK-81': {
        code: 'LK-81',
        name: 'Badulla',
        parent: 'LK-8',
    },
    'LK-82': {
        code: 'LK-82',
        name: 'Monaragala',
        parent: 'LK-8',
    },
    'LK-9': {
        code: 'LK-9',
        name: 'Sabaragamuwa Province',
        parent: 'LK',
    },
    'LK-91': {
        code: 'LK-91',
        name: 'Ratnapura',
        parent: 'LK-9',
    },
    'LK-92': {
        code: 'LK-92',
        name: 'Kegalla',
        parent: 'LK-9',
    },
    'LR-BG': {
        code: 'LR-BG',
        name: 'Bong',
        parent: 'LR',
    },
    'LR-BM': {
        code: 'LR-BM',
        name: 'Bomi',
        parent: 'LR',
    },
    'LR-CM': {
        code: 'LR-CM',
        name: 'Grand Cape Mount',
        parent: 'LR',
    },
    'LR-GB': {
        code: 'LR-GB',
        name: 'Grand Bassa',
        parent: 'LR',
    },
    'LR-GG': {
        code: 'LR-GG',
        name: 'Grand Gedeh',
        parent: 'LR',
    },
    'LR-GK': {
        code: 'LR-GK',
        name: 'Grand Kru',
        parent: 'LR',
    },
    'LR-GP': {
        code: 'LR-GP',
        name: 'Gbarpolu',
        parent: 'LR',
    },
    'LR-LO': {
        code: 'LR-LO',
        name: 'Lofa',
        parent: 'LR',
    },
    'LR-MG': {
        code: 'LR-MG',
        name: 'Margibi',
        parent: 'LR',
    },
    'LR-MO': {
        code: 'LR-MO',
        name: 'Montserrado',
        parent: 'LR',
    },
    'LR-MY': {
        code: 'LR-MY',
        name: 'Maryland',
        parent: 'LR',
    },
    'LR-NI': {
        code: 'LR-NI',
        name: 'Nimba',
        parent: 'LR',
    },
    'LR-RG': {
        code: 'LR-RG',
        name: 'River Gee',
        parent: 'LR',
    },
    'LR-RI': {
        code: 'LR-RI',
        name: 'River Cess(local variant is Rivercess)',
        parent: 'LR',
    },
    'LR-SI': {
        code: 'LR-SI',
        name: 'Sinoe',
        parent: 'LR',
    },
    'LS-A': {
        code: 'LS-A',
        name: 'Maseru',
        parent: 'LS',
    },
    'LS-B': {
        code: 'LS-B',
        name: 'Botha-Bothe',
        parent: 'LS',
    },
    'LS-C': {
        code: 'LS-C',
        name: 'Leribe',
        parent: 'LS',
    },
    'LS-D': {
        code: 'LS-D',
        name: 'Berea',
        parent: 'LS',
    },
    'LS-E': {
        code: 'LS-E',
        name: 'Mafeteng',
        parent: 'LS',
    },
    'LS-F': {
        code: 'LS-F',
        name: "Mohale's Hoek",
        parent: 'LS',
    },
    'LS-G': {
        code: 'LS-G',
        name: 'Quthing',
        parent: 'LS',
    },
    'LS-H': {
        code: 'LS-H',
        name: "Qacha's Nek",
        parent: 'LS',
    },
    'LS-J': {
        code: 'LS-J',
        name: 'Mokhotlong',
        parent: 'LS',
    },
    'LS-K': {
        code: 'LS-K',
        name: 'Thaba-Tseka',
        parent: 'LS',
    },
    'LT-01': {
        code: 'LT-01',
        name: 'Akmenė',
        parent: 'LT',
    },
    'LT-02': {
        code: 'LT-02',
        name: 'Alytaus miestas',
        parent: 'LT',
    },
    'LT-03': {
        code: 'LT-03',
        name: 'Alytus',
        parent: 'LT',
    },
    'LT-04': {
        code: 'LT-04',
        name: 'Anykščiai',
        parent: 'LT',
    },
    'LT-05': {
        code: 'LT-05',
        name: 'Birštono',
        parent: 'LT',
    },
    'LT-06': {
        code: 'LT-06',
        name: 'Biržai',
        parent: 'LT',
    },
    'LT-07': {
        code: 'LT-07',
        name: 'Druskininkai',
        parent: 'LT',
    },
    'LT-08': {
        code: 'LT-08',
        name: 'Elektrėnai',
        parent: 'LT',
    },
    'LT-09': {
        code: 'LT-09',
        name: 'Ignalina',
        parent: 'LT',
    },
    'LT-10': {
        code: 'LT-10',
        name: 'Jonava',
        parent: 'LT',
    },
    'LT-11': {
        code: 'LT-11',
        name: 'Joniškis',
        parent: 'LT',
    },
    'LT-12': {
        code: 'LT-12',
        name: 'Jurbarkas',
        parent: 'LT',
    },
    'LT-13': {
        code: 'LT-13',
        name: 'Kaišiadorys',
        parent: 'LT',
    },
    'LT-14': {
        code: 'LT-14',
        name: 'Kalvarijos',
        parent: 'LT',
    },
    'LT-15': {
        code: 'LT-15',
        name: 'Kauno miestas',
        parent: 'LT',
    },
    'LT-16': {
        code: 'LT-16',
        name: 'Kaunas',
        parent: 'LT',
    },
    'LT-17': {
        code: 'LT-17',
        name: 'Kazlų Rūdos',
        parent: 'LT',
    },
    'LT-18': {
        code: 'LT-18',
        name: 'Kėdainiai',
        parent: 'LT',
    },
    'LT-19': {
        code: 'LT-19',
        name: 'Kelmė',
        parent: 'LT',
    },
    'LT-20': {
        code: 'LT-20',
        name: 'Klaipėdos miestas',
        parent: 'LT',
    },
    'LT-21': {
        code: 'LT-21',
        name: 'Klaipėda',
        parent: 'LT',
    },
    'LT-22': {
        code: 'LT-22',
        name: 'Kretinga',
        parent: 'LT',
    },
    'LT-23': {
        code: 'LT-23',
        name: 'Kupiškis',
        parent: 'LT',
    },
    'LT-24': {
        code: 'LT-24',
        name: 'Lazdijai',
        parent: 'LT',
    },
    'LT-25': {
        code: 'LT-25',
        name: 'Marijampolė',
        parent: 'LT',
    },
    'LT-26': {
        code: 'LT-26',
        name: 'Mažeikiai',
        parent: 'LT',
    },
    'LT-27': {
        code: 'LT-27',
        name: 'Molėtai',
        parent: 'LT',
    },
    'LT-28': {
        code: 'LT-28',
        name: 'Neringa',
        parent: 'LT',
    },
    'LT-29': {
        code: 'LT-29',
        name: 'Pagėgiai',
        parent: 'LT',
    },
    'LT-30': {
        code: 'LT-30',
        name: 'Pakruojis',
        parent: 'LT',
    },
    'LT-31': {
        code: 'LT-31',
        name: 'Palangos miestas',
        parent: 'LT',
    },
    'LT-32': {
        code: 'LT-32',
        name: 'Panevėžio miestas',
        parent: 'LT',
    },
    'LT-33': {
        code: 'LT-33',
        name: 'Panevėžys',
        parent: 'LT',
    },
    'LT-34': {
        code: 'LT-34',
        name: 'Pasvalys',
        parent: 'LT',
    },
    'LT-35': {
        code: 'LT-35',
        name: 'Plungė',
        parent: 'LT',
    },
    'LT-36': {
        code: 'LT-36',
        name: 'Prienai',
        parent: 'LT',
    },
    'LT-37': {
        code: 'LT-37',
        name: 'Radviliškis',
        parent: 'LT',
    },
    'LT-38': {
        code: 'LT-38',
        name: 'Raseiniai',
        parent: 'LT',
    },
    'LT-39': {
        code: 'LT-39',
        name: 'Rietavo',
        parent: 'LT',
    },
    'LT-40': {
        code: 'LT-40',
        name: 'Rokiškis',
        parent: 'LT',
    },
    'LT-41': {
        code: 'LT-41',
        name: 'Šakiai',
        parent: 'LT',
    },
    'LT-42': {
        code: 'LT-42',
        name: 'Šalčininkai',
        parent: 'LT',
    },
    'LT-43': {
        code: 'LT-43',
        name: 'Šiaulių miestas',
        parent: 'LT',
    },
    'LT-44': {
        code: 'LT-44',
        name: 'Šiauliai',
        parent: 'LT',
    },
    'LT-45': {
        code: 'LT-45',
        name: 'Šilalė',
        parent: 'LT',
    },
    'LT-46': {
        code: 'LT-46',
        name: 'Šilutė',
        parent: 'LT',
    },
    'LT-47': {
        code: 'LT-47',
        name: 'Širvintos',
        parent: 'LT',
    },
    'LT-48': {
        code: 'LT-48',
        name: 'Skuodas',
        parent: 'LT',
    },
    'LT-49': {
        code: 'LT-49',
        name: 'Švenčionys',
        parent: 'LT',
    },
    'LT-50': {
        code: 'LT-50',
        name: 'Tauragė',
        parent: 'LT',
    },
    'LT-51': {
        code: 'LT-51',
        name: 'Telšiai',
        parent: 'LT',
    },
    'LT-52': {
        code: 'LT-52',
        name: 'Trakai',
        parent: 'LT',
    },
    'LT-53': {
        code: 'LT-53',
        name: 'Ukmergė',
        parent: 'LT',
    },
    'LT-54': {
        code: 'LT-54',
        name: 'Utena',
        parent: 'LT',
    },
    'LT-55': {
        code: 'LT-55',
        name: 'Varėna',
        parent: 'LT',
    },
    'LT-56': {
        code: 'LT-56',
        name: 'Vilkaviškis',
        parent: 'LT',
    },
    'LT-57': {
        code: 'LT-57',
        name: 'Vilniaus miestas',
        parent: 'LT',
    },
    'LT-58': {
        code: 'LT-58',
        name: 'Vilnius',
        parent: 'LT',
    },
    'LT-59': {
        code: 'LT-59',
        name: 'Visaginas',
        parent: 'LT',
    },
    'LT-60': {
        code: 'LT-60',
        name: 'Zarasai',
        parent: 'LT',
    },
    'LT-AL': {
        code: 'LT-AL',
        name: 'Alytaus apskritis',
        parent: 'LT',
    },
    'LT-KL': {
        code: 'LT-KL',
        name: 'Klaipėdos apskritis',
        parent: 'LT',
    },
    'LT-KU': {
        code: 'LT-KU',
        name: 'Kauno apskritis',
        parent: 'LT',
    },
    'LT-MR': {
        code: 'LT-MR',
        name: 'Marijampolės apskritis',
        parent: 'LT',
    },
    'LT-PN': {
        code: 'LT-PN',
        name: 'Panevėžio apskritis',
        parent: 'LT',
    },
    'LT-SA': {
        code: 'LT-SA',
        name: 'Šiaulių apskritis',
        parent: 'LT',
    },
    'LT-TA': {
        code: 'LT-TA',
        name: 'Tauragės apskritis',
        parent: 'LT',
    },
    'LT-TE': {
        code: 'LT-TE',
        name: 'Telšių apskritis',
        parent: 'LT',
    },
    'LT-UT': {
        code: 'LT-UT',
        name: 'Utenos apskritis',
        parent: 'LT',
    },
    'LT-VL': {
        code: 'LT-VL',
        name: 'Vilniaus apskritis',
        parent: 'LT',
    },
    'LU-CA': {
        code: 'LU-CA',
        name: 'Capellen',
        parent: 'LU',
    },
    'LU-CL': {
        code: 'LU-CL',
        name: 'Clervaux',
        parent: 'LU',
    },
    'LU-DI': {
        code: 'LU-DI',
        name: 'Diekirch',
        parent: 'LU',
    },
    'LU-EC': {
        code: 'LU-EC',
        name: 'Echternach',
        parent: 'LU',
    },
    'LU-ES': {
        code: 'LU-ES',
        name: 'Esch-sur-Alzette',
        parent: 'LU',
    },
    'LU-GR': {
        code: 'LU-GR',
        name: 'Grevenmacher',
        parent: 'LU',
    },
    'LU-LU': {
        code: 'LU-LU',
        name: 'Luxembourg',
        parent: 'LU',
    },
    'LU-ME': {
        code: 'LU-ME',
        name: 'Mersch',
        parent: 'LU',
    },
    'LU-RD': {
        code: 'LU-RD',
        name: 'Redange',
        parent: 'LU',
    },
    'LU-RM': {
        code: 'LU-RM',
        name: 'Remich',
        parent: 'LU',
    },
    'LU-VD': {
        code: 'LU-VD',
        name: 'Vianden',
        parent: 'LU',
    },
    'LU-WI': {
        code: 'LU-WI',
        name: 'Wiltz',
        parent: 'LU',
    },
    'LV-001': {
        code: 'LV-001',
        name: 'Aglonas novads',
        parent: 'LV',
    },
    'LV-002': {
        code: 'LV-002',
        name: 'Aizkraukles novads',
        parent: 'LV',
    },
    'LV-003': {
        code: 'LV-003',
        name: 'Aizputes novads',
        parent: 'LV',
    },
    'LV-004': {
        code: 'LV-004',
        name: 'Aknīstes novads',
        parent: 'LV',
    },
    'LV-005': {
        code: 'LV-005',
        name: 'Alojas novads',
        parent: 'LV',
    },
    'LV-006': {
        code: 'LV-006',
        name: 'Alsungas novads',
        parent: 'LV',
    },
    'LV-007': {
        code: 'LV-007',
        name: 'Alūksnes novads',
        parent: 'LV',
    },
    'LV-008': {
        code: 'LV-008',
        name: 'Amatas novads',
        parent: 'LV',
    },
    'LV-009': {
        code: 'LV-009',
        name: 'Apes novads',
        parent: 'LV',
    },
    'LV-010': {
        code: 'LV-010',
        name: 'Auces novads',
        parent: 'LV',
    },
    'LV-011': {
        code: 'LV-011',
        name: 'Ādažu novads',
        parent: 'LV',
    },
    'LV-012': {
        code: 'LV-012',
        name: 'Babītes novads',
        parent: 'LV',
    },
    'LV-013': {
        code: 'LV-013',
        name: 'Baldones novads',
        parent: 'LV',
    },
    'LV-014': {
        code: 'LV-014',
        name: 'Baltinavas novads',
        parent: 'LV',
    },
    'LV-015': {
        code: 'LV-015',
        name: 'Balvu novads',
        parent: 'LV',
    },
    'LV-016': {
        code: 'LV-016',
        name: 'Bauskas novads',
        parent: 'LV',
    },
    'LV-017': {
        code: 'LV-017',
        name: 'Beverīnas novads',
        parent: 'LV',
    },
    'LV-018': {
        code: 'LV-018',
        name: 'Brocēnu novads',
        parent: 'LV',
    },
    'LV-019': {
        code: 'LV-019',
        name: 'Burtnieku novads',
        parent: 'LV',
    },
    'LV-020': {
        code: 'LV-020',
        name: 'Carnikavas novads',
        parent: 'LV',
    },
    'LV-021': {
        code: 'LV-021',
        name: 'Cesvaines novads',
        parent: 'LV',
    },
    'LV-022': {
        code: 'LV-022',
        name: 'Cēsu novads',
        parent: 'LV',
    },
    'LV-023': {
        code: 'LV-023',
        name: 'Ciblas novads',
        parent: 'LV',
    },
    'LV-024': {
        code: 'LV-024',
        name: 'Dagdas novads',
        parent: 'LV',
    },
    'LV-025': {
        code: 'LV-025',
        name: 'Daugavpils novads',
        parent: 'LV',
    },
    'LV-026': {
        code: 'LV-026',
        name: 'Dobeles novads',
        parent: 'LV',
    },
    'LV-027': {
        code: 'LV-027',
        name: 'Dundagas novads',
        parent: 'LV',
    },
    'LV-028': {
        code: 'LV-028',
        name: 'Durbes novads',
        parent: 'LV',
    },
    'LV-029': {
        code: 'LV-029',
        name: 'Engures novads',
        parent: 'LV',
    },
    'LV-030': {
        code: 'LV-030',
        name: 'Ērgļu novads',
        parent: 'LV',
    },
    'LV-031': {
        code: 'LV-031',
        name: 'Garkalnes novads',
        parent: 'LV',
    },
    'LV-032': {
        code: 'LV-032',
        name: 'Grobiņas novads',
        parent: 'LV',
    },
    'LV-033': {
        code: 'LV-033',
        name: 'Gulbenes novads',
        parent: 'LV',
    },
    'LV-034': {
        code: 'LV-034',
        name: 'Iecavas novads',
        parent: 'LV',
    },
    'LV-035': {
        code: 'LV-035',
        name: 'Ikšķiles novads',
        parent: 'LV',
    },
    'LV-036': {
        code: 'LV-036',
        name: 'Ilūkstes novads',
        parent: 'LV',
    },
    'LV-037': {
        code: 'LV-037',
        name: 'Inčukalna novads',
        parent: 'LV',
    },
    'LV-038': {
        code: 'LV-038',
        name: 'Jaunjelgavas novads',
        parent: 'LV',
    },
    'LV-039': {
        code: 'LV-039',
        name: 'Jaunpiebalgas novads',
        parent: 'LV',
    },
    'LV-040': {
        code: 'LV-040',
        name: 'Jaunpils novads',
        parent: 'LV',
    },
    'LV-041': {
        code: 'LV-041',
        name: 'Jelgavas novads',
        parent: 'LV',
    },
    'LV-042': {
        code: 'LV-042',
        name: 'Jēkabpils novads',
        parent: 'LV',
    },
    'LV-043': {
        code: 'LV-043',
        name: 'Kandavas novads',
        parent: 'LV',
    },
    'LV-044': {
        code: 'LV-044',
        name: 'Kārsavas novads',
        parent: 'LV',
    },
    'LV-045': {
        code: 'LV-045',
        name: 'Kocēnu novads',
        parent: 'LV',
    },
    'LV-046': {
        code: 'LV-046',
        name: 'Kokneses novads',
        parent: 'LV',
    },
    'LV-047': {
        code: 'LV-047',
        name: 'Krāslavas novads',
        parent: 'LV',
    },
    'LV-048': {
        code: 'LV-048',
        name: 'Krimuldas novads',
        parent: 'LV',
    },
    'LV-049': {
        code: 'LV-049',
        name: 'Krustpils novads',
        parent: 'LV',
    },
    'LV-050': {
        code: 'LV-050',
        name: 'Kuldīgas novads',
        parent: 'LV',
    },
    'LV-051': {
        code: 'LV-051',
        name: 'Ķeguma novads',
        parent: 'LV',
    },
    'LV-052': {
        code: 'LV-052',
        name: 'Ķekavas novads',
        parent: 'LV',
    },
    'LV-053': {
        code: 'LV-053',
        name: 'Lielvārdes novads',
        parent: 'LV',
    },
    'LV-054': {
        code: 'LV-054',
        name: 'Limbažu novads',
        parent: 'LV',
    },
    'LV-055': {
        code: 'LV-055',
        name: 'Līgatnes novads',
        parent: 'LV',
    },
    'LV-056': {
        code: 'LV-056',
        name: 'Līvānu novads',
        parent: 'LV',
    },
    'LV-057': {
        code: 'LV-057',
        name: 'Lubānas novads',
        parent: 'LV',
    },
    'LV-058': {
        code: 'LV-058',
        name: 'Ludzas novads',
        parent: 'LV',
    },
    'LV-059': {
        code: 'LV-059',
        name: 'Madonas novads',
        parent: 'LV',
    },
    'LV-060': {
        code: 'LV-060',
        name: 'Mazsalacas novads',
        parent: 'LV',
    },
    'LV-061': {
        code: 'LV-061',
        name: 'Mālpils novads',
        parent: 'LV',
    },
    'LV-062': {
        code: 'LV-062',
        name: 'Mārupes novads',
        parent: 'LV',
    },
    'LV-063': {
        code: 'LV-063',
        name: 'Mērsraga novads',
        parent: 'LV',
    },
    'LV-064': {
        code: 'LV-064',
        name: 'Naukšēnu novads',
        parent: 'LV',
    },
    'LV-065': {
        code: 'LV-065',
        name: 'Neretas novads',
        parent: 'LV',
    },
    'LV-066': {
        code: 'LV-066',
        name: 'Nīcas novads',
        parent: 'LV',
    },
    'LV-067': {
        code: 'LV-067',
        name: 'Ogres novads',
        parent: 'LV',
    },
    'LV-068': {
        code: 'LV-068',
        name: 'Olaines novads',
        parent: 'LV',
    },
    'LV-069': {
        code: 'LV-069',
        name: 'Ozolnieku novads',
        parent: 'LV',
    },
    'LV-070': {
        code: 'LV-070',
        name: 'Pārgaujas novads',
        parent: 'LV',
    },
    'LV-071': {
        code: 'LV-071',
        name: 'Pāvilostas novads',
        parent: 'LV',
    },
    'LV-072': {
        code: 'LV-072',
        name: 'Pļaviņu novads',
        parent: 'LV',
    },
    'LV-073': {
        code: 'LV-073',
        name: 'Preiļu novads',
        parent: 'LV',
    },
    'LV-074': {
        code: 'LV-074',
        name: 'Priekules novads',
        parent: 'LV',
    },
    'LV-075': {
        code: 'LV-075',
        name: 'Priekuļu novads',
        parent: 'LV',
    },
    'LV-076': {
        code: 'LV-076',
        name: 'Raunas novads',
        parent: 'LV',
    },
    'LV-077': {
        code: 'LV-077',
        name: 'Rēzeknes novads',
        parent: 'LV',
    },
    'LV-078': {
        code: 'LV-078',
        name: 'Riebiņu novads',
        parent: 'LV',
    },
    'LV-079': {
        code: 'LV-079',
        name: 'Rojas novads',
        parent: 'LV',
    },
    'LV-080': {
        code: 'LV-080',
        name: 'Ropažu novads',
        parent: 'LV',
    },
    'LV-081': {
        code: 'LV-081',
        name: 'Rucavas novads',
        parent: 'LV',
    },
    'LV-082': {
        code: 'LV-082',
        name: 'Rugāju novads',
        parent: 'LV',
    },
    'LV-083': {
        code: 'LV-083',
        name: 'Rundāles novads',
        parent: 'LV',
    },
    'LV-084': {
        code: 'LV-084',
        name: 'Rūjienas novads',
        parent: 'LV',
    },
    'LV-085': {
        code: 'LV-085',
        name: 'Salas novads',
        parent: 'LV',
    },
    'LV-086': {
        code: 'LV-086',
        name: 'Salacgrīvas novads',
        parent: 'LV',
    },
    'LV-087': {
        code: 'LV-087',
        name: 'Salaspils novads',
        parent: 'LV',
    },
    'LV-088': {
        code: 'LV-088',
        name: 'Saldus novads',
        parent: 'LV',
    },
    'LV-089': {
        code: 'LV-089',
        name: 'Saulkrastu novads',
        parent: 'LV',
    },
    'LV-090': {
        code: 'LV-090',
        name: 'Sējas novads',
        parent: 'LV',
    },
    'LV-091': {
        code: 'LV-091',
        name: 'Siguldas novads',
        parent: 'LV',
    },
    'LV-092': {
        code: 'LV-092',
        name: 'Skrīveru novads',
        parent: 'LV',
    },
    'LV-093': {
        code: 'LV-093',
        name: 'Skrundas novads',
        parent: 'LV',
    },
    'LV-094': {
        code: 'LV-094',
        name: 'Smiltenes novads',
        parent: 'LV',
    },
    'LV-095': {
        code: 'LV-095',
        name: 'Stopiņu novads',
        parent: 'LV',
    },
    'LV-096': {
        code: 'LV-096',
        name: 'Strenču novads',
        parent: 'LV',
    },
    'LV-097': {
        code: 'LV-097',
        name: 'Talsu novads',
        parent: 'LV',
    },
    'LV-098': {
        code: 'LV-098',
        name: 'Tērvetes novads',
        parent: 'LV',
    },
    'LV-099': {
        code: 'LV-099',
        name: 'Tukuma novads',
        parent: 'LV',
    },
    'LV-100': {
        code: 'LV-100',
        name: 'Vaiņodes novads',
        parent: 'LV',
    },
    'LV-101': {
        code: 'LV-101',
        name: 'Valkas novads',
        parent: 'LV',
    },
    'LV-102': {
        code: 'LV-102',
        name: 'Varakļānu novads',
        parent: 'LV',
    },
    'LV-103': {
        code: 'LV-103',
        name: 'Vārkavas novads',
        parent: 'LV',
    },
    'LV-104': {
        code: 'LV-104',
        name: 'Vecpiebalgas novads',
        parent: 'LV',
    },
    'LV-105': {
        code: 'LV-105',
        name: 'Vecumnieku novads',
        parent: 'LV',
    },
    'LV-106': {
        code: 'LV-106',
        name: 'Ventspils novads',
        parent: 'LV',
    },
    'LV-107': {
        code: 'LV-107',
        name: 'Viesītes novads',
        parent: 'LV',
    },
    'LV-108': {
        code: 'LV-108',
        name: 'Viļakas novads',
        parent: 'LV',
    },
    'LV-109': {
        code: 'LV-109',
        name: 'Viļānu novads',
        parent: 'LV',
    },
    'LV-110': {
        code: 'LV-110',
        name: 'Zilupes novads',
        parent: 'LV',
    },
    'LV-DGV': {
        code: 'LV-DGV',
        name: 'Daugavpils',
        parent: 'LV',
    },
    'LV-JEL': {
        code: 'LV-JEL',
        name: 'Jelgava',
        parent: 'LV',
    },
    'LV-JKB': {
        code: 'LV-JKB',
        name: 'Jēkabpils',
        parent: 'LV',
    },
    'LV-JUR': {
        code: 'LV-JUR',
        name: 'Jūrmala',
        parent: 'LV',
    },
    'LV-LPX': {
        code: 'LV-LPX',
        name: 'Liepāja',
        parent: 'LV',
    },
    'LV-REZ': {
        code: 'LV-REZ',
        name: 'Rēzekne',
        parent: 'LV',
    },
    'LV-RIX': {
        code: 'LV-RIX',
        name: 'Rīga',
        parent: 'LV',
    },
    'LV-VEN': {
        code: 'LV-VEN',
        name: 'Ventspils',
        parent: 'LV',
    },
    'LV-VMR': {
        code: 'LV-VMR',
        name: 'Valmiera',
        parent: 'LV',
    },
    'LY-BA': {
        code: 'LY-BA',
        name: 'Banghāzī',
        parent: 'LY',
    },
    'LY-BU': {
        code: 'LY-BU',
        name: 'Al Buţnān',
        parent: 'LY',
    },
    'LY-DR': {
        code: 'LY-DR',
        name: 'Darnah',
        parent: 'LY',
    },
    'LY-GT': {
        code: 'LY-GT',
        name: 'Ghāt',
        parent: 'LY',
    },
    'LY-JA': {
        code: 'LY-JA',
        name: 'Al Jabal al Akhḑar',
        parent: 'LY',
    },
    'LY-JG': {
        code: 'LY-JG',
        name: 'Al Jabal al Gharbī',
        parent: 'LY',
    },
    'LY-JI': {
        code: 'LY-JI',
        name: 'Al Jafārah',
        parent: 'LY',
    },
    'LY-JU': {
        code: 'LY-JU',
        name: 'Al Jufrah',
        parent: 'LY',
    },
    'LY-KF': {
        code: 'LY-KF',
        name: 'Al Kufrah',
        parent: 'LY',
    },
    'LY-MB': {
        code: 'LY-MB',
        name: 'Al Marqab',
        parent: 'LY',
    },
    'LY-MI': {
        code: 'LY-MI',
        name: 'Mişrātah',
        parent: 'LY',
    },
    'LY-MJ': {
        code: 'LY-MJ',
        name: 'Al Marj',
        parent: 'LY',
    },
    'LY-MQ': {
        code: 'LY-MQ',
        name: 'Murzuq',
        parent: 'LY',
    },
    'LY-NL': {
        code: 'LY-NL',
        name: 'Nālūt',
        parent: 'LY',
    },
    'LY-NQ': {
        code: 'LY-NQ',
        name: 'An Nuqāţ al Khams',
        parent: 'LY',
    },
    'LY-SB': {
        code: 'LY-SB',
        name: 'Sabhā',
        parent: 'LY',
    },
    'LY-SR': {
        code: 'LY-SR',
        name: 'Surt',
        parent: 'LY',
    },
    'LY-TB': {
        code: 'LY-TB',
        name: 'Ţarābulus',
        parent: 'LY',
    },
    'LY-WA': {
        code: 'LY-WA',
        name: 'Al Wāḩāt',
        parent: 'LY',
    },
    'LY-WD': {
        code: 'LY-WD',
        name: 'Wādī al Ḩayāt',
        parent: 'LY',
    },
    'LY-WS': {
        code: 'LY-WS',
        name: 'Wādī ash Shāţi’',
        parent: 'LY',
    },
    'LY-ZA': {
        code: 'LY-ZA',
        name: 'Az Zāwiyah',
        parent: 'LY',
    },
    'MA-01': {
        code: 'MA-01',
        name: 'Tanger-Tétouan-Al Hoceïma',
        parent: 'MA',
    },
    'MA-02': {
        code: 'MA-02',
        name: "L'Oriental",
        parent: 'MA',
    },
    'MA-03': {
        code: 'MA-03',
        name: 'Fès-Meknès',
        parent: 'MA',
    },
    'MA-04': {
        code: 'MA-04',
        name: 'Rabat-Salé-Kénitra',
        parent: 'MA',
    },
    'MA-05': {
        code: 'MA-05',
        name: 'Béni Mellal-Khénifra',
        parent: 'MA',
    },
    'MA-06': {
        code: 'MA-06',
        name: 'Casablanca-Settat',
        parent: 'MA',
    },
    'MA-07': {
        code: 'MA-07',
        name: 'Marrakech-Safi',
        parent: 'MA',
    },
    'MA-08': {
        code: 'MA-08',
        name: 'Drâa-Tafilalet',
        parent: 'MA',
    },
    'MA-09': {
        code: 'MA-09',
        name: 'Souss-Massa',
        parent: 'MA',
    },
    'MA-10': {
        code: 'MA-10',
        name: 'Guelmim-Oued Noun (EH-partial)',
        parent: 'MA',
    },
    'MA-11': {
        code: 'MA-11',
        name: 'Laâyoune-Sakia El Hamra (EH-partial)',
        parent: 'MA',
    },
    'MA-12': {
        code: 'MA-12',
        name: 'Dakhla-Oued Ed-Dahab (EH)',
        parent: 'MA',
    },
    'MA-AGD': {
        code: 'MA-AGD',
        name: 'Agadir-Ida-Ou-Tanane',
        parent: 'MA-09',
    },
    'MA-AOU': {
        code: 'MA-AOU',
        name: 'Aousserd (EH)',
        parent: 'MA-12',
    },
    'MA-ASZ': {
        code: 'MA-ASZ',
        name: 'Assa-Zag (EH-partial)',
        parent: 'MA-10',
    },
    'MA-AZI': {
        code: 'MA-AZI',
        name: 'Azilal',
        parent: 'MA-05',
    },
    'MA-BEM': {
        code: 'MA-BEM',
        name: 'Béni Mellal',
        parent: 'MA-05',
    },
    'MA-BER': {
        code: 'MA-BER',
        name: 'Berkane',
        parent: 'MA-02',
    },
    'MA-BES': {
        code: 'MA-BES',
        name: 'Benslimane',
        parent: 'MA-06',
    },
    'MA-BOD': {
        code: 'MA-BOD',
        name: 'Boujdour (EH)',
        parent: 'MA-11',
    },
    'MA-BOM': {
        code: 'MA-BOM',
        name: 'Boulemane',
        parent: 'MA-03',
    },
    'MA-BRR': {
        code: 'MA-BRR',
        name: 'Berrechid',
        parent: 'MA-06',
    },
    'MA-CAS': {
        code: 'MA-CAS',
        name: 'Casablanca',
        parent: 'MA-06',
    },
    'MA-CHE': {
        code: 'MA-CHE',
        name: 'Chefchaouen',
        parent: 'MA-01',
    },
    'MA-CHI': {
        code: 'MA-CHI',
        name: 'Chichaoua',
        parent: 'MA-07',
    },
    'MA-CHT': {
        code: 'MA-CHT',
        name: 'Chtouka-Ait Baha',
        parent: 'MA-06',
    },
    'MA-DRI': {
        code: 'MA-DRI',
        name: 'Driouch',
        parent: 'MA-02',
    },
    'MA-ERR': {
        code: 'MA-ERR',
        name: 'Errachidia',
        parent: 'MA-08',
    },
    'MA-ESI': {
        code: 'MA-ESI',
        name: 'Essaouira',
        parent: 'MA-07',
    },
    'MA-ESM': {
        code: 'MA-ESM',
        name: 'Es-Semara (EH-partial)',
        parent: 'MA-11',
    },
    'MA-FAH': {
        code: 'MA-FAH',
        name: 'Fahs-Anjra',
        parent: 'MA-01',
    },
    'MA-FES': {
        code: 'MA-FES',
        name: 'Fès',
        parent: 'MA-03',
    },
    'MA-FIG': {
        code: 'MA-FIG',
        name: 'Figuig',
        parent: 'MA-02',
    },
    'MA-FQH': {
        code: 'MA-FQH',
        name: 'Fquih Ben Salah',
        parent: 'MA-05',
    },
    'MA-GUE': {
        code: 'MA-GUE',
        name: 'Guelmim',
        parent: 'MA-10',
    },
    'MA-GUF': {
        code: 'MA-GUF',
        name: 'Guercif',
        parent: 'MA-02',
    },
    'MA-HAJ': {
        code: 'MA-HAJ',
        name: 'El Hajeb',
        parent: 'MA-03',
    },
    'MA-HAO': {
        code: 'MA-HAO',
        name: 'Al Haouz',
        parent: 'MA-07',
    },
    'MA-HOC': {
        code: 'MA-HOC',
        name: 'Al Hoceïma',
        parent: 'MA-01',
    },
    'MA-IFR': {
        code: 'MA-IFR',
        name: 'Ifrane',
        parent: 'MA-03',
    },
    'MA-INE': {
        code: 'MA-INE',
        name: 'Inezgane-Ait Melloul',
        parent: 'MA-09',
    },
    'MA-JDI': {
        code: 'MA-JDI',
        name: 'El Jadida',
        parent: 'MA-06',
    },
    'MA-JRA': {
        code: 'MA-JRA',
        name: 'Jerada',
        parent: 'MA-02',
    },
    'MA-KEN': {
        code: 'MA-KEN',
        name: 'Kénitra',
        parent: 'MA-04',
    },
    'MA-KES': {
        code: 'MA-KES',
        name: 'El Kelâa des Sraghna',
        parent: 'MA-07',
    },
    'MA-KHE': {
        code: 'MA-KHE',
        name: 'Khémisset',
        parent: 'MA-04',
    },
    'MA-KHN': {
        code: 'MA-KHN',
        name: 'Khénifra',
        parent: 'MA-05',
    },
    'MA-KHO': {
        code: 'MA-KHO',
        name: 'Khouribga',
        parent: 'MA-05',
    },
    'MA-LAA': {
        code: 'MA-LAA',
        name: 'Laâyoune (EH)',
        parent: 'MA-11',
    },
    'MA-LAR': {
        code: 'MA-LAR',
        name: 'Larache',
        parent: 'MA-01',
    },
    'MA-MAR': {
        code: 'MA-MAR',
        name: 'Marrakech',
        parent: 'MA-07',
    },
    'MA-MDF': {
        code: 'MA-MDF',
        name: 'M’diq-Fnideq',
        parent: 'MA-01',
    },
    'MA-MED': {
        code: 'MA-MED',
        name: 'Médiouna',
        parent: 'MA-06',
    },
    'MA-MEK': {
        code: 'MA-MEK',
        name: 'Meknès',
        parent: 'MA-03',
    },
    'MA-MID': {
        code: 'MA-MID',
        name: 'Midelt',
        parent: 'MA-08',
    },
    'MA-MOH': {
        code: 'MA-MOH',
        name: 'Mohammadia',
        parent: 'MA-06',
    },
    'MA-MOU': {
        code: 'MA-MOU',
        name: 'Moulay Yacoub',
        parent: 'MA-03',
    },
    'MA-NAD': {
        code: 'MA-NAD',
        name: 'Nador',
        parent: 'MA-02',
    },
    'MA-NOU': {
        code: 'MA-NOU',
        name: 'Nouaceur',
        parent: 'MA-04',
    },
    'MA-OUA': {
        code: 'MA-OUA',
        name: 'Ouarzazate',
        parent: 'MA-08',
    },
    'MA-OUD': {
        code: 'MA-OUD',
        name: 'Oued Ed-Dahab (EH)',
        parent: 'MA-12',
    },
    'MA-OUJ': {
        code: 'MA-OUJ',
        name: 'Oujda-Angad',
        parent: 'MA-02',
    },
    'MA-OUZ': {
        code: 'MA-OUZ',
        name: 'Ouezzane',
        parent: 'MA-01',
    },
    'MA-RAB': {
        code: 'MA-RAB',
        name: 'Rabat',
        parent: 'MA-04',
    },
    'MA-REH': {
        code: 'MA-REH',
        name: 'Rehamna',
        parent: 'MA-07',
    },
    'MA-SAF': {
        code: 'MA-SAF',
        name: 'Safi',
        parent: 'MA-07',
    },
    'MA-SAL': {
        code: 'MA-SAL',
        name: 'Salé',
        parent: 'MA-04',
    },
    'MA-SEF': {
        code: 'MA-SEF',
        name: 'Sefrou',
        parent: 'MA-03',
    },
    'MA-SET': {
        code: 'MA-SET',
        name: 'Settat',
        parent: 'MA-06',
    },
    'MA-SIB': {
        code: 'MA-SIB',
        name: 'Sidi Bennour',
        parent: 'MA-06',
    },
    'MA-SIF': {
        code: 'MA-SIF',
        name: 'Sidi Ifni',
        parent: 'MA-10',
    },
    'MA-SIK': {
        code: 'MA-SIK',
        name: 'Sidi Kacem',
        parent: 'MA-04',
    },
    'MA-SIL': {
        code: 'MA-SIL',
        name: 'Sidi Slimane',
        parent: 'MA-04',
    },
    'MA-SKH': {
        code: 'MA-SKH',
        name: 'Skhirate-Témara',
        parent: 'MA-04',
    },
    'MA-TAF': {
        code: 'MA-TAF',
        name: 'Tarfaya (EH-partial)',
        parent: 'MA-11',
    },
    'MA-TAI': {
        code: 'MA-TAI',
        name: 'Taourirt',
        parent: 'MA-02',
    },
    'MA-TAO': {
        code: 'MA-TAO',
        name: 'Taounate',
        parent: 'MA-03',
    },
    'MA-TAR': {
        code: 'MA-TAR',
        name: 'Taroudannt',
        parent: 'MA-09',
    },
    'MA-TAT': {
        code: 'MA-TAT',
        name: 'Tata',
        parent: 'MA-09',
    },
    'MA-TAZ': {
        code: 'MA-TAZ',
        name: 'Taza',
        parent: 'MA-03',
    },
    'MA-TET': {
        code: 'MA-TET',
        name: 'Tétouan',
        parent: 'MA-01',
    },
    'MA-TIN': {
        code: 'MA-TIN',
        name: 'Tinghir',
        parent: 'MA-08',
    },
    'MA-TIZ': {
        code: 'MA-TIZ',
        name: 'Tiznit',
        parent: 'MA-09',
    },
    'MA-TNG': {
        code: 'MA-TNG',
        name: 'Tanger-Assilah',
        parent: 'MA-01',
    },
    'MA-TNT': {
        code: 'MA-TNT',
        name: 'Tan-Tan (EH-partial)',
        parent: 'MA-10',
    },
    'MA-YUS': {
        code: 'MA-YUS',
        name: 'Youssoufia',
        parent: 'MA-07',
    },
    'MA-ZAG': {
        code: 'MA-ZAG',
        name: 'Zagora',
        parent: 'MA-08',
    },
    'MC-CL': {
        code: 'MC-CL',
        name: 'La Colle',
        parent: 'MC',
    },
    'MC-CO': {
        code: 'MC-CO',
        name: 'La Condamine',
        parent: 'MC',
    },
    'MC-FO': {
        code: 'MC-FO',
        name: 'Fontvieille',
        parent: 'MC',
    },
    'MC-GA': {
        code: 'MC-GA',
        name: 'La Gare',
        parent: 'MC',
    },
    'MC-JE': {
        code: 'MC-JE',
        name: 'Jardin Exotique',
        parent: 'MC',
    },
    'MC-LA': {
        code: 'MC-LA',
        name: 'Larvotto',
        parent: 'MC',
    },
    'MC-MA': {
        code: 'MC-MA',
        name: 'Malbousquet',
        parent: 'MC',
    },
    'MC-MC': {
        code: 'MC-MC',
        name: 'Monte-Carlo',
        parent: 'MC',
    },
    'MC-MG': {
        code: 'MC-MG',
        name: 'Moneghetti',
        parent: 'MC',
    },
    'MC-MO': {
        code: 'MC-MO',
        name: 'Monaco-Ville',
        parent: 'MC',
    },
    'MC-MU': {
        code: 'MC-MU',
        name: 'Moulins',
        parent: 'MC',
    },
    'MC-PH': {
        code: 'MC-PH',
        name: 'Port-Hercule',
        parent: 'MC',
    },
    'MC-SD': {
        code: 'MC-SD',
        name: 'Sainte-Dévote',
        parent: 'MC',
    },
    'MC-SO': {
        code: 'MC-SO',
        name: 'La Source',
        parent: 'MC',
    },
    'MC-SP': {
        code: 'MC-SP',
        name: 'Spélugues',
        parent: 'MC',
    },
    'MC-SR': {
        code: 'MC-SR',
        name: 'Saint-Roman',
        parent: 'MC',
    },
    'MC-VR': {
        code: 'MC-VR',
        name: 'Vallon de la Rousse',
        parent: 'MC',
    },
    'MD-AN': {
        code: 'MD-AN',
        name: 'Anenii Noi',
        parent: 'MD',
    },
    'MD-BA': {
        code: 'MD-BA',
        name: 'Bălți',
        parent: 'MD',
    },
    'MD-BD': {
        code: 'MD-BD',
        name: 'Bender',
        parent: 'MD',
    },
    'MD-BR': {
        code: 'MD-BR',
        name: 'Briceni',
        parent: 'MD',
    },
    'MD-BS': {
        code: 'MD-BS',
        name: 'Basarabeasca',
        parent: 'MD',
    },
    'MD-CA': {
        code: 'MD-CA',
        name: 'Cahul',
        parent: 'MD',
    },
    'MD-CL': {
        code: 'MD-CL',
        name: 'Călărași',
        parent: 'MD',
    },
    'MD-CM': {
        code: 'MD-CM',
        name: 'Cimișlia',
        parent: 'MD',
    },
    'MD-CR': {
        code: 'MD-CR',
        name: 'Criuleni',
        parent: 'MD',
    },
    'MD-CS': {
        code: 'MD-CS',
        name: 'Căușeni',
        parent: 'MD',
    },
    'MD-CT': {
        code: 'MD-CT',
        name: 'Cantemir',
        parent: 'MD',
    },
    'MD-CU': {
        code: 'MD-CU',
        name: 'Chișinău',
        parent: 'MD',
    },
    'MD-DO': {
        code: 'MD-DO',
        name: 'Dondușeni',
        parent: 'MD',
    },
    'MD-DR': {
        code: 'MD-DR',
        name: 'Drochia',
        parent: 'MD',
    },
    'MD-DU': {
        code: 'MD-DU',
        name: 'Dubăsari',
        parent: 'MD',
    },
    'MD-ED': {
        code: 'MD-ED',
        name: 'Edineț',
        parent: 'MD',
    },
    'MD-FA': {
        code: 'MD-FA',
        name: 'Fălești',
        parent: 'MD',
    },
    'MD-FL': {
        code: 'MD-FL',
        name: 'Florești',
        parent: 'MD',
    },
    'MD-GA': {
        code: 'MD-GA',
        name: 'Găgăuzia, Unitatea teritorială autonomă (UTAG)',
        parent: 'MD',
    },
    'MD-GL': {
        code: 'MD-GL',
        name: 'Glodeni',
        parent: 'MD',
    },
    'MD-HI': {
        code: 'MD-HI',
        name: 'Hîncești',
        parent: 'MD',
    },
    'MD-IA': {
        code: 'MD-IA',
        name: 'Ialoveni',
        parent: 'MD',
    },
    'MD-LE': {
        code: 'MD-LE',
        name: 'Leova',
        parent: 'MD',
    },
    'MD-NI': {
        code: 'MD-NI',
        name: 'Nisporeni',
        parent: 'MD',
    },
    'MD-OC': {
        code: 'MD-OC',
        name: 'Ocnița',
        parent: 'MD',
    },
    'MD-OR': {
        code: 'MD-OR',
        name: 'Orhei',
        parent: 'MD',
    },
    'MD-RE': {
        code: 'MD-RE',
        name: 'Rezina',
        parent: 'MD',
    },
    'MD-RI': {
        code: 'MD-RI',
        name: 'Rîșcani',
        parent: 'MD',
    },
    'MD-SD': {
        code: 'MD-SD',
        name: 'Șoldănești',
        parent: 'MD',
    },
    'MD-SI': {
        code: 'MD-SI',
        name: 'Sîngerei',
        parent: 'MD',
    },
    'MD-SN': {
        code: 'MD-SN',
        name: 'Stînga Nistrului, unitatea teritorială din',
        parent: 'MD',
    },
    'MD-SO': {
        code: 'MD-SO',
        name: 'Soroca',
        parent: 'MD',
    },
    'MD-ST': {
        code: 'MD-ST',
        name: 'Strășeni',
        parent: 'MD',
    },
    'MD-SV': {
        code: 'MD-SV',
        name: 'Ștefan Vodă',
        parent: 'MD',
    },
    'MD-TA': {
        code: 'MD-TA',
        name: 'Taraclia',
        parent: 'MD',
    },
    'MD-TE': {
        code: 'MD-TE',
        name: 'Telenești',
        parent: 'MD',
    },
    'MD-UN': {
        code: 'MD-UN',
        name: 'Ungheni',
        parent: 'MD',
    },
    'ME-01': {
        code: 'ME-01',
        name: 'Andrijevica',
        parent: 'ME',
    },
    'ME-02': {
        code: 'ME-02',
        name: 'Bar',
        parent: 'ME',
    },
    'ME-03': {
        code: 'ME-03',
        name: 'Berane',
        parent: 'ME',
    },
    'ME-04': {
        code: 'ME-04',
        name: 'Bijelo Polje',
        parent: 'ME',
    },
    'ME-05': {
        code: 'ME-05',
        name: 'Budva',
        parent: 'ME',
    },
    'ME-06': {
        code: 'ME-06',
        name: 'Cetinje',
        parent: 'ME',
    },
    'ME-07': {
        code: 'ME-07',
        name: 'Danilovgrad',
        parent: 'ME',
    },
    'ME-08': {
        code: 'ME-08',
        name: 'Herceg-Novi',
        parent: 'ME',
    },
    'ME-09': {
        code: 'ME-09',
        name: 'Kolašin',
        parent: 'ME',
    },
    'ME-10': {
        code: 'ME-10',
        name: 'Kotor',
        parent: 'ME',
    },
    'ME-11': {
        code: 'ME-11',
        name: 'Mojkovac',
        parent: 'ME',
    },
    'ME-12': {
        code: 'ME-12',
        name: 'Nikšić',
        parent: 'ME',
    },
    'ME-13': {
        code: 'ME-13',
        name: 'Plav',
        parent: 'ME',
    },
    'ME-14': {
        code: 'ME-14',
        name: 'Pljevlja',
        parent: 'ME',
    },
    'ME-15': {
        code: 'ME-15',
        name: 'Plužine',
        parent: 'ME',
    },
    'ME-16': {
        code: 'ME-16',
        name: 'Podgorica',
        parent: 'ME',
    },
    'ME-17': {
        code: 'ME-17',
        name: 'Rožaje',
        parent: 'ME',
    },
    'ME-18': {
        code: 'ME-18',
        name: 'Šavnik',
        parent: 'ME',
    },
    'ME-19': {
        code: 'ME-19',
        name: 'Tivat',
        parent: 'ME',
    },
    'ME-20': {
        code: 'ME-20',
        name: 'Ulcinj',
        parent: 'ME',
    },
    'ME-21': {
        code: 'ME-21',
        name: 'Žabljak',
        parent: 'ME',
    },
    'ME-22': {
        code: 'ME-22',
        name: 'Gusinje',
        parent: 'ME',
    },
    'ME-23': {
        code: 'ME-23',
        name: 'Petnjica',
        parent: 'ME',
    },
    'ME-24': {
        code: 'ME-24',
        name: 'Tuzi',
        parent: 'ME',
    },
    'MG-A': {
        code: 'MG-A',
        name: 'Toamasina',
        parent: 'MG',
    },
    'MG-D': {
        code: 'MG-D',
        name: 'Antsiranana',
        parent: 'MG',
    },
    'MG-F': {
        code: 'MG-F',
        name: 'Fianarantsoa',
        parent: 'MG',
    },
    'MG-M': {
        code: 'MG-M',
        name: 'Mahajanga',
        parent: 'MG',
    },
    'MG-T': {
        code: 'MG-T',
        name: 'Antananarivo',
        parent: 'MG',
    },
    'MG-U': {
        code: 'MG-U',
        name: 'Toliara',
        parent: 'MG',
    },
    'MH-ALK': {
        code: 'MH-ALK',
        name: 'Ailuk',
        parent: 'MH-T',
    },
    'MH-ALL': {
        code: 'MH-ALL',
        name: 'Ailinglaplap',
        parent: 'MH-L',
    },
    'MH-ARN': {
        code: 'MH-ARN',
        name: 'Arno',
        parent: 'MH-T',
    },
    'MH-AUR': {
        code: 'MH-AUR',
        name: 'Aur',
        parent: 'MH-T',
    },
    'MH-EBO': {
        code: 'MH-EBO',
        name: 'Ebon',
        parent: 'MH-L',
    },
    'MH-ENI': {
        code: 'MH-ENI',
        name: 'Enewetak & Ujelang',
        parent: 'MH-L',
    },
    'MH-JAB': {
        code: 'MH-JAB',
        name: 'Jabat',
        parent: 'MH-L',
    },
    'MH-JAL': {
        code: 'MH-JAL',
        name: 'Jaluit',
        parent: 'MH-L',
    },
    'MH-KIL': {
        code: 'MH-KIL',
        name: 'Bikini & Kili',
        parent: 'MH-L',
    },
    'MH-KWA': {
        code: 'MH-KWA',
        name: 'Kwajalein',
        parent: 'MH-L',
    },
    'MH-L': {
        code: 'MH-L',
        name: 'Ralik chain',
        parent: 'MH',
    },
    'MH-LAE': {
        code: 'MH-LAE',
        name: 'Lae',
        parent: 'MH-L',
    },
    'MH-LIB': {
        code: 'MH-LIB',
        name: 'Lib',
        parent: 'MH-L',
    },
    'MH-LIK': {
        code: 'MH-LIK',
        name: 'Likiep',
        parent: 'MH-T',
    },
    'MH-MAJ': {
        code: 'MH-MAJ',
        name: 'Majuro',
        parent: 'MH-T',
    },
    'MH-MAL': {
        code: 'MH-MAL',
        name: 'Maloelap',
        parent: 'MH-T',
    },
    'MH-MEJ': {
        code: 'MH-MEJ',
        name: 'Mejit',
        parent: 'MH-T',
    },
    'MH-MIL': {
        code: 'MH-MIL',
        name: 'Mili',
        parent: 'MH-T',
    },
    'MH-NMK': {
        code: 'MH-NMK',
        name: 'Namdrik',
        parent: 'MH-L',
    },
    'MH-NMU': {
        code: 'MH-NMU',
        name: 'Namu',
        parent: 'MH-L',
    },
    'MH-RON': {
        code: 'MH-RON',
        name: 'Rongelap',
        parent: 'MH-L',
    },
    'MH-T': {
        code: 'MH-T',
        name: 'Ratak chain',
        parent: 'MH',
    },
    'MH-UJA': {
        code: 'MH-UJA',
        name: 'Ujae',
        parent: 'MH-L',
    },
    'MH-UTI': {
        code: 'MH-UTI',
        name: 'Utrik',
        parent: 'MH-T',
    },
    'MH-WTH': {
        code: 'MH-WTH',
        name: 'Wotho',
        parent: 'MH-L',
    },
    'MH-WTJ': {
        code: 'MH-WTJ',
        name: 'Wotje',
        parent: 'MH-T',
    },
    'MK-101': {
        code: 'MK-101',
        name: 'Veles',
        parent: 'MK',
    },
    'MK-102': {
        code: 'MK-102',
        name: 'Gradsko',
        parent: 'MK',
    },
    'MK-103': {
        code: 'MK-103',
        name: 'Demir Kapija',
        parent: 'MK',
    },
    'MK-104': {
        code: 'MK-104',
        name: 'Kavadarci',
        parent: 'MK',
    },
    'MK-105': {
        code: 'MK-105',
        name: 'Lozovo',
        parent: 'MK',
    },
    'MK-106': {
        code: 'MK-106',
        name: 'Negotino',
        parent: 'MK',
    },
    'MK-107': {
        code: 'MK-107',
        name: 'Rosoman',
        parent: 'MK',
    },
    'MK-108': {
        code: 'MK-108',
        name: 'Sveti Nikole',
        parent: 'MK',
    },
    'MK-109': {
        code: 'MK-109',
        name: 'Čaška',
        parent: 'MK',
    },
    'MK-201': {
        code: 'MK-201',
        name: 'Berovo',
        parent: 'MK',
    },
    'MK-202': {
        code: 'MK-202',
        name: 'Vinica',
        parent: 'MK',
    },
    'MK-203': {
        code: 'MK-203',
        name: 'Delčevo',
        parent: 'MK',
    },
    'MK-204': {
        code: 'MK-204',
        name: 'Zrnovci',
        parent: 'MK',
    },
    'MK-205': {
        code: 'MK-205',
        name: 'Karbinci',
        parent: 'MK',
    },
    'MK-206': {
        code: 'MK-206',
        name: 'Kočani',
        parent: 'MK',
    },
    'MK-207': {
        code: 'MK-207',
        name: 'Makedonska Kamenica',
        parent: 'MK',
    },
    'MK-208': {
        code: 'MK-208',
        name: 'Pehčevo',
        parent: 'MK',
    },
    'MK-209': {
        code: 'MK-209',
        name: 'Probištip',
        parent: 'MK',
    },
    'MK-210': {
        code: 'MK-210',
        name: 'Češinovo-Obleševo',
        parent: 'MK',
    },
    'MK-211': {
        code: 'MK-211',
        name: 'Štip',
        parent: 'MK',
    },
    'MK-301': {
        code: 'MK-301',
        name: 'Vevčani',
        parent: 'MK',
    },
    'MK-303': {
        code: 'MK-303',
        name: 'Debar',
        parent: 'MK',
    },
    'MK-304': {
        code: 'MK-304',
        name: 'Debarca',
        parent: 'MK',
    },
    'MK-307': {
        code: 'MK-307',
        name: 'Kičevo',
        parent: 'MK',
    },
    'MK-308': {
        code: 'MK-308',
        name: 'Makedonski Brod',
        parent: 'MK',
    },
    'MK-310': {
        code: 'MK-310',
        name: 'Ohrid',
        parent: 'MK',
    },
    'MK-311': {
        code: 'MK-311',
        name: 'Plasnica',
        parent: 'MK',
    },
    'MK-312': {
        code: 'MK-312',
        name: 'Struga',
        parent: 'MK',
    },
    'MK-313': {
        code: 'MK-313',
        name: 'Centar Župa',
        parent: 'MK',
    },
    'MK-401': {
        code: 'MK-401',
        name: 'Bogdanci',
        parent: 'MK',
    },
    'MK-402': {
        code: 'MK-402',
        name: 'Bosilovo',
        parent: 'MK',
    },
    'MK-403': {
        code: 'MK-403',
        name: 'Valandovo',
        parent: 'MK',
    },
    'MK-404': {
        code: 'MK-404',
        name: 'Vasilevo',
        parent: 'MK',
    },
    'MK-405': {
        code: 'MK-405',
        name: 'Gevgelija',
        parent: 'MK',
    },
    'MK-406': {
        code: 'MK-406',
        name: 'Dojran',
        parent: 'MK',
    },
    'MK-407': {
        code: 'MK-407',
        name: 'Konče',
        parent: 'MK',
    },
    'MK-408': {
        code: 'MK-408',
        name: 'Novo Selo',
        parent: 'MK',
    },
    'MK-409': {
        code: 'MK-409',
        name: 'Radoviš',
        parent: 'MK',
    },
    'MK-410': {
        code: 'MK-410',
        name: 'Strumica',
        parent: 'MK',
    },
    'MK-501': {
        code: 'MK-501',
        name: 'Bitola',
        parent: 'MK',
    },
    'MK-502': {
        code: 'MK-502',
        name: 'Demir Hisar',
        parent: 'MK',
    },
    'MK-503': {
        code: 'MK-503',
        name: 'Dolneni',
        parent: 'MK',
    },
    'MK-504': {
        code: 'MK-504',
        name: 'Krivogaštani',
        parent: 'MK',
    },
    'MK-505': {
        code: 'MK-505',
        name: 'Kruševo',
        parent: 'MK',
    },
    'MK-506': {
        code: 'MK-506',
        name: 'Mogila',
        parent: 'MK',
    },
    'MK-507': {
        code: 'MK-507',
        name: 'Novaci',
        parent: 'MK',
    },
    'MK-508': {
        code: 'MK-508',
        name: 'Prilep',
        parent: 'MK',
    },
    'MK-509': {
        code: 'MK-509',
        name: 'Resen',
        parent: 'MK',
    },
    'MK-601': {
        code: 'MK-601',
        name: 'Bogovinje',
        parent: 'MK',
    },
    'MK-602': {
        code: 'MK-602',
        name: 'Brvenica',
        parent: 'MK',
    },
    'MK-603': {
        code: 'MK-603',
        name: 'Vrapčište',
        parent: 'MK',
    },
    'MK-604': {
        code: 'MK-604',
        name: 'Gostivar',
        parent: 'MK',
    },
    'MK-605': {
        code: 'MK-605',
        name: 'Želino',
        parent: 'MK',
    },
    'MK-606': {
        code: 'MK-606',
        name: 'Jegunovce',
        parent: 'MK',
    },
    'MK-607': {
        code: 'MK-607',
        name: 'Mavrovo i Rostuše',
        parent: 'MK',
    },
    'MK-608': {
        code: 'MK-608',
        name: 'Tearce',
        parent: 'MK',
    },
    'MK-609': {
        code: 'MK-609',
        name: 'Tetovo',
        parent: 'MK',
    },
    'MK-701': {
        code: 'MK-701',
        name: 'Kratovo',
        parent: 'MK',
    },
    'MK-702': {
        code: 'MK-702',
        name: 'Kriva Palanka',
        parent: 'MK',
    },
    'MK-703': {
        code: 'MK-703',
        name: 'Kumanovo',
        parent: 'MK',
    },
    'MK-704': {
        code: 'MK-704',
        name: 'Lipkovo',
        parent: 'MK',
    },
    'MK-705': {
        code: 'MK-705',
        name: 'Rankovce',
        parent: 'MK',
    },
    'MK-706': {
        code: 'MK-706',
        name: 'Staro Nagoričane',
        parent: 'MK',
    },
    'MK-801': {
        code: 'MK-801',
        name: 'Aerodrom',
        parent: 'MK',
    },
    'MK-802': {
        code: 'MK-802',
        name: 'Aračinovo',
        parent: 'MK',
    },
    'MK-803': {
        code: 'MK-803',
        name: 'Butel',
        parent: 'MK',
    },
    'MK-804': {
        code: 'MK-804',
        name: 'Gazi Baba',
        parent: 'MK',
    },
    'MK-805': {
        code: 'MK-805',
        name: 'Gjorče Petrov',
        parent: 'MK',
    },
    'MK-806': {
        code: 'MK-806',
        name: 'Zelenikovo',
        parent: 'MK',
    },
    'MK-807': {
        code: 'MK-807',
        name: 'Ilinden',
        parent: 'MK',
    },
    'MK-808': {
        code: 'MK-808',
        name: 'Karpoš',
        parent: 'MK',
    },
    'MK-809': {
        code: 'MK-809',
        name: 'Kisela Voda',
        parent: 'MK',
    },
    'MK-810': {
        code: 'MK-810',
        name: 'Petrovec',
        parent: 'MK',
    },
    'MK-811': {
        code: 'MK-811',
        name: 'Saraj',
        parent: 'MK',
    },
    'MK-812': {
        code: 'MK-812',
        name: 'Sopište',
        parent: 'MK',
    },
    'MK-813': {
        code: 'MK-813',
        name: 'Studeničani',
        parent: 'MK',
    },
    'MK-814': {
        code: 'MK-814',
        name: 'Centar',
        parent: 'MK',
    },
    'MK-815': {
        code: 'MK-815',
        name: 'Čair',
        parent: 'MK',
    },
    'MK-816': {
        code: 'MK-816',
        name: 'Čučer-Sandevo',
        parent: 'MK',
    },
    'MK-817': {
        code: 'MK-817',
        name: 'Šuto Orizari',
        parent: 'MK',
    },
    'ML-1': {
        code: 'ML-1',
        name: 'Kayes',
        parent: 'ML',
    },
    'ML-10': {
        code: 'ML-10',
        name: 'Taoudénit(local variants are Taoudenni, Taoudéni)',
        parent: 'ML',
    },
    'ML-2': {
        code: 'ML-2',
        name: 'Koulikoro',
        parent: 'ML',
    },
    'ML-3': {
        code: 'ML-3',
        name: 'Sikasso',
        parent: 'ML',
    },
    'ML-4': {
        code: 'ML-4',
        name: 'Ségou',
        parent: 'ML',
    },
    'ML-5': {
        code: 'ML-5',
        name: 'Mopti',
        parent: 'ML',
    },
    'ML-6': {
        code: 'ML-6',
        name: 'Tombouctou',
        parent: 'ML',
    },
    'ML-7': {
        code: 'ML-7',
        name: 'Gao',
        parent: 'ML',
    },
    'ML-8': {
        code: 'ML-8',
        name: 'Kidal',
        parent: 'ML',
    },
    'ML-9': {
        code: 'ML-9',
        name: 'Ménaka',
        parent: 'ML',
    },
    'ML-BKO': {
        code: 'ML-BKO',
        name: 'Bamako',
        parent: 'ML',
    },
    'MM-01': {
        code: 'MM-01',
        name: 'Sagaing',
        parent: 'MM',
    },
    'MM-02': {
        code: 'MM-02',
        name: 'Bago',
        parent: 'MM',
    },
    'MM-03': {
        code: 'MM-03',
        name: 'Magway',
        parent: 'MM',
    },
    'MM-04': {
        code: 'MM-04',
        name: 'Mandalay',
        parent: 'MM',
    },
    'MM-05': {
        code: 'MM-05',
        name: 'Tanintharyi',
        parent: 'MM',
    },
    'MM-06': {
        code: 'MM-06',
        name: 'Yangon',
        parent: 'MM',
    },
    'MM-07': {
        code: 'MM-07',
        name: 'Ayeyarwady',
        parent: 'MM',
    },
    'MM-11': {
        code: 'MM-11',
        name: 'Kachin',
        parent: 'MM',
    },
    'MM-12': {
        code: 'MM-12',
        name: 'Kayah',
        parent: 'MM',
    },
    'MM-13': {
        code: 'MM-13',
        name: 'Kayin',
        parent: 'MM',
    },
    'MM-14': {
        code: 'MM-14',
        name: 'Chin',
        parent: 'MM',
    },
    'MM-15': {
        code: 'MM-15',
        name: 'Mon',
        parent: 'MM',
    },
    'MM-16': {
        code: 'MM-16',
        name: 'Rakhine',
        parent: 'MM',
    },
    'MM-17': {
        code: 'MM-17',
        name: 'Shan',
        parent: 'MM',
    },
    'MM-18': {
        code: 'MM-18',
        name: 'Nay Pyi Taw',
        parent: 'MM',
    },
    'MN-035': {
        code: 'MN-035',
        name: 'Orhon',
        parent: 'MN',
    },
    'MN-037': {
        code: 'MN-037',
        name: 'Darhan uul',
        parent: 'MN',
    },
    'MN-039': {
        code: 'MN-039',
        name: 'Hentiy',
        parent: 'MN',
    },
    'MN-041': {
        code: 'MN-041',
        name: 'Hövsgöl',
        parent: 'MN',
    },
    'MN-043': {
        code: 'MN-043',
        name: 'Hovd',
        parent: 'MN',
    },
    'MN-046': {
        code: 'MN-046',
        name: 'Uvs',
        parent: 'MN',
    },
    'MN-047': {
        code: 'MN-047',
        name: 'Töv',
        parent: 'MN',
    },
    'MN-049': {
        code: 'MN-049',
        name: 'Selenge',
        parent: 'MN',
    },
    'MN-051': {
        code: 'MN-051',
        name: 'Sühbaatar',
        parent: 'MN',
    },
    'MN-053': {
        code: 'MN-053',
        name: 'Ömnögovĭ',
        parent: 'MN',
    },
    'MN-055': {
        code: 'MN-055',
        name: 'Övörhangay',
        parent: 'MN',
    },
    'MN-057': {
        code: 'MN-057',
        name: 'Dzavhan',
        parent: 'MN',
    },
    'MN-059': {
        code: 'MN-059',
        name: 'Dundgovĭ',
        parent: 'MN',
    },
    'MN-061': {
        code: 'MN-061',
        name: 'Dornod',
        parent: 'MN',
    },
    'MN-063': {
        code: 'MN-063',
        name: 'Dornogovĭ',
        parent: 'MN',
    },
    'MN-064': {
        code: 'MN-064',
        name: 'Govĭ-Sümber',
        parent: 'MN',
    },
    'MN-065': {
        code: 'MN-065',
        name: 'Govĭ-Altay',
        parent: 'MN',
    },
    'MN-067': {
        code: 'MN-067',
        name: 'Bulgan',
        parent: 'MN',
    },
    'MN-069': {
        code: 'MN-069',
        name: 'Bayanhongor',
        parent: 'MN',
    },
    'MN-071': {
        code: 'MN-071',
        name: 'Bayan-Ölgiy',
        parent: 'MN',
    },
    'MN-073': {
        code: 'MN-073',
        name: 'Arhangay',
        parent: 'MN',
    },
    'MN-1': {
        code: 'MN-1',
        name: 'Ulaanbaatar',
        parent: 'MN',
    },
    'MR-01': {
        code: 'MR-01',
        name: 'Hodh ech Chargui',
        parent: 'MR',
    },
    'MR-02': {
        code: 'MR-02',
        name: 'Hodh el Gharbi',
        parent: 'MR',
    },
    'MR-03': {
        code: 'MR-03',
        name: 'Assaba',
        parent: 'MR',
    },
    'MR-04': {
        code: 'MR-04',
        name: 'Gorgol',
        parent: 'MR',
    },
    'MR-05': {
        code: 'MR-05',
        name: 'Brakna',
        parent: 'MR',
    },
    'MR-06': {
        code: 'MR-06',
        name: 'Trarza',
        parent: 'MR',
    },
    'MR-07': {
        code: 'MR-07',
        name: 'Adrar',
        parent: 'MR',
    },
    'MR-08': {
        code: 'MR-08',
        name: 'Dakhlet Nouâdhibou',
        parent: 'MR',
    },
    'MR-09': {
        code: 'MR-09',
        name: 'Tagant',
        parent: 'MR',
    },
    'MR-10': {
        code: 'MR-10',
        name: 'Guidimaka',
        parent: 'MR',
    },
    'MR-11': {
        code: 'MR-11',
        name: 'Tiris Zemmour',
        parent: 'MR',
    },
    'MR-12': {
        code: 'MR-12',
        name: 'Inchiri',
        parent: 'MR',
    },
    'MR-13': {
        code: 'MR-13',
        name: 'Nuwākshūţ al Gharbīyah',
        parent: 'MR',
    },
    'MR-14': {
        code: 'MR-14',
        name: 'Nuwākshūţ ash Shamālīyah',
        parent: 'MR',
    },
    'MR-15': {
        code: 'MR-15',
        name: 'Nuwākshūţ al Janūbīyah',
        parent: 'MR',
    },
    'MT-01': {
        code: 'MT-01',
        name: 'Attard',
        parent: 'MT',
    },
    'MT-02': {
        code: 'MT-02',
        name: 'Balzan',
        parent: 'MT',
    },
    'MT-03': {
        code: 'MT-03',
        name: 'Birgu',
        parent: 'MT',
    },
    'MT-04': {
        code: 'MT-04',
        name: 'Birkirkara',
        parent: 'MT',
    },
    'MT-05': {
        code: 'MT-05',
        name: 'Birżebbuġa',
        parent: 'MT',
    },
    'MT-06': {
        code: 'MT-06',
        name: 'Bormla',
        parent: 'MT',
    },
    'MT-07': {
        code: 'MT-07',
        name: 'Dingli',
        parent: 'MT',
    },
    'MT-08': {
        code: 'MT-08',
        name: 'Fgura',
        parent: 'MT',
    },
    'MT-09': {
        code: 'MT-09',
        name: 'Floriana',
        parent: 'MT',
    },
    'MT-10': {
        code: 'MT-10',
        name: 'Fontana',
        parent: 'MT',
    },
    'MT-11': {
        code: 'MT-11',
        name: 'Gudja',
        parent: 'MT',
    },
    'MT-12': {
        code: 'MT-12',
        name: 'Gżira',
        parent: 'MT',
    },
    'MT-13': {
        code: 'MT-13',
        name: 'Għajnsielem',
        parent: 'MT',
    },
    'MT-14': {
        code: 'MT-14',
        name: 'Għarb',
        parent: 'MT',
    },
    'MT-15': {
        code: 'MT-15',
        name: 'Għargħur',
        parent: 'MT',
    },
    'MT-16': {
        code: 'MT-16',
        name: 'Għasri',
        parent: 'MT',
    },
    'MT-17': {
        code: 'MT-17',
        name: 'Għaxaq',
        parent: 'MT',
    },
    'MT-18': {
        code: 'MT-18',
        name: 'Ħamrun',
        parent: 'MT',
    },
    'MT-19': {
        code: 'MT-19',
        name: 'Iklin',
        parent: 'MT',
    },
    'MT-20': {
        code: 'MT-20',
        name: 'Isla',
        parent: 'MT',
    },
    'MT-21': {
        code: 'MT-21',
        name: 'Kalkara',
        parent: 'MT',
    },
    'MT-22': {
        code: 'MT-22',
        name: 'Kerċem',
        parent: 'MT',
    },
    'MT-23': {
        code: 'MT-23',
        name: 'Kirkop',
        parent: 'MT',
    },
    'MT-24': {
        code: 'MT-24',
        name: 'Lija',
        parent: 'MT',
    },
    'MT-25': {
        code: 'MT-25',
        name: 'Luqa',
        parent: 'MT',
    },
    'MT-26': {
        code: 'MT-26',
        name: 'Marsa',
        parent: 'MT',
    },
    'MT-27': {
        code: 'MT-27',
        name: 'Marsaskala',
        parent: 'MT',
    },
    'MT-28': {
        code: 'MT-28',
        name: 'Marsaxlokk',
        parent: 'MT',
    },
    'MT-29': {
        code: 'MT-29',
        name: 'Mdina',
        parent: 'MT',
    },
    'MT-30': {
        code: 'MT-30',
        name: 'Mellieħa',
        parent: 'MT',
    },
    'MT-31': {
        code: 'MT-31',
        name: 'Mġarr',
        parent: 'MT',
    },
    'MT-32': {
        code: 'MT-32',
        name: 'Mosta',
        parent: 'MT',
    },
    'MT-33': {
        code: 'MT-33',
        name: 'Mqabba',
        parent: 'MT',
    },
    'MT-34': {
        code: 'MT-34',
        name: 'Msida',
        parent: 'MT',
    },
    'MT-35': {
        code: 'MT-35',
        name: 'Mtarfa',
        parent: 'MT',
    },
    'MT-36': {
        code: 'MT-36',
        name: 'Munxar',
        parent: 'MT',
    },
    'MT-37': {
        code: 'MT-37',
        name: 'Nadur',
        parent: 'MT',
    },
    'MT-38': {
        code: 'MT-38',
        name: 'Naxxar',
        parent: 'MT',
    },
    'MT-39': {
        code: 'MT-39',
        name: 'Paola',
        parent: 'MT',
    },
    'MT-40': {
        code: 'MT-40',
        name: 'Pembroke',
        parent: 'MT',
    },
    'MT-41': {
        code: 'MT-41',
        name: 'Pietà',
        parent: 'MT',
    },
    'MT-42': {
        code: 'MT-42',
        name: 'Qala',
        parent: 'MT',
    },
    'MT-43': {
        code: 'MT-43',
        name: 'Qormi',
        parent: 'MT',
    },
    'MT-44': {
        code: 'MT-44',
        name: 'Qrendi',
        parent: 'MT',
    },
    'MT-45': {
        code: 'MT-45',
        name: 'Rabat Gozo',
        parent: 'MT',
    },
    'MT-46': {
        code: 'MT-46',
        name: 'Rabat Malta',
        parent: 'MT',
    },
    'MT-47': {
        code: 'MT-47',
        name: 'Safi',
        parent: 'MT',
    },
    'MT-48': {
        code: 'MT-48',
        name: "Saint Julian's",
        parent: 'MT',
    },
    'MT-49': {
        code: 'MT-49',
        name: 'Saint John',
        parent: 'MT',
    },
    'MT-50': {
        code: 'MT-50',
        name: 'Saint Lawrence',
        parent: 'MT',
    },
    'MT-51': {
        code: 'MT-51',
        name: "Saint Paul's Bay",
        parent: 'MT',
    },
    'MT-52': {
        code: 'MT-52',
        name: 'Sannat',
        parent: 'MT',
    },
    'MT-53': {
        code: 'MT-53',
        name: "Saint Lucia's",
        parent: 'MT',
    },
    'MT-54': {
        code: 'MT-54',
        name: 'Santa Venera',
        parent: 'MT',
    },
    'MT-55': {
        code: 'MT-55',
        name: 'Siġġiewi',
        parent: 'MT',
    },
    'MT-56': {
        code: 'MT-56',
        name: 'Sliema',
        parent: 'MT',
    },
    'MT-57': {
        code: 'MT-57',
        name: 'Swieqi',
        parent: 'MT',
    },
    'MT-58': {
        code: 'MT-58',
        name: "Ta' Xbiex",
        parent: 'MT',
    },
    'MT-59': {
        code: 'MT-59',
        name: 'Tarxien',
        parent: 'MT',
    },
    'MT-60': {
        code: 'MT-60',
        name: 'Valletta',
        parent: 'MT',
    },
    'MT-61': {
        code: 'MT-61',
        name: 'Xagħra',
        parent: 'MT',
    },
    'MT-62': {
        code: 'MT-62',
        name: 'Xewkija',
        parent: 'MT',
    },
    'MT-63': {
        code: 'MT-63',
        name: 'Xgħajra',
        parent: 'MT',
    },
    'MT-64': {
        code: 'MT-64',
        name: 'Żabbar',
        parent: 'MT',
    },
    'MT-65': {
        code: 'MT-65',
        name: 'Żebbuġ Gozo',
        parent: 'MT',
    },
    'MT-66': {
        code: 'MT-66',
        name: 'Żebbuġ Malta',
        parent: 'MT',
    },
    'MT-67': {
        code: 'MT-67',
        name: 'Żejtun',
        parent: 'MT',
    },
    'MT-68': {
        code: 'MT-68',
        name: 'Żurrieq',
        parent: 'MT',
    },
    'MU-AG': {
        code: 'MU-AG',
        name: 'Agalega Islands',
        parent: 'MU',
    },
    'MU-BL': {
        code: 'MU-BL',
        name: 'Black River',
        parent: 'MU',
    },
    'MU-CC': {
        code: 'MU-CC',
        name: 'Cargados Carajos Shoals(local variant is Saint Brandon Islands)',
        parent: 'MU',
    },
    'MU-FL': {
        code: 'MU-FL',
        name: 'Flacq',
        parent: 'MU',
    },
    'MU-GP': {
        code: 'MU-GP',
        name: 'Grand Port',
        parent: 'MU',
    },
    'MU-MO': {
        code: 'MU-MO',
        name: 'Moka',
        parent: 'MU',
    },
    'MU-PA': {
        code: 'MU-PA',
        name: 'Pamplemousses',
        parent: 'MU',
    },
    'MU-PL': {
        code: 'MU-PL',
        name: 'Port Louis',
        parent: 'MU',
    },
    'MU-PW': {
        code: 'MU-PW',
        name: 'Plaines Wilhems',
        parent: 'MU',
    },
    'MU-RO': {
        code: 'MU-RO',
        name: 'Rodrigues Island',
        parent: 'MU',
    },
    'MU-RR': {
        code: 'MU-RR',
        name: 'Rivière du Rempart',
        parent: 'MU',
    },
    'MU-SA': {
        code: 'MU-SA',
        name: 'Savanne',
        parent: 'MU',
    },
    'MV-00': {
        code: 'MV-00',
        name: 'South Ari Atoll',
        parent: 'MV',
    },
    'MV-01': {
        code: 'MV-01',
        name: 'Addu City',
        parent: 'MV',
    },
    'MV-02': {
        code: 'MV-02',
        name: 'North Ari Atoll',
        parent: 'MV',
    },
    'MV-03': {
        code: 'MV-03',
        name: 'Faadhippolhu',
        parent: 'MV',
    },
    'MV-04': {
        code: 'MV-04',
        name: 'Felidhu Atoll',
        parent: 'MV',
    },
    'MV-05': {
        code: 'MV-05',
        name: 'Hahdhunmathi',
        parent: 'MV',
    },
    'MV-07': {
        code: 'MV-07',
        name: 'North Thiladhunmathi',
        parent: 'MV',
    },
    'MV-08': {
        code: 'MV-08',
        name: 'Kolhumadulu',
        parent: 'MV',
    },
    'MV-12': {
        code: 'MV-12',
        name: 'Mulaku Atoll',
        parent: 'MV',
    },
    'MV-13': {
        code: 'MV-13',
        name: 'North Maalhosmadulu',
        parent: 'MV',
    },
    'MV-14': {
        code: 'MV-14',
        name: 'North Nilandhe Atoll',
        parent: 'MV',
    },
    'MV-17': {
        code: 'MV-17',
        name: 'South Nilandhe Atoll',
        parent: 'MV',
    },
    'MV-20': {
        code: 'MV-20',
        name: 'South Maalhosmadulu',
        parent: 'MV',
    },
    'MV-23': {
        code: 'MV-23',
        name: 'South Thiladhunmathi',
        parent: 'MV',
    },
    'MV-24': {
        code: 'MV-24',
        name: 'North Miladhunmadulu',
        parent: 'MV',
    },
    'MV-25': {
        code: 'MV-25',
        name: 'South Miladhunmadulu',
        parent: 'MV',
    },
    'MV-26': {
        code: 'MV-26',
        name: 'Male Atoll',
        parent: 'MV',
    },
    'MV-27': {
        code: 'MV-27',
        name: 'North Huvadhu Atoll',
        parent: 'MV',
    },
    'MV-28': {
        code: 'MV-28',
        name: 'South Huvadhu Atoll',
        parent: 'MV',
    },
    'MV-29': {
        code: 'MV-29',
        name: 'Fuvammulah',
        parent: 'MV',
    },
    'MV-MLE': {
        code: 'MV-MLE',
        name: 'Male',
        parent: 'MV',
    },
    'MW-BA': {
        code: 'MW-BA',
        name: 'Balaka',
        parent: 'MW-S',
    },
    'MW-BL': {
        code: 'MW-BL',
        name: 'Blantyre',
        parent: 'MW-S',
    },
    'MW-C': {
        code: 'MW-C',
        name: 'Central Region',
        parent: 'MW',
    },
    'MW-CK': {
        code: 'MW-CK',
        name: 'Chikwawa',
        parent: 'MW-S',
    },
    'MW-CR': {
        code: 'MW-CR',
        name: 'Chiradzulu',
        parent: 'MW-S',
    },
    'MW-CT': {
        code: 'MW-CT',
        name: 'Chitipa',
        parent: 'MW-N',
    },
    'MW-DE': {
        code: 'MW-DE',
        name: 'Dedza',
        parent: 'MW-C',
    },
    'MW-DO': {
        code: 'MW-DO',
        name: 'Dowa',
        parent: 'MW-C',
    },
    'MW-KR': {
        code: 'MW-KR',
        name: 'Karonga',
        parent: 'MW-N',
    },
    'MW-KS': {
        code: 'MW-KS',
        name: 'Kasungu',
        parent: 'MW-C',
    },
    'MW-LI': {
        code: 'MW-LI',
        name: 'Lilongwe',
        parent: 'MW-C',
    },
    'MW-LK': {
        code: 'MW-LK',
        name: 'Likoma',
        parent: 'MW-N',
    },
    'MW-MC': {
        code: 'MW-MC',
        name: 'Mchinji',
        parent: 'MW-C',
    },
    'MW-MG': {
        code: 'MW-MG',
        name: 'Mangochi',
        parent: 'MW-S',
    },
    'MW-MH': {
        code: 'MW-MH',
        name: 'Machinga',
        parent: 'MW-S',
    },
    'MW-MU': {
        code: 'MW-MU',
        name: 'Mulanje',
        parent: 'MW-S',
    },
    'MW-MW': {
        code: 'MW-MW',
        name: 'Mwanza',
        parent: 'MW-S',
    },
    'MW-MZ': {
        code: 'MW-MZ',
        name: 'Mzimba',
        parent: 'MW-N',
    },
    'MW-N': {
        code: 'MW-N',
        name: 'Northern Region',
        parent: 'MW',
    },
    'MW-NB': {
        code: 'MW-NB',
        name: 'Nkhata Bay',
        parent: 'MW-N',
    },
    'MW-NE': {
        code: 'MW-NE',
        name: 'Neno',
        parent: 'MW-S',
    },
    'MW-NI': {
        code: 'MW-NI',
        name: 'Ntchisi',
        parent: 'MW-C',
    },
    'MW-NK': {
        code: 'MW-NK',
        name: 'Nkhotakota',
        parent: 'MW-C',
    },
    'MW-NS': {
        code: 'MW-NS',
        name: 'Nsanje',
        parent: 'MW-S',
    },
    'MW-NU': {
        code: 'MW-NU',
        name: 'Ntcheu',
        parent: 'MW-C',
    },
    'MW-PH': {
        code: 'MW-PH',
        name: 'Phalombe',
        parent: 'MW-S',
    },
    'MW-RU': {
        code: 'MW-RU',
        name: 'Rumphi',
        parent: 'MW-N',
    },
    'MW-S': {
        code: 'MW-S',
        name: 'Southern Region',
        parent: 'MW',
    },
    'MW-SA': {
        code: 'MW-SA',
        name: 'Salima',
        parent: 'MW-C',
    },
    'MW-TH': {
        code: 'MW-TH',
        name: 'Thyolo',
        parent: 'MW-S',
    },
    'MW-ZO': {
        code: 'MW-ZO',
        name: 'Zomba',
        parent: 'MW-S',
    },
    'MX-AGU': {
        code: 'MX-AGU',
        name: 'Aguascalientes',
        parent: 'MX',
    },
    'MX-BCN': {
        code: 'MX-BCN',
        name: 'Baja California',
        parent: 'MX',
    },
    'MX-BCS': {
        code: 'MX-BCS',
        name: 'Baja California Sur',
        parent: 'MX',
    },
    'MX-CAM': {
        code: 'MX-CAM',
        name: 'Campeche',
        parent: 'MX',
    },
    'MX-CHH': {
        code: 'MX-CHH',
        name: 'Chihuahua',
        parent: 'MX',
    },
    'MX-CHP': {
        code: 'MX-CHP',
        name: 'Chiapas',
        parent: 'MX',
    },
    'MX-CMX': {
        code: 'MX-CMX',
        name: 'Ciudad de México',
        parent: 'MX',
    },
    'MX-COA': {
        code: 'MX-COA',
        name: 'Coahuila de Zaragoza',
        parent: 'MX',
    },
    'MX-COL': {
        code: 'MX-COL',
        name: 'Colima',
        parent: 'MX',
    },
    'MX-DUR': {
        code: 'MX-DUR',
        name: 'Durango',
        parent: 'MX',
    },
    'MX-GRO': {
        code: 'MX-GRO',
        name: 'Guerrero',
        parent: 'MX',
    },
    'MX-GUA': {
        code: 'MX-GUA',
        name: 'Guanajuato',
        parent: 'MX',
    },
    'MX-HID': {
        code: 'MX-HID',
        name: 'Hidalgo',
        parent: 'MX',
    },
    'MX-JAL': {
        code: 'MX-JAL',
        name: 'Jalisco',
        parent: 'MX',
    },
    'MX-MEX': {
        code: 'MX-MEX',
        name: 'México',
        parent: 'MX',
    },
    'MX-MIC': {
        code: 'MX-MIC',
        name: 'Michoacán de Ocampo',
        parent: 'MX',
    },
    'MX-MOR': {
        code: 'MX-MOR',
        name: 'Morelos',
        parent: 'MX',
    },
    'MX-NAY': {
        code: 'MX-NAY',
        name: 'Nayarit',
        parent: 'MX',
    },
    'MX-NLE': {
        code: 'MX-NLE',
        name: 'Nuevo León',
        parent: 'MX',
    },
    'MX-OAX': {
        code: 'MX-OAX',
        name: 'Oaxaca',
        parent: 'MX',
    },
    'MX-PUE': {
        code: 'MX-PUE',
        name: 'Puebla',
        parent: 'MX',
    },
    'MX-QUE': {
        code: 'MX-QUE',
        name: 'Querétaro',
        parent: 'MX',
    },
    'MX-ROO': {
        code: 'MX-ROO',
        name: 'Quintana Roo',
        parent: 'MX',
    },
    'MX-SIN': {
        code: 'MX-SIN',
        name: 'Sinaloa',
        parent: 'MX',
    },
    'MX-SLP': {
        code: 'MX-SLP',
        name: 'San Luis Potosí',
        parent: 'MX',
    },
    'MX-SON': {
        code: 'MX-SON',
        name: 'Sonora',
        parent: 'MX',
    },
    'MX-TAB': {
        code: 'MX-TAB',
        name: 'Tabasco',
        parent: 'MX',
    },
    'MX-TAM': {
        code: 'MX-TAM',
        name: 'Tamaulipas',
        parent: 'MX',
    },
    'MX-TLA': {
        code: 'MX-TLA',
        name: 'Tlaxcala',
        parent: 'MX',
    },
    'MX-VER': {
        code: 'MX-VER',
        name: 'Veracruz de Ignacio de la Llave',
        parent: 'MX',
    },
    'MX-YUC': {
        code: 'MX-YUC',
        name: 'Yucatán',
        parent: 'MX',
    },
    'MX-ZAC': {
        code: 'MX-ZAC',
        name: 'Zacatecas',
        parent: 'MX',
    },
    'MY-01': {
        code: 'MY-01',
        name: 'Johor',
        parent: 'MY',
    },
    'MY-02': {
        code: 'MY-02',
        name: 'Kedah',
        parent: 'MY',
    },
    'MY-03': {
        code: 'MY-03',
        name: 'Kelantan',
        parent: 'MY',
    },
    'MY-04': {
        code: 'MY-04',
        name: 'Melaka',
        parent: 'MY',
    },
    'MY-05': {
        code: 'MY-05',
        name: 'Negeri Sembilan',
        parent: 'MY',
    },
    'MY-06': {
        code: 'MY-06',
        name: 'Pahang',
        parent: 'MY',
    },
    'MY-07': {
        code: 'MY-07',
        name: 'Pulau Pinang',
        parent: 'MY',
    },
    'MY-08': {
        code: 'MY-08',
        name: 'Perak',
        parent: 'MY',
    },
    'MY-09': {
        code: 'MY-09',
        name: 'Perlis',
        parent: 'MY',
    },
    'MY-10': {
        code: 'MY-10',
        name: 'Selangor',
        parent: 'MY',
    },
    'MY-11': {
        code: 'MY-11',
        name: 'Terengganu',
        parent: 'MY',
    },
    'MY-12': {
        code: 'MY-12',
        name: 'Sabah',
        parent: 'MY',
    },
    'MY-13': {
        code: 'MY-13',
        name: 'Sarawak',
        parent: 'MY',
    },
    'MY-14': {
        code: 'MY-14',
        name: 'Wilayah Persekutuan Kuala Lumpur',
        parent: 'MY',
    },
    'MY-15': {
        code: 'MY-15',
        name: 'Wilayah Persekutuan Labuan',
        parent: 'MY',
    },
    'MY-16': {
        code: 'MY-16',
        name: 'Wilayah Persekutuan Putrajaya',
        parent: 'MY',
    },
    'MZ-A': {
        code: 'MZ-A',
        name: 'Niassa',
        parent: 'MZ',
    },
    'MZ-B': {
        code: 'MZ-B',
        name: 'Manica',
        parent: 'MZ',
    },
    'MZ-G': {
        code: 'MZ-G',
        name: 'Gaza',
        parent: 'MZ',
    },
    'MZ-I': {
        code: 'MZ-I',
        name: 'Inhambane',
        parent: 'MZ',
    },
    'MZ-L': {
        code: 'MZ-L',
        name: 'Maputo',
        parent: 'MZ',
    },
    'MZ-MPM': {
        code: 'MZ-MPM',
        name: 'Maputo',
        parent: 'MZ',
    },
    'MZ-N': {
        code: 'MZ-N',
        name: 'Nampula',
        parent: 'MZ',
    },
    'MZ-P': {
        code: 'MZ-P',
        name: 'Cabo Delgado',
        parent: 'MZ',
    },
    'MZ-Q': {
        code: 'MZ-Q',
        name: 'Zambézia',
        parent: 'MZ',
    },
    'MZ-S': {
        code: 'MZ-S',
        name: 'Sofala',
        parent: 'MZ',
    },
    'MZ-T': {
        code: 'MZ-T',
        name: 'Tete',
        parent: 'MZ',
    },
    'NA-CA': {
        code: 'NA-CA',
        name: 'Zambezi',
        parent: 'NA',
    },
    'NA-ER': {
        code: 'NA-ER',
        name: 'Erongo',
        parent: 'NA',
    },
    'NA-HA': {
        code: 'NA-HA',
        name: 'Hardap',
        parent: 'NA',
    },
    'NA-KA': {
        code: 'NA-KA',
        name: '//Karas(local variants are Karas and !Karas)',
        parent: 'NA',
    },
    'NA-KE': {
        code: 'NA-KE',
        name: 'Kavango East',
        parent: 'NA',
    },
    'NA-KH': {
        code: 'NA-KH',
        name: 'Khomas',
        parent: 'NA',
    },
    'NA-KU': {
        code: 'NA-KU',
        name: 'Kunene',
        parent: 'NA',
    },
    'NA-KW': {
        code: 'NA-KW',
        name: 'Kavango West',
        parent: 'NA',
    },
    'NA-OD': {
        code: 'NA-OD',
        name: 'Otjozondjupa',
        parent: 'NA',
    },
    'NA-OH': {
        code: 'NA-OH',
        name: 'Omaheke',
        parent: 'NA',
    },
    'NA-ON': {
        code: 'NA-ON',
        name: 'Oshana',
        parent: 'NA',
    },
    'NA-OS': {
        code: 'NA-OS',
        name: 'Omusati',
        parent: 'NA',
    },
    'NA-OT': {
        code: 'NA-OT',
        name: 'Oshikoto',
        parent: 'NA',
    },
    'NA-OW': {
        code: 'NA-OW',
        name: 'Ohangwena',
        parent: 'NA',
    },
    'NE-1': {
        code: 'NE-1',
        name: 'Agadez',
        parent: 'NE',
    },
    'NE-2': {
        code: 'NE-2',
        name: 'Diffa',
        parent: 'NE',
    },
    'NE-3': {
        code: 'NE-3',
        name: 'Dosso',
        parent: 'NE',
    },
    'NE-4': {
        code: 'NE-4',
        name: 'Maradi',
        parent: 'NE',
    },
    'NE-5': {
        code: 'NE-5',
        name: 'Tahoua',
        parent: 'NE',
    },
    'NE-6': {
        code: 'NE-6',
        name: 'Tillabéri',
        parent: 'NE',
    },
    'NE-7': {
        code: 'NE-7',
        name: 'Zinder',
        parent: 'NE',
    },
    'NE-8': {
        code: 'NE-8',
        name: 'Niamey',
        parent: 'NE',
    },
    'NG-AB': {
        code: 'NG-AB',
        name: 'Abia',
        parent: 'NG',
    },
    'NG-AD': {
        code: 'NG-AD',
        name: 'Adamawa',
        parent: 'NG',
    },
    'NG-AK': {
        code: 'NG-AK',
        name: 'Akwa Ibom',
        parent: 'NG',
    },
    'NG-AN': {
        code: 'NG-AN',
        name: 'Anambra',
        parent: 'NG',
    },
    'NG-BA': {
        code: 'NG-BA',
        name: 'Bauchi',
        parent: 'NG',
    },
    'NG-BE': {
        code: 'NG-BE',
        name: 'Benue',
        parent: 'NG',
    },
    'NG-BO': {
        code: 'NG-BO',
        name: 'Borno',
        parent: 'NG',
    },
    'NG-BY': {
        code: 'NG-BY',
        name: 'Bayelsa',
        parent: 'NG',
    },
    'NG-CR': {
        code: 'NG-CR',
        name: 'Cross River',
        parent: 'NG',
    },
    'NG-DE': {
        code: 'NG-DE',
        name: 'Delta',
        parent: 'NG',
    },
    'NG-EB': {
        code: 'NG-EB',
        name: 'Ebonyi',
        parent: 'NG',
    },
    'NG-ED': {
        code: 'NG-ED',
        name: 'Edo',
        parent: 'NG',
    },
    'NG-EK': {
        code: 'NG-EK',
        name: 'Ekiti',
        parent: 'NG',
    },
    'NG-EN': {
        code: 'NG-EN',
        name: 'Enugu',
        parent: 'NG',
    },
    'NG-FC': {
        code: 'NG-FC',
        name: 'Abuja Federal Capital Territory',
        parent: 'NG',
    },
    'NG-GO': {
        code: 'NG-GO',
        name: 'Gombe',
        parent: 'NG',
    },
    'NG-IM': {
        code: 'NG-IM',
        name: 'Imo',
        parent: 'NG',
    },
    'NG-JI': {
        code: 'NG-JI',
        name: 'Jigawa',
        parent: 'NG',
    },
    'NG-KD': {
        code: 'NG-KD',
        name: 'Kaduna',
        parent: 'NG',
    },
    'NG-KE': {
        code: 'NG-KE',
        name: 'Kebbi',
        parent: 'NG',
    },
    'NG-KN': {
        code: 'NG-KN',
        name: 'Kano',
        parent: 'NG',
    },
    'NG-KO': {
        code: 'NG-KO',
        name: 'Kogi',
        parent: 'NG',
    },
    'NG-KT': {
        code: 'NG-KT',
        name: 'Katsina',
        parent: 'NG',
    },
    'NG-KW': {
        code: 'NG-KW',
        name: 'Kwara',
        parent: 'NG',
    },
    'NG-LA': {
        code: 'NG-LA',
        name: 'Lagos',
        parent: 'NG',
    },
    'NG-NA': {
        code: 'NG-NA',
        name: 'Nasarawa',
        parent: 'NG',
    },
    'NG-NI': {
        code: 'NG-NI',
        name: 'Niger',
        parent: 'NG',
    },
    'NG-OG': {
        code: 'NG-OG',
        name: 'Ogun',
        parent: 'NG',
    },
    'NG-ON': {
        code: 'NG-ON',
        name: 'Ondo',
        parent: 'NG',
    },
    'NG-OS': {
        code: 'NG-OS',
        name: 'Osun',
        parent: 'NG',
    },
    'NG-OY': {
        code: 'NG-OY',
        name: 'Oyo',
        parent: 'NG',
    },
    'NG-PL': {
        code: 'NG-PL',
        name: 'Plateau',
        parent: 'NG',
    },
    'NG-RI': {
        code: 'NG-RI',
        name: 'Rivers',
        parent: 'NG',
    },
    'NG-SO': {
        code: 'NG-SO',
        name: 'Sokoto',
        parent: 'NG',
    },
    'NG-TA': {
        code: 'NG-TA',
        name: 'Taraba',
        parent: 'NG',
    },
    'NG-YO': {
        code: 'NG-YO',
        name: 'Yobe',
        parent: 'NG',
    },
    'NG-ZA': {
        code: 'NG-ZA',
        name: 'Zamfara',
        parent: 'NG',
    },
    'NI-AN': {
        code: 'NI-AN',
        name: 'Costa Caribe Norte',
        parent: 'NI',
    },
    'NI-AS': {
        code: 'NI-AS',
        name: 'Costa Caribe Sur',
        parent: 'NI',
    },
    'NI-BO': {
        code: 'NI-BO',
        name: 'Boaco',
        parent: 'NI',
    },
    'NI-CA': {
        code: 'NI-CA',
        name: 'Carazo',
        parent: 'NI',
    },
    'NI-CI': {
        code: 'NI-CI',
        name: 'Chinandega',
        parent: 'NI',
    },
    'NI-CO': {
        code: 'NI-CO',
        name: 'Chontales',
        parent: 'NI',
    },
    'NI-ES': {
        code: 'NI-ES',
        name: 'Estelí',
        parent: 'NI',
    },
    'NI-GR': {
        code: 'NI-GR',
        name: 'Granada',
        parent: 'NI',
    },
    'NI-JI': {
        code: 'NI-JI',
        name: 'Jinotega',
        parent: 'NI',
    },
    'NI-LE': {
        code: 'NI-LE',
        name: 'León',
        parent: 'NI',
    },
    'NI-MD': {
        code: 'NI-MD',
        name: 'Madriz',
        parent: 'NI',
    },
    'NI-MN': {
        code: 'NI-MN',
        name: 'Managua',
        parent: 'NI',
    },
    'NI-MS': {
        code: 'NI-MS',
        name: 'Masaya',
        parent: 'NI',
    },
    'NI-MT': {
        code: 'NI-MT',
        name: 'Matagalpa',
        parent: 'NI',
    },
    'NI-NS': {
        code: 'NI-NS',
        name: 'Nueva Segovia',
        parent: 'NI',
    },
    'NI-RI': {
        code: 'NI-RI',
        name: 'Rivas',
        parent: 'NI',
    },
    'NI-SJ': {
        code: 'NI-SJ',
        name: 'Río San Juan',
        parent: 'NI',
    },
    'NL-AW': {
        code: 'NL-AW',
        name: 'Aruba',
        parent: 'NL',
    },
    'NL-BQ1': {
        code: 'NL-BQ1',
        name: 'Bonaire',
        parent: 'NL',
    },
    'NL-BQ2': {
        code: 'NL-BQ2',
        name: 'Saba',
        parent: 'NL',
    },
    'NL-BQ3': {
        code: 'NL-BQ3',
        name: 'Sint Eustatius',
        parent: 'NL',
    },
    'NL-CW': {
        code: 'NL-CW',
        name: 'Curaçao',
        parent: 'NL',
    },
    'NL-DR': {
        code: 'NL-DR',
        name: 'Drenthe',
        parent: 'NL',
    },
    'NL-FL': {
        code: 'NL-FL',
        name: 'Flevoland',
        parent: 'NL',
    },
    'NL-FR': {
        code: 'NL-FR',
        name: 'Fryslân',
        parent: 'NL',
    },
    'NL-GE': {
        code: 'NL-GE',
        name: 'Gelderland',
        parent: 'NL',
    },
    'NL-GR': {
        code: 'NL-GR',
        name: 'Groningen',
        parent: 'NL',
    },
    'NL-LI': {
        code: 'NL-LI',
        name: 'Limburg',
        parent: 'NL',
    },
    'NL-NB': {
        code: 'NL-NB',
        name: 'Noord-Brabant',
        parent: 'NL',
    },
    'NL-NH': {
        code: 'NL-NH',
        name: 'Noord-Holland',
        parent: 'NL',
    },
    'NL-OV': {
        code: 'NL-OV',
        name: 'Overijssel',
        parent: 'NL',
    },
    'NL-SX': {
        code: 'NL-SX',
        name: 'Sint Maarten',
        parent: 'NL',
    },
    'NL-UT': {
        code: 'NL-UT',
        name: 'Utrecht',
        parent: 'NL',
    },
    'NL-ZE': {
        code: 'NL-ZE',
        name: 'Zeeland',
        parent: 'NL',
    },
    'NL-ZH': {
        code: 'NL-ZH',
        name: 'Zuid-Holland',
        parent: 'NL',
    },
    'NO-03': {
        code: 'NO-03',
        name: 'Oslo',
        parent: 'NO',
    },
    'NO-11': {
        code: 'NO-11',
        name: 'Rogaland',
        parent: 'NO',
    },
    'NO-15': {
        code: 'NO-15',
        name: 'Møre og Romsdal',
        parent: 'NO',
    },
    'NO-18': {
        code: 'NO-18',
        name: 'Nordland',
        parent: 'NO',
    },
    'NO-21': {
        code: 'NO-21',
        name: 'Svalbard',
        parent: 'NO',
    },
    'NO-22': {
        code: 'NO-22',
        name: 'Jan Mayen',
        parent: 'NO',
    },
    'NO-30': {
        code: 'NO-30',
        name: 'Viken',
        parent: 'NO',
    },
    'NO-34': {
        code: 'NO-34',
        name: 'Innlandet',
        parent: 'NO',
    },
    'NO-38': {
        code: 'NO-38',
        name: 'Vestfold og Telemark',
        parent: 'NO',
    },
    'NO-42': {
        code: 'NO-42',
        name: 'Agder',
        parent: 'NO',
    },
    'NO-46': {
        code: 'NO-46',
        name: 'Vestland',
        parent: 'NO',
    },
    'NO-50': {
        code: 'NO-50',
        name: 'Trøndelag / Trööndelage (-)',
        parent: 'NO',
    },
    'NO-54': {
        code: 'NO-54',
        name: 'Troms og Finnmark / Romsa ja Finnmárku',
        parent: 'NO',
    },
    'NP-1': {
        code: 'NP-1',
        name: 'Madhyamanchal',
        parent: 'NP',
    },
    'NP-2': {
        code: 'NP-2',
        name: 'Madhya Pashchimanchal',
        parent: 'NP',
    },
    'NP-3': {
        code: 'NP-3',
        name: 'Pashchimanchal',
        parent: 'NP',
    },
    'NP-4': {
        code: 'NP-4',
        name: 'Purwanchal',
        parent: 'NP',
    },
    'NP-5': {
        code: 'NP-5',
        name: 'Sudur Pashchimanchal',
        parent: 'NP',
    },
    'NP-BA': {
        code: 'NP-BA',
        name: 'Bagmati',
        parent: 'NP-1',
    },
    'NP-BH': {
        code: 'NP-BH',
        name: 'Bheri',
        parent: 'NP-2',
    },
    'NP-DH': {
        code: 'NP-DH',
        name: 'Dhawalagiri',
        parent: 'NP-3',
    },
    'NP-GA': {
        code: 'NP-GA',
        name: 'Gandaki',
        parent: 'NP-3',
    },
    'NP-JA': {
        code: 'NP-JA',
        name: 'Janakpur',
        parent: 'NP-1',
    },
    'NP-KA': {
        code: 'NP-KA',
        name: 'Karnali',
        parent: 'NP-2',
    },
    'NP-KO': {
        code: 'NP-KO',
        name: 'Kosi(local variant is Koshi)',
        parent: 'NP-4',
    },
    'NP-LU': {
        code: 'NP-LU',
        name: 'Lumbini',
        parent: 'NP-3',
    },
    'NP-MA': {
        code: 'NP-MA',
        name: 'Mahakali',
        parent: 'NP-5',
    },
    'NP-ME': {
        code: 'NP-ME',
        name: 'Mechi',
        parent: 'NP-4',
    },
    'NP-NA': {
        code: 'NP-NA',
        name: 'Narayani',
        parent: 'NP-1',
    },
    'NP-P1': {
        code: 'NP-P1',
        name: 'Pradesh 1',
        parent: 'NP',
    },
    'NP-P2': {
        code: 'NP-P2',
        name: 'Pradesh 2',
        parent: 'NP',
    },
    'NP-P3': {
        code: 'NP-P3',
        name: 'Bāgmatī',
        parent: 'NP',
    },
    'NP-P4': {
        code: 'NP-P4',
        name: 'Gandaki',
        parent: 'NP',
    },
    'NP-P5': {
        code: 'NP-P5',
        name: 'Lumbini',
        parent: 'NP',
    },
    'NP-P6': {
        code: 'NP-P6',
        name: 'Karnali',
        parent: 'NP',
    },
    'NP-P7': {
        code: 'NP-P7',
        name: 'Sudūr Pashchim',
        parent: 'NP',
    },
    'NP-RA': {
        code: 'NP-RA',
        name: 'Rapti',
        parent: 'NP-2',
    },
    'NP-SA': {
        code: 'NP-SA',
        name: 'Sagarmatha',
        parent: 'NP-4',
    },
    'NP-SE': {
        code: 'NP-SE',
        name: 'Seti',
        parent: 'NP-5',
    },
    'NR-01': {
        code: 'NR-01',
        name: 'Aiwo',
        parent: 'NR',
    },
    'NR-02': {
        code: 'NR-02',
        name: 'Anabar',
        parent: 'NR',
    },
    'NR-03': {
        code: 'NR-03',
        name: 'Anetan',
        parent: 'NR',
    },
    'NR-04': {
        code: 'NR-04',
        name: 'Anibare',
        parent: 'NR',
    },
    'NR-05': {
        code: 'NR-05',
        name: 'Baitsi (local variant is Baiti)',
        parent: 'NR',
    },
    'NR-06': {
        code: 'NR-06',
        name: 'Boe',
        parent: 'NR',
    },
    'NR-07': {
        code: 'NR-07',
        name: 'Buada',
        parent: 'NR',
    },
    'NR-08': {
        code: 'NR-08',
        name: 'Denigomodu',
        parent: 'NR',
    },
    'NR-09': {
        code: 'NR-09',
        name: 'Ewa',
        parent: 'NR',
    },
    'NR-10': {
        code: 'NR-10',
        name: 'Ijuw',
        parent: 'NR',
    },
    'NR-11': {
        code: 'NR-11',
        name: 'Meneng',
        parent: 'NR',
    },
    'NR-12': {
        code: 'NR-12',
        name: 'Nibok',
        parent: 'NR',
    },
    'NR-13': {
        code: 'NR-13',
        name: 'Uaboe',
        parent: 'NR',
    },
    'NR-14': {
        code: 'NR-14',
        name: 'Yaren',
        parent: 'NR',
    },
    'NZ-AUK': {
        code: 'NZ-AUK',
        name: 'Auckland',
        parent: 'NZ',
    },
    'NZ-BOP': {
        code: 'NZ-BOP',
        name: 'Bay of Plenty',
        parent: 'NZ',
    },
    'NZ-CAN': {
        code: 'NZ-CAN',
        name: 'Canterbury',
        parent: 'NZ',
    },
    'NZ-CIT': {
        code: 'NZ-CIT',
        name: 'Chatham Islands Territory',
        parent: 'NZ',
    },
    'NZ-GIS': {
        code: 'NZ-GIS',
        name: 'Gisborne',
        parent: 'NZ',
    },
    'NZ-HKB': {
        code: 'NZ-HKB',
        name: "Hawke's Bay",
        parent: 'NZ',
    },
    'NZ-MBH': {
        code: 'NZ-MBH',
        name: 'Marlborough',
        parent: 'NZ',
    },
    'NZ-MWT': {
        code: 'NZ-MWT',
        name: 'Manawatu-Wanganui',
        parent: 'NZ',
    },
    'NZ-NSN': {
        code: 'NZ-NSN',
        name: 'Nelson',
        parent: 'NZ',
    },
    'NZ-NTL': {
        code: 'NZ-NTL',
        name: 'Northland',
        parent: 'NZ',
    },
    'NZ-OTA': {
        code: 'NZ-OTA',
        name: 'Otago',
        parent: 'NZ',
    },
    'NZ-STL': {
        code: 'NZ-STL',
        name: 'Southland',
        parent: 'NZ',
    },
    'NZ-TAS': {
        code: 'NZ-TAS',
        name: 'Tasman',
        parent: 'NZ',
    },
    'NZ-TKI': {
        code: 'NZ-TKI',
        name: 'Taranaki',
        parent: 'NZ',
    },
    'NZ-WGN': {
        code: 'NZ-WGN',
        name: 'Wellington',
        parent: 'NZ',
    },
    'NZ-WKO': {
        code: 'NZ-WKO',
        name: 'Waikato',
        parent: 'NZ',
    },
    'NZ-WTC': {
        code: 'NZ-WTC',
        name: 'West Coast',
        parent: 'NZ',
    },
    'OM-BJ': {
        code: 'OM-BJ',
        name: 'Janūb al Bāţinah',
        parent: 'OM',
    },
    'OM-BS': {
        code: 'OM-BS',
        name: 'Shamāl al Bāţinah',
        parent: 'OM',
    },
    'OM-BU': {
        code: 'OM-BU',
        name: 'Al Buraymī',
        parent: 'OM',
    },
    'OM-DA': {
        code: 'OM-DA',
        name: 'Ad Dākhilīyah',
        parent: 'OM',
    },
    'OM-MA': {
        code: 'OM-MA',
        name: 'Masqaţ',
        parent: 'OM',
    },
    'OM-MU': {
        code: 'OM-MU',
        name: 'Musandam',
        parent: 'OM',
    },
    'OM-SJ': {
        code: 'OM-SJ',
        name: 'Janūb ash Sharqīyah',
        parent: 'OM',
    },
    'OM-SS': {
        code: 'OM-SS',
        name: 'Shamāl ash Sharqīyah',
        parent: 'OM',
    },
    'OM-WU': {
        code: 'OM-WU',
        name: 'Al Wusţá',
        parent: 'OM',
    },
    'OM-ZA': {
        code: 'OM-ZA',
        name: 'Az̧ Z̧āhirah',
        parent: 'OM',
    },
    'OM-ZU': {
        code: 'OM-ZU',
        name: 'Z̧ufār',
        parent: 'OM',
    },
    'PA-1': {
        code: 'PA-1',
        name: 'Bocas del Toro',
        parent: 'PA',
    },
    'PA-10': {
        code: 'PA-10',
        name: 'Panamá Oeste',
        parent: 'PA',
    },
    'PA-2': {
        code: 'PA-2',
        name: 'Coclé',
        parent: 'PA',
    },
    'PA-3': {
        code: 'PA-3',
        name: 'Colón',
        parent: 'PA',
    },
    'PA-4': {
        code: 'PA-4',
        name: 'Chiriquí',
        parent: 'PA',
    },
    'PA-5': {
        code: 'PA-5',
        name: 'Darién',
        parent: 'PA',
    },
    'PA-6': {
        code: 'PA-6',
        name: 'Herrera',
        parent: 'PA',
    },
    'PA-7': {
        code: 'PA-7',
        name: 'Los Santos',
        parent: 'PA',
    },
    'PA-8': {
        code: 'PA-8',
        name: 'Panamá',
        parent: 'PA',
    },
    'PA-9': {
        code: 'PA-9',
        name: 'Veraguas',
        parent: 'PA',
    },
    'PA-EM': {
        code: 'PA-EM',
        name: 'Emberá',
        parent: 'PA',
    },
    'PA-KY': {
        code: 'PA-KY',
        name: 'Guna Yala(local variant is Kuna Yala)',
        parent: 'PA',
    },
    'PA-NB': {
        code: 'PA-NB',
        name: 'Ngöbe-Buglé',
        parent: 'PA',
    },
    'PE-AMA': {
        code: 'PE-AMA',
        name: 'Amazonas',
        parent: 'PE',
    },
    'PE-ANC': {
        code: 'PE-ANC',
        name: 'Ancash',
        parent: 'PE',
    },
    'PE-APU': {
        code: 'PE-APU',
        name: 'Apurímac',
        parent: 'PE',
    },
    'PE-ARE': {
        code: 'PE-ARE',
        name: 'Arequipa',
        parent: 'PE',
    },
    'PE-AYA': {
        code: 'PE-AYA',
        name: 'Ayacucho',
        parent: 'PE',
    },
    'PE-CAJ': {
        code: 'PE-CAJ',
        name: 'Cajamarca',
        parent: 'PE',
    },
    'PE-CAL': {
        code: 'PE-CAL',
        name: 'El Callao',
        parent: 'PE',
    },
    'PE-CUS': {
        code: 'PE-CUS',
        name: 'Cusco(local variant is Cuzco)',
        parent: 'PE',
    },
    'PE-HUC': {
        code: 'PE-HUC',
        name: 'Huánuco',
        parent: 'PE',
    },
    'PE-HUV': {
        code: 'PE-HUV',
        name: 'Huancavelica',
        parent: 'PE',
    },
    'PE-ICA': {
        code: 'PE-ICA',
        name: 'Ica',
        parent: 'PE',
    },
    'PE-JUN': {
        code: 'PE-JUN',
        name: 'Junín',
        parent: 'PE',
    },
    'PE-LAL': {
        code: 'PE-LAL',
        name: 'La Libertad',
        parent: 'PE',
    },
    'PE-LAM': {
        code: 'PE-LAM',
        name: 'Lambayeque',
        parent: 'PE',
    },
    'PE-LIM': {
        code: 'PE-LIM',
        name: 'Lima',
        parent: 'PE',
    },
    'PE-LMA': {
        code: 'PE-LMA',
        name: 'Municipalidad Metropolitana de Lima',
        parent: 'PE',
    },
    'PE-LOR': {
        code: 'PE-LOR',
        name: 'Loreto',
        parent: 'PE',
    },
    'PE-MDD': {
        code: 'PE-MDD',
        name: 'Madre de Dios',
        parent: 'PE',
    },
    'PE-MOQ': {
        code: 'PE-MOQ',
        name: 'Moquegua',
        parent: 'PE',
    },
    'PE-PAS': {
        code: 'PE-PAS',
        name: 'Pasco',
        parent: 'PE',
    },
    'PE-PIU': {
        code: 'PE-PIU',
        name: 'Piura',
        parent: 'PE',
    },
    'PE-PUN': {
        code: 'PE-PUN',
        name: 'Puno',
        parent: 'PE',
    },
    'PE-SAM': {
        code: 'PE-SAM',
        name: 'San Martín',
        parent: 'PE',
    },
    'PE-TAC': {
        code: 'PE-TAC',
        name: 'Tacna',
        parent: 'PE',
    },
    'PE-TUM': {
        code: 'PE-TUM',
        name: 'Tumbes',
        parent: 'PE',
    },
    'PE-UCA': {
        code: 'PE-UCA',
        name: 'Ucayali',
        parent: 'PE',
    },
    'PG-CPK': {
        code: 'PG-CPK',
        name: 'Chimbu',
        parent: 'PG',
    },
    'PG-CPM': {
        code: 'PG-CPM',
        name: 'Central',
        parent: 'PG',
    },
    'PG-EBR': {
        code: 'PG-EBR',
        name: 'East New Britain',
        parent: 'PG',
    },
    'PG-EHG': {
        code: 'PG-EHG',
        name: 'Eastern Highlands',
        parent: 'PG',
    },
    'PG-EPW': {
        code: 'PG-EPW',
        name: 'Enga',
        parent: 'PG',
    },
    'PG-ESW': {
        code: 'PG-ESW',
        name: 'East Sepik',
        parent: 'PG',
    },
    'PG-GPK': {
        code: 'PG-GPK',
        name: 'Gulf',
        parent: 'PG',
    },
    'PG-HLA': {
        code: 'PG-HLA',
        name: 'Hela',
        parent: 'PG',
    },
    'PG-JWK': {
        code: 'PG-JWK',
        name: 'Jiwaka',
        parent: 'PG',
    },
    'PG-MBA': {
        code: 'PG-MBA',
        name: 'Milne Bay',
        parent: 'PG',
    },
    'PG-MPL': {
        code: 'PG-MPL',
        name: 'Morobe',
        parent: 'PG',
    },
    'PG-MPM': {
        code: 'PG-MPM',
        name: 'Madang',
        parent: 'PG',
    },
    'PG-MRL': {
        code: 'PG-MRL',
        name: 'Manus',
        parent: 'PG',
    },
    'PG-NCD': {
        code: 'PG-NCD',
        name: 'National Capital District (Port Moresby)',
        parent: 'PG',
    },
    'PG-NIK': {
        code: 'PG-NIK',
        name: 'New Ireland',
        parent: 'PG',
    },
    'PG-NPP': {
        code: 'PG-NPP',
        name: 'Northern',
        parent: 'PG',
    },
    'PG-NSB': {
        code: 'PG-NSB',
        name: 'Bougainville',
        parent: 'PG',
    },
    'PG-SAN': {
        code: 'PG-SAN',
        name: 'West Sepik',
        parent: 'PG',
    },
    'PG-SHM': {
        code: 'PG-SHM',
        name: 'Southern Highlands',
        parent: 'PG',
    },
    'PG-WBK': {
        code: 'PG-WBK',
        name: 'West New Britain',
        parent: 'PG',
    },
    'PG-WHM': {
        code: 'PG-WHM',
        name: 'Western Highlands',
        parent: 'PG',
    },
    'PG-WPD': {
        code: 'PG-WPD',
        name: 'Western',
        parent: 'PG',
    },
    'PH-00': {
        code: 'PH-00',
        name: 'National Capital Region',
        parent: 'PH',
    },
    'PH-01': {
        code: 'PH-01',
        name: 'Ilocos',
        parent: 'PH',
    },
    'PH-02': {
        code: 'PH-02',
        name: 'Cagayan Valley',
        parent: 'PH',
    },
    'PH-03': {
        code: 'PH-03',
        name: 'Central Luzon',
        parent: 'PH',
    },
    'PH-05': {
        code: 'PH-05',
        name: 'Bicol',
        parent: 'PH',
    },
    'PH-06': {
        code: 'PH-06',
        name: 'Western Visayas',
        parent: 'PH',
    },
    'PH-07': {
        code: 'PH-07',
        name: 'Central Visayas',
        parent: 'PH',
    },
    'PH-08': {
        code: 'PH-08',
        name: 'Eastern Visayas',
        parent: 'PH',
    },
    'PH-09': {
        code: 'PH-09',
        name: 'Zamboanga Peninsula',
        parent: 'PH',
    },
    'PH-10': {
        code: 'PH-10',
        name: 'Northern Mindanao',
        parent: 'PH',
    },
    'PH-11': {
        code: 'PH-11',
        name: 'Davao',
        parent: 'PH',
    },
    'PH-12': {
        code: 'PH-12',
        name: 'Soccsksargen',
        parent: 'PH',
    },
    'PH-13': {
        code: 'PH-13',
        name: 'Caraga',
        parent: 'PH',
    },
    'PH-14': {
        code: 'PH-14',
        name: 'Autonomous Region in Muslim Mindanao',
        parent: 'PH',
    },
    'PH-15': {
        code: 'PH-15',
        name: 'Cordillera Administrative Region',
        parent: 'PH',
    },
    'PH-40': {
        code: 'PH-40',
        name: 'Calabarzon',
        parent: 'PH',
    },
    'PH-41': {
        code: 'PH-41',
        name: 'Mimaropa',
        parent: 'PH',
    },
    'PH-ABR': {
        code: 'PH-ABR',
        name: 'Abra',
        parent: 'PH-15',
    },
    'PH-AGN': {
        code: 'PH-AGN',
        name: 'Agusan del Norte',
        parent: 'PH-13',
    },
    'PH-AGS': {
        code: 'PH-AGS',
        name: 'Agusan del Sur',
        parent: 'PH-13',
    },
    'PH-AKL': {
        code: 'PH-AKL',
        name: 'Aklan',
        parent: 'PH-06',
    },
    'PH-ALB': {
        code: 'PH-ALB',
        name: 'Albay',
        parent: 'PH-05',
    },
    'PH-ANT': {
        code: 'PH-ANT',
        name: 'Antique',
        parent: 'PH-06',
    },
    'PH-APA': {
        code: 'PH-APA',
        name: 'Apayao',
        parent: 'PH-15',
    },
    'PH-AUR': {
        code: 'PH-AUR',
        name: 'Aurora',
        parent: 'PH-03',
    },
    'PH-BAN': {
        code: 'PH-BAN',
        name: 'Bataan',
        parent: 'PH-03',
    },
    'PH-BAS': {
        code: 'PH-BAS',
        name: 'Basilan',
        parent: 'PH-09',
    },
    'PH-BEN': {
        code: 'PH-BEN',
        name: 'Benguet',
        parent: 'PH-15',
    },
    'PH-BIL': {
        code: 'PH-BIL',
        name: 'Biliran',
        parent: 'PH-08',
    },
    'PH-BOH': {
        code: 'PH-BOH',
        name: 'Bohol',
        parent: 'PH-07',
    },
    'PH-BTG': {
        code: 'PH-BTG',
        name: 'Batangas',
        parent: 'PH-40',
    },
    'PH-BTN': {
        code: 'PH-BTN',
        name: 'Batanes',
        parent: 'PH-02',
    },
    'PH-BUK': {
        code: 'PH-BUK',
        name: 'Bukidnon',
        parent: 'PH-10',
    },
    'PH-BUL': {
        code: 'PH-BUL',
        name: 'Bulacan',
        parent: 'PH-03',
    },
    'PH-CAG': {
        code: 'PH-CAG',
        name: 'Cagayan',
        parent: 'PH-02',
    },
    'PH-CAM': {
        code: 'PH-CAM',
        name: 'Camiguin',
        parent: 'PH-10',
    },
    'PH-CAN': {
        code: 'PH-CAN',
        name: 'Camarines Norte',
        parent: 'PH-05',
    },
    'PH-CAP': {
        code: 'PH-CAP',
        name: 'Capiz',
        parent: 'PH-06',
    },
    'PH-CAS': {
        code: 'PH-CAS',
        name: 'Camarines Sur',
        parent: 'PH-05',
    },
    'PH-CAT': {
        code: 'PH-CAT',
        name: 'Catanduanes',
        parent: 'PH-05',
    },
    'PH-CAV': {
        code: 'PH-CAV',
        name: 'Cavite',
        parent: 'PH-40',
    },
    'PH-CEB': {
        code: 'PH-CEB',
        name: 'Cebu',
        parent: 'PH-07',
    },
    'PH-COM': {
        code: 'PH-COM',
        name: 'Davao de Oro',
        parent: 'PH-11',
    },
    'PH-DAO': {
        code: 'PH-DAO',
        name: 'Davao Oriental',
        parent: 'PH-11',
    },
    'PH-DAS': {
        code: 'PH-DAS',
        name: 'Davao del Sur',
        parent: 'PH-11',
    },
    'PH-DAV': {
        code: 'PH-DAV',
        name: 'Davao del Norte',
        parent: 'PH-11',
    },
    'PH-DIN': {
        code: 'PH-DIN',
        name: 'Dinagat Islands',
        parent: 'PH-13',
    },
    'PH-DVO': {
        code: 'PH-DVO',
        name: 'Davao Occidental',
        parent: 'PH-11',
    },
    'PH-EAS': {
        code: 'PH-EAS',
        name: 'Eastern Samar',
        parent: 'PH-08',
    },
    'PH-GUI': {
        code: 'PH-GUI',
        name: 'Guimaras',
        parent: 'PH-06',
    },
    'PH-IFU': {
        code: 'PH-IFU',
        name: 'Ifugao',
        parent: 'PH-15',
    },
    'PH-ILI': {
        code: 'PH-ILI',
        name: 'Iloilo',
        parent: 'PH-06',
    },
    'PH-ILN': {
        code: 'PH-ILN',
        name: 'Ilocos Norte',
        parent: 'PH-01',
    },
    'PH-ILS': {
        code: 'PH-ILS',
        name: 'Ilocos Sur',
        parent: 'PH-01',
    },
    'PH-ISA': {
        code: 'PH-ISA',
        name: 'Isabela',
        parent: 'PH-02',
    },
    'PH-KAL': {
        code: 'PH-KAL',
        name: 'Kalinga',
        parent: 'PH-15',
    },
    'PH-LAG': {
        code: 'PH-LAG',
        name: 'Laguna',
        parent: 'PH-40',
    },
    'PH-LAN': {
        code: 'PH-LAN',
        name: 'Lanao del Norte',
        parent: 'PH-12',
    },
    'PH-LAS': {
        code: 'PH-LAS',
        name: 'Lanao del Sur',
        parent: 'PH-14',
    },
    'PH-LEY': {
        code: 'PH-LEY',
        name: 'Leyte',
        parent: 'PH-08',
    },
    'PH-LUN': {
        code: 'PH-LUN',
        name: 'La Union',
        parent: 'PH-01',
    },
    'PH-MAD': {
        code: 'PH-MAD',
        name: 'Marinduque',
        parent: 'PH-41',
    },
    'PH-MAG': {
        code: 'PH-MAG',
        name: 'Maguindanao',
        parent: 'PH-14',
    },
    'PH-MAS': {
        code: 'PH-MAS',
        name: 'Masbate',
        parent: 'PH-05',
    },
    'PH-MDC': {
        code: 'PH-MDC',
        name: 'Mindoro Occidental',
        parent: 'PH-41',
    },
    'PH-MDR': {
        code: 'PH-MDR',
        name: 'Mindoro Oriental',
        parent: 'PH-41',
    },
    'PH-MOU': {
        code: 'PH-MOU',
        name: 'Mountain Province',
        parent: 'PH-15',
    },
    'PH-MSC': {
        code: 'PH-MSC',
        name: 'Misamis Occidental',
        parent: 'PH-10',
    },
    'PH-MSR': {
        code: 'PH-MSR',
        name: 'Misamis Oriental',
        parent: 'PH-10',
    },
    'PH-NCO': {
        code: 'PH-NCO',
        name: 'Cotabato',
        parent: 'PH-12',
    },
    'PH-NEC': {
        code: 'PH-NEC',
        name: 'Negros Occidental',
        parent: 'PH-06',
    },
    'PH-NER': {
        code: 'PH-NER',
        name: 'Negros Oriental',
        parent: 'PH-07',
    },
    'PH-NSA': {
        code: 'PH-NSA',
        name: 'Northern Samar',
        parent: 'PH-08',
    },
    'PH-NUE': {
        code: 'PH-NUE',
        name: 'Nueva Ecija',
        parent: 'PH-03',
    },
    'PH-NUV': {
        code: 'PH-NUV',
        name: 'Nueva Vizcaya',
        parent: 'PH-02',
    },
    'PH-PAM': {
        code: 'PH-PAM',
        name: 'Pampanga',
        parent: 'PH-03',
    },
    'PH-PAN': {
        code: 'PH-PAN',
        name: 'Pangasinan',
        parent: 'PH-01',
    },
    'PH-PLW': {
        code: 'PH-PLW',
        name: 'Palawan',
        parent: 'PH-41',
    },
    'PH-QUE': {
        code: 'PH-QUE',
        name: 'Quezon',
        parent: 'PH-40',
    },
    'PH-QUI': {
        code: 'PH-QUI',
        name: 'Quirino',
        parent: 'PH-02',
    },
    'PH-RIZ': {
        code: 'PH-RIZ',
        name: 'Rizal',
        parent: 'PH-40',
    },
    'PH-ROM': {
        code: 'PH-ROM',
        name: 'Romblon',
        parent: 'PH-41',
    },
    'PH-SAR': {
        code: 'PH-SAR',
        name: 'Sarangani',
        parent: 'PH-11',
    },
    'PH-SCO': {
        code: 'PH-SCO',
        name: 'South Cotabato',
        parent: 'PH-11',
    },
    'PH-SIG': {
        code: 'PH-SIG',
        name: 'Siquijor',
        parent: 'PH-07',
    },
    'PH-SLE': {
        code: 'PH-SLE',
        name: 'Southern Leyte',
        parent: 'PH-08',
    },
    'PH-SLU': {
        code: 'PH-SLU',
        name: 'Sulu',
        parent: 'PH-14',
    },
    'PH-SOR': {
        code: 'PH-SOR',
        name: 'Sorsogon',
        parent: 'PH-05',
    },
    'PH-SUK': {
        code: 'PH-SUK',
        name: 'Sultan Kudarat',
        parent: 'PH-12',
    },
    'PH-SUN': {
        code: 'PH-SUN',
        name: 'Surigao del Norte',
        parent: 'PH-13',
    },
    'PH-SUR': {
        code: 'PH-SUR',
        name: 'Surigao del Sur',
        parent: 'PH-13',
    },
    'PH-TAR': {
        code: 'PH-TAR',
        name: 'Tarlac',
        parent: 'PH-03',
    },
    'PH-TAW': {
        code: 'PH-TAW',
        name: 'Tawi-Tawi',
        parent: 'PH-14',
    },
    'PH-WSA': {
        code: 'PH-WSA',
        name: 'Samar (Western Samar)',
        parent: 'PH-08',
    },
    'PH-ZAN': {
        code: 'PH-ZAN',
        name: 'Zamboanga del Norte',
        parent: 'PH-09',
    },
    'PH-ZAS': {
        code: 'PH-ZAS',
        name: 'Zamboanga del Sur',
        parent: 'PH-09',
    },
    'PH-ZMB': {
        code: 'PH-ZMB',
        name: 'Zambales',
        parent: 'PH-03',
    },
    'PH-ZSI': {
        code: 'PH-ZSI',
        name: 'Zamboanga Sibugay',
        parent: 'PH-09',
    },
    'PK-BA': {
        code: 'PK-BA',
        name: 'Balochistan',
        parent: 'PK',
    },
    'PK-GB': {
        code: 'PK-GB',
        name: 'Gilgit-Baltistan',
        parent: 'PK',
    },
    'PK-IS': {
        code: 'PK-IS',
        name: 'Islamabad',
        parent: 'PK',
    },
    'PK-JK': {
        code: 'PK-JK',
        name: 'Azad Jammu and Kashmir(local variant is AJ&K)',
        parent: 'PK',
    },
    'PK-KP': {
        code: 'PK-KP',
        name: 'Khyber Pakhtunkhwa',
        parent: 'PK',
    },
    'PK-PB': {
        code: 'PK-PB',
        name: 'Punjab',
        parent: 'PK',
    },
    'PK-SD': {
        code: 'PK-SD',
        name: 'Sindh',
        parent: 'PK',
    },
    'PK-TA': {
        code: 'PK-TA',
        name: 'Federally Administered Tribal Areas',
        parent: 'PK',
    },
    'PL-02': {
        code: 'PL-02',
        name: 'Dolnośląskie',
        parent: 'PL',
    },
    'PL-04': {
        code: 'PL-04',
        name: 'Kujawsko-pomorskie',
        parent: 'PL',
    },
    'PL-06': {
        code: 'PL-06',
        name: 'Lubelskie',
        parent: 'PL',
    },
    'PL-08': {
        code: 'PL-08',
        name: 'Lubuskie',
        parent: 'PL',
    },
    'PL-10': {
        code: 'PL-10',
        name: 'Łódzkie',
        parent: 'PL',
    },
    'PL-12': {
        code: 'PL-12',
        name: 'Małopolskie',
        parent: 'PL',
    },
    'PL-14': {
        code: 'PL-14',
        name: 'Mazowieckie',
        parent: 'PL',
    },
    'PL-16': {
        code: 'PL-16',
        name: 'Opolskie',
        parent: 'PL',
    },
    'PL-18': {
        code: 'PL-18',
        name: 'Podkarpackie',
        parent: 'PL',
    },
    'PL-20': {
        code: 'PL-20',
        name: 'Podlaskie',
        parent: 'PL',
    },
    'PL-22': {
        code: 'PL-22',
        name: 'Pomorskie',
        parent: 'PL',
    },
    'PL-24': {
        code: 'PL-24',
        name: 'Śląskie',
        parent: 'PL',
    },
    'PL-26': {
        code: 'PL-26',
        name: 'Świętokrzyskie',
        parent: 'PL',
    },
    'PL-28': {
        code: 'PL-28',
        name: 'Warmińsko-mazurskie',
        parent: 'PL',
    },
    'PL-30': {
        code: 'PL-30',
        name: 'Wielkopolskie',
        parent: 'PL',
    },
    'PL-32': {
        code: 'PL-32',
        name: 'Zachodniopomorskie',
        parent: 'PL',
    },
    'PS-BTH': {
        code: 'PS-BTH',
        name: 'Bethlehem',
        parent: 'PS',
    },
    'PS-DEB': {
        code: 'PS-DEB',
        name: 'Deir El Balah',
        parent: 'PS',
    },
    'PS-GZA': {
        code: 'PS-GZA',
        name: 'Gaza',
        parent: 'PS',
    },
    'PS-HBN': {
        code: 'PS-HBN',
        name: 'Hebron',
        parent: 'PS',
    },
    'PS-JEM': {
        code: 'PS-JEM',
        name: 'Jerusalem',
        parent: 'PS',
    },
    'PS-JEN': {
        code: 'PS-JEN',
        name: 'Jenin',
        parent: 'PS',
    },
    'PS-JRH': {
        code: 'PS-JRH',
        name: 'Jericho and Al Aghwar',
        parent: 'PS',
    },
    'PS-KYS': {
        code: 'PS-KYS',
        name: 'Khan Yunis',
        parent: 'PS',
    },
    'PS-NBS': {
        code: 'PS-NBS',
        name: 'Nablus',
        parent: 'PS',
    },
    'PS-NGZ': {
        code: 'PS-NGZ',
        name: 'North Gaza',
        parent: 'PS',
    },
    'PS-QQA': {
        code: 'PS-QQA',
        name: 'Qalqilya',
        parent: 'PS',
    },
    'PS-RBH': {
        code: 'PS-RBH',
        name: 'Ramallah',
        parent: 'PS',
    },
    'PS-RFH': {
        code: 'PS-RFH',
        name: 'Rafah',
        parent: 'PS',
    },
    'PS-SLT': {
        code: 'PS-SLT',
        name: 'Salfit',
        parent: 'PS',
    },
    'PS-TBS': {
        code: 'PS-TBS',
        name: 'Tubas',
        parent: 'PS',
    },
    'PS-TKM': {
        code: 'PS-TKM',
        name: 'Tulkarm',
        parent: 'PS',
    },
    'PT-01': {
        code: 'PT-01',
        name: 'Aveiro',
        parent: 'PT',
    },
    'PT-02': {
        code: 'PT-02',
        name: 'Beja',
        parent: 'PT',
    },
    'PT-03': {
        code: 'PT-03',
        name: 'Braga',
        parent: 'PT',
    },
    'PT-04': {
        code: 'PT-04',
        name: 'Bragança',
        parent: 'PT',
    },
    'PT-05': {
        code: 'PT-05',
        name: 'Castelo Branco',
        parent: 'PT',
    },
    'PT-06': {
        code: 'PT-06',
        name: 'Coimbra',
        parent: 'PT',
    },
    'PT-07': {
        code: 'PT-07',
        name: 'Évora',
        parent: 'PT',
    },
    'PT-08': {
        code: 'PT-08',
        name: 'Faro',
        parent: 'PT',
    },
    'PT-09': {
        code: 'PT-09',
        name: 'Guarda',
        parent: 'PT',
    },
    'PT-10': {
        code: 'PT-10',
        name: 'Leiria',
        parent: 'PT',
    },
    'PT-11': {
        code: 'PT-11',
        name: 'Lisboa',
        parent: 'PT',
    },
    'PT-12': {
        code: 'PT-12',
        name: 'Portalegre',
        parent: 'PT',
    },
    'PT-13': {
        code: 'PT-13',
        name: 'Porto',
        parent: 'PT',
    },
    'PT-14': {
        code: 'PT-14',
        name: 'Santarém',
        parent: 'PT',
    },
    'PT-15': {
        code: 'PT-15',
        name: 'Setúbal',
        parent: 'PT',
    },
    'PT-16': {
        code: 'PT-16',
        name: 'Viana do Castelo',
        parent: 'PT',
    },
    'PT-17': {
        code: 'PT-17',
        name: 'Vila Real',
        parent: 'PT',
    },
    'PT-18': {
        code: 'PT-18',
        name: 'Viseu',
        parent: 'PT',
    },
    'PT-20': {
        code: 'PT-20',
        name: 'Região Autónoma dos Açores',
        parent: 'PT',
    },
    'PT-30': {
        code: 'PT-30',
        name: 'Região Autónoma da Madeira',
        parent: 'PT',
    },
    'PW-002': {
        code: 'PW-002',
        name: 'Aimeliik',
        parent: 'PW',
    },
    'PW-004': {
        code: 'PW-004',
        name: 'Airai',
        parent: 'PW',
    },
    'PW-010': {
        code: 'PW-010',
        name: 'Angaur',
        parent: 'PW',
    },
    'PW-050': {
        code: 'PW-050',
        name: 'Hatohobei',
        parent: 'PW',
    },
    'PW-100': {
        code: 'PW-100',
        name: 'Kayangel',
        parent: 'PW',
    },
    'PW-150': {
        code: 'PW-150',
        name: 'Koror',
        parent: 'PW',
    },
    'PW-212': {
        code: 'PW-212',
        name: 'Melekeok',
        parent: 'PW',
    },
    'PW-214': {
        code: 'PW-214',
        name: 'Ngaraard',
        parent: 'PW',
    },
    'PW-218': {
        code: 'PW-218',
        name: 'Ngarchelong',
        parent: 'PW',
    },
    'PW-222': {
        code: 'PW-222',
        name: 'Ngardmau',
        parent: 'PW',
    },
    'PW-224': {
        code: 'PW-224',
        name: 'Ngatpang',
        parent: 'PW',
    },
    'PW-226': {
        code: 'PW-226',
        name: 'Ngchesar',
        parent: 'PW',
    },
    'PW-227': {
        code: 'PW-227',
        name: 'Ngeremlengui',
        parent: 'PW',
    },
    'PW-228': {
        code: 'PW-228',
        name: 'Ngiwal',
        parent: 'PW',
    },
    'PW-350': {
        code: 'PW-350',
        name: 'Peleliu',
        parent: 'PW',
    },
    'PW-370': {
        code: 'PW-370',
        name: 'Sonsorol',
        parent: 'PW',
    },
    'PY-1': {
        code: 'PY-1',
        name: 'Concepción',
        parent: 'PY',
    },
    'PY-10': {
        code: 'PY-10',
        name: 'Alto Paraná',
        parent: 'PY',
    },
    'PY-11': {
        code: 'PY-11',
        name: 'Central',
        parent: 'PY',
    },
    'PY-12': {
        code: 'PY-12',
        name: 'Ñeembucú',
        parent: 'PY',
    },
    'PY-13': {
        code: 'PY-13',
        name: 'Amambay',
        parent: 'PY',
    },
    'PY-14': {
        code: 'PY-14',
        name: 'Canindeyú',
        parent: 'PY',
    },
    'PY-15': {
        code: 'PY-15',
        name: 'Presidente Hayes',
        parent: 'PY',
    },
    'PY-16': {
        code: 'PY-16',
        name: 'Alto Paraguay',
        parent: 'PY',
    },
    'PY-19': {
        code: 'PY-19',
        name: 'Boquerón',
        parent: 'PY',
    },
    'PY-2': {
        code: 'PY-2',
        name: 'San Pedro',
        parent: 'PY',
    },
    'PY-3': {
        code: 'PY-3',
        name: 'Cordillera',
        parent: 'PY',
    },
    'PY-4': {
        code: 'PY-4',
        name: 'Guairá',
        parent: 'PY',
    },
    'PY-5': {
        code: 'PY-5',
        name: 'Caaguazú',
        parent: 'PY',
    },
    'PY-6': {
        code: 'PY-6',
        name: 'Caazapá',
        parent: 'PY',
    },
    'PY-7': {
        code: 'PY-7',
        name: 'Itapúa',
        parent: 'PY',
    },
    'PY-8': {
        code: 'PY-8',
        name: 'Misiones',
        parent: 'PY',
    },
    'PY-9': {
        code: 'PY-9',
        name: 'Paraguarí',
        parent: 'PY',
    },
    'PY-ASU': {
        code: 'PY-ASU',
        name: 'Asunción',
        parent: 'PY',
    },
    'QA-DA': {
        code: 'QA-DA',
        name: 'Ad Dawḩah',
        parent: 'QA',
    },
    'QA-KH': {
        code: 'QA-KH',
        name: 'Al Khawr wa adh Dhakhīrah',
        parent: 'QA',
    },
    'QA-MS': {
        code: 'QA-MS',
        name: 'Ash Shamāl',
        parent: 'QA',
    },
    'QA-RA': {
        code: 'QA-RA',
        name: 'Ar Rayyān',
        parent: 'QA',
    },
    'QA-SH': {
        code: 'QA-SH',
        name: 'Ash Shīḩānīyah',
        parent: 'QA',
    },
    'QA-US': {
        code: 'QA-US',
        name: 'Umm Şalāl',
        parent: 'QA',
    },
    'QA-WA': {
        code: 'QA-WA',
        name: 'Al Wakrah',
        parent: 'QA',
    },
    'QA-ZA': {
        code: 'QA-ZA',
        name: 'Az̧ Z̧a‘āyin',
        parent: 'QA',
    },
    'RO-AB': {
        code: 'RO-AB',
        name: 'Alba',
        parent: 'RO',
    },
    'RO-AG': {
        code: 'RO-AG',
        name: 'Argeș',
        parent: 'RO',
    },
    'RO-AR': {
        code: 'RO-AR',
        name: 'Arad',
        parent: 'RO',
    },
    'RO-B': {
        code: 'RO-B',
        name: 'București',
        parent: 'RO',
    },
    'RO-BC': {
        code: 'RO-BC',
        name: 'Bacău',
        parent: 'RO',
    },
    'RO-BH': {
        code: 'RO-BH',
        name: 'Bihor',
        parent: 'RO',
    },
    'RO-BN': {
        code: 'RO-BN',
        name: 'Bistrița-Năsăud',
        parent: 'RO',
    },
    'RO-BR': {
        code: 'RO-BR',
        name: 'Brăila',
        parent: 'RO',
    },
    'RO-BT': {
        code: 'RO-BT',
        name: 'Botoșani',
        parent: 'RO',
    },
    'RO-BV': {
        code: 'RO-BV',
        name: 'Brașov',
        parent: 'RO',
    },
    'RO-BZ': {
        code: 'RO-BZ',
        name: 'Buzău',
        parent: 'RO',
    },
    'RO-CJ': {
        code: 'RO-CJ',
        name: 'Cluj',
        parent: 'RO',
    },
    'RO-CL': {
        code: 'RO-CL',
        name: 'Călărași',
        parent: 'RO',
    },
    'RO-CS': {
        code: 'RO-CS',
        name: 'Caraș-Severin',
        parent: 'RO',
    },
    'RO-CT': {
        code: 'RO-CT',
        name: 'Constanța',
        parent: 'RO',
    },
    'RO-CV': {
        code: 'RO-CV',
        name: 'Covasna',
        parent: 'RO',
    },
    'RO-DB': {
        code: 'RO-DB',
        name: 'Dâmbovița',
        parent: 'RO',
    },
    'RO-DJ': {
        code: 'RO-DJ',
        name: 'Dolj',
        parent: 'RO',
    },
    'RO-GJ': {
        code: 'RO-GJ',
        name: 'Gorj',
        parent: 'RO',
    },
    'RO-GL': {
        code: 'RO-GL',
        name: 'Galați',
        parent: 'RO',
    },
    'RO-GR': {
        code: 'RO-GR',
        name: 'Giurgiu',
        parent: 'RO',
    },
    'RO-HD': {
        code: 'RO-HD',
        name: 'Hunedoara',
        parent: 'RO',
    },
    'RO-HR': {
        code: 'RO-HR',
        name: 'Harghita',
        parent: 'RO',
    },
    'RO-IF': {
        code: 'RO-IF',
        name: 'Ilfov',
        parent: 'RO',
    },
    'RO-IL': {
        code: 'RO-IL',
        name: 'Ialomița',
        parent: 'RO',
    },
    'RO-IS': {
        code: 'RO-IS',
        name: 'Iași',
        parent: 'RO',
    },
    'RO-MH': {
        code: 'RO-MH',
        name: 'Mehedinți',
        parent: 'RO',
    },
    'RO-MM': {
        code: 'RO-MM',
        name: 'Maramureș',
        parent: 'RO',
    },
    'RO-MS': {
        code: 'RO-MS',
        name: 'Mureș',
        parent: 'RO',
    },
    'RO-NT': {
        code: 'RO-NT',
        name: 'Neamț',
        parent: 'RO',
    },
    'RO-OT': {
        code: 'RO-OT',
        name: 'Olt',
        parent: 'RO',
    },
    'RO-PH': {
        code: 'RO-PH',
        name: 'Prahova',
        parent: 'RO',
    },
    'RO-SB': {
        code: 'RO-SB',
        name: 'Sibiu',
        parent: 'RO',
    },
    'RO-SJ': {
        code: 'RO-SJ',
        name: 'Sălaj',
        parent: 'RO',
    },
    'RO-SM': {
        code: 'RO-SM',
        name: 'Satu Mare',
        parent: 'RO',
    },
    'RO-SV': {
        code: 'RO-SV',
        name: 'Suceava',
        parent: 'RO',
    },
    'RO-TL': {
        code: 'RO-TL',
        name: 'Tulcea',
        parent: 'RO',
    },
    'RO-TM': {
        code: 'RO-TM',
        name: 'Timiș',
        parent: 'RO',
    },
    'RO-TR': {
        code: 'RO-TR',
        name: 'Teleorman',
        parent: 'RO',
    },
    'RO-VL': {
        code: 'RO-VL',
        name: 'Vâlcea',
        parent: 'RO',
    },
    'RO-VN': {
        code: 'RO-VN',
        name: 'Vrancea',
        parent: 'RO',
    },
    'RO-VS': {
        code: 'RO-VS',
        name: 'Vaslui',
        parent: 'RO',
    },
    'RS-00': {
        code: 'RS-00',
        name: 'Beograd',
        parent: 'RS',
    },
    'RS-01': {
        code: 'RS-01',
        name: 'Severnobački okrug',
        parent: 'RS-VO',
    },
    'RS-02': {
        code: 'RS-02',
        name: 'Srednjebanatski okrug',
        parent: 'RS-VO',
    },
    'RS-03': {
        code: 'RS-03',
        name: 'Severnobanatski okrug',
        parent: 'RS-VO',
    },
    'RS-04': {
        code: 'RS-04',
        name: 'Južnobanatski okrug',
        parent: 'RS-VO',
    },
    'RS-05': {
        code: 'RS-05',
        name: 'Zapadnobački okrug',
        parent: 'RS-VO',
    },
    'RS-06': {
        code: 'RS-06',
        name: 'Južnobački okrug',
        parent: 'RS-VO',
    },
    'RS-07': {
        code: 'RS-07',
        name: 'Sremski okrug',
        parent: 'RS-VO',
    },
    'RS-08': {
        code: 'RS-08',
        name: 'Mačvanski okrug',
        parent: 'RS',
    },
    'RS-09': {
        code: 'RS-09',
        name: 'Kolubarski okrug',
        parent: 'RS',
    },
    'RS-10': {
        code: 'RS-10',
        name: 'Podunavski okrug',
        parent: 'RS',
    },
    'RS-11': {
        code: 'RS-11',
        name: 'Braničevski okrug',
        parent: 'RS',
    },
    'RS-12': {
        code: 'RS-12',
        name: 'Šumadijski okrug',
        parent: 'RS',
    },
    'RS-13': {
        code: 'RS-13',
        name: 'Pomoravski okrug',
        parent: 'RS',
    },
    'RS-14': {
        code: 'RS-14',
        name: 'Borski okrug',
        parent: 'RS',
    },
    'RS-15': {
        code: 'RS-15',
        name: 'Zaječarski okrug',
        parent: 'RS',
    },
    'RS-16': {
        code: 'RS-16',
        name: 'Zlatiborski okrug',
        parent: 'RS',
    },
    'RS-17': {
        code: 'RS-17',
        name: 'Moravički okrug',
        parent: 'RS',
    },
    'RS-18': {
        code: 'RS-18',
        name: 'Raški okrug',
        parent: 'RS',
    },
    'RS-19': {
        code: 'RS-19',
        name: 'Rasinski okrug',
        parent: 'RS',
    },
    'RS-20': {
        code: 'RS-20',
        name: 'Nišavski okrug',
        parent: 'RS',
    },
    'RS-21': {
        code: 'RS-21',
        name: 'Toplički okrug',
        parent: 'RS',
    },
    'RS-22': {
        code: 'RS-22',
        name: 'Pirotski okrug',
        parent: 'RS',
    },
    'RS-23': {
        code: 'RS-23',
        name: 'Jablanički okrug',
        parent: 'RS',
    },
    'RS-24': {
        code: 'RS-24',
        name: 'Pčinjski okrug',
        parent: 'RS',
    },
    'RS-25': {
        code: 'RS-25',
        name: 'Kosovski okrug',
        parent: 'RS-KM',
    },
    'RS-26': {
        code: 'RS-26',
        name: 'Pećki okrug',
        parent: 'RS-KM',
    },
    'RS-27': {
        code: 'RS-27',
        name: 'Prizrenski okrug',
        parent: 'RS-KM',
    },
    'RS-28': {
        code: 'RS-28',
        name: 'Kosovsko-Mitrovački okrug',
        parent: 'RS-KM',
    },
    'RS-29': {
        code: 'RS-29',
        name: 'Kosovsko-Pomoravski okrug',
        parent: 'RS-KM',
    },
    'RS-KM': {
        code: 'RS-KM',
        name: 'Kosovo-Metohija',
        parent: 'RS',
    },
    'RS-VO': {
        code: 'RS-VO',
        name: 'Vojvodina',
        parent: 'RS',
    },
    'RU-AD': {
        code: 'RU-AD',
        name: 'Adygeya, Respublika',
        parent: 'RU',
    },
    'RU-AL': {
        code: 'RU-AL',
        name: 'Altay, Respublika',
        parent: 'RU',
    },
    'RU-ALT': {
        code: 'RU-ALT',
        name: 'Altayskiy kray',
        parent: 'RU',
    },
    'RU-AMU': {
        code: 'RU-AMU',
        name: "Amurskaya oblast'",
        parent: 'RU',
    },
    'RU-ARK': {
        code: 'RU-ARK',
        name: "Arkhangel'skaya oblast'",
        parent: 'RU',
    },
    'RU-AST': {
        code: 'RU-AST',
        name: "Astrakhanskaya oblast'",
        parent: 'RU',
    },
    'RU-BA': {
        code: 'RU-BA',
        name: 'Bashkortostan, Respublika',
        parent: 'RU',
    },
    'RU-BEL': {
        code: 'RU-BEL',
        name: "Belgorodskaya oblast'",
        parent: 'RU',
    },
    'RU-BRY': {
        code: 'RU-BRY',
        name: "Bryanskaya oblast'",
        parent: 'RU',
    },
    'RU-BU': {
        code: 'RU-BU',
        name: 'Buryatiya, Respublika',
        parent: 'RU',
    },
    'RU-CE': {
        code: 'RU-CE',
        name: 'Chechenskaya Respublika',
        parent: 'RU',
    },
    'RU-CHE': {
        code: 'RU-CHE',
        name: "Chelyabinskaya oblast'",
        parent: 'RU',
    },
    'RU-CHU': {
        code: 'RU-CHU',
        name: 'Chukotskiy avtonomnyy okrug',
        parent: 'RU',
    },
    'RU-CU': {
        code: 'RU-CU',
        name: 'Chuvashskaya Respublika',
        parent: 'RU',
    },
    'RU-DA': {
        code: 'RU-DA',
        name: 'Dagestan, Respublika',
        parent: 'RU',
    },
    'RU-IN': {
        code: 'RU-IN',
        name: 'Ingushetiya, Respublika',
        parent: 'RU',
    },
    'RU-IRK': {
        code: 'RU-IRK',
        name: "Irkutskaya oblast'",
        parent: 'RU',
    },
    'RU-IVA': {
        code: 'RU-IVA',
        name: "Ivanovskaya oblast'",
        parent: 'RU',
    },
    'RU-KAM': {
        code: 'RU-KAM',
        name: 'Kamchatskiy kray',
        parent: 'RU',
    },
    'RU-KB': {
        code: 'RU-KB',
        name: 'Kabardino-Balkarskaya Respublika',
        parent: 'RU',
    },
    'RU-KC': {
        code: 'RU-KC',
        name: 'Karachayevo-Cherkesskaya Respublika',
        parent: 'RU',
    },
    'RU-KDA': {
        code: 'RU-KDA',
        name: 'Krasnodarskiy kray',
        parent: 'RU',
    },
    'RU-KEM': {
        code: 'RU-KEM',
        name: "Kemerovskaya oblast'",
        parent: 'RU',
    },
    'RU-KGD': {
        code: 'RU-KGD',
        name: "Kaliningradskaya oblast'",
        parent: 'RU',
    },
    'RU-KGN': {
        code: 'RU-KGN',
        name: "Kurganskaya oblast'",
        parent: 'RU',
    },
    'RU-KHA': {
        code: 'RU-KHA',
        name: 'Khabarovskiy kray',
        parent: 'RU',
    },
    'RU-KHM': {
        code: 'RU-KHM',
        name: 'Khanty-Mansiyskiy avtonomnyy okrug(local variant is Yugra)',
        parent: 'RU',
    },
    'RU-KIR': {
        code: 'RU-KIR',
        name: "Kirovskaya oblast'",
        parent: 'RU',
    },
    'RU-KK': {
        code: 'RU-KK',
        name: 'Khakasiya, Respublika',
        parent: 'RU',
    },
    'RU-KL': {
        code: 'RU-KL',
        name: 'Kalmykiya, Respublika',
        parent: 'RU',
    },
    'RU-KLU': {
        code: 'RU-KLU',
        name: "Kaluzhskaya oblast'",
        parent: 'RU',
    },
    'RU-KO': {
        code: 'RU-KO',
        name: 'Komi, Respublika',
        parent: 'RU',
    },
    'RU-KOS': {
        code: 'RU-KOS',
        name: "Kostromskaya oblast'",
        parent: 'RU',
    },
    'RU-KR': {
        code: 'RU-KR',
        name: 'Kareliya, Respublika',
        parent: 'RU',
    },
    'RU-KRS': {
        code: 'RU-KRS',
        name: "Kurskaya oblast'",
        parent: 'RU',
    },
    'RU-KYA': {
        code: 'RU-KYA',
        name: 'Krasnoyarskiy kray',
        parent: 'RU',
    },
    'RU-LEN': {
        code: 'RU-LEN',
        name: "Leningradskaya oblast'",
        parent: 'RU',
    },
    'RU-LIP': {
        code: 'RU-LIP',
        name: "Lipetskaya oblast'",
        parent: 'RU',
    },
    'RU-MAG': {
        code: 'RU-MAG',
        name: "Magadanskaya oblast'",
        parent: 'RU',
    },
    'RU-ME': {
        code: 'RU-ME',
        name: 'Mariy El, Respublika',
        parent: 'RU',
    },
    'RU-MO': {
        code: 'RU-MO',
        name: 'Mordoviya, Respublika',
        parent: 'RU',
    },
    'RU-MOS': {
        code: 'RU-MOS',
        name: "Moskovskaya oblast'",
        parent: 'RU',
    },
    'RU-MOW': {
        code: 'RU-MOW',
        name: 'Moskva',
        parent: 'RU',
    },
    'RU-MUR': {
        code: 'RU-MUR',
        name: "Murmanskaya oblast'",
        parent: 'RU',
    },
    'RU-NEN': {
        code: 'RU-NEN',
        name: 'Nenetskiy avtonomnyy okrug',
        parent: 'RU',
    },
    'RU-NGR': {
        code: 'RU-NGR',
        name: "Novgorodskaya oblast'",
        parent: 'RU',
    },
    'RU-NIZ': {
        code: 'RU-NIZ',
        name: "Nizhegorodskaya oblast'",
        parent: 'RU',
    },
    'RU-NVS': {
        code: 'RU-NVS',
        name: "Novosibirskaya oblast'",
        parent: 'RU',
    },
    'RU-OMS': {
        code: 'RU-OMS',
        name: "Omskaya oblast'",
        parent: 'RU',
    },
    'RU-ORE': {
        code: 'RU-ORE',
        name: "Orenburgskaya oblast'",
        parent: 'RU',
    },
    'RU-ORL': {
        code: 'RU-ORL',
        name: "Orlovskaya oblast'",
        parent: 'RU',
    },
    'RU-PER': {
        code: 'RU-PER',
        name: 'Permskiy kray',
        parent: 'RU',
    },
    'RU-PNZ': {
        code: 'RU-PNZ',
        name: "Penzenskaya oblast'",
        parent: 'RU',
    },
    'RU-PRI': {
        code: 'RU-PRI',
        name: 'Primorskiy kray',
        parent: 'RU',
    },
    'RU-PSK': {
        code: 'RU-PSK',
        name: "Pskovskaya oblast'",
        parent: 'RU',
    },
    'RU-ROS': {
        code: 'RU-ROS',
        name: "Rostovskaya oblast'",
        parent: 'RU',
    },
    'RU-RYA': {
        code: 'RU-RYA',
        name: "Ryazanskaya oblast'",
        parent: 'RU',
    },
    'RU-SA': {
        code: 'RU-SA',
        name: 'Saha, Respublika(local variant is Jakutija)',
        parent: 'RU',
    },
    'RU-SAK': {
        code: 'RU-SAK',
        name: "Sakhalinskaya oblast'",
        parent: 'RU',
    },
    'RU-SAM': {
        code: 'RU-SAM',
        name: "Samarskaya oblast'",
        parent: 'RU',
    },
    'RU-SAR': {
        code: 'RU-SAR',
        name: "Saratovskaya oblast'",
        parent: 'RU',
    },
    'RU-SE': {
        code: 'RU-SE',
        name: 'Severnaya Osetiya, Respublika(local variant is Alaniya )',
        parent: 'RU',
    },
    'RU-SMO': {
        code: 'RU-SMO',
        name: "Smolenskaya oblast'",
        parent: 'RU',
    },
    'RU-SPE': {
        code: 'RU-SPE',
        name: 'Sankt-Peterburg',
        parent: 'RU',
    },
    'RU-STA': {
        code: 'RU-STA',
        name: "Stavropol'skiy kray",
        parent: 'RU',
    },
    'RU-SVE': {
        code: 'RU-SVE',
        name: "Sverdlovskaya oblast'",
        parent: 'RU',
    },
    'RU-TA': {
        code: 'RU-TA',
        name: 'Tatarstan, Respublika',
        parent: 'RU',
    },
    'RU-TAM': {
        code: 'RU-TAM',
        name: "Tambovskaya oblast'",
        parent: 'RU',
    },
    'RU-TOM': {
        code: 'RU-TOM',
        name: "Tomskaya oblast'",
        parent: 'RU',
    },
    'RU-TUL': {
        code: 'RU-TUL',
        name: "Tul'skaya oblast'",
        parent: 'RU',
    },
    'RU-TVE': {
        code: 'RU-TVE',
        name: "Tverskaya oblast'",
        parent: 'RU',
    },
    'RU-TY': {
        code: 'RU-TY',
        name: 'Tyva, Respublika(local variant is Tuva)',
        parent: 'RU',
    },
    'RU-TYU': {
        code: 'RU-TYU',
        name: "Tyumenskaya oblast'",
        parent: 'RU',
    },
    'RU-UD': {
        code: 'RU-UD',
        name: 'Udmurtskaya Respublika',
        parent: 'RU',
    },
    'RU-ULY': {
        code: 'RU-ULY',
        name: "Ul'yanovskaya oblast'",
        parent: 'RU',
    },
    'RU-VGG': {
        code: 'RU-VGG',
        name: "Volgogradskaya oblast'",
        parent: 'RU',
    },
    'RU-VLA': {
        code: 'RU-VLA',
        name: "Vladimirskaya oblast'",
        parent: 'RU',
    },
    'RU-VLG': {
        code: 'RU-VLG',
        name: "Vologodskaya oblast'",
        parent: 'RU',
    },
    'RU-VOR': {
        code: 'RU-VOR',
        name: "Voronezhskaya oblast'",
        parent: 'RU',
    },
    'RU-YAN': {
        code: 'RU-YAN',
        name: 'Yamalo-Nenetskiy avtonomnyy okrug',
        parent: 'RU',
    },
    'RU-YAR': {
        code: 'RU-YAR',
        name: "Yaroslavskaya oblast'",
        parent: 'RU',
    },
    'RU-YEV': {
        code: 'RU-YEV',
        name: "Yevreyskaya avtonomnaya oblast'",
        parent: 'RU',
    },
    'RU-ZAB': {
        code: 'RU-ZAB',
        name: "Zabaykal'skiy kray",
        parent: 'RU',
    },
    'RW-01': {
        code: 'RW-01',
        name: 'City of Kigali',
        parent: 'RW',
    },
    'RW-02': {
        code: 'RW-02',
        name: 'Eastern',
        parent: 'RW',
    },
    'RW-03': {
        code: 'RW-03',
        name: 'Northern',
        parent: 'RW',
    },
    'RW-04': {
        code: 'RW-04',
        name: 'Western',
        parent: 'RW',
    },
    'RW-05': {
        code: 'RW-05',
        name: 'Southern',
        parent: 'RW',
    },
    'SA-01': {
        code: 'SA-01',
        name: 'Ar Riyāḑ',
        parent: 'SA',
    },
    'SA-02': {
        code: 'SA-02',
        name: 'Makkah al Mukarramah',
        parent: 'SA',
    },
    'SA-03': {
        code: 'SA-03',
        name: 'Al Madīnah al Munawwarah',
        parent: 'SA',
    },
    'SA-04': {
        code: 'SA-04',
        name: 'Ash Sharqīyah',
        parent: 'SA',
    },
    'SA-05': {
        code: 'SA-05',
        name: 'Al Qaşīm',
        parent: 'SA',
    },
    'SA-06': {
        code: 'SA-06',
        name: "Ḩā'il",
        parent: 'SA',
    },
    'SA-07': {
        code: 'SA-07',
        name: 'Tabūk',
        parent: 'SA',
    },
    'SA-08': {
        code: 'SA-08',
        name: 'Al Ḩudūd ash Shamālīyah',
        parent: 'SA',
    },
    'SA-09': {
        code: 'SA-09',
        name: 'Jāzān',
        parent: 'SA',
    },
    'SA-10': {
        code: 'SA-10',
        name: 'Najrān',
        parent: 'SA',
    },
    'SA-11': {
        code: 'SA-11',
        name: 'Al Bāḩah',
        parent: 'SA',
    },
    'SA-12': {
        code: 'SA-12',
        name: 'Al Jawf',
        parent: 'SA',
    },
    'SA-14': {
        code: 'SA-14',
        name: "'Asīr",
        parent: 'SA',
    },
    'SB-CE': {
        code: 'SB-CE',
        name: 'Central',
        parent: 'SB',
    },
    'SB-CH': {
        code: 'SB-CH',
        name: 'Choiseul',
        parent: 'SB',
    },
    'SB-CT': {
        code: 'SB-CT',
        name: 'Capital Territory (Honiara)',
        parent: 'SB',
    },
    'SB-GU': {
        code: 'SB-GU',
        name: 'Guadalcanal',
        parent: 'SB',
    },
    'SB-IS': {
        code: 'SB-IS',
        name: 'Isabel',
        parent: 'SB',
    },
    'SB-MK': {
        code: 'SB-MK',
        name: 'Makira-Ulawa',
        parent: 'SB',
    },
    'SB-ML': {
        code: 'SB-ML',
        name: 'Malaita',
        parent: 'SB',
    },
    'SB-RB': {
        code: 'SB-RB',
        name: 'Rennell and Bellona',
        parent: 'SB',
    },
    'SB-TE': {
        code: 'SB-TE',
        name: 'Temotu',
        parent: 'SB',
    },
    'SB-WE': {
        code: 'SB-WE',
        name: 'Western',
        parent: 'SB',
    },
    'SC-01': {
        code: 'SC-01',
        name: 'Anse aux Pins',
        parent: 'SC',
    },
    'SC-02': {
        code: 'SC-02',
        name: 'Anse Boileau',
        parent: 'SC',
    },
    'SC-03': {
        code: 'SC-03',
        name: 'Anse Etoile',
        parent: 'SC',
    },
    'SC-04': {
        code: 'SC-04',
        name: 'Au Cap',
        parent: 'SC',
    },
    'SC-05': {
        code: 'SC-05',
        name: 'Anse Royale',
        parent: 'SC',
    },
    'SC-06': {
        code: 'SC-06',
        name: 'Baie Lazare',
        parent: 'SC',
    },
    'SC-07': {
        code: 'SC-07',
        name: 'Baie Sainte Anne',
        parent: 'SC',
    },
    'SC-08': {
        code: 'SC-08',
        name: 'Beau Vallon',
        parent: 'SC',
    },
    'SC-09': {
        code: 'SC-09',
        name: 'Bel Air',
        parent: 'SC',
    },
    'SC-10': {
        code: 'SC-10',
        name: 'Bel Ombre',
        parent: 'SC',
    },
    'SC-11': {
        code: 'SC-11',
        name: 'Cascade',
        parent: 'SC',
    },
    'SC-12': {
        code: 'SC-12',
        name: 'Glacis',
        parent: 'SC',
    },
    'SC-13': {
        code: 'SC-13',
        name: 'Grand Anse Mahe',
        parent: 'SC',
    },
    'SC-14': {
        code: 'SC-14',
        name: 'Grand Anse Praslin',
        parent: 'SC',
    },
    'SC-15': {
        code: 'SC-15',
        name: 'La Digue',
        parent: 'SC',
    },
    'SC-16': {
        code: 'SC-16',
        name: 'English River',
        parent: 'SC',
    },
    'SC-17': {
        code: 'SC-17',
        name: 'Mont Buxton',
        parent: 'SC',
    },
    'SC-18': {
        code: 'SC-18',
        name: 'Mont Fleuri',
        parent: 'SC',
    },
    'SC-19': {
        code: 'SC-19',
        name: 'Plaisance',
        parent: 'SC',
    },
    'SC-20': {
        code: 'SC-20',
        name: 'Pointe Larue',
        parent: 'SC',
    },
    'SC-21': {
        code: 'SC-21',
        name: 'Port Glaud',
        parent: 'SC',
    },
    'SC-22': {
        code: 'SC-22',
        name: 'Saint Louis',
        parent: 'SC',
    },
    'SC-23': {
        code: 'SC-23',
        name: 'Takamaka',
        parent: 'SC',
    },
    'SC-24': {
        code: 'SC-24',
        name: 'Les Mamelles',
        parent: 'SC',
    },
    'SC-25': {
        code: 'SC-25',
        name: 'Roche Caiman',
        parent: 'SC',
    },
    'SC-26': {
        code: 'SC-26',
        name: 'Ile Perseverance I',
        parent: 'SC',
    },
    'SC-27': {
        code: 'SC-27',
        name: 'Ile Perseverance II',
        parent: 'SC',
    },
    'SD-DC': {
        code: 'SD-DC',
        name: 'Wasaţ Dārfūr(local variant is Zālinjay)',
        parent: 'SD',
    },
    'SD-DE': {
        code: 'SD-DE',
        name: 'Sharq Dārfūr',
        parent: 'SD',
    },
    'SD-DN': {
        code: 'SD-DN',
        name: 'Shamāl Dārfūr',
        parent: 'SD',
    },
    'SD-DS': {
        code: 'SD-DS',
        name: 'Janūb Dārfūr',
        parent: 'SD',
    },
    'SD-DW': {
        code: 'SD-DW',
        name: 'Gharb Dārfūr',
        parent: 'SD',
    },
    'SD-GD': {
        code: 'SD-GD',
        name: 'Al Qaḑārif',
        parent: 'SD',
    },
    'SD-GK': {
        code: 'SD-GK',
        name: 'Gharb Kurdufān',
        parent: 'SD',
    },
    'SD-GZ': {
        code: 'SD-GZ',
        name: 'Al Jazīrah',
        parent: 'SD',
    },
    'SD-KA': {
        code: 'SD-KA',
        name: 'Kassalā',
        parent: 'SD',
    },
    'SD-KH': {
        code: 'SD-KH',
        name: 'Al Kharţūm',
        parent: 'SD',
    },
    'SD-KN': {
        code: 'SD-KN',
        name: 'Shamāl Kurdufān',
        parent: 'SD',
    },
    'SD-KS': {
        code: 'SD-KS',
        name: 'Janūb Kurdufān',
        parent: 'SD',
    },
    'SD-NB': {
        code: 'SD-NB',
        name: 'An Nīl al Azraq',
        parent: 'SD',
    },
    'SD-NO': {
        code: 'SD-NO',
        name: 'Ash Shamālīyah',
        parent: 'SD',
    },
    'SD-NR': {
        code: 'SD-NR',
        name: 'Nahr an Nīl',
        parent: 'SD',
    },
    'SD-NW': {
        code: 'SD-NW',
        name: 'An Nīl al Abyaḑ',
        parent: 'SD',
    },
    'SD-RS': {
        code: 'SD-RS',
        name: 'Al Baḩr al Aḩmar',
        parent: 'SD',
    },
    'SD-SI': {
        code: 'SD-SI',
        name: 'Sinnār',
        parent: 'SD',
    },
    'SE-AB': {
        code: 'SE-AB',
        name: 'Stockholms län',
        parent: 'SE',
    },
    'SE-AC': {
        code: 'SE-AC',
        name: 'Västerbottens län',
        parent: 'SE',
    },
    'SE-BD': {
        code: 'SE-BD',
        name: 'Norrbottens län',
        parent: 'SE',
    },
    'SE-C': {
        code: 'SE-C',
        name: 'Uppsala län',
        parent: 'SE',
    },
    'SE-D': {
        code: 'SE-D',
        name: 'Södermanlands län',
        parent: 'SE',
    },
    'SE-E': {
        code: 'SE-E',
        name: 'Östergötlands län',
        parent: 'SE',
    },
    'SE-F': {
        code: 'SE-F',
        name: 'Jönköpings län',
        parent: 'SE',
    },
    'SE-G': {
        code: 'SE-G',
        name: 'Kronobergs län',
        parent: 'SE',
    },
    'SE-H': {
        code: 'SE-H',
        name: 'Kalmar län',
        parent: 'SE',
    },
    'SE-I': {
        code: 'SE-I',
        name: 'Gotlands län',
        parent: 'SE',
    },
    'SE-K': {
        code: 'SE-K',
        name: 'Blekinge län',
        parent: 'SE',
    },
    'SE-M': {
        code: 'SE-M',
        name: 'Skåne län',
        parent: 'SE',
    },
    'SE-N': {
        code: 'SE-N',
        name: 'Hallands län',
        parent: 'SE',
    },
    'SE-O': {
        code: 'SE-O',
        name: 'Västra Götalands län',
        parent: 'SE',
    },
    'SE-S': {
        code: 'SE-S',
        name: 'Värmlands län',
        parent: 'SE',
    },
    'SE-T': {
        code: 'SE-T',
        name: 'Örebro län',
        parent: 'SE',
    },
    'SE-U': {
        code: 'SE-U',
        name: 'Västmanlands län',
        parent: 'SE',
    },
    'SE-W': {
        code: 'SE-W',
        name: 'Dalarnas län',
        parent: 'SE',
    },
    'SE-X': {
        code: 'SE-X',
        name: 'Gävleborgs län',
        parent: 'SE',
    },
    'SE-Y': {
        code: 'SE-Y',
        name: 'Västernorrlands län',
        parent: 'SE',
    },
    'SE-Z': {
        code: 'SE-Z',
        name: 'Jämtlands län',
        parent: 'SE',
    },
    'SG-01': {
        code: 'SG-01',
        name: 'Central Singapore',
        parent: 'SG',
    },
    'SG-02': {
        code: 'SG-02',
        name: 'North East',
        parent: 'SG',
    },
    'SG-03': {
        code: 'SG-03',
        name: 'North West',
        parent: 'SG',
    },
    'SG-04': {
        code: 'SG-04',
        name: 'South East',
        parent: 'SG',
    },
    'SG-05': {
        code: 'SG-05',
        name: 'South West',
        parent: 'SG',
    },
    'SH-AC': {
        code: 'SH-AC',
        name: 'Ascension',
        parent: 'SH',
    },
    'SH-HL': {
        code: 'SH-HL',
        name: 'Saint Helena',
        parent: 'SH',
    },
    'SH-TA': {
        code: 'SH-TA',
        name: 'Tristan da Cunha',
        parent: 'SH',
    },
    'SI-001': {
        code: 'SI-001',
        name: 'Ajdovščina',
        parent: 'SI',
    },
    'SI-002': {
        code: 'SI-002',
        name: 'Beltinci',
        parent: 'SI',
    },
    'SI-003': {
        code: 'SI-003',
        name: 'Bled',
        parent: 'SI',
    },
    'SI-004': {
        code: 'SI-004',
        name: 'Bohinj',
        parent: 'SI',
    },
    'SI-005': {
        code: 'SI-005',
        name: 'Borovnica',
        parent: 'SI',
    },
    'SI-006': {
        code: 'SI-006',
        name: 'Bovec',
        parent: 'SI',
    },
    'SI-007': {
        code: 'SI-007',
        name: 'Brda',
        parent: 'SI',
    },
    'SI-008': {
        code: 'SI-008',
        name: 'Brezovica',
        parent: 'SI',
    },
    'SI-009': {
        code: 'SI-009',
        name: 'Brežice',
        parent: 'SI',
    },
    'SI-010': {
        code: 'SI-010',
        name: 'Tišina',
        parent: 'SI',
    },
    'SI-011': {
        code: 'SI-011',
        name: 'Celje',
        parent: 'SI',
    },
    'SI-012': {
        code: 'SI-012',
        name: 'Cerklje na Gorenjskem',
        parent: 'SI',
    },
    'SI-013': {
        code: 'SI-013',
        name: 'Cerknica',
        parent: 'SI',
    },
    'SI-014': {
        code: 'SI-014',
        name: 'Cerkno',
        parent: 'SI',
    },
    'SI-015': {
        code: 'SI-015',
        name: 'Črenšovci',
        parent: 'SI',
    },
    'SI-016': {
        code: 'SI-016',
        name: 'Črna na Koroškem',
        parent: 'SI',
    },
    'SI-017': {
        code: 'SI-017',
        name: 'Črnomelj',
        parent: 'SI',
    },
    'SI-018': {
        code: 'SI-018',
        name: 'Destrnik',
        parent: 'SI',
    },
    'SI-019': {
        code: 'SI-019',
        name: 'Divača',
        parent: 'SI',
    },
    'SI-020': {
        code: 'SI-020',
        name: 'Dobrepolje',
        parent: 'SI',
    },
    'SI-021': {
        code: 'SI-021',
        name: 'Dobrova-Polhov Gradec',
        parent: 'SI',
    },
    'SI-022': {
        code: 'SI-022',
        name: 'Dol pri Ljubljani',
        parent: 'SI',
    },
    'SI-023': {
        code: 'SI-023',
        name: 'Domžale',
        parent: 'SI',
    },
    'SI-024': {
        code: 'SI-024',
        name: 'Dornava',
        parent: 'SI',
    },
    'SI-025': {
        code: 'SI-025',
        name: 'Dravograd',
        parent: 'SI',
    },
    'SI-026': {
        code: 'SI-026',
        name: 'Duplek',
        parent: 'SI',
    },
    'SI-027': {
        code: 'SI-027',
        name: 'Gorenja vas-Poljane',
        parent: 'SI',
    },
    'SI-028': {
        code: 'SI-028',
        name: 'Gorišnica',
        parent: 'SI',
    },
    'SI-029': {
        code: 'SI-029',
        name: 'Gornja Radgona',
        parent: 'SI',
    },
    'SI-030': {
        code: 'SI-030',
        name: 'Gornji Grad',
        parent: 'SI',
    },
    'SI-031': {
        code: 'SI-031',
        name: 'Gornji Petrovci',
        parent: 'SI',
    },
    'SI-032': {
        code: 'SI-032',
        name: 'Grosuplje',
        parent: 'SI',
    },
    'SI-033': {
        code: 'SI-033',
        name: 'Šalovci',
        parent: 'SI',
    },
    'SI-034': {
        code: 'SI-034',
        name: 'Hrastnik',
        parent: 'SI',
    },
    'SI-035': {
        code: 'SI-035',
        name: 'Hrpelje-Kozina',
        parent: 'SI',
    },
    'SI-036': {
        code: 'SI-036',
        name: 'Idrija',
        parent: 'SI',
    },
    'SI-037': {
        code: 'SI-037',
        name: 'Ig',
        parent: 'SI',
    },
    'SI-038': {
        code: 'SI-038',
        name: 'Ilirska Bistrica',
        parent: 'SI',
    },
    'SI-039': {
        code: 'SI-039',
        name: 'Ivančna Gorica',
        parent: 'SI',
    },
    'SI-040': {
        code: 'SI-040',
        name: 'Izola',
        parent: 'SI',
    },
    'SI-041': {
        code: 'SI-041',
        name: 'Jesenice',
        parent: 'SI',
    },
    'SI-042': {
        code: 'SI-042',
        name: 'Juršinci',
        parent: 'SI',
    },
    'SI-043': {
        code: 'SI-043',
        name: 'Kamnik',
        parent: 'SI',
    },
    'SI-044': {
        code: 'SI-044',
        name: 'Kanal',
        parent: 'SI',
    },
    'SI-045': {
        code: 'SI-045',
        name: 'Kidričevo',
        parent: 'SI',
    },
    'SI-046': {
        code: 'SI-046',
        name: 'Kobarid',
        parent: 'SI',
    },
    'SI-047': {
        code: 'SI-047',
        name: 'Kobilje',
        parent: 'SI',
    },
    'SI-048': {
        code: 'SI-048',
        name: 'Kočevje',
        parent: 'SI',
    },
    'SI-049': {
        code: 'SI-049',
        name: 'Komen',
        parent: 'SI',
    },
    'SI-050': {
        code: 'SI-050',
        name: 'Koper',
        parent: 'SI',
    },
    'SI-051': {
        code: 'SI-051',
        name: 'Kozje',
        parent: 'SI',
    },
    'SI-052': {
        code: 'SI-052',
        name: 'Kranj',
        parent: 'SI',
    },
    'SI-053': {
        code: 'SI-053',
        name: 'Kranjska Gora',
        parent: 'SI',
    },
    'SI-054': {
        code: 'SI-054',
        name: 'Krško',
        parent: 'SI',
    },
    'SI-055': {
        code: 'SI-055',
        name: 'Kungota',
        parent: 'SI',
    },
    'SI-056': {
        code: 'SI-056',
        name: 'Kuzma',
        parent: 'SI',
    },
    'SI-057': {
        code: 'SI-057',
        name: 'Laško',
        parent: 'SI',
    },
    'SI-058': {
        code: 'SI-058',
        name: 'Lenart',
        parent: 'SI',
    },
    'SI-059': {
        code: 'SI-059',
        name: 'Lendava',
        parent: 'SI',
    },
    'SI-060': {
        code: 'SI-060',
        name: 'Litija',
        parent: 'SI',
    },
    'SI-061': {
        code: 'SI-061',
        name: 'Ljubljana',
        parent: 'SI',
    },
    'SI-062': {
        code: 'SI-062',
        name: 'Ljubno',
        parent: 'SI',
    },
    'SI-063': {
        code: 'SI-063',
        name: 'Ljutomer',
        parent: 'SI',
    },
    'SI-064': {
        code: 'SI-064',
        name: 'Logatec',
        parent: 'SI',
    },
    'SI-065': {
        code: 'SI-065',
        name: 'Loška dolina',
        parent: 'SI',
    },
    'SI-066': {
        code: 'SI-066',
        name: 'Loški Potok',
        parent: 'SI',
    },
    'SI-067': {
        code: 'SI-067',
        name: 'Luče',
        parent: 'SI',
    },
    'SI-068': {
        code: 'SI-068',
        name: 'Lukovica',
        parent: 'SI',
    },
    'SI-069': {
        code: 'SI-069',
        name: 'Majšperk',
        parent: 'SI',
    },
    'SI-070': {
        code: 'SI-070',
        name: 'Maribor',
        parent: 'SI',
    },
    'SI-071': {
        code: 'SI-071',
        name: 'Medvode',
        parent: 'SI',
    },
    'SI-072': {
        code: 'SI-072',
        name: 'Mengeš',
        parent: 'SI',
    },
    'SI-073': {
        code: 'SI-073',
        name: 'Metlika',
        parent: 'SI',
    },
    'SI-074': {
        code: 'SI-074',
        name: 'Mežica',
        parent: 'SI',
    },
    'SI-075': {
        code: 'SI-075',
        name: 'Miren-Kostanjevica',
        parent: 'SI',
    },
    'SI-076': {
        code: 'SI-076',
        name: 'Mislinja',
        parent: 'SI',
    },
    'SI-077': {
        code: 'SI-077',
        name: 'Moravče',
        parent: 'SI',
    },
    'SI-078': {
        code: 'SI-078',
        name: 'Moravske Toplice',
        parent: 'SI',
    },
    'SI-079': {
        code: 'SI-079',
        name: 'Mozirje',
        parent: 'SI',
    },
    'SI-080': {
        code: 'SI-080',
        name: 'Murska Sobota',
        parent: 'SI',
    },
    'SI-081': {
        code: 'SI-081',
        name: 'Muta',
        parent: 'SI',
    },
    'SI-082': {
        code: 'SI-082',
        name: 'Naklo',
        parent: 'SI',
    },
    'SI-083': {
        code: 'SI-083',
        name: 'Nazarje',
        parent: 'SI',
    },
    'SI-084': {
        code: 'SI-084',
        name: 'Nova Gorica',
        parent: 'SI',
    },
    'SI-085': {
        code: 'SI-085',
        name: 'Novo Mesto',
        parent: 'SI',
    },
    'SI-086': {
        code: 'SI-086',
        name: 'Odranci',
        parent: 'SI',
    },
    'SI-087': {
        code: 'SI-087',
        name: 'Ormož',
        parent: 'SI',
    },
    'SI-088': {
        code: 'SI-088',
        name: 'Osilnica',
        parent: 'SI',
    },
    'SI-089': {
        code: 'SI-089',
        name: 'Pesnica',
        parent: 'SI',
    },
    'SI-090': {
        code: 'SI-090',
        name: 'Piran',
        parent: 'SI',
    },
    'SI-091': {
        code: 'SI-091',
        name: 'Pivka',
        parent: 'SI',
    },
    'SI-092': {
        code: 'SI-092',
        name: 'Podčetrtek',
        parent: 'SI',
    },
    'SI-093': {
        code: 'SI-093',
        name: 'Podvelka',
        parent: 'SI',
    },
    'SI-094': {
        code: 'SI-094',
        name: 'Postojna',
        parent: 'SI',
    },
    'SI-095': {
        code: 'SI-095',
        name: 'Preddvor',
        parent: 'SI',
    },
    'SI-096': {
        code: 'SI-096',
        name: 'Ptuj',
        parent: 'SI',
    },
    'SI-097': {
        code: 'SI-097',
        name: 'Puconci',
        parent: 'SI',
    },
    'SI-098': {
        code: 'SI-098',
        name: 'Rače-Fram',
        parent: 'SI',
    },
    'SI-099': {
        code: 'SI-099',
        name: 'Radeče',
        parent: 'SI',
    },
    'SI-100': {
        code: 'SI-100',
        name: 'Radenci',
        parent: 'SI',
    },
    'SI-101': {
        code: 'SI-101',
        name: 'Radlje ob Dravi',
        parent: 'SI',
    },
    'SI-102': {
        code: 'SI-102',
        name: 'Radovljica',
        parent: 'SI',
    },
    'SI-103': {
        code: 'SI-103',
        name: 'Ravne na Koroškem',
        parent: 'SI',
    },
    'SI-104': {
        code: 'SI-104',
        name: 'Ribnica',
        parent: 'SI',
    },
    'SI-105': {
        code: 'SI-105',
        name: 'Rogašovci',
        parent: 'SI',
    },
    'SI-106': {
        code: 'SI-106',
        name: 'Rogaška Slatina',
        parent: 'SI',
    },
    'SI-107': {
        code: 'SI-107',
        name: 'Rogatec',
        parent: 'SI',
    },
    'SI-108': {
        code: 'SI-108',
        name: 'Ruše',
        parent: 'SI',
    },
    'SI-109': {
        code: 'SI-109',
        name: 'Semič',
        parent: 'SI',
    },
    'SI-110': {
        code: 'SI-110',
        name: 'Sevnica',
        parent: 'SI',
    },
    'SI-111': {
        code: 'SI-111',
        name: 'Sežana',
        parent: 'SI',
    },
    'SI-112': {
        code: 'SI-112',
        name: 'Slovenj Gradec',
        parent: 'SI',
    },
    'SI-113': {
        code: 'SI-113',
        name: 'Slovenska Bistrica',
        parent: 'SI',
    },
    'SI-114': {
        code: 'SI-114',
        name: 'Slovenske Konjice',
        parent: 'SI',
    },
    'SI-115': {
        code: 'SI-115',
        name: 'Starše',
        parent: 'SI',
    },
    'SI-116': {
        code: 'SI-116',
        name: 'Sveti Jurij ob Ščavnici',
        parent: 'SI',
    },
    'SI-117': {
        code: 'SI-117',
        name: 'Šenčur',
        parent: 'SI',
    },
    'SI-118': {
        code: 'SI-118',
        name: 'Šentilj',
        parent: 'SI',
    },
    'SI-119': {
        code: 'SI-119',
        name: 'Šentjernej',
        parent: 'SI',
    },
    'SI-120': {
        code: 'SI-120',
        name: 'Šentjur',
        parent: 'SI',
    },
    'SI-121': {
        code: 'SI-121',
        name: 'Škocjan',
        parent: 'SI',
    },
    'SI-122': {
        code: 'SI-122',
        name: 'Škofja Loka',
        parent: 'SI',
    },
    'SI-123': {
        code: 'SI-123',
        name: 'Škofljica',
        parent: 'SI',
    },
    'SI-124': {
        code: 'SI-124',
        name: 'Šmarje pri Jelšah',
        parent: 'SI',
    },
    'SI-125': {
        code: 'SI-125',
        name: 'Šmartno ob Paki',
        parent: 'SI',
    },
    'SI-126': {
        code: 'SI-126',
        name: 'Šoštanj',
        parent: 'SI',
    },
    'SI-127': {
        code: 'SI-127',
        name: 'Štore',
        parent: 'SI',
    },
    'SI-128': {
        code: 'SI-128',
        name: 'Tolmin',
        parent: 'SI',
    },
    'SI-129': {
        code: 'SI-129',
        name: 'Trbovlje',
        parent: 'SI',
    },
    'SI-130': {
        code: 'SI-130',
        name: 'Trebnje',
        parent: 'SI',
    },
    'SI-131': {
        code: 'SI-131',
        name: 'Tržič',
        parent: 'SI',
    },
    'SI-132': {
        code: 'SI-132',
        name: 'Turnišče',
        parent: 'SI',
    },
    'SI-133': {
        code: 'SI-133',
        name: 'Velenje',
        parent: 'SI',
    },
    'SI-134': {
        code: 'SI-134',
        name: 'Velike Lašče',
        parent: 'SI',
    },
    'SI-135': {
        code: 'SI-135',
        name: 'Videm',
        parent: 'SI',
    },
    'SI-136': {
        code: 'SI-136',
        name: 'Vipava',
        parent: 'SI',
    },
    'SI-137': {
        code: 'SI-137',
        name: 'Vitanje',
        parent: 'SI',
    },
    'SI-138': {
        code: 'SI-138',
        name: 'Vodice',
        parent: 'SI',
    },
    'SI-139': {
        code: 'SI-139',
        name: 'Vojnik',
        parent: 'SI',
    },
    'SI-140': {
        code: 'SI-140',
        name: 'Vrhnika',
        parent: 'SI',
    },
    'SI-141': {
        code: 'SI-141',
        name: 'Vuzenica',
        parent: 'SI',
    },
    'SI-142': {
        code: 'SI-142',
        name: 'Zagorje ob Savi',
        parent: 'SI',
    },
    'SI-143': {
        code: 'SI-143',
        name: 'Zavrč',
        parent: 'SI',
    },
    'SI-144': {
        code: 'SI-144',
        name: 'Zreče',
        parent: 'SI',
    },
    'SI-146': {
        code: 'SI-146',
        name: 'Železniki',
        parent: 'SI',
    },
    'SI-147': {
        code: 'SI-147',
        name: 'Žiri',
        parent: 'SI',
    },
    'SI-148': {
        code: 'SI-148',
        name: 'Benedikt',
        parent: 'SI',
    },
    'SI-149': {
        code: 'SI-149',
        name: 'Bistrica ob Sotli',
        parent: 'SI',
    },
    'SI-150': {
        code: 'SI-150',
        name: 'Bloke',
        parent: 'SI',
    },
    'SI-151': {
        code: 'SI-151',
        name: 'Braslovče',
        parent: 'SI',
    },
    'SI-152': {
        code: 'SI-152',
        name: 'Cankova',
        parent: 'SI',
    },
    'SI-153': {
        code: 'SI-153',
        name: 'Cerkvenjak',
        parent: 'SI',
    },
    'SI-154': {
        code: 'SI-154',
        name: 'Dobje',
        parent: 'SI',
    },
    'SI-155': {
        code: 'SI-155',
        name: 'Dobrna',
        parent: 'SI',
    },
    'SI-156': {
        code: 'SI-156',
        name: 'Dobrovnik',
        parent: 'SI',
    },
    'SI-157': {
        code: 'SI-157',
        name: 'Dolenjske Toplice',
        parent: 'SI',
    },
    'SI-158': {
        code: 'SI-158',
        name: 'Grad',
        parent: 'SI',
    },
    'SI-159': {
        code: 'SI-159',
        name: 'Hajdina',
        parent: 'SI',
    },
    'SI-160': {
        code: 'SI-160',
        name: 'Hoče-Slivnica',
        parent: 'SI',
    },
    'SI-161': {
        code: 'SI-161',
        name: 'Hodoš',
        parent: 'SI',
    },
    'SI-162': {
        code: 'SI-162',
        name: 'Horjul',
        parent: 'SI',
    },
    'SI-163': {
        code: 'SI-163',
        name: 'Jezersko',
        parent: 'SI',
    },
    'SI-164': {
        code: 'SI-164',
        name: 'Komenda',
        parent: 'SI',
    },
    'SI-165': {
        code: 'SI-165',
        name: 'Kostel',
        parent: 'SI',
    },
    'SI-166': {
        code: 'SI-166',
        name: 'Križevci',
        parent: 'SI',
    },
    'SI-167': {
        code: 'SI-167',
        name: 'Lovrenc na Pohorju',
        parent: 'SI',
    },
    'SI-168': {
        code: 'SI-168',
        name: 'Markovci',
        parent: 'SI',
    },
    'SI-169': {
        code: 'SI-169',
        name: 'Miklavž na Dravskem polju',
        parent: 'SI',
    },
    'SI-170': {
        code: 'SI-170',
        name: 'Mirna Peč',
        parent: 'SI',
    },
    'SI-171': {
        code: 'SI-171',
        name: 'Oplotnica',
        parent: 'SI',
    },
    'SI-172': {
        code: 'SI-172',
        name: 'Podlehnik',
        parent: 'SI',
    },
    'SI-173': {
        code: 'SI-173',
        name: 'Polzela',
        parent: 'SI',
    },
    'SI-174': {
        code: 'SI-174',
        name: 'Prebold',
        parent: 'SI',
    },
    'SI-175': {
        code: 'SI-175',
        name: 'Prevalje',
        parent: 'SI',
    },
    'SI-176': {
        code: 'SI-176',
        name: 'Razkrižje',
        parent: 'SI',
    },
    'SI-177': {
        code: 'SI-177',
        name: 'Ribnica na Pohorju',
        parent: 'SI',
    },
    'SI-178': {
        code: 'SI-178',
        name: 'Selnica ob Dravi',
        parent: 'SI',
    },
    'SI-179': {
        code: 'SI-179',
        name: 'Sodražica',
        parent: 'SI',
    },
    'SI-180': {
        code: 'SI-180',
        name: 'Solčava',
        parent: 'SI',
    },
    'SI-181': {
        code: 'SI-181',
        name: 'Sveta Ana',
        parent: 'SI',
    },
    'SI-182': {
        code: 'SI-182',
        name: 'Sveti Andraž v Slovenskih goricah',
        parent: 'SI',
    },
    'SI-183': {
        code: 'SI-183',
        name: 'Šempeter-Vrtojba',
        parent: 'SI',
    },
    'SI-184': {
        code: 'SI-184',
        name: 'Tabor',
        parent: 'SI',
    },
    'SI-185': {
        code: 'SI-185',
        name: 'Trnovska Vas',
        parent: 'SI',
    },
    'SI-186': {
        code: 'SI-186',
        name: 'Trzin',
        parent: 'SI',
    },
    'SI-187': {
        code: 'SI-187',
        name: 'Velika Polana',
        parent: 'SI',
    },
    'SI-188': {
        code: 'SI-188',
        name: 'Veržej',
        parent: 'SI',
    },
    'SI-189': {
        code: 'SI-189',
        name: 'Vransko',
        parent: 'SI',
    },
    'SI-190': {
        code: 'SI-190',
        name: 'Žalec',
        parent: 'SI',
    },
    'SI-191': {
        code: 'SI-191',
        name: 'Žetale',
        parent: 'SI',
    },
    'SI-192': {
        code: 'SI-192',
        name: 'Žirovnica',
        parent: 'SI',
    },
    'SI-193': {
        code: 'SI-193',
        name: 'Žužemberk',
        parent: 'SI',
    },
    'SI-194': {
        code: 'SI-194',
        name: 'Šmartno pri Litiji',
        parent: 'SI',
    },
    'SI-195': {
        code: 'SI-195',
        name: 'Apače',
        parent: 'SI',
    },
    'SI-196': {
        code: 'SI-196',
        name: 'Cirkulane',
        parent: 'SI',
    },
    'SI-197': {
        code: 'SI-197',
        name: 'Kosanjevica na Krki',
        parent: 'SI',
    },
    'SI-198': {
        code: 'SI-198',
        name: 'Makole',
        parent: 'SI',
    },
    'SI-199': {
        code: 'SI-199',
        name: 'Mokronog-Trebelno',
        parent: 'SI',
    },
    'SI-200': {
        code: 'SI-200',
        name: 'Poljčane',
        parent: 'SI',
    },
    'SI-201': {
        code: 'SI-201',
        name: 'Renče-Vogrsko',
        parent: 'SI',
    },
    'SI-202': {
        code: 'SI-202',
        name: 'Središče ob Dravi',
        parent: 'SI',
    },
    'SI-203': {
        code: 'SI-203',
        name: 'Straža',
        parent: 'SI',
    },
    'SI-204': {
        code: 'SI-204',
        name: 'Sveta Trojica v Slovenskih goricah',
        parent: 'SI',
    },
    'SI-205': {
        code: 'SI-205',
        name: 'Sveti Tomaž',
        parent: 'SI',
    },
    'SI-206': {
        code: 'SI-206',
        name: 'Šmarješke Toplice',
        parent: 'SI',
    },
    'SI-207': {
        code: 'SI-207',
        name: 'Gorje',
        parent: 'SI',
    },
    'SI-208': {
        code: 'SI-208',
        name: 'Log-Dragomer',
        parent: 'SI',
    },
    'SI-209': {
        code: 'SI-209',
        name: 'Rečica ob Savinji',
        parent: 'SI',
    },
    'SI-210': {
        code: 'SI-210',
        name: 'Sveti Jurij v Slovenskih goricah',
        parent: 'SI',
    },
    'SI-211': {
        code: 'SI-211',
        name: 'Šentrupert',
        parent: 'SI',
    },
    'SI-212': {
        code: 'SI-212',
        name: 'Mirna',
        parent: 'SI',
    },
    'SI-213': {
        code: 'SI-213',
        name: 'Ankaran',
        parent: 'SI',
    },
    'SK-BC': {
        code: 'SK-BC',
        name: 'Banskobystrický kraj',
        parent: 'SK',
    },
    'SK-BL': {
        code: 'SK-BL',
        name: 'Bratislavský kraj',
        parent: 'SK',
    },
    'SK-KI': {
        code: 'SK-KI',
        name: 'Košický kraj',
        parent: 'SK',
    },
    'SK-NI': {
        code: 'SK-NI',
        name: 'Nitriansky kraj',
        parent: 'SK',
    },
    'SK-PV': {
        code: 'SK-PV',
        name: 'Prešovský kraj',
        parent: 'SK',
    },
    'SK-TA': {
        code: 'SK-TA',
        name: 'Trnavský kraj',
        parent: 'SK',
    },
    'SK-TC': {
        code: 'SK-TC',
        name: 'Trenčiansky kraj',
        parent: 'SK',
    },
    'SK-ZI': {
        code: 'SK-ZI',
        name: 'Žilinský kraj',
        parent: 'SK',
    },
    'SL-E': {
        code: 'SL-E',
        name: 'Eastern',
        parent: 'SL',
    },
    'SL-N': {
        code: 'SL-N',
        name: 'Northern',
        parent: 'SL',
    },
    'SL-NW': {
        code: 'SL-NW',
        name: 'North Western',
        parent: 'SL',
    },
    'SL-S': {
        code: 'SL-S',
        name: 'Southern',
        parent: 'SL',
    },
    'SL-W': {
        code: 'SL-W',
        name: 'Western Area (Freetown)',
        parent: 'SL',
    },
    'SM-01': {
        code: 'SM-01',
        name: 'Acquaviva',
        parent: 'SM',
    },
    'SM-02': {
        code: 'SM-02',
        name: 'Chiesanuova',
        parent: 'SM',
    },
    'SM-03': {
        code: 'SM-03',
        name: 'Domagnano',
        parent: 'SM',
    },
    'SM-04': {
        code: 'SM-04',
        name: 'Faetano',
        parent: 'SM',
    },
    'SM-05': {
        code: 'SM-05',
        name: 'Fiorentino',
        parent: 'SM',
    },
    'SM-06': {
        code: 'SM-06',
        name: 'Borgo Maggiore',
        parent: 'SM',
    },
    'SM-07': {
        code: 'SM-07',
        name: 'Città di San Marino(local variant is San Marino)',
        parent: 'SM',
    },
    'SM-08': {
        code: 'SM-08',
        name: 'Montegiardino',
        parent: 'SM',
    },
    'SM-09': {
        code: 'SM-09',
        name: 'Serravalle',
        parent: 'SM',
    },
    'SN-DB': {
        code: 'SN-DB',
        name: 'Diourbel',
        parent: 'SN',
    },
    'SN-DK': {
        code: 'SN-DK',
        name: 'Dakar',
        parent: 'SN',
    },
    'SN-FK': {
        code: 'SN-FK',
        name: 'Fatick',
        parent: 'SN',
    },
    'SN-KA': {
        code: 'SN-KA',
        name: 'Kaffrine',
        parent: 'SN',
    },
    'SN-KD': {
        code: 'SN-KD',
        name: 'Kolda',
        parent: 'SN',
    },
    'SN-KE': {
        code: 'SN-KE',
        name: 'Kédougou',
        parent: 'SN',
    },
    'SN-KL': {
        code: 'SN-KL',
        name: 'Kaolack',
        parent: 'SN',
    },
    'SN-LG': {
        code: 'SN-LG',
        name: 'Louga',
        parent: 'SN',
    },
    'SN-MT': {
        code: 'SN-MT',
        name: 'Matam',
        parent: 'SN',
    },
    'SN-SE': {
        code: 'SN-SE',
        name: 'Sédhiou',
        parent: 'SN',
    },
    'SN-SL': {
        code: 'SN-SL',
        name: 'Saint-Louis',
        parent: 'SN',
    },
    'SN-TC': {
        code: 'SN-TC',
        name: 'Tambacounda',
        parent: 'SN',
    },
    'SN-TH': {
        code: 'SN-TH',
        name: 'Thiès',
        parent: 'SN',
    },
    'SN-ZG': {
        code: 'SN-ZG',
        name: 'Ziguinchor',
        parent: 'SN',
    },
    'SO-AW': {
        code: 'SO-AW',
        name: 'Awdal',
        parent: 'SO',
    },
    'SO-BK': {
        code: 'SO-BK',
        name: 'Bakool',
        parent: 'SO',
    },
    'SO-BN': {
        code: 'SO-BN',
        name: 'Banaadir',
        parent: 'SO',
    },
    'SO-BR': {
        code: 'SO-BR',
        name: 'Bari',
        parent: 'SO',
    },
    'SO-BY': {
        code: 'SO-BY',
        name: 'Bay',
        parent: 'SO',
    },
    'SO-GA': {
        code: 'SO-GA',
        name: 'Galguduud',
        parent: 'SO',
    },
    'SO-GE': {
        code: 'SO-GE',
        name: 'Gedo',
        parent: 'SO',
    },
    'SO-HI': {
        code: 'SO-HI',
        name: 'Hiiraan',
        parent: 'SO',
    },
    'SO-JD': {
        code: 'SO-JD',
        name: 'Jubbada Dhexe',
        parent: 'SO',
    },
    'SO-JH': {
        code: 'SO-JH',
        name: 'Jubbada Hoose',
        parent: 'SO',
    },
    'SO-MU': {
        code: 'SO-MU',
        name: 'Mudug',
        parent: 'SO',
    },
    'SO-NU': {
        code: 'SO-NU',
        name: 'Nugaal',
        parent: 'SO',
    },
    'SO-SA': {
        code: 'SO-SA',
        name: 'Sanaag',
        parent: 'SO',
    },
    'SO-SD': {
        code: 'SO-SD',
        name: 'Shabeellaha Dhexe',
        parent: 'SO',
    },
    'SO-SH': {
        code: 'SO-SH',
        name: 'Shabeellaha Hoose',
        parent: 'SO',
    },
    'SO-SO': {
        code: 'SO-SO',
        name: 'Sool',
        parent: 'SO',
    },
    'SO-TO': {
        code: 'SO-TO',
        name: 'Togdheer',
        parent: 'SO',
    },
    'SO-WO': {
        code: 'SO-WO',
        name: 'Woqooyi Galbeed',
        parent: 'SO',
    },
    'SR-BR': {
        code: 'SR-BR',
        name: 'Brokopondo',
        parent: 'SR',
    },
    'SR-CM': {
        code: 'SR-CM',
        name: 'Commewijne',
        parent: 'SR',
    },
    'SR-CR': {
        code: 'SR-CR',
        name: 'Coronie',
        parent: 'SR',
    },
    'SR-MA': {
        code: 'SR-MA',
        name: 'Marowijne',
        parent: 'SR',
    },
    'SR-NI': {
        code: 'SR-NI',
        name: 'Nickerie',
        parent: 'SR',
    },
    'SR-PM': {
        code: 'SR-PM',
        name: 'Paramaribo',
        parent: 'SR',
    },
    'SR-PR': {
        code: 'SR-PR',
        name: 'Para',
        parent: 'SR',
    },
    'SR-SA': {
        code: 'SR-SA',
        name: 'Saramacca',
        parent: 'SR',
    },
    'SR-SI': {
        code: 'SR-SI',
        name: 'Sipaliwini',
        parent: 'SR',
    },
    'SR-WA': {
        code: 'SR-WA',
        name: 'Wanica',
        parent: 'SR',
    },
    'SS-BN': {
        code: 'SS-BN',
        name: 'Northern Bahr el Ghazal',
        parent: 'SS',
    },
    'SS-BW': {
        code: 'SS-BW',
        name: 'Western Bahr el Ghazal',
        parent: 'SS',
    },
    'SS-EC': {
        code: 'SS-EC',
        name: 'Central Equatoria',
        parent: 'SS',
    },
    'SS-EE': {
        code: 'SS-EE',
        name: 'Eastern Equatoria',
        parent: 'SS',
    },
    'SS-EW': {
        code: 'SS-EW',
        name: 'Western Equatoria',
        parent: 'SS',
    },
    'SS-JG': {
        code: 'SS-JG',
        name: 'Jonglei',
        parent: 'SS',
    },
    'SS-LK': {
        code: 'SS-LK',
        name: 'Lakes',
        parent: 'SS',
    },
    'SS-NU': {
        code: 'SS-NU',
        name: 'Upper Nile',
        parent: 'SS',
    },
    'SS-UY': {
        code: 'SS-UY',
        name: 'Unity',
        parent: 'SS',
    },
    'SS-WR': {
        code: 'SS-WR',
        name: 'Warrap',
        parent: 'SS',
    },
    'ST-01': {
        code: 'ST-01',
        name: 'Água Grande',
        parent: 'ST',
    },
    'ST-02': {
        code: 'ST-02',
        name: 'Cantagalo',
        parent: 'ST',
    },
    'ST-03': {
        code: 'ST-03',
        name: 'Caué',
        parent: 'ST',
    },
    'ST-04': {
        code: 'ST-04',
        name: 'Lembá',
        parent: 'ST',
    },
    'ST-05': {
        code: 'ST-05',
        name: 'Lobata',
        parent: 'ST',
    },
    'ST-06': {
        code: 'ST-06',
        name: 'Mé-Zóchi',
        parent: 'ST',
    },
    'ST-P': {
        code: 'ST-P',
        name: 'Príncipe',
        parent: 'ST',
    },
    'SV-AH': {
        code: 'SV-AH',
        name: 'Ahuachapán',
        parent: 'SV',
    },
    'SV-CA': {
        code: 'SV-CA',
        name: 'Cabañas',
        parent: 'SV',
    },
    'SV-CH': {
        code: 'SV-CH',
        name: 'Chalatenango',
        parent: 'SV',
    },
    'SV-CU': {
        code: 'SV-CU',
        name: 'Cuscatlán',
        parent: 'SV',
    },
    'SV-LI': {
        code: 'SV-LI',
        name: 'La Libertad',
        parent: 'SV',
    },
    'SV-MO': {
        code: 'SV-MO',
        name: 'Morazán',
        parent: 'SV',
    },
    'SV-PA': {
        code: 'SV-PA',
        name: 'La Paz',
        parent: 'SV',
    },
    'SV-SA': {
        code: 'SV-SA',
        name: 'Santa Ana',
        parent: 'SV',
    },
    'SV-SM': {
        code: 'SV-SM',
        name: 'San Miguel',
        parent: 'SV',
    },
    'SV-SO': {
        code: 'SV-SO',
        name: 'Sonsonate',
        parent: 'SV',
    },
    'SV-SS': {
        code: 'SV-SS',
        name: 'San Salvador',
        parent: 'SV',
    },
    'SV-SV': {
        code: 'SV-SV',
        name: 'San Vicente',
        parent: 'SV',
    },
    'SV-UN': {
        code: 'SV-UN',
        name: 'La Unión',
        parent: 'SV',
    },
    'SV-US': {
        code: 'SV-US',
        name: 'Usulután',
        parent: 'SV',
    },
    'SY-DI': {
        code: 'SY-DI',
        name: 'Dimashq',
        parent: 'SY',
    },
    'SY-DR': {
        code: 'SY-DR',
        name: "Dar'ā",
        parent: 'SY',
    },
    'SY-DY': {
        code: 'SY-DY',
        name: 'Dayr az Zawr',
        parent: 'SY',
    },
    'SY-HA': {
        code: 'SY-HA',
        name: 'Al Ḩasakah',
        parent: 'SY',
    },
    'SY-HI': {
        code: 'SY-HI',
        name: 'Ḩimş',
        parent: 'SY',
    },
    'SY-HL': {
        code: 'SY-HL',
        name: 'Ḩalab',
        parent: 'SY',
    },
    'SY-HM': {
        code: 'SY-HM',
        name: 'Ḩamāh',
        parent: 'SY',
    },
    'SY-ID': {
        code: 'SY-ID',
        name: 'Idlib',
        parent: 'SY',
    },
    'SY-LA': {
        code: 'SY-LA',
        name: 'Al Lādhiqīyah',
        parent: 'SY',
    },
    'SY-QU': {
        code: 'SY-QU',
        name: 'Al Qunayţirah',
        parent: 'SY',
    },
    'SY-RA': {
        code: 'SY-RA',
        name: 'Ar Raqqah',
        parent: 'SY',
    },
    'SY-RD': {
        code: 'SY-RD',
        name: 'Rīf Dimashq',
        parent: 'SY',
    },
    'SY-SU': {
        code: 'SY-SU',
        name: "As Suwaydā'",
        parent: 'SY',
    },
    'SY-TA': {
        code: 'SY-TA',
        name: 'Ţarţūs',
        parent: 'SY',
    },
    'SZ-HH': {
        code: 'SZ-HH',
        name: 'Hhohho',
        parent: 'SZ',
    },
    'SZ-LU': {
        code: 'SZ-LU',
        name: 'Lubombo',
        parent: 'SZ',
    },
    'SZ-MA': {
        code: 'SZ-MA',
        name: 'Manzini',
        parent: 'SZ',
    },
    'SZ-SH': {
        code: 'SZ-SH',
        name: 'Shiselweni',
        parent: 'SZ',
    },
    'TD-BA': {
        code: 'TD-BA',
        name: 'Al Baţḩā’',
        parent: 'TD',
    },
    'TD-BG': {
        code: 'TD-BG',
        name: 'Baḩr al Ghazāl',
        parent: 'TD',
    },
    'TD-BO': {
        code: 'TD-BO',
        name: 'Būrkū',
        parent: 'TD',
    },
    'TD-CB': {
        code: 'TD-CB',
        name: 'Shārī Bāqirmī',
        parent: 'TD',
    },
    'TD-EE': {
        code: 'TD-EE',
        name: 'Inīdī ash Sharqī',
        parent: 'TD',
    },
    'TD-EO': {
        code: 'TD-EO',
        name: 'Inīdī al Gharbī',
        parent: 'TD',
    },
    'TD-GR': {
        code: 'TD-GR',
        name: 'Qīrā',
        parent: 'TD',
    },
    'TD-HL': {
        code: 'TD-HL',
        name: 'Ḩajjar Lamīs',
        parent: 'TD',
    },
    'TD-KA': {
        code: 'TD-KA',
        name: 'Kānim',
        parent: 'TD',
    },
    'TD-LC': {
        code: 'TD-LC',
        name: 'Al Buḩayrah',
        parent: 'TD',
    },
    'TD-LO': {
        code: 'TD-LO',
        name: 'Lūghūn al Gharbī',
        parent: 'TD',
    },
    'TD-LR': {
        code: 'TD-LR',
        name: 'Lūghūn ash Sharqī',
        parent: 'TD',
    },
    'TD-MA': {
        code: 'TD-MA',
        name: 'Māndūl',
        parent: 'TD',
    },
    'TD-MC': {
        code: 'TD-MC',
        name: 'Shārī al Awsaţ',
        parent: 'TD',
    },
    'TD-ME': {
        code: 'TD-ME',
        name: 'Māyū Kībbī ash Sharqī',
        parent: 'TD',
    },
    'TD-MO': {
        code: 'TD-MO',
        name: 'Māyū Kībbī al Gharbī',
        parent: 'TD',
    },
    'TD-ND': {
        code: 'TD-ND',
        name: 'Madīnat Injamīnā',
        parent: 'TD',
    },
    'TD-OD': {
        code: 'TD-OD',
        name: 'Waddāy',
        parent: 'TD',
    },
    'TD-SA': {
        code: 'TD-SA',
        name: 'Salāmāt',
        parent: 'TD',
    },
    'TD-SI': {
        code: 'TD-SI',
        name: 'Sīlā',
        parent: 'TD',
    },
    'TD-TA': {
        code: 'TD-TA',
        name: 'Tānjīlī',
        parent: 'TD',
    },
    'TD-TI': {
        code: 'TD-TI',
        name: 'Tibastī',
        parent: 'TD',
    },
    'TD-WF': {
        code: 'TD-WF',
        name: 'Wādī Fīrā’',
        parent: 'TD',
    },
    'TG-C': {
        code: 'TG-C',
        name: 'Centrale',
        parent: 'TG',
    },
    'TG-K': {
        code: 'TG-K',
        name: 'Kara',
        parent: 'TG',
    },
    'TG-M': {
        code: 'TG-M',
        name: 'Maritime (Région)',
        parent: 'TG',
    },
    'TG-P': {
        code: 'TG-P',
        name: 'Plateaux',
        parent: 'TG',
    },
    'TG-S': {
        code: 'TG-S',
        name: 'Savanes',
        parent: 'TG',
    },
    'TH-10': {
        code: 'TH-10',
        name: 'Krung Thep Maha Nakhon(local variant is Bangkok)',
        parent: 'TH',
    },
    'TH-11': {
        code: 'TH-11',
        name: 'Samut Prakan',
        parent: 'TH',
    },
    'TH-12': {
        code: 'TH-12',
        name: 'Nonthaburi',
        parent: 'TH',
    },
    'TH-13': {
        code: 'TH-13',
        name: 'Pathum Thani',
        parent: 'TH',
    },
    'TH-14': {
        code: 'TH-14',
        name: 'Phra Nakhon Si Ayutthaya',
        parent: 'TH',
    },
    'TH-15': {
        code: 'TH-15',
        name: 'Ang Thong',
        parent: 'TH',
    },
    'TH-16': {
        code: 'TH-16',
        name: 'Lop Buri',
        parent: 'TH',
    },
    'TH-17': {
        code: 'TH-17',
        name: 'Sing Buri',
        parent: 'TH',
    },
    'TH-18': {
        code: 'TH-18',
        name: 'Chai Nat',
        parent: 'TH',
    },
    'TH-19': {
        code: 'TH-19',
        name: 'Saraburi',
        parent: 'TH',
    },
    'TH-20': {
        code: 'TH-20',
        name: 'Chon Buri',
        parent: 'TH',
    },
    'TH-21': {
        code: 'TH-21',
        name: 'Rayong',
        parent: 'TH',
    },
    'TH-22': {
        code: 'TH-22',
        name: 'Chanthaburi',
        parent: 'TH',
    },
    'TH-23': {
        code: 'TH-23',
        name: 'Trat',
        parent: 'TH',
    },
    'TH-24': {
        code: 'TH-24',
        name: 'Chachoengsao',
        parent: 'TH',
    },
    'TH-25': {
        code: 'TH-25',
        name: 'Prachin Buri',
        parent: 'TH',
    },
    'TH-26': {
        code: 'TH-26',
        name: 'Nakhon Nayok',
        parent: 'TH',
    },
    'TH-27': {
        code: 'TH-27',
        name: 'Sa Kaeo',
        parent: 'TH',
    },
    'TH-30': {
        code: 'TH-30',
        name: 'Nakhon Ratchasima',
        parent: 'TH',
    },
    'TH-31': {
        code: 'TH-31',
        name: 'Buri Ram',
        parent: 'TH',
    },
    'TH-32': {
        code: 'TH-32',
        name: 'Surin',
        parent: 'TH',
    },
    'TH-33': {
        code: 'TH-33',
        name: 'Si Sa Ket',
        parent: 'TH',
    },
    'TH-34': {
        code: 'TH-34',
        name: 'Ubon Ratchathani',
        parent: 'TH',
    },
    'TH-35': {
        code: 'TH-35',
        name: 'Yasothon',
        parent: 'TH',
    },
    'TH-36': {
        code: 'TH-36',
        name: 'Chaiyaphum',
        parent: 'TH',
    },
    'TH-37': {
        code: 'TH-37',
        name: 'Amnat Charoen',
        parent: 'TH',
    },
    'TH-38': {
        code: 'TH-38',
        name: 'Bueng Kan',
        parent: 'TH',
    },
    'TH-39': {
        code: 'TH-39',
        name: 'Nong Bua Lam Phu',
        parent: 'TH',
    },
    'TH-40': {
        code: 'TH-40',
        name: 'Khon Kaen',
        parent: 'TH',
    },
    'TH-41': {
        code: 'TH-41',
        name: 'Udon Thani',
        parent: 'TH',
    },
    'TH-42': {
        code: 'TH-42',
        name: 'Loei',
        parent: 'TH',
    },
    'TH-43': {
        code: 'TH-43',
        name: 'Nong Khai',
        parent: 'TH',
    },
    'TH-44': {
        code: 'TH-44',
        name: 'Maha Sarakham',
        parent: 'TH',
    },
    'TH-45': {
        code: 'TH-45',
        name: 'Roi Et',
        parent: 'TH',
    },
    'TH-46': {
        code: 'TH-46',
        name: 'Kalasin',
        parent: 'TH',
    },
    'TH-47': {
        code: 'TH-47',
        name: 'Sakon Nakhon',
        parent: 'TH',
    },
    'TH-48': {
        code: 'TH-48',
        name: 'Nakhon Phanom',
        parent: 'TH',
    },
    'TH-49': {
        code: 'TH-49',
        name: 'Mukdahan',
        parent: 'TH',
    },
    'TH-50': {
        code: 'TH-50',
        name: 'Chiang Mai',
        parent: 'TH',
    },
    'TH-51': {
        code: 'TH-51',
        name: 'Lamphun',
        parent: 'TH',
    },
    'TH-52': {
        code: 'TH-52',
        name: 'Lampang',
        parent: 'TH',
    },
    'TH-53': {
        code: 'TH-53',
        name: 'Uttaradit',
        parent: 'TH',
    },
    'TH-54': {
        code: 'TH-54',
        name: 'Phrae',
        parent: 'TH',
    },
    'TH-55': {
        code: 'TH-55',
        name: 'Nan',
        parent: 'TH',
    },
    'TH-56': {
        code: 'TH-56',
        name: 'Phayao',
        parent: 'TH',
    },
    'TH-57': {
        code: 'TH-57',
        name: 'Chiang Rai',
        parent: 'TH',
    },
    'TH-58': {
        code: 'TH-58',
        name: 'Mae Hong Son',
        parent: 'TH',
    },
    'TH-60': {
        code: 'TH-60',
        name: 'Nakhon Sawan',
        parent: 'TH',
    },
    'TH-61': {
        code: 'TH-61',
        name: 'Uthai Thani',
        parent: 'TH',
    },
    'TH-62': {
        code: 'TH-62',
        name: 'Kamphaeng Phet',
        parent: 'TH',
    },
    'TH-63': {
        code: 'TH-63',
        name: 'Tak',
        parent: 'TH',
    },
    'TH-64': {
        code: 'TH-64',
        name: 'Sukhothai',
        parent: 'TH',
    },
    'TH-65': {
        code: 'TH-65',
        name: 'Phitsanulok',
        parent: 'TH',
    },
    'TH-66': {
        code: 'TH-66',
        name: 'Phichit',
        parent: 'TH',
    },
    'TH-67': {
        code: 'TH-67',
        name: 'Phetchabun',
        parent: 'TH',
    },
    'TH-70': {
        code: 'TH-70',
        name: 'Ratchaburi',
        parent: 'TH',
    },
    'TH-71': {
        code: 'TH-71',
        name: 'Kanchanaburi',
        parent: 'TH',
    },
    'TH-72': {
        code: 'TH-72',
        name: 'Suphan Buri',
        parent: 'TH',
    },
    'TH-73': {
        code: 'TH-73',
        name: 'Nakhon Pathom',
        parent: 'TH',
    },
    'TH-74': {
        code: 'TH-74',
        name: 'Samut Sakhon',
        parent: 'TH',
    },
    'TH-75': {
        code: 'TH-75',
        name: 'Samut Songkhram',
        parent: 'TH',
    },
    'TH-76': {
        code: 'TH-76',
        name: 'Phetchaburi',
        parent: 'TH',
    },
    'TH-77': {
        code: 'TH-77',
        name: 'Prachuap Khiri Khan',
        parent: 'TH',
    },
    'TH-80': {
        code: 'TH-80',
        name: 'Nakhon Si Thammarat',
        parent: 'TH',
    },
    'TH-81': {
        code: 'TH-81',
        name: 'Krabi',
        parent: 'TH',
    },
    'TH-82': {
        code: 'TH-82',
        name: 'Phangnga',
        parent: 'TH',
    },
    'TH-83': {
        code: 'TH-83',
        name: 'Phuket',
        parent: 'TH',
    },
    'TH-84': {
        code: 'TH-84',
        name: 'Surat Thani',
        parent: 'TH',
    },
    'TH-85': {
        code: 'TH-85',
        name: 'Ranong',
        parent: 'TH',
    },
    'TH-86': {
        code: 'TH-86',
        name: 'Chumphon',
        parent: 'TH',
    },
    'TH-90': {
        code: 'TH-90',
        name: 'Songkhla',
        parent: 'TH',
    },
    'TH-91': {
        code: 'TH-91',
        name: 'Satun',
        parent: 'TH',
    },
    'TH-92': {
        code: 'TH-92',
        name: 'Trang',
        parent: 'TH',
    },
    'TH-93': {
        code: 'TH-93',
        name: 'Phatthalung',
        parent: 'TH',
    },
    'TH-94': {
        code: 'TH-94',
        name: 'Pattani',
        parent: 'TH',
    },
    'TH-95': {
        code: 'TH-95',
        name: 'Yala',
        parent: 'TH',
    },
    'TH-96': {
        code: 'TH-96',
        name: 'Narathiwat',
        parent: 'TH',
    },
    'TH-S': {
        code: 'TH-S',
        name: 'Phatthaya',
        parent: 'TH',
    },
    'TJ-DU': {
        code: 'TJ-DU',
        name: 'Dushanbe',
        parent: 'TJ',
    },
    'TJ-GB': {
        code: 'TJ-GB',
        name: 'Kŭhistoni Badakhshon',
        parent: 'TJ',
    },
    'TJ-KT': {
        code: 'TJ-KT',
        name: 'Khatlon',
        parent: 'TJ',
    },
    'TJ-RA': {
        code: 'TJ-RA',
        name: 'nohiyahoi tobei jumhurí',
        parent: 'TJ',
    },
    'TJ-SU': {
        code: 'TJ-SU',
        name: 'Sughd',
        parent: 'TJ',
    },
    'TL-AL': {
        code: 'TL-AL',
        name: 'Aileu',
        parent: 'TL',
    },
    'TL-AN': {
        code: 'TL-AN',
        name: 'Ainaro',
        parent: 'TL',
    },
    'TL-BA': {
        code: 'TL-BA',
        name: 'Baucau',
        parent: 'TL',
    },
    'TL-BO': {
        code: 'TL-BO',
        name: 'Bobonaro',
        parent: 'TL',
    },
    'TL-CO': {
        code: 'TL-CO',
        name: 'Cova Lima',
        parent: 'TL',
    },
    'TL-DI': {
        code: 'TL-DI',
        name: 'Díli',
        parent: 'TL',
    },
    'TL-ER': {
        code: 'TL-ER',
        name: 'Ermera',
        parent: 'TL',
    },
    'TL-LA': {
        code: 'TL-LA',
        name: 'Lautém',
        parent: 'TL',
    },
    'TL-LI': {
        code: 'TL-LI',
        name: 'Liquiça',
        parent: 'TL',
    },
    'TL-MF': {
        code: 'TL-MF',
        name: 'Manufahi',
        parent: 'TL',
    },
    'TL-MT': {
        code: 'TL-MT',
        name: 'Manatuto',
        parent: 'TL',
    },
    'TL-OE': {
        code: 'TL-OE',
        name: 'Oé-Cusse Ambeno(local variant is Oecussi)',
        parent: 'TL',
    },
    'TL-VI': {
        code: 'TL-VI',
        name: 'Viqueque',
        parent: 'TL',
    },
    'TM-A': {
        code: 'TM-A',
        name: 'Ahal',
        parent: 'TM',
    },
    'TM-B': {
        code: 'TM-B',
        name: 'Balkan',
        parent: 'TM',
    },
    'TM-D': {
        code: 'TM-D',
        name: 'Daşoguz',
        parent: 'TM',
    },
    'TM-L': {
        code: 'TM-L',
        name: 'Lebap',
        parent: 'TM',
    },
    'TM-M': {
        code: 'TM-M',
        name: 'Mary',
        parent: 'TM',
    },
    'TM-S': {
        code: 'TM-S',
        name: 'Aşgabat',
        parent: 'TM',
    },
    'TN-11': {
        code: 'TN-11',
        name: 'Tunis',
        parent: 'TN',
    },
    'TN-12': {
        code: 'TN-12',
        name: "L'Ariana",
        parent: 'TN',
    },
    'TN-13': {
        code: 'TN-13',
        name: 'Ben Arous',
        parent: 'TN',
    },
    'TN-14': {
        code: 'TN-14',
        name: 'La Manouba',
        parent: 'TN',
    },
    'TN-21': {
        code: 'TN-21',
        name: 'Nabeul',
        parent: 'TN',
    },
    'TN-22': {
        code: 'TN-22',
        name: 'Zaghouan',
        parent: 'TN',
    },
    'TN-23': {
        code: 'TN-23',
        name: 'Bizerte',
        parent: 'TN',
    },
    'TN-31': {
        code: 'TN-31',
        name: 'Béja',
        parent: 'TN',
    },
    'TN-32': {
        code: 'TN-32',
        name: 'Jendouba',
        parent: 'TN',
    },
    'TN-33': {
        code: 'TN-33',
        name: 'Le Kef',
        parent: 'TN',
    },
    'TN-34': {
        code: 'TN-34',
        name: 'Siliana',
        parent: 'TN',
    },
    'TN-41': {
        code: 'TN-41',
        name: 'Kairouan',
        parent: 'TN',
    },
    'TN-42': {
        code: 'TN-42',
        name: 'Kasserine',
        parent: 'TN',
    },
    'TN-43': {
        code: 'TN-43',
        name: 'Sidi Bouzid',
        parent: 'TN',
    },
    'TN-51': {
        code: 'TN-51',
        name: 'Sousse',
        parent: 'TN',
    },
    'TN-52': {
        code: 'TN-52',
        name: 'Monastir',
        parent: 'TN',
    },
    'TN-53': {
        code: 'TN-53',
        name: 'Mahdia',
        parent: 'TN',
    },
    'TN-61': {
        code: 'TN-61',
        name: 'Sfax',
        parent: 'TN',
    },
    'TN-71': {
        code: 'TN-71',
        name: 'Gafsa',
        parent: 'TN',
    },
    'TN-72': {
        code: 'TN-72',
        name: 'Tozeur',
        parent: 'TN',
    },
    'TN-73': {
        code: 'TN-73',
        name: 'Kébili',
        parent: 'TN',
    },
    'TN-81': {
        code: 'TN-81',
        name: 'Gabès',
        parent: 'TN',
    },
    'TN-82': {
        code: 'TN-82',
        name: 'Médenine',
        parent: 'TN',
    },
    'TN-83': {
        code: 'TN-83',
        name: 'Tataouine',
        parent: 'TN',
    },
    'TO-01': {
        code: 'TO-01',
        name: "'Eua",
        parent: 'TO',
    },
    'TO-02': {
        code: 'TO-02',
        name: "Ha'apai",
        parent: 'TO',
    },
    'TO-03': {
        code: 'TO-03',
        name: 'Niuas',
        parent: 'TO',
    },
    'TO-04': {
        code: 'TO-04',
        name: 'Tongatapu',
        parent: 'TO',
    },
    'TO-05': {
        code: 'TO-05',
        name: "Vava'u",
        parent: 'TO',
    },
    'TR-01': {
        code: 'TR-01',
        name: 'Adana',
        parent: 'TR',
    },
    'TR-02': {
        code: 'TR-02',
        name: 'Adıyaman',
        parent: 'TR',
    },
    'TR-03': {
        code: 'TR-03',
        name: 'Afyonkarahisar',
        parent: 'TR',
    },
    'TR-04': {
        code: 'TR-04',
        name: 'Ağrı',
        parent: 'TR',
    },
    'TR-05': {
        code: 'TR-05',
        name: 'Amasya',
        parent: 'TR',
    },
    'TR-06': {
        code: 'TR-06',
        name: 'Ankara',
        parent: 'TR',
    },
    'TR-07': {
        code: 'TR-07',
        name: 'Antalya',
        parent: 'TR',
    },
    'TR-08': {
        code: 'TR-08',
        name: 'Artvin',
        parent: 'TR',
    },
    'TR-09': {
        code: 'TR-09',
        name: 'Aydın',
        parent: 'TR',
    },
    'TR-10': {
        code: 'TR-10',
        name: 'Balıkesir',
        parent: 'TR',
    },
    'TR-11': {
        code: 'TR-11',
        name: 'Bilecik',
        parent: 'TR',
    },
    'TR-12': {
        code: 'TR-12',
        name: 'Bingöl',
        parent: 'TR',
    },
    'TR-13': {
        code: 'TR-13',
        name: 'Bitlis',
        parent: 'TR',
    },
    'TR-14': {
        code: 'TR-14',
        name: 'Bolu',
        parent: 'TR',
    },
    'TR-15': {
        code: 'TR-15',
        name: 'Burdur',
        parent: 'TR',
    },
    'TR-16': {
        code: 'TR-16',
        name: 'Bursa',
        parent: 'TR',
    },
    'TR-17': {
        code: 'TR-17',
        name: 'Çanakkale',
        parent: 'TR',
    },
    'TR-18': {
        code: 'TR-18',
        name: 'Çankırı',
        parent: 'TR',
    },
    'TR-19': {
        code: 'TR-19',
        name: 'Çorum',
        parent: 'TR',
    },
    'TR-20': {
        code: 'TR-20',
        name: 'Denizli',
        parent: 'TR',
    },
    'TR-21': {
        code: 'TR-21',
        name: 'Diyarbakır',
        parent: 'TR',
    },
    'TR-22': {
        code: 'TR-22',
        name: 'Edirne',
        parent: 'TR',
    },
    'TR-23': {
        code: 'TR-23',
        name: 'Elazığ',
        parent: 'TR',
    },
    'TR-24': {
        code: 'TR-24',
        name: 'Erzincan',
        parent: 'TR',
    },
    'TR-25': {
        code: 'TR-25',
        name: 'Erzurum',
        parent: 'TR',
    },
    'TR-26': {
        code: 'TR-26',
        name: 'Eskişehir',
        parent: 'TR',
    },
    'TR-27': {
        code: 'TR-27',
        name: 'Gaziantep',
        parent: 'TR',
    },
    'TR-28': {
        code: 'TR-28',
        name: 'Giresun',
        parent: 'TR',
    },
    'TR-29': {
        code: 'TR-29',
        name: 'Gümüşhane',
        parent: 'TR',
    },
    'TR-30': {
        code: 'TR-30',
        name: 'Hakkâri',
        parent: 'TR',
    },
    'TR-31': {
        code: 'TR-31',
        name: 'Hatay',
        parent: 'TR',
    },
    'TR-32': {
        code: 'TR-32',
        name: 'Isparta',
        parent: 'TR',
    },
    'TR-33': {
        code: 'TR-33',
        name: 'Mersin',
        parent: 'TR',
    },
    'TR-34': {
        code: 'TR-34',
        name: 'İstanbul',
        parent: 'TR',
    },
    'TR-35': {
        code: 'TR-35',
        name: 'İzmir',
        parent: 'TR',
    },
    'TR-36': {
        code: 'TR-36',
        name: 'Kars',
        parent: 'TR',
    },
    'TR-37': {
        code: 'TR-37',
        name: 'Kastamonu',
        parent: 'TR',
    },
    'TR-38': {
        code: 'TR-38',
        name: 'Kayseri',
        parent: 'TR',
    },
    'TR-39': {
        code: 'TR-39',
        name: 'Kırklareli',
        parent: 'TR',
    },
    'TR-40': {
        code: 'TR-40',
        name: 'Kırşehir',
        parent: 'TR',
    },
    'TR-41': {
        code: 'TR-41',
        name: 'Kocaeli',
        parent: 'TR',
    },
    'TR-42': {
        code: 'TR-42',
        name: 'Konya',
        parent: 'TR',
    },
    'TR-43': {
        code: 'TR-43',
        name: 'Kütahya',
        parent: 'TR',
    },
    'TR-44': {
        code: 'TR-44',
        name: 'Malatya',
        parent: 'TR',
    },
    'TR-45': {
        code: 'TR-45',
        name: 'Manisa',
        parent: 'TR',
    },
    'TR-46': {
        code: 'TR-46',
        name: 'Kahramanmaraş',
        parent: 'TR',
    },
    'TR-47': {
        code: 'TR-47',
        name: 'Mardin',
        parent: 'TR',
    },
    'TR-48': {
        code: 'TR-48',
        name: 'Muğla',
        parent: 'TR',
    },
    'TR-49': {
        code: 'TR-49',
        name: 'Muş',
        parent: 'TR',
    },
    'TR-50': {
        code: 'TR-50',
        name: 'Nevşehir',
        parent: 'TR',
    },
    'TR-51': {
        code: 'TR-51',
        name: 'Niğde',
        parent: 'TR',
    },
    'TR-52': {
        code: 'TR-52',
        name: 'Ordu',
        parent: 'TR',
    },
    'TR-53': {
        code: 'TR-53',
        name: 'Rize',
        parent: 'TR',
    },
    'TR-54': {
        code: 'TR-54',
        name: 'Sakarya',
        parent: 'TR',
    },
    'TR-55': {
        code: 'TR-55',
        name: 'Samsun',
        parent: 'TR',
    },
    'TR-56': {
        code: 'TR-56',
        name: 'Siirt',
        parent: 'TR',
    },
    'TR-57': {
        code: 'TR-57',
        name: 'Sinop',
        parent: 'TR',
    },
    'TR-58': {
        code: 'TR-58',
        name: 'Sivas',
        parent: 'TR',
    },
    'TR-59': {
        code: 'TR-59',
        name: 'Tekirdağ',
        parent: 'TR',
    },
    'TR-60': {
        code: 'TR-60',
        name: 'Tokat',
        parent: 'TR',
    },
    'TR-61': {
        code: 'TR-61',
        name: 'Trabzon',
        parent: 'TR',
    },
    'TR-62': {
        code: 'TR-62',
        name: 'Tunceli',
        parent: 'TR',
    },
    'TR-63': {
        code: 'TR-63',
        name: 'Şanlıurfa',
        parent: 'TR',
    },
    'TR-64': {
        code: 'TR-64',
        name: 'Uşak',
        parent: 'TR',
    },
    'TR-65': {
        code: 'TR-65',
        name: 'Van',
        parent: 'TR',
    },
    'TR-66': {
        code: 'TR-66',
        name: 'Yozgat',
        parent: 'TR',
    },
    'TR-67': {
        code: 'TR-67',
        name: 'Zonguldak',
        parent: 'TR',
    },
    'TR-68': {
        code: 'TR-68',
        name: 'Aksaray',
        parent: 'TR',
    },
    'TR-69': {
        code: 'TR-69',
        name: 'Bayburt',
        parent: 'TR',
    },
    'TR-70': {
        code: 'TR-70',
        name: 'Karaman',
        parent: 'TR',
    },
    'TR-71': {
        code: 'TR-71',
        name: 'Kırıkkale',
        parent: 'TR',
    },
    'TR-72': {
        code: 'TR-72',
        name: 'Batman',
        parent: 'TR',
    },
    'TR-73': {
        code: 'TR-73',
        name: 'Şırnak',
        parent: 'TR',
    },
    'TR-74': {
        code: 'TR-74',
        name: 'Bartın',
        parent: 'TR',
    },
    'TR-75': {
        code: 'TR-75',
        name: 'Ardahan',
        parent: 'TR',
    },
    'TR-76': {
        code: 'TR-76',
        name: 'Iğdır',
        parent: 'TR',
    },
    'TR-77': {
        code: 'TR-77',
        name: 'Yalova',
        parent: 'TR',
    },
    'TR-78': {
        code: 'TR-78',
        name: 'Karabük',
        parent: 'TR',
    },
    'TR-79': {
        code: 'TR-79',
        name: 'Kilis',
        parent: 'TR',
    },
    'TR-80': {
        code: 'TR-80',
        name: 'Osmaniye',
        parent: 'TR',
    },
    'TR-81': {
        code: 'TR-81',
        name: 'Düzce',
        parent: 'TR',
    },
    'TT-ARI': {
        code: 'TT-ARI',
        name: 'Arima',
        parent: 'TT',
    },
    'TT-CHA': {
        code: 'TT-CHA',
        name: 'Chaguanas',
        parent: 'TT',
    },
    'TT-CTT': {
        code: 'TT-CTT',
        name: 'Couva–Tabaquite–Talparo',
        parent: 'TT',
    },
    'TT-DMN': {
        code: 'TT-DMN',
        name: 'Diego Martin',
        parent: 'TT',
    },
    'TT-MRC': {
        code: 'TT-MRC',
        name: 'Mayaro-Rio Claro',
        parent: 'TT',
    },
    'TT-PED': {
        code: 'TT-PED',
        name: 'Penal-Debe',
        parent: 'TT',
    },
    'TT-POS': {
        code: 'TT-POS',
        name: 'Port of Spain',
        parent: 'TT',
    },
    'TT-PRT': {
        code: 'TT-PRT',
        name: 'Princes Town',
        parent: 'TT',
    },
    'TT-PTF': {
        code: 'TT-PTF',
        name: 'Point Fortin',
        parent: 'TT',
    },
    'TT-SFO': {
        code: 'TT-SFO',
        name: 'San Fernando',
        parent: 'TT',
    },
    'TT-SGE': {
        code: 'TT-SGE',
        name: 'Sangre Grande',
        parent: 'TT',
    },
    'TT-SIP': {
        code: 'TT-SIP',
        name: 'Siparia',
        parent: 'TT',
    },
    'TT-SJL': {
        code: 'TT-SJL',
        name: 'San Juan-Laventille',
        parent: 'TT',
    },
    'TT-TOB': {
        code: 'TT-TOB',
        name: 'Tobago',
        parent: 'TT',
    },
    'TT-TUP': {
        code: 'TT-TUP',
        name: 'Tunapuna-Piarco',
        parent: 'TT',
    },
    'TV-FUN': {
        code: 'TV-FUN',
        name: 'Funafuti',
        parent: 'TV',
    },
    'TV-NIT': {
        code: 'TV-NIT',
        name: 'Niutao',
        parent: 'TV',
    },
    'TV-NKF': {
        code: 'TV-NKF',
        name: 'Nukufetau',
        parent: 'TV',
    },
    'TV-NKL': {
        code: 'TV-NKL',
        name: 'Nukulaelae',
        parent: 'TV',
    },
    'TV-NMA': {
        code: 'TV-NMA',
        name: 'Nanumea',
        parent: 'TV',
    },
    'TV-NMG': {
        code: 'TV-NMG',
        name: 'Nanumaga',
        parent: 'TV',
    },
    'TV-NUI': {
        code: 'TV-NUI',
        name: 'Nui',
        parent: 'TV',
    },
    'TV-VAI': {
        code: 'TV-VAI',
        name: 'Vaitupu',
        parent: 'TV',
    },
    'TW-CHA': {
        code: 'TW-CHA',
        name: 'Changhua',
        parent: 'TW',
    },
    'TW-CYI': {
        code: 'TW-CYI',
        name: 'Chiayi',
        parent: 'TW',
    },
    'TW-CYQ': {
        code: 'TW-CYQ',
        name: 'Chiayi',
        parent: 'TW',
    },
    'TW-HSQ': {
        code: 'TW-HSQ',
        name: 'Hsinchu',
        parent: 'TW',
    },
    'TW-HSZ': {
        code: 'TW-HSZ',
        name: 'Hsinchu',
        parent: 'TW',
    },
    'TW-HUA': {
        code: 'TW-HUA',
        name: 'Hualien',
        parent: 'TW',
    },
    'TW-ILA': {
        code: 'TW-ILA',
        name: 'Yilan',
        parent: 'TW',
    },
    'TW-KEE': {
        code: 'TW-KEE',
        name: 'Keelung',
        parent: 'TW',
    },
    'TW-KHH': {
        code: 'TW-KHH',
        name: 'Kaohsiung',
        parent: 'TW',
    },
    'TW-KIN': {
        code: 'TW-KIN',
        name: 'Kinmen',
        parent: 'TW',
    },
    'TW-LIE': {
        code: 'TW-LIE',
        name: 'Lienchiang',
        parent: 'TW',
    },
    'TW-MIA': {
        code: 'TW-MIA',
        name: 'Miaoli',
        parent: 'TW',
    },
    'TW-NAN': {
        code: 'TW-NAN',
        name: 'Nantou',
        parent: 'TW',
    },
    'TW-NWT': {
        code: 'TW-NWT',
        name: 'New Taipei',
        parent: 'TW',
    },
    'TW-PEN': {
        code: 'TW-PEN',
        name: 'Penghu',
        parent: 'TW',
    },
    'TW-PIF': {
        code: 'TW-PIF',
        name: 'Pingtung',
        parent: 'TW',
    },
    'TW-TAO': {
        code: 'TW-TAO',
        name: 'Taoyuan',
        parent: 'TW',
    },
    'TW-TNN': {
        code: 'TW-TNN',
        name: 'Tainan',
        parent: 'TW',
    },
    'TW-TPE': {
        code: 'TW-TPE',
        name: 'Taipei',
        parent: 'TW',
    },
    'TW-TTT': {
        code: 'TW-TTT',
        name: 'Taitung',
        parent: 'TW',
    },
    'TW-TXG': {
        code: 'TW-TXG',
        name: 'Taichung',
        parent: 'TW',
    },
    'TW-YUN': {
        code: 'TW-YUN',
        name: 'Yunlin',
        parent: 'TW',
    },
    'TZ-01': {
        code: 'TZ-01',
        name: 'Arusha',
        parent: 'TZ',
    },
    'TZ-02': {
        code: 'TZ-02',
        name: 'Dar es Salaam',
        parent: 'TZ',
    },
    'TZ-03': {
        code: 'TZ-03',
        name: 'Dodoma',
        parent: 'TZ',
    },
    'TZ-04': {
        code: 'TZ-04',
        name: 'Iringa',
        parent: 'TZ',
    },
    'TZ-05': {
        code: 'TZ-05',
        name: 'Kagera',
        parent: 'TZ',
    },
    'TZ-06': {
        code: 'TZ-06',
        name: 'Kaskazini Pemba',
        parent: 'TZ',
    },
    'TZ-07': {
        code: 'TZ-07',
        name: 'Kaskazini Unguja',
        parent: 'TZ',
    },
    'TZ-08': {
        code: 'TZ-08',
        name: 'Kigoma',
        parent: 'TZ',
    },
    'TZ-09': {
        code: 'TZ-09',
        name: 'Kilimanjaro',
        parent: 'TZ',
    },
    'TZ-10': {
        code: 'TZ-10',
        name: 'Kusini Pemba',
        parent: 'TZ',
    },
    'TZ-11': {
        code: 'TZ-11',
        name: 'Kusini Unguja',
        parent: 'TZ',
    },
    'TZ-12': {
        code: 'TZ-12',
        name: 'Lindi',
        parent: 'TZ',
    },
    'TZ-13': {
        code: 'TZ-13',
        name: 'Mara',
        parent: 'TZ',
    },
    'TZ-14': {
        code: 'TZ-14',
        name: 'Mbeya',
        parent: 'TZ',
    },
    'TZ-15': {
        code: 'TZ-15',
        name: 'Mjini Magharibi',
        parent: 'TZ',
    },
    'TZ-16': {
        code: 'TZ-16',
        name: 'Morogoro',
        parent: 'TZ',
    },
    'TZ-17': {
        code: 'TZ-17',
        name: 'Mtwara',
        parent: 'TZ',
    },
    'TZ-18': {
        code: 'TZ-18',
        name: 'Mwanza',
        parent: 'TZ',
    },
    'TZ-19': {
        code: 'TZ-19',
        name: 'Pwani',
        parent: 'TZ',
    },
    'TZ-20': {
        code: 'TZ-20',
        name: 'Rukwa',
        parent: 'TZ',
    },
    'TZ-21': {
        code: 'TZ-21',
        name: 'Ruvuma',
        parent: 'TZ',
    },
    'TZ-22': {
        code: 'TZ-22',
        name: 'Shinyanga',
        parent: 'TZ',
    },
    'TZ-23': {
        code: 'TZ-23',
        name: 'Singida',
        parent: 'TZ',
    },
    'TZ-24': {
        code: 'TZ-24',
        name: 'Tabora',
        parent: 'TZ',
    },
    'TZ-25': {
        code: 'TZ-25',
        name: 'Tanga',
        parent: 'TZ',
    },
    'TZ-26': {
        code: 'TZ-26',
        name: 'Manyara',
        parent: 'TZ',
    },
    'TZ-27': {
        code: 'TZ-27',
        name: 'Geita',
        parent: 'TZ',
    },
    'TZ-28': {
        code: 'TZ-28',
        name: 'Katavi',
        parent: 'TZ',
    },
    'TZ-29': {
        code: 'TZ-29',
        name: 'Njombe',
        parent: 'TZ',
    },
    'TZ-30': {
        code: 'TZ-30',
        name: 'Simiyu',
        parent: 'TZ',
    },
    'TZ-31': {
        code: 'TZ-31',
        name: 'Songwe',
        parent: 'TZ',
    },
    'UA-05': {
        code: 'UA-05',
        name: 'Vinnytska oblast',
        parent: 'UA',
    },
    'UA-07': {
        code: 'UA-07',
        name: 'Volynska oblast',
        parent: 'UA',
    },
    'UA-09': {
        code: 'UA-09',
        name: 'Luhanska oblast',
        parent: 'UA',
    },
    'UA-12': {
        code: 'UA-12',
        name: 'Dnipropetrovska oblast',
        parent: 'UA',
    },
    'UA-14': {
        code: 'UA-14',
        name: 'Donetska oblast',
        parent: 'UA',
    },
    'UA-18': {
        code: 'UA-18',
        name: 'Zhytomyrska oblast',
        parent: 'UA',
    },
    'UA-21': {
        code: 'UA-21',
        name: 'Zakarpatska oblast',
        parent: 'UA',
    },
    'UA-23': {
        code: 'UA-23',
        name: 'Zaporizka oblast',
        parent: 'UA',
    },
    'UA-26': {
        code: 'UA-26',
        name: 'Ivano-Frankivska oblast',
        parent: 'UA',
    },
    'UA-30': {
        code: 'UA-30',
        name: 'Kyiv',
        parent: 'UA',
    },
    'UA-32': {
        code: 'UA-32',
        name: 'Kyivska oblast',
        parent: 'UA',
    },
    'UA-35': {
        code: 'UA-35',
        name: 'Kirovohradska oblast',
        parent: 'UA',
    },
    'UA-40': {
        code: 'UA-40',
        name: 'Sevastopol',
        parent: 'UA',
    },
    'UA-43': {
        code: 'UA-43',
        name: 'Avtonomna Respublika Krym',
        parent: 'UA',
    },
    'UA-46': {
        code: 'UA-46',
        name: 'Lvivska oblast',
        parent: 'UA',
    },
    'UA-48': {
        code: 'UA-48',
        name: 'Mykolaivska oblast',
        parent: 'UA',
    },
    'UA-51': {
        code: 'UA-51',
        name: 'Odeska oblast',
        parent: 'UA',
    },
    'UA-53': {
        code: 'UA-53',
        name: 'Poltavska oblast',
        parent: 'UA',
    },
    'UA-56': {
        code: 'UA-56',
        name: 'Rivnenska oblast',
        parent: 'UA',
    },
    'UA-59': {
        code: 'UA-59',
        name: 'Sumska oblast',
        parent: 'UA',
    },
    'UA-61': {
        code: 'UA-61',
        name: 'Ternopilska oblast',
        parent: 'UA',
    },
    'UA-63': {
        code: 'UA-63',
        name: 'Kharkivska oblast',
        parent: 'UA',
    },
    'UA-65': {
        code: 'UA-65',
        name: 'Khersonska oblast',
        parent: 'UA',
    },
    'UA-68': {
        code: 'UA-68',
        name: 'Khmelnytska oblast',
        parent: 'UA',
    },
    'UA-71': {
        code: 'UA-71',
        name: 'Cherkaska oblast',
        parent: 'UA',
    },
    'UA-74': {
        code: 'UA-74',
        name: 'Chernihivska oblast',
        parent: 'UA',
    },
    'UA-77': {
        code: 'UA-77',
        name: 'Chernivetska oblast',
        parent: 'UA',
    },
    'UG-101': {
        code: 'UG-101',
        name: 'Kalangala',
        parent: 'UG-C',
    },
    'UG-102': {
        code: 'UG-102',
        name: 'Kampala',
        parent: 'UG-C',
    },
    'UG-103': {
        code: 'UG-103',
        name: 'Kiboga',
        parent: 'UG-C',
    },
    'UG-104': {
        code: 'UG-104',
        name: 'Luwero',
        parent: 'UG-C',
    },
    'UG-105': {
        code: 'UG-105',
        name: 'Masaka',
        parent: 'UG-C',
    },
    'UG-106': {
        code: 'UG-106',
        name: 'Mpigi',
        parent: 'UG-C',
    },
    'UG-107': {
        code: 'UG-107',
        name: 'Mubende',
        parent: 'UG-C',
    },
    'UG-108': {
        code: 'UG-108',
        name: 'Mukono',
        parent: 'UG-C',
    },
    'UG-109': {
        code: 'UG-109',
        name: 'Nakasongola',
        parent: 'UG-C',
    },
    'UG-110': {
        code: 'UG-110',
        name: 'Rakai',
        parent: 'UG-C',
    },
    'UG-111': {
        code: 'UG-111',
        name: 'Sembabule',
        parent: 'UG-C',
    },
    'UG-112': {
        code: 'UG-112',
        name: 'Kayunga',
        parent: 'UG-C',
    },
    'UG-113': {
        code: 'UG-113',
        name: 'Wakiso',
        parent: 'UG-C',
    },
    'UG-114': {
        code: 'UG-114',
        name: 'Lyantonde',
        parent: 'UG-C',
    },
    'UG-115': {
        code: 'UG-115',
        name: 'Mityana',
        parent: 'UG-C',
    },
    'UG-116': {
        code: 'UG-116',
        name: 'Nakaseke',
        parent: 'UG-C',
    },
    'UG-117': {
        code: 'UG-117',
        name: 'Buikwe',
        parent: 'UG-C',
    },
    'UG-118': {
        code: 'UG-118',
        name: 'Bukomansibi',
        parent: 'UG-C',
    },
    'UG-119': {
        code: 'UG-119',
        name: 'Butambala',
        parent: 'UG-C',
    },
    'UG-120': {
        code: 'UG-120',
        name: 'Buvuma',
        parent: 'UG-C',
    },
    'UG-121': {
        code: 'UG-121',
        name: 'Gomba',
        parent: 'UG-C',
    },
    'UG-122': {
        code: 'UG-122',
        name: 'Kalungu',
        parent: 'UG-C',
    },
    'UG-123': {
        code: 'UG-123',
        name: 'Kyankwanzi',
        parent: 'UG-C',
    },
    'UG-124': {
        code: 'UG-124',
        name: 'Lwengo',
        parent: 'UG-C',
    },
    'UG-125': {
        code: 'UG-125',
        name: 'Kyotera',
        parent: 'UG-C',
    },
    'UG-126': {
        code: 'UG-126',
        name: 'Kasanda',
        parent: 'UG-C',
    },
    'UG-201': {
        code: 'UG-201',
        name: 'Bugiri',
        parent: 'UG-E',
    },
    'UG-202': {
        code: 'UG-202',
        name: 'Busia',
        parent: 'UG-E',
    },
    'UG-203': {
        code: 'UG-203',
        name: 'Iganga',
        parent: 'UG-E',
    },
    'UG-204': {
        code: 'UG-204',
        name: 'Jinja',
        parent: 'UG-E',
    },
    'UG-205': {
        code: 'UG-205',
        name: 'Kamuli',
        parent: 'UG-E',
    },
    'UG-206': {
        code: 'UG-206',
        name: 'Kapchorwa',
        parent: 'UG-E',
    },
    'UG-207': {
        code: 'UG-207',
        name: 'Katakwi',
        parent: 'UG-E',
    },
    'UG-208': {
        code: 'UG-208',
        name: 'Kumi',
        parent: 'UG-E',
    },
    'UG-209': {
        code: 'UG-209',
        name: 'Mbale',
        parent: 'UG-E',
    },
    'UG-210': {
        code: 'UG-210',
        name: 'Pallisa',
        parent: 'UG-E',
    },
    'UG-211': {
        code: 'UG-211',
        name: 'Soroti',
        parent: 'UG-E',
    },
    'UG-212': {
        code: 'UG-212',
        name: 'Tororo',
        parent: 'UG-E',
    },
    'UG-213': {
        code: 'UG-213',
        name: 'Kaberamaido',
        parent: 'UG-E',
    },
    'UG-214': {
        code: 'UG-214',
        name: 'Mayuge',
        parent: 'UG-E',
    },
    'UG-215': {
        code: 'UG-215',
        name: 'Sironko',
        parent: 'UG-E',
    },
    'UG-216': {
        code: 'UG-216',
        name: 'Amuria',
        parent: 'UG-E',
    },
    'UG-217': {
        code: 'UG-217',
        name: 'Budaka',
        parent: 'UG-E',
    },
    'UG-218': {
        code: 'UG-218',
        name: 'Bududa',
        parent: 'UG-E',
    },
    'UG-219': {
        code: 'UG-219',
        name: 'Bukedea',
        parent: 'UG-E',
    },
    'UG-220': {
        code: 'UG-220',
        name: 'Bukwo',
        parent: 'UG-E',
    },
    'UG-221': {
        code: 'UG-221',
        name: 'Butaleja',
        parent: 'UG-E',
    },
    'UG-222': {
        code: 'UG-222',
        name: 'Kaliro',
        parent: 'UG-E',
    },
    'UG-223': {
        code: 'UG-223',
        name: 'Manafwa',
        parent: 'UG-E',
    },
    'UG-224': {
        code: 'UG-224',
        name: 'Namutumba',
        parent: 'UG-E',
    },
    'UG-225': {
        code: 'UG-225',
        name: 'Bulambuli',
        parent: 'UG-E',
    },
    'UG-226': {
        code: 'UG-226',
        name: 'Buyende',
        parent: 'UG-E',
    },
    'UG-227': {
        code: 'UG-227',
        name: 'Kibuku',
        parent: 'UG-E',
    },
    'UG-228': {
        code: 'UG-228',
        name: 'Kween',
        parent: 'UG-E',
    },
    'UG-229': {
        code: 'UG-229',
        name: 'Luuka',
        parent: 'UG-E',
    },
    'UG-230': {
        code: 'UG-230',
        name: 'Namayingo',
        parent: 'UG-E',
    },
    'UG-231': {
        code: 'UG-231',
        name: 'Ngora',
        parent: 'UG-E',
    },
    'UG-232': {
        code: 'UG-232',
        name: 'Serere',
        parent: 'UG-E',
    },
    'UG-233': {
        code: 'UG-233',
        name: 'Butebo',
        parent: 'UG-E',
    },
    'UG-234': {
        code: 'UG-234',
        name: 'Namisindwa',
        parent: 'UG-E',
    },
    'UG-235': {
        code: 'UG-235',
        name: 'Bugweri',
        parent: 'UG-E',
    },
    'UG-236': {
        code: 'UG-236',
        name: 'Kapelebyong',
        parent: 'UG-E',
    },
    'UG-237': {
        code: 'UG-237',
        name: 'Kalaki',
        parent: 'UG-E',
    },
    'UG-301': {
        code: 'UG-301',
        name: 'Adjumani',
        parent: 'UG-N',
    },
    'UG-302': {
        code: 'UG-302',
        name: 'Apac',
        parent: 'UG-N',
    },
    'UG-303': {
        code: 'UG-303',
        name: 'Arua',
        parent: 'UG-N',
    },
    'UG-304': {
        code: 'UG-304',
        name: 'Gulu',
        parent: 'UG-N',
    },
    'UG-305': {
        code: 'UG-305',
        name: 'Kitgum',
        parent: 'UG-N',
    },
    'UG-306': {
        code: 'UG-306',
        name: 'Kotido',
        parent: 'UG-N',
    },
    'UG-307': {
        code: 'UG-307',
        name: 'Lira',
        parent: 'UG-N',
    },
    'UG-308': {
        code: 'UG-308',
        name: 'Moroto',
        parent: 'UG-N',
    },
    'UG-309': {
        code: 'UG-309',
        name: 'Moyo',
        parent: 'UG-N',
    },
    'UG-310': {
        code: 'UG-310',
        name: 'Nebbi',
        parent: 'UG-N',
    },
    'UG-311': {
        code: 'UG-311',
        name: 'Nakapiripirit',
        parent: 'UG-N',
    },
    'UG-312': {
        code: 'UG-312',
        name: 'Pader',
        parent: 'UG-N',
    },
    'UG-313': {
        code: 'UG-313',
        name: 'Yumbe',
        parent: 'UG-N',
    },
    'UG-314': {
        code: 'UG-314',
        name: 'Abim',
        parent: 'UG-N',
    },
    'UG-315': {
        code: 'UG-315',
        name: 'Amolatar',
        parent: 'UG-N',
    },
    'UG-316': {
        code: 'UG-316',
        name: 'Amuru',
        parent: 'UG-N',
    },
    'UG-317': {
        code: 'UG-317',
        name: 'Dokolo',
        parent: 'UG-N',
    },
    'UG-318': {
        code: 'UG-318',
        name: 'Kaabong',
        parent: 'UG-N',
    },
    'UG-319': {
        code: 'UG-319',
        name: 'Koboko',
        parent: 'UG-N',
    },
    'UG-320': {
        code: 'UG-320',
        name: 'Maracha',
        parent: 'UG-N',
    },
    'UG-321': {
        code: 'UG-321',
        name: 'Oyam',
        parent: 'UG-N',
    },
    'UG-322': {
        code: 'UG-322',
        name: 'Agago',
        parent: 'UG-N',
    },
    'UG-323': {
        code: 'UG-323',
        name: 'Alebtong',
        parent: 'UG-N',
    },
    'UG-324': {
        code: 'UG-324',
        name: 'Amudat',
        parent: 'UG-N',
    },
    'UG-325': {
        code: 'UG-325',
        name: 'Kole',
        parent: 'UG-N',
    },
    'UG-326': {
        code: 'UG-326',
        name: 'Lamwo',
        parent: 'UG-N',
    },
    'UG-327': {
        code: 'UG-327',
        name: 'Napak',
        parent: 'UG-N',
    },
    'UG-328': {
        code: 'UG-328',
        name: 'Nwoya',
        parent: 'UG-N',
    },
    'UG-329': {
        code: 'UG-329',
        name: 'Otuke',
        parent: 'UG-N',
    },
    'UG-330': {
        code: 'UG-330',
        name: 'Zombo',
        parent: 'UG-N',
    },
    'UG-331': {
        code: 'UG-331',
        name: 'Omoro',
        parent: 'UG-N',
    },
    'UG-332': {
        code: 'UG-332',
        name: 'Pakwach',
        parent: 'UG-N',
    },
    'UG-333': {
        code: 'UG-333',
        name: 'Kwania',
        parent: 'UG-N',
    },
    'UG-334': {
        code: 'UG-334',
        name: 'Nabilatuk',
        parent: 'UG-N',
    },
    'UG-335': {
        code: 'UG-335',
        name: 'Karenga',
        parent: 'UG-N',
    },
    'UG-336': {
        code: 'UG-336',
        name: 'Madi-Okollo',
        parent: 'UG-N',
    },
    'UG-337': {
        code: 'UG-337',
        name: 'Obongi',
        parent: 'UG-N',
    },
    'UG-401': {
        code: 'UG-401',
        name: 'Bundibugyo',
        parent: 'UG-W',
    },
    'UG-402': {
        code: 'UG-402',
        name: 'Bushenyi',
        parent: 'UG-W',
    },
    'UG-403': {
        code: 'UG-403',
        name: 'Hoima',
        parent: 'UG-W',
    },
    'UG-404': {
        code: 'UG-404',
        name: 'Kabale',
        parent: 'UG-W',
    },
    'UG-405': {
        code: 'UG-405',
        name: 'Kabarole',
        parent: 'UG-W',
    },
    'UG-406': {
        code: 'UG-406',
        name: 'Kasese',
        parent: 'UG-W',
    },
    'UG-407': {
        code: 'UG-407',
        name: 'Kibaale',
        parent: 'UG-W',
    },
    'UG-408': {
        code: 'UG-408',
        name: 'Kisoro',
        parent: 'UG-W',
    },
    'UG-409': {
        code: 'UG-409',
        name: 'Masindi',
        parent: 'UG-W',
    },
    'UG-410': {
        code: 'UG-410',
        name: 'Mbarara',
        parent: 'UG-W',
    },
    'UG-411': {
        code: 'UG-411',
        name: 'Ntungamo',
        parent: 'UG-W',
    },
    'UG-412': {
        code: 'UG-412',
        name: 'Rukungiri',
        parent: 'UG-W',
    },
    'UG-413': {
        code: 'UG-413',
        name: 'Kamwenge',
        parent: 'UG-W',
    },
    'UG-414': {
        code: 'UG-414',
        name: 'Kanungu',
        parent: 'UG-W',
    },
    'UG-415': {
        code: 'UG-415',
        name: 'Kyenjojo',
        parent: 'UG-W',
    },
    'UG-416': {
        code: 'UG-416',
        name: 'Buliisa',
        parent: 'UG-W',
    },
    'UG-417': {
        code: 'UG-417',
        name: 'Ibanda',
        parent: 'UG-W',
    },
    'UG-418': {
        code: 'UG-418',
        name: 'Isingiro',
        parent: 'UG-W',
    },
    'UG-419': {
        code: 'UG-419',
        name: 'Kiruhura',
        parent: 'UG-W',
    },
    'UG-420': {
        code: 'UG-420',
        name: 'Buhweju',
        parent: 'UG-W',
    },
    'UG-421': {
        code: 'UG-421',
        name: 'Kiryandongo',
        parent: 'UG-W',
    },
    'UG-422': {
        code: 'UG-422',
        name: 'Kyegegwa',
        parent: 'UG-W',
    },
    'UG-423': {
        code: 'UG-423',
        name: 'Mitooma',
        parent: 'UG-W',
    },
    'UG-424': {
        code: 'UG-424',
        name: 'Ntoroko',
        parent: 'UG-W',
    },
    'UG-425': {
        code: 'UG-425',
        name: 'Rubirizi',
        parent: 'UG-W',
    },
    'UG-426': {
        code: 'UG-426',
        name: 'Sheema',
        parent: 'UG-W',
    },
    'UG-427': {
        code: 'UG-427',
        name: 'Kagadi',
        parent: 'UG-W',
    },
    'UG-428': {
        code: 'UG-428',
        name: 'Kakumiro',
        parent: 'UG-W',
    },
    'UG-429': {
        code: 'UG-429',
        name: 'Rubanda',
        parent: 'UG-W',
    },
    'UG-430': {
        code: 'UG-430',
        name: 'Bunyangabu',
        parent: 'UG-W',
    },
    'UG-431': {
        code: 'UG-431',
        name: 'Rukiga',
        parent: 'UG-W',
    },
    'UG-432': {
        code: 'UG-432',
        name: 'Kikuube',
        parent: 'UG-W',
    },
    'UG-433': {
        code: 'UG-433',
        name: 'Kazo',
        parent: 'UG-W',
    },
    'UG-434': {
        code: 'UG-434',
        name: 'Kitagwenda',
        parent: 'UG-W',
    },
    'UG-435': {
        code: 'UG-435',
        name: 'Rwampara',
        parent: 'UG-W',
    },
    'UG-C': {
        code: 'UG-C',
        name: 'Central',
        parent: 'UG',
    },
    'UG-E': {
        code: 'UG-E',
        name: 'Eastern',
        parent: 'UG',
    },
    'UG-N': {
        code: 'UG-N',
        name: 'Northern',
        parent: 'UG',
    },
    'UG-W': {
        code: 'UG-W',
        name: 'Western',
        parent: 'UG',
    },
    'UM-67': {
        code: 'UM-67',
        name: 'Johnston Atoll',
        parent: 'UM',
    },
    'UM-71': {
        code: 'UM-71',
        name: 'Midway Islands',
        parent: 'UM',
    },
    'UM-76': {
        code: 'UM-76',
        name: 'Navassa Island',
        parent: 'UM',
    },
    'UM-79': {
        code: 'UM-79',
        name: 'Wake Island',
        parent: 'UM',
    },
    'UM-81': {
        code: 'UM-81',
        name: 'Baker Island',
        parent: 'UM',
    },
    'UM-84': {
        code: 'UM-84',
        name: 'Howland Island',
        parent: 'UM',
    },
    'UM-86': {
        code: 'UM-86',
        name: 'Jarvis Island',
        parent: 'UM',
    },
    'UM-89': {
        code: 'UM-89',
        name: 'Kingman Reef',
        parent: 'UM',
    },
    'UM-95': {
        code: 'UM-95',
        name: 'Palmyra Atoll',
        parent: 'UM',
    },
    'US-AK': {
        code: 'US-AK',
        name: 'Alaska',
        parent: 'US',
    },
    'US-AL': {
        code: 'US-AL',
        name: 'Alabama',
        parent: 'US',
    },
    'US-AR': {
        code: 'US-AR',
        name: 'Arkansas',
        parent: 'US',
    },
    'US-AS': {
        code: 'US-AS',
        name: 'American Samoa',
        parent: 'US',
    },
    'US-AZ': {
        code: 'US-AZ',
        name: 'Arizona',
        parent: 'US',
    },
    'US-CA': {
        code: 'US-CA',
        name: 'California',
        parent: 'US',
    },
    'US-CO': {
        code: 'US-CO',
        name: 'Colorado',
        parent: 'US',
    },
    'US-CT': {
        code: 'US-CT',
        name: 'Connecticut',
        parent: 'US',
    },
    'US-DC': {
        code: 'US-DC',
        name: 'District of Columbia',
        parent: 'US',
    },
    'US-DE': {
        code: 'US-DE',
        name: 'Delaware',
        parent: 'US',
    },
    'US-FL': {
        code: 'US-FL',
        name: 'Florida',
        parent: 'US',
    },
    'US-GA': {
        code: 'US-GA',
        name: 'Georgia',
        parent: 'US',
    },
    'US-GU': {
        code: 'US-GU',
        name: 'Guam',
        parent: 'US',
    },
    'US-HI': {
        code: 'US-HI',
        name: 'Hawaii',
        parent: 'US',
    },
    'US-IA': {
        code: 'US-IA',
        name: 'Iowa',
        parent: 'US',
    },
    'US-ID': {
        code: 'US-ID',
        name: 'Idaho',
        parent: 'US',
    },
    'US-IL': {
        code: 'US-IL',
        name: 'Illinois',
        parent: 'US',
    },
    'US-IN': {
        code: 'US-IN',
        name: 'Indiana',
        parent: 'US',
    },
    'US-KS': {
        code: 'US-KS',
        name: 'Kansas',
        parent: 'US',
    },
    'US-KY': {
        code: 'US-KY',
        name: 'Kentucky',
        parent: 'US',
    },
    'US-LA': {
        code: 'US-LA',
        name: 'Louisiana',
        parent: 'US',
    },
    'US-MA': {
        code: 'US-MA',
        name: 'Massachusetts',
        parent: 'US',
    },
    'US-MD': {
        code: 'US-MD',
        name: 'Maryland',
        parent: 'US',
    },
    'US-ME': {
        code: 'US-ME',
        name: 'Maine',
        parent: 'US',
    },
    'US-MI': {
        code: 'US-MI',
        name: 'Michigan',
        parent: 'US',
    },
    'US-MN': {
        code: 'US-MN',
        name: 'Minnesota',
        parent: 'US',
    },
    'US-MO': {
        code: 'US-MO',
        name: 'Missouri',
        parent: 'US',
    },
    'US-MP': {
        code: 'US-MP',
        name: 'Northern Mariana Islands',
        parent: 'US',
    },
    'US-MS': {
        code: 'US-MS',
        name: 'Mississippi',
        parent: 'US',
    },
    'US-MT': {
        code: 'US-MT',
        name: 'Montana',
        parent: 'US',
    },
    'US-NC': {
        code: 'US-NC',
        name: 'North Carolina',
        parent: 'US',
    },
    'US-ND': {
        code: 'US-ND',
        name: 'North Dakota',
        parent: 'US',
    },
    'US-NE': {
        code: 'US-NE',
        name: 'Nebraska',
        parent: 'US',
    },
    'US-NH': {
        code: 'US-NH',
        name: 'New Hampshire',
        parent: 'US',
    },
    'US-NJ': {
        code: 'US-NJ',
        name: 'New Jersey',
        parent: 'US',
    },
    'US-NM': {
        code: 'US-NM',
        name: 'New Mexico',
        parent: 'US',
    },
    'US-NV': {
        code: 'US-NV',
        name: 'Nevada',
        parent: 'US',
    },
    'US-NY': {
        code: 'US-NY',
        name: 'New York',
        parent: 'US',
    },
    'US-OH': {
        code: 'US-OH',
        name: 'Ohio',
        parent: 'US',
    },
    'US-OK': {
        code: 'US-OK',
        name: 'Oklahoma',
        parent: 'US',
    },
    'US-OR': {
        code: 'US-OR',
        name: 'Oregon',
        parent: 'US',
    },
    'US-PA': {
        code: 'US-PA',
        name: 'Pennsylvania',
        parent: 'US',
    },
    'US-PR': {
        code: 'US-PR',
        name: 'Puerto Rico',
        parent: 'US',
    },
    'US-RI': {
        code: 'US-RI',
        name: 'Rhode Island',
        parent: 'US',
    },
    'US-SC': {
        code: 'US-SC',
        name: 'South Carolina',
        parent: 'US',
    },
    'US-SD': {
        code: 'US-SD',
        name: 'South Dakota',
        parent: 'US',
    },
    'US-TN': {
        code: 'US-TN',
        name: 'Tennessee',
        parent: 'US',
    },
    'US-TX': {
        code: 'US-TX',
        name: 'Texas',
        parent: 'US',
    },
    'US-UM': {
        code: 'US-UM',
        name: 'United States Minor Outlying Islands',
        parent: 'US',
    },
    'US-UT': {
        code: 'US-UT',
        name: 'Utah',
        parent: 'US',
    },
    'US-VA': {
        code: 'US-VA',
        name: 'Virginia',
        parent: 'US',
    },
    'US-VI': {
        code: 'US-VI',
        name: 'U.S. Virgin Islands',
        parent: 'US',
    },
    'US-VT': {
        code: 'US-VT',
        name: 'Vermont',
        parent: 'US',
    },
    'US-WA': {
        code: 'US-WA',
        name: 'Washington',
        parent: 'US',
    },
    'US-WI': {
        code: 'US-WI',
        name: 'Wisconsin',
        parent: 'US',
    },
    'US-WV': {
        code: 'US-WV',
        name: 'West Virginia',
        parent: 'US',
    },
    'US-WY': {
        code: 'US-WY',
        name: 'Wyoming',
        parent: 'US',
    },
    'UY-AR': {
        code: 'UY-AR',
        name: 'Artigas',
        parent: 'UY',
    },
    'UY-CA': {
        code: 'UY-CA',
        name: 'Canelones',
        parent: 'UY',
    },
    'UY-CL': {
        code: 'UY-CL',
        name: 'Cerro Largo',
        parent: 'UY',
    },
    'UY-CO': {
        code: 'UY-CO',
        name: 'Colonia',
        parent: 'UY',
    },
    'UY-DU': {
        code: 'UY-DU',
        name: 'Durazno',
        parent: 'UY',
    },
    'UY-FD': {
        code: 'UY-FD',
        name: 'Florida',
        parent: 'UY',
    },
    'UY-FS': {
        code: 'UY-FS',
        name: 'Flores',
        parent: 'UY',
    },
    'UY-LA': {
        code: 'UY-LA',
        name: 'Lavalleja',
        parent: 'UY',
    },
    'UY-MA': {
        code: 'UY-MA',
        name: 'Maldonado',
        parent: 'UY',
    },
    'UY-MO': {
        code: 'UY-MO',
        name: 'Montevideo',
        parent: 'UY',
    },
    'UY-PA': {
        code: 'UY-PA',
        name: 'Paysandú',
        parent: 'UY',
    },
    'UY-RN': {
        code: 'UY-RN',
        name: 'Río Negro',
        parent: 'UY',
    },
    'UY-RO': {
        code: 'UY-RO',
        name: 'Rocha',
        parent: 'UY',
    },
    'UY-RV': {
        code: 'UY-RV',
        name: 'Rivera',
        parent: 'UY',
    },
    'UY-SA': {
        code: 'UY-SA',
        name: 'Salto',
        parent: 'UY',
    },
    'UY-SJ': {
        code: 'UY-SJ',
        name: 'San José',
        parent: 'UY',
    },
    'UY-SO': {
        code: 'UY-SO',
        name: 'Soriano',
        parent: 'UY',
    },
    'UY-TA': {
        code: 'UY-TA',
        name: 'Tacuarembó',
        parent: 'UY',
    },
    'UY-TT': {
        code: 'UY-TT',
        name: 'Treinta y Tres',
        parent: 'UY',
    },
    'UZ-AN': {
        code: 'UZ-AN',
        name: 'Andijon',
        parent: 'UZ',
    },
    'UZ-BU': {
        code: 'UZ-BU',
        name: 'Buxoro',
        parent: 'UZ',
    },
    'UZ-FA': {
        code: 'UZ-FA',
        name: 'Farg‘ona',
        parent: 'UZ',
    },
    'UZ-JI': {
        code: 'UZ-JI',
        name: 'Jizzax',
        parent: 'UZ',
    },
    'UZ-NG': {
        code: 'UZ-NG',
        name: 'Namangan',
        parent: 'UZ',
    },
    'UZ-NW': {
        code: 'UZ-NW',
        name: 'Navoiy',
        parent: 'UZ',
    },
    'UZ-QA': {
        code: 'UZ-QA',
        name: 'Qashqadaryo',
        parent: 'UZ',
    },
    'UZ-QR': {
        code: 'UZ-QR',
        name: 'Qoraqalpog‘iston Respublikasi',
        parent: 'UZ',
    },
    'UZ-SA': {
        code: 'UZ-SA',
        name: 'Samarqand',
        parent: 'UZ',
    },
    'UZ-SI': {
        code: 'UZ-SI',
        name: 'Sirdaryo',
        parent: 'UZ',
    },
    'UZ-SU': {
        code: 'UZ-SU',
        name: 'Surxondaryo',
        parent: 'UZ',
    },
    'UZ-TK': {
        code: 'UZ-TK',
        name: 'Toshkent',
        parent: 'UZ',
    },
    'UZ-TO': {
        code: 'UZ-TO',
        name: 'Toshkent',
        parent: 'UZ',
    },
    'UZ-XO': {
        code: 'UZ-XO',
        name: 'Xorazm',
        parent: 'UZ',
    },
    'VC-01': {
        code: 'VC-01',
        name: 'Charlotte',
        parent: 'VC',
    },
    'VC-02': {
        code: 'VC-02',
        name: 'Saint Andrew',
        parent: 'VC',
    },
    'VC-03': {
        code: 'VC-03',
        name: 'Saint David',
        parent: 'VC',
    },
    'VC-04': {
        code: 'VC-04',
        name: 'Saint George',
        parent: 'VC',
    },
    'VC-05': {
        code: 'VC-05',
        name: 'Saint Patrick',
        parent: 'VC',
    },
    'VC-06': {
        code: 'VC-06',
        name: 'Grenadines',
        parent: 'VC',
    },
    'VE-A': {
        code: 'VE-A',
        name: 'Distrito Capital',
        parent: 'VE',
    },
    'VE-B': {
        code: 'VE-B',
        name: 'Anzoátegui',
        parent: 'VE',
    },
    'VE-C': {
        code: 'VE-C',
        name: 'Apure',
        parent: 'VE',
    },
    'VE-D': {
        code: 'VE-D',
        name: 'Aragua',
        parent: 'VE',
    },
    'VE-E': {
        code: 'VE-E',
        name: 'Barinas',
        parent: 'VE',
    },
    'VE-F': {
        code: 'VE-F',
        name: 'Bolívar',
        parent: 'VE',
    },
    'VE-G': {
        code: 'VE-G',
        name: 'Carabobo',
        parent: 'VE',
    },
    'VE-H': {
        code: 'VE-H',
        name: 'Cojedes',
        parent: 'VE',
    },
    'VE-I': {
        code: 'VE-I',
        name: 'Falcón',
        parent: 'VE',
    },
    'VE-J': {
        code: 'VE-J',
        name: 'Guárico',
        parent: 'VE',
    },
    'VE-K': {
        code: 'VE-K',
        name: 'Lara',
        parent: 'VE',
    },
    'VE-L': {
        code: 'VE-L',
        name: 'Mérida',
        parent: 'VE',
    },
    'VE-M': {
        code: 'VE-M',
        name: 'Miranda',
        parent: 'VE',
    },
    'VE-N': {
        code: 'VE-N',
        name: 'Monagas',
        parent: 'VE',
    },
    'VE-O': {
        code: 'VE-O',
        name: 'Nueva Esparta',
        parent: 'VE',
    },
    'VE-P': {
        code: 'VE-P',
        name: 'Portuguesa',
        parent: 'VE',
    },
    'VE-R': {
        code: 'VE-R',
        name: 'Sucre',
        parent: 'VE',
    },
    'VE-S': {
        code: 'VE-S',
        name: 'Táchira',
        parent: 'VE',
    },
    'VE-T': {
        code: 'VE-T',
        name: 'Trujillo',
        parent: 'VE',
    },
    'VE-U': {
        code: 'VE-U',
        name: 'Yaracuy',
        parent: 'VE',
    },
    'VE-V': {
        code: 'VE-V',
        name: 'Zulia',
        parent: 'VE',
    },
    'VE-W': {
        code: 'VE-W',
        name: 'Dependencias Federales',
        parent: 'VE',
    },
    'VE-X': {
        code: 'VE-X',
        name: 'Vargas',
        parent: 'VE',
    },
    'VE-Y': {
        code: 'VE-Y',
        name: 'Delta Amacuro',
        parent: 'VE',
    },
    'VE-Z': {
        code: 'VE-Z',
        name: 'Amazonas',
        parent: 'VE',
    },
    'VN-01': {
        code: 'VN-01',
        name: 'Lai Châu',
        parent: 'VN',
    },
    'VN-02': {
        code: 'VN-02',
        name: 'Lào Cai',
        parent: 'VN',
    },
    'VN-03': {
        code: 'VN-03',
        name: 'Hà Giang',
        parent: 'VN',
    },
    'VN-04': {
        code: 'VN-04',
        name: 'Cao Bằng',
        parent: 'VN',
    },
    'VN-05': {
        code: 'VN-05',
        name: 'Sơn La',
        parent: 'VN',
    },
    'VN-06': {
        code: 'VN-06',
        name: 'Yên Bái',
        parent: 'VN',
    },
    'VN-07': {
        code: 'VN-07',
        name: 'Tuyên Quang',
        parent: 'VN',
    },
    'VN-09': {
        code: 'VN-09',
        name: 'Lạng Sơn',
        parent: 'VN',
    },
    'VN-13': {
        code: 'VN-13',
        name: 'Quảng Ninh',
        parent: 'VN',
    },
    'VN-14': {
        code: 'VN-14',
        name: 'Hòa Bình',
        parent: 'VN',
    },
    'VN-18': {
        code: 'VN-18',
        name: 'Ninh Bình',
        parent: 'VN',
    },
    'VN-20': {
        code: 'VN-20',
        name: 'Thái Bình',
        parent: 'VN',
    },
    'VN-21': {
        code: 'VN-21',
        name: 'Thanh Hóa',
        parent: 'VN',
    },
    'VN-22': {
        code: 'VN-22',
        name: 'Nghệ An',
        parent: 'VN',
    },
    'VN-23': {
        code: 'VN-23',
        name: 'Hà Tĩnh',
        parent: 'VN',
    },
    'VN-24': {
        code: 'VN-24',
        name: 'Quảng Bình',
        parent: 'VN',
    },
    'VN-25': {
        code: 'VN-25',
        name: 'Quảng Trị',
        parent: 'VN',
    },
    'VN-26': {
        code: 'VN-26',
        name: 'Thừa Thiên-Huế',
        parent: 'VN',
    },
    'VN-27': {
        code: 'VN-27',
        name: 'Quảng Nam',
        parent: 'VN',
    },
    'VN-28': {
        code: 'VN-28',
        name: 'Kon Tum',
        parent: 'VN',
    },
    'VN-29': {
        code: 'VN-29',
        name: 'Quảng Ngãi',
        parent: 'VN',
    },
    'VN-30': {
        code: 'VN-30',
        name: 'Gia Lai',
        parent: 'VN',
    },
    'VN-31': {
        code: 'VN-31',
        name: 'Bình Định',
        parent: 'VN',
    },
    'VN-32': {
        code: 'VN-32',
        name: 'Phú Yên',
        parent: 'VN',
    },
    'VN-33': {
        code: 'VN-33',
        name: 'Đắk Lắk',
        parent: 'VN',
    },
    'VN-34': {
        code: 'VN-34',
        name: 'Khánh Hòa',
        parent: 'VN',
    },
    'VN-35': {
        code: 'VN-35',
        name: 'Lâm Đồng',
        parent: 'VN',
    },
    'VN-36': {
        code: 'VN-36',
        name: 'Ninh Thuận',
        parent: 'VN',
    },
    'VN-37': {
        code: 'VN-37',
        name: 'Tây Ninh',
        parent: 'VN',
    },
    'VN-39': {
        code: 'VN-39',
        name: 'Đồng Nai',
        parent: 'VN',
    },
    'VN-40': {
        code: 'VN-40',
        name: 'Bình Thuận',
        parent: 'VN',
    },
    'VN-41': {
        code: 'VN-41',
        name: 'Long An',
        parent: 'VN',
    },
    'VN-43': {
        code: 'VN-43',
        name: 'Bà Rịa - Vũng Tàu',
        parent: 'VN',
    },
    'VN-44': {
        code: 'VN-44',
        name: 'An Giang',
        parent: 'VN',
    },
    'VN-45': {
        code: 'VN-45',
        name: 'Đồng Tháp',
        parent: 'VN',
    },
    'VN-46': {
        code: 'VN-46',
        name: 'Tiền Giang',
        parent: 'VN',
    },
    'VN-47': {
        code: 'VN-47',
        name: 'Kiến Giang',
        parent: 'VN',
    },
    'VN-49': {
        code: 'VN-49',
        name: 'Vĩnh Long',
        parent: 'VN',
    },
    'VN-50': {
        code: 'VN-50',
        name: 'Bến Tre',
        parent: 'VN',
    },
    'VN-51': {
        code: 'VN-51',
        name: 'Trà Vinh',
        parent: 'VN',
    },
    'VN-52': {
        code: 'VN-52',
        name: 'Sóc Trăng',
        parent: 'VN',
    },
    'VN-53': {
        code: 'VN-53',
        name: 'Bắc Kạn',
        parent: 'VN',
    },
    'VN-54': {
        code: 'VN-54',
        name: 'Bắc Giang',
        parent: 'VN',
    },
    'VN-55': {
        code: 'VN-55',
        name: 'Bạc Liêu',
        parent: 'VN',
    },
    'VN-56': {
        code: 'VN-56',
        name: 'Bắc Ninh',
        parent: 'VN',
    },
    'VN-57': {
        code: 'VN-57',
        name: 'Bình Dương',
        parent: 'VN',
    },
    'VN-58': {
        code: 'VN-58',
        name: 'Bình Phước',
        parent: 'VN',
    },
    'VN-59': {
        code: 'VN-59',
        name: 'Cà Mau',
        parent: 'VN',
    },
    'VN-61': {
        code: 'VN-61',
        name: 'Hải Dương',
        parent: 'VN',
    },
    'VN-63': {
        code: 'VN-63',
        name: 'Hà Nam',
        parent: 'VN',
    },
    'VN-66': {
        code: 'VN-66',
        name: 'Hưng Yên',
        parent: 'VN',
    },
    'VN-67': {
        code: 'VN-67',
        name: 'Nam Định',
        parent: 'VN',
    },
    'VN-68': {
        code: 'VN-68',
        name: 'Phú Thọ',
        parent: 'VN',
    },
    'VN-69': {
        code: 'VN-69',
        name: 'Thái Nguyên',
        parent: 'VN',
    },
    'VN-70': {
        code: 'VN-70',
        name: 'Vĩnh Phúc',
        parent: 'VN',
    },
    'VN-71': {
        code: 'VN-71',
        name: 'Điện Biên',
        parent: 'VN',
    },
    'VN-72': {
        code: 'VN-72',
        name: 'Đắk Nông',
        parent: 'VN',
    },
    'VN-73': {
        code: 'VN-73',
        name: 'Hậu Giang',
        parent: 'VN',
    },
    'VN-CT': {
        code: 'VN-CT',
        name: 'Cần Thơ',
        parent: 'VN',
    },
    'VN-DN': {
        code: 'VN-DN',
        name: 'Đà Nẵng',
        parent: 'VN',
    },
    'VN-HN': {
        code: 'VN-HN',
        name: 'Hà Nội',
        parent: 'VN',
    },
    'VN-HP': {
        code: 'VN-HP',
        name: 'Hải Phòng',
        parent: 'VN',
    },
    'VN-SG': {
        code: 'VN-SG',
        name: 'Hồ Chí Minh(local variant is Sai Gon)',
        parent: 'VN',
    },
    'VU-MAP': {
        code: 'VU-MAP',
        name: 'Malampa',
        parent: 'VU',
    },
    'VU-PAM': {
        code: 'VU-PAM',
        name: 'Pénama',
        parent: 'VU',
    },
    'VU-SAM': {
        code: 'VU-SAM',
        name: 'Sanma',
        parent: 'VU',
    },
    'VU-SEE': {
        code: 'VU-SEE',
        name: 'Shéfa',
        parent: 'VU',
    },
    'VU-TAE': {
        code: 'VU-TAE',
        name: 'Taféa',
        parent: 'VU',
    },
    'VU-TOB': {
        code: 'VU-TOB',
        name: 'Torba',
        parent: 'VU',
    },
    'WF-AL': {
        code: 'WF-AL',
        name: 'Alo',
        parent: 'WF',
    },
    'WF-SG': {
        code: 'WF-SG',
        name: 'Sigave',
        parent: 'WF',
    },
    'WF-UV': {
        code: 'WF-UV',
        name: 'Uvea',
        parent: 'WF',
    },
    'WS-AA': {
        code: 'WS-AA',
        name: "A'ana",
        parent: 'WS',
    },
    'WS-AL': {
        code: 'WS-AL',
        name: 'Aiga-i-le-Tai',
        parent: 'WS',
    },
    'WS-AT': {
        code: 'WS-AT',
        name: 'Atua',
        parent: 'WS',
    },
    'WS-FA': {
        code: 'WS-FA',
        name: "Fa'asaleleaga",
        parent: 'WS',
    },
    'WS-GE': {
        code: 'WS-GE',
        name: "Gaga'emauga",
        parent: 'WS',
    },
    'WS-GI': {
        code: 'WS-GI',
        name: 'Gagaifomauga',
        parent: 'WS',
    },
    'WS-PA': {
        code: 'WS-PA',
        name: 'Palauli',
        parent: 'WS',
    },
    'WS-SA': {
        code: 'WS-SA',
        name: "Satupa'itea",
        parent: 'WS',
    },
    'WS-TU': {
        code: 'WS-TU',
        name: 'Tuamasaga',
        parent: 'WS',
    },
    'WS-VF': {
        code: 'WS-VF',
        name: "Va'a-o-Fonoti",
        parent: 'WS',
    },
    'WS-VS': {
        code: 'WS-VS',
        name: 'Vaisigano',
        parent: 'WS',
    },
    'YE-AB': {
        code: 'YE-AB',
        name: 'Abyan',
        parent: 'YE',
    },
    'YE-AD': {
        code: 'YE-AD',
        name: '‘Adan',
        parent: 'YE',
    },
    'YE-AM': {
        code: 'YE-AM',
        name: '‘Amrān',
        parent: 'YE',
    },
    'YE-BA': {
        code: 'YE-BA',
        name: 'Al Bayḑā’',
        parent: 'YE',
    },
    'YE-DA': {
        code: 'YE-DA',
        name: 'Aḑ Ḑāli‘',
        parent: 'YE',
    },
    'YE-DH': {
        code: 'YE-DH',
        name: 'Dhamār',
        parent: 'YE',
    },
    'YE-HD': {
        code: 'YE-HD',
        name: 'Ḩaḑramawt',
        parent: 'YE',
    },
    'YE-HJ': {
        code: 'YE-HJ',
        name: 'Ḩajjah',
        parent: 'YE',
    },
    'YE-HU': {
        code: 'YE-HU',
        name: 'Al Ḩudaydah',
        parent: 'YE',
    },
    'YE-IB': {
        code: 'YE-IB',
        name: 'Ibb',
        parent: 'YE',
    },
    'YE-JA': {
        code: 'YE-JA',
        name: 'Al Jawf',
        parent: 'YE',
    },
    'YE-LA': {
        code: 'YE-LA',
        name: 'Laḩij',
        parent: 'YE',
    },
    'YE-MA': {
        code: 'YE-MA',
        name: 'Ma’rib',
        parent: 'YE',
    },
    'YE-MR': {
        code: 'YE-MR',
        name: 'Al Mahrah',
        parent: 'YE',
    },
    'YE-MW': {
        code: 'YE-MW',
        name: 'Al Maḩwīt',
        parent: 'YE',
    },
    'YE-RA': {
        code: 'YE-RA',
        name: 'Raymah',
        parent: 'YE',
    },
    'YE-SA': {
        code: 'YE-SA',
        name: 'Amānat al ‘Āşimah',
        parent: 'YE',
    },
    'YE-SD': {
        code: 'YE-SD',
        name: 'Şāʻdah',
        parent: 'YE',
    },
    'YE-SH': {
        code: 'YE-SH',
        name: 'Shabwah',
        parent: 'YE',
    },
    'YE-SN': {
        code: 'YE-SN',
        name: 'Şanʻā’',
        parent: 'YE',
    },
    'YE-SU': {
        code: 'YE-SU',
        name: 'Arkhabīl Suquţrá',
        parent: 'YE',
    },
    'YE-TA': {
        code: 'YE-TA',
        name: 'Tāʻizz',
        parent: 'YE',
    },
    'ZA-EC': {
        code: 'ZA-EC',
        name: 'Kapa-Vuxa',
        parent: 'ZA',
    },
    'ZA-FS': {
        code: 'ZA-FS',
        name: 'Free State',
        parent: 'ZA',
    },
    'ZA-GP': {
        code: 'ZA-GP',
        name: 'Gauteng',
        parent: 'ZA',
    },
    'ZA-KZN': {
        code: 'ZA-KZN',
        name: 'Kwazulu-Natal',
        parent: 'ZA',
    },
    'ZA-LP': {
        code: 'ZA-LP',
        name: 'Limpopo',
        parent: 'ZA',
    },
    'ZA-MP': {
        code: 'ZA-MP',
        name: 'Mpumalanga',
        parent: 'ZA',
    },
    'ZA-NC': {
        code: 'ZA-NC',
        name: "Kapa-N'walungu",
        parent: 'ZA',
    },
    'ZA-NW': {
        code: 'ZA-NW',
        name: "N'walungu-Vupeladyambu",
        parent: 'ZA',
    },
    'ZA-WC': {
        code: 'ZA-WC',
        name: 'Kapa-Vupeladyambu',
        parent: 'ZA',
    },
    'ZM-01': {
        code: 'ZM-01',
        name: 'Western',
        parent: 'ZM',
    },
    'ZM-02': {
        code: 'ZM-02',
        name: 'Central',
        parent: 'ZM',
    },
    'ZM-03': {
        code: 'ZM-03',
        name: 'Eastern',
        parent: 'ZM',
    },
    'ZM-04': {
        code: 'ZM-04',
        name: 'Luapula',
        parent: 'ZM',
    },
    'ZM-05': {
        code: 'ZM-05',
        name: 'Northern',
        parent: 'ZM',
    },
    'ZM-06': {
        code: 'ZM-06',
        name: 'North-Western',
        parent: 'ZM',
    },
    'ZM-07': {
        code: 'ZM-07',
        name: 'Southern',
        parent: 'ZM',
    },
    'ZM-08': {
        code: 'ZM-08',
        name: 'Copperbelt',
        parent: 'ZM',
    },
    'ZM-09': {
        code: 'ZM-09',
        name: 'Lusaka',
        parent: 'ZM',
    },
    'ZM-10': {
        code: 'ZM-10',
        name: 'Muchinga',
        parent: 'ZM',
    },
    'ZW-BU': {
        code: 'ZW-BU',
        name: 'Bulawayo',
        parent: 'ZW',
    },
    'ZW-HA': {
        code: 'ZW-HA',
        name: 'Harare',
        parent: 'ZW',
    },
    'ZW-MA': {
        code: 'ZW-MA',
        name: 'Manicaland',
        parent: 'ZW',
    },
    'ZW-MC': {
        code: 'ZW-MC',
        name: 'Mashonaland Central',
        parent: 'ZW',
    },
    'ZW-ME': {
        code: 'ZW-ME',
        name: 'Mashonaland East',
        parent: 'ZW',
    },
    'ZW-MI': {
        code: 'ZW-MI',
        name: 'Midlands',
        parent: 'ZW',
    },
    'ZW-MN': {
        code: 'ZW-MN',
        name: 'Matabeleland North',
        parent: 'ZW',
    },
    'ZW-MS': {
        code: 'ZW-MS',
        name: 'Matabeleland South',
        parent: 'ZW',
    },
    'ZW-MV': {
        code: 'ZW-MV',
        name: 'Masvingo',
        parent: 'ZW',
    },
    'ZW-MW': {
        code: 'ZW-MW',
        name: 'Mashonaland West',
        parent: 'ZW',
    },
};
/* eslint-enable max-lines */
//# sourceMappingURL=iso3166-2.js.map